// src/contexts/TranslationContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const TranslationContext = createContext();

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within TranslationProvider');
  }
  return context;
};

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'english');
  const [translations, setTranslations] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // TranslationContext.js - Complete translations for all 7 languages

const staticTranslations = {
  english: {


    // ===== NEW DEPARTMENTS (10) =====
deptCoffeeShop: 'Coffee Shop Operations',
deptCoffeeShopDesc: 'Professional barista training, coffee preparation, and cafe management',
deptHousekeeping: 'Housekeeping Operations',
deptHousekeepingDesc: 'Professional cleaning, organization, and hospitality management',
deptCarpetYarn: 'Carpet & Yarn Production',
deptCarpetYarnDesc: 'Hand-woven carpet making and yarn production using traditional and modern methods',
deptLeatherFootwear: 'Leather Goods and Footwear Design and Production',
deptLeatherFootwearDesc: 'Leather goods production including bags, shoes, and accessories',
deptSewingGarment: 'Sewing and Garment Production',
deptSewingGarmentDesc: 'Professional sewing, tailoring, and garment production',
deptMilkProcessing: 'Milk Processing',
deptMilkProcessingDesc: 'Milk and yogurt processing, packaging, and dairy product development',
deptBakeryPastry: 'Bakery & Pastry Production',
deptBakeryPastryDesc: 'Professional baking, pastry making, and confectionery skills',
deptNutritionalFood: 'Nutritional Food Production',
deptNutritionalFoodDesc: 'Production of nutritious food products and balanced meal preparation',
deptReception: 'Reception Operations',
deptReceptionDesc: 'Professional receptionist, customer service, and office management',
deptHorticulture: 'Horticulture Production (Agriculture)',
deptHorticultureDesc: 'Sustainable horticulture production, vegetable farming, and agricultural practices',

// Modal-specific keys
unemployedWomenFound: 'unemployed women found',
noUnemployedWomenInDepartment: 'No unemployed women found in this department.',

    noEventsLine:'No Events',
    clickCardToView:'Click Card To View',

        // ===== Trainee Stats Page =====
        stats: 'Stats',
        traineeStats: 'Trainees Statistics',
        traineeStatsIntro: 'Explore Our Certified Graduates',
        ourImpact: 'Our Impact',
        totalTrainees: 'Certified Graduates',
        employedByCompany: 'Employed by Company',
        unemployed: 'Unemployed',
        professionalInternship: 'Professional Internship',
        selfEmployed: 'Self Employed',
        traineesFound: 'trainees found',
        noTraineesFound: 'No trainees found',
        tryDifferentFilters: 'Try adjusting your filters or search.',
        searchTrainees: 'Search by name, skills...',
        allDepartments: 'All Departments',
        yearsExp: 'yrs exp',

    employed: 'Employed',
    studying: 'Studying',
    workingForOthers: 'Working for Others',
    notAvailableForHire: 'Not available for hire',
    womenFound: 'women found',
    noWomenInDepartment: 'No women found in this department.',
    exportExcel: 'Export to Excel',
    exportPDF: 'Export to PDF',
    noWomenFoundWithStatus: 'No women found with this status',
        // Form labels
        fullName: 'Full Name',
        age: 'Age',
        cohort: 'Cohort',
        phone: 'Phone',
        email: 'Email',
        placementLocation: 'Placement Location',
        competenceSkills: 'Competence Skills',
        commaSeparated: 'comma-separated',
        optional: 'Optional',
        emailOptional: 'Email is optional but recommended for communication',
        enterName: 'Enter your full name',
        enterAge: 'Your age',
        enterPhone: '+250 78X XXX XXX',
        enterEmail: 'your@email.com (optional)',
        enterPlacementLocation: 'City, District, Country',
        enterCompetenceSkills: 'e.g., Computer Skills, Decision Making, Leadership',
        separateWithCommas: 'Separate multiple skills with commas',
        enterCompanyName: 'Company/organization name',
        enterWorkingPosition: 'Job title',
        enterWorkingLocation: 'Work location',
        enterYears: 'Years',
        enterBio: 'Brief biography',
        uploadPhoto: 'Upload Photo',
      
        // Validation messages
        fullNameRequired: 'Full name is required',
        nameMinLength: 'Name must be at least 2 characters long',
        selectDepartmentRequired: 'Please select a department',
        selectEmploymentStatus: 'Please select employment status',
        selectJobSecured: 'Please select how you secured your job',
        selectJobSecured: 'Please select how you secured your job',
      
        // Employment status (already exist)
        // selfEmployed, unemployed, employedByCompany, workForOthers, continuingTraining
        // publicSector, privateSector, ngo, other
        // permanent, internship, partTime, volunteer
        // selectStatus, selectSector, selectMode, selectIncome, selectRelevance, selectConfidence
      
        // Employment messages
        employmentStatusDesc: 'Tell us about your current employment situation.',
        unemployedInfo: 'You selected "Unemployed". Additional employment details are not required.',
      
        // Job secured options
        wocPlacement: 'Through WOC Job Placement Support',
        wocInternship: 'Internship/Industrial Attachment at WOC',
        wocRecommendation: 'Recommendation from WOC Trainers',
        familyFriends: 'Family/Friends',
        socialMedia: 'Social Media',
        onlinePortal: 'Online Job Portal',
        walkIn: 'Walk-in Application',
        newspaper: 'Newspaper Advertisement',
      
        // Job relevance
        jobRelevanceDesc: 'Is your current job related to the training you received at WOC?',
      
        // Job challenges
        jobChallengesDesc: 'What are the main reasons for your unemployment? (Check all that apply)',
        lackJobOpportunities: 'Lack of job opportunities',
        lackWorkExperience: 'Lack of work experience',
        insufficientSkills: 'Insufficient skills',
        familyResponsibilities: 'Family responsibilities',
        continuingEducation: 'Continuing education',
        healthReasons: 'Health reasons',
        lackStartupCapital: 'Lack of startup capital',
        locationTransport: 'Location/transport challenges',
      
        // Entrepreneurship
        entrepreneurshipDesc: 'Have you started your own business after graduating?',
        employeesEmployed: 'How many people have you employed?',
        moreThan5: 'More than 5',
      
        // Support needed
        supportNeededDesc: 'What support would help you grow your business? (Check all that apply)',
        accessFinance: 'Access to finance',
        businessMentorship: 'Business mentorship',
        marketingSupport: 'Marketing support',
        advancedTraining: 'Advanced technical training',
        equipment: 'Equipment',
        marketLinkage: 'Market linkage',
        businessRegistration: 'Business registration support',
        selectNumber: 'Select number',
      
        // Confidence
        confidenceDesc: 'To what extent has the training at WOC improved your confidence and ability to make independent life decisions?',
      
        // Financial situation
        financialSupportChanged: 'How has your ability to support yourself financially changed?',
        financialStability: 'Compared to before attending WOC, how would you rate your current financial stability?',
        savedMoney: 'Have you been able to save money regularly since completing your training?',
        incomeManagement: 'How confident are you in managing your personal income?',
      
        // Financial options (already exist)
        // fullyIndependent, significantlyContribute, occasionallyContribute, notChanged, worsened
        // muchBetter, better, same, worse, muchWorse
        // yesEveryMonth, yesOccasionally, noButPlan, no
        // veryConfident, confident, moderatelyConfident, slightlyConfident, notConfident
      
        // Community impact
        communityImpactDesc: 'How would you describe the impact of WOC training on your life and your community?',
        leadershipInvolvement: 'Have you become more involved in leadership or decision-making within your family or community after graduating from WOC?',
      
        // Community options (already exist)
        // transformational, significantPositive, moderatePositive, slightPositive, noImpact
        // significantly, toSomeExtent, noChange, lessInvolved
      
        // Edit mode
        editTraineeProfile: 'Edit Trainee Profile',
        updateProfile: 'Update Profile',
        editing: 'Editing:',
      
        // Progress
        step: 'Step',
        of: 'of',
        skipped: 'Skipped',
        notApplicable: 'Not applicable',
      
        // Buttons
        continue: 'Continue',
        previous: 'Previous',
        next: 'Next',
        submit: 'Complete Registration',
        submitting: 'Submitting...',
        updateProfile: 'Update Profile',
      
        // Success messages (already exist)
        // profileUpdatedSuccess, registrationComplete, thankYouRegistration,
        // registrationSuccessSub
      
        // Error messages
        noServerResponse: 'No response from server. Please check your connection.',
        registrationFailed: 'Registration failed. Please try again.',
        pleaseFillRequiredFields: 'Please fill in all required fields',
      
        // Skip messages (already exist)
        // stepSkippedUnemployed, stepSkippedNotUnemployed, stepSkippedNotEntrepreneur,
        // skipToNextStep
      
        // Additional
        above200k: 'Above 200,000 RWF',
        selectOption: 'Select option',
        selectRating: 'Select rating',
        selectImpact: 'Select impact level',
        yes: 'Yes',
        no: 'No',
        none: 'None',
        selectCohort: 'Select cohort',
        selectDepartment: 'Select department',
        selectStatus: 'Select status',
      

      // Trainee Registration Translations - ENGLISH
traineeRegister: 'Register as Trainee',
traineeRegistration: 'Trainee Registration',
basicInformation: 'Basic Information',
employmentStatus: 'Employment Status',
jobSecured: 'How You Secured Job',
jobRelevance: 'Job Relevance',
jobChallenges: 'Job Search Challenges',
entrepreneurship: 'Entrepreneurship',
supportNeeded: 'Support Needed',
confidenceImpact: 'Confidence & Impact',
financialSituation: 'Financial Situation',
communityImpact: 'Community Impact',
registrationComplete: 'Registration Complete!',
thankYouRegistration: 'Thank you for completing your registration.',
registrationSuccess: 'Your information has been saved successfully.',
registrationSuccessSub: 'You can now access all features of the platform.',
previous: 'Previous',
next: 'Next',
submit: 'Complete Registration',
submitting: 'Submitting...',
fullName: 'Full Name',
age: 'Age',
cohort: 'Cohort',
placementLocation: 'Placement Location',
competenceSkills: 'Competence Skills',
profilePhoto: 'Profile Photo',
employmentSector: 'Employment Sector',
companyName: 'Company Name',
workingPosition: 'Working Position',
workingLocation: 'Working Location',
modeOfEmployment: 'Mode of Employment',
yearsOfExperience: 'Years of Experience',
monthlyIncome: 'Approximate Monthly Income',
contractStartDate: 'Contract Start Date',
contractEndDate: 'Contract End Date',
selectCohort: 'Select cohort',
selectDepartment: 'Select department',
selectStatus: 'Select status',
selectSector: 'Select sector',
selectMode: 'Select mode',
selectIncome: 'Select range',
selectRelevance: 'Select relevance',
selectConfidence: 'Select confidence level',
selfEmployed: 'Self Employed',
unemployed: 'Unemployed',
employedByCompany: 'Employed by Company',
workForOthers: 'Work for Others',
continuingTraining: 'Continuing Training',
publicSector: 'Public',
privateSector: 'Private',
ngo: 'NGO',
other: 'Other',
permanent: 'Permanent Job',
internship: 'Internship',
partTime: 'Part Time Contract',
volunteer: 'Volunteer',
directlyRelated: 'Directly Related',
somewhatRelated: 'Somewhat Related',
notRelated: 'Not Related',
veryGreatExtent: 'To a very great extent',
greatExtent: 'To a great extent',
moderateExtent: 'To a moderate extent',
smallExtent: 'To a small extent',
notAtAll: 'Not at all',
fullyIndependent: 'I am now fully financially independent',
significantlyContribute: 'I contribute significantly to my household income',
occasionallyContribute: 'I contribute occasionally to household income',
notChanged: 'My financial situation has not changed',
worsened: 'My financial situation has worsened',
muchBetter: 'Much better',
better: 'Better',
same: 'About the same',
worse: 'Worse',
muchWorse: 'Much worse',
yesEveryMonth: 'Yes, every month',
yesOccasionally: 'Yes, occasionally',
noButPlan: 'No, but I plan to',
no: 'No',
veryConfident: 'Very confident',
confident: 'Confident',
moderatelyConfident: 'Moderately confident',
slightlyConfident: 'Slightly confident',
notConfident: 'Not confident at all',
transformational: 'Transformational',
significantPositive: 'Significant positive impact',
moderatePositive: 'Moderate positive impact',
slightPositive: 'Slight positive impact',
noImpact: 'No noticeable impact',
significantly: 'Yes, significantly',
toSomeExtent: 'Yes, to some extent',
noChange: 'No change',
lessInvolved: 'Less involved than before',
confirmToggleStatus: 'Toggle Status',
confirmToggleTraineeStatus: 'Are you sure you want to toggle this trainee\'s active status? Inactive trainees will not appear on the homepage.',
traineeActivated: 'Trainee activated successfully',
traineeDeactivated: 'Trainee deactivated successfully',
failedToggleTraineeStatus: 'Failed to toggle trainee status',
traineeInactive: 'Trainee is inactive',


// In the english section, add these:

// Trainee Registration Modal - Step validation messages
pleaseFillRequiredFields: 'Please fill in all required fields',
stepErrorBasicInfo: 'Please fill in all required fields in Basic Information',
stepErrorEmployment: 'Please select your employment status',
stepErrorJobSecured: 'Please select how you secured your job',

// Skip messages
stepSkippedUnemployed: 'You selected "Unemployed" in the previous step. This step is not applicable.',
stepSkippedNotUnemployed: 'You are not unemployed. This step is not applicable.',
stepSkippedNotEntrepreneur: 'You selected "No" for entrepreneurship. This step is not applicable.',
skipToNextStep: 'Skip to Next Step',

// Edit mode
editTraineeProfile: 'Edit Trainee Profile',
updateProfile: 'Update Profile',
profileUpdatedSuccess: 'Profile updated successfully!',
profileAddedSuccess: 'Profile added successfully!',
editing: 'Editing:',

// Current photo
currentPhotoLabel: 'Current photo:',

// No data messages
noDepartmentsAvailable: 'No departments available',
noGalleryImages: 'No gallery images available at the moment.',
noWomenProfiles: 'No women profiles available at the moment.',
noEvents: 'No events to display',

// Gallery
welcomeToGallery: 'Welcome to Our Gallery',
gallerySubtitle: 'Explore the journey of women empowerment',
viewAll: 'View All',
matching: 'matching',
resetFilters: 'Reset Filters',
noImagesInDatabase: 'No images found in database. Showing sample images.',
errorLoadingImages: 'Error loading images. Showing sample images.',
errorLoadingDepartments: 'Error loading departments. Using default list.',
unknownDepartment: 'Unknown Department',
noImagesForDepartment: 'No images available for this department yet.',
clickToView: 'Click to view',
department: 'Department',
category: 'Category',
date: 'Date',
close: 'Close',
viewDetails: 'View Details',

// Additional keys
viewAllDepartments: 'View All Departments',
viewAllWomen: 'View All Women',
loadMoreImages: 'Load More Images',
noDescription: 'No description available',
featured: 'Featured',
    // Search Bar Translations - ENGLISH
searchPlaceholder: 'Search for women, departments, activities...',
trainedWomen: 'Trained Women',
trainingDepartments: 'Training Departments',
activities: 'Activities',
galleryImages: 'Gallery Images',
viewAllResults: 'View all results for',
searchResultsFor: 'Search Results for',
viewAllItems: 'View all →',
noResultsFound: 'No results found for',
trySearchingFor: 'Try searching for:',
searchSuggestions: 'tailoring, cooking, agriculture, sewing, leatherwork',
viewCompleteSearchResults: 'View Complete Search Results',
    // Trainee Registration - Additional Fields Translations
enterName: 'Enter full name',
enterAge: 'Age',
enterPhone: '+250 78X XXX XXX',
enterEmail: 'email@example.com',
enterPlacementLocation: 'City, District, Country',
enterCompetenceSkills: 'e.g., Computer Skills, Decision Making, Leadership',
separateWithCommas: 'Separate multiple skills with commas',
enterCompanyName: 'Company/organization name',
enterWorkingPosition: 'Job title',
enterWorkingLocation: 'Work location',
enterYears: 'Years',
enterLocation: 'Current location',
enterBio: 'Brief biography',
selectJobSecured: 'Select how you secured your job',
selectChallenges: 'Select all that apply',
selectSupport: 'What support would help you grow your business? Select all that apply',
selectOption: 'Select option',
selectNumber: 'Select number',
selectRating: 'Select rating',
selectImpact: 'Select impact level',
startedBusiness: 'Have you started your own business after graduating?',
employeesEmployed: 'How many people have you employed?',
none: 'None',
moreThan5: 'More than 5',
yes: 'Yes',
no: 'No',
saving: 'Saving...',
educationAndBio: 'Education & Biography',
confidenceImproved: 'To what extent has training improved your confidence?',
financialSupportChanged: 'How has your ability to support yourself financially changed?',
financialStability: 'Compared to before training, how would you rate your financial stability?',
savedMoney: 'Have you been able to save money regularly since training?',
incomeManagement: 'How confident are you in managing your personal income?',
communityImpactDesc: 'How would you describe the impact of WOC training on your life and community?',
leadershipInvolvement: 'Have you become more involved in leadership or decision-making?',
currentPhoto: 'Current photo',
yesEveryMonth: 'Yes, every month',
yesOccasionally: 'Yes, occasionally',
noButPlan: 'No, but I plan to',
notChanged: 'Has not changed',
worsened: 'Has worsened',
fullyIndependent: 'Fully financially independent',
significantlyContribute: 'Significantly contribute to household',
occasionallyContribute: 'Occasionally contribute to household',
muchBetter: 'Much better',
better: 'Better',
same: 'About the same',
worse: 'Worse',
muchWorse: 'Much worse',
veryGreatExtent: 'To a very great extent',
greatExtent: 'To a great extent',
moderateExtent: 'To a moderate extent',
smallExtent: 'To a small extent',
notAtAll: 'Not at all',
veryConfident: 'Very confident',
confident: 'Confident',
moderatelyConfident: 'Moderately confident',
slightlyConfident: 'Slightly confident',
notConfident: 'Not confident at all',
transformational: 'Transformational',
significantPositive: 'Significant positive impact',
moderatePositive: 'Moderate positive impact',
slightPositive: 'Slight positive impact',
noImpact: 'No noticeable impact',
significantly: 'Yes, significantly',
toSomeExtent: 'Yes, to some extent',
noChange: 'No change',
lessInvolved: 'Less involved than before',

    homepageManagement: 'Homepage Management',
heroSlides: 'Hero Slides',
addHeroSlide: 'Add Hero Slide',
editHeroSlide: 'Edit Hero Slide',
noHeroSlides: 'No hero slides',
addHeroSlidesDesc: 'Add slides to display on the homepage hero section',
stats: 'Statistics',
noStats: 'No statistics',
addStatsDesc: 'Add statistics to display on the homepage',
addStat: 'Add Stat',
editStat: 'Edit Stat',
statAdded: 'Stat added successfully',
statUpdated: 'Stat updated successfully',
statDeleted: 'Stat deleted successfully',
confirmDeleteStat: 'Are you sure you want to delete this stat?',
confirmDeleteStatTitle: 'Delete Stat',
heroSlideAdded: 'Hero slide added successfully',
heroSlideUpdated: 'Hero slide updated successfully',
heroSlideDeleted: 'Hero slide deleted successfully',
heroSlideStatusToggled: 'Hero slide status updated',
failedAddHeroSlide: 'Failed to add hero slide',
failedUpdateHeroSlide: 'Failed to update hero slide',
failedDeleteHeroSlide: 'Failed to delete hero slide',
failedToggleHeroSlideStatus: 'Failed to update hero slide status',
confirmDeleteHeroSlideTitle: 'Delete Hero Slide',
confirmDeleteHeroSlide: 'Are you sure you want to delete this hero slide?',
failedLoadHeroSlides: 'Failed to load hero slides',
failedLoadStats: 'Failed to load statistics',
failedAddStat: 'Failed to add stat',
failedUpdateStat: 'Failed to update stat',
failedDeleteStat: 'Failed to delete stat',

activityImages: 'Activity Images',
activityImagesManagement: 'Activity Images Management',
addActivityImage: 'Add Activity Image',
editActivityImage: 'Edit Activity Image',
activityImageAdded: 'Activity image added successfully',
activityImageUpdated: 'Activity image updated successfully',
activityImageDeleted: 'Activity image deleted successfully',
activityImageStatusToggled: 'Activity image status updated',
confirmDeleteActivityImage: 'Are you sure you want to delete this activity image?',
searchActivityImages: 'Search activity images...',
bulkUpload: 'Bulk Upload',
bulkUploadImages: 'Bulk Upload Images',
bulkUploadComplete: 'Bulk upload completed successfully',
failedBulkUpload: 'Bulk upload failed',
selectImagesToUpload: 'Please select images to upload',
selectedFiles: 'Selected Files',
uploadAll: 'Upload All',
uploading: 'Uploading...',
imageRequired: 'Image file is required',
failedAddActivityImage: 'Failed to add activity image',
failedUpdateActivityImage: 'Failed to update activity image',
failedDeleteImage: 'Failed to delete image',
imageDeleted: 'Image deleted successfully',
imageRestored: 'Image restored successfully',
failedRestoreImage: 'Failed to restore image',
imageStatusToggled: 'Image status updated',
failedToggleImageStatus: 'Failed to update image status',
failedLoadActivityImages: 'Failed to load activity images',
exportActivityImages: 'Export Activity Images',
activityImagesExported: 'Activity images exported successfully',
failedExportActivityImages: 'Failed to export activity images',
womenInAction: 'Women in Action',
totalImages: 'Total Images',
activeImages: 'Active Images',
departmentsWithImages: 'Departments with Images',
lastUpload: 'Last Upload',
never: 'Never',
noActivityImages: 'No activity images found',
addActivityImagesDesc: 'Add images to display in the Women in Action section on the homepage',
    deleteWhyChooseUs: "Are you sure you want to delete this item?",
    deleteWhyChooseUsTitle: "Delete Item",
    deleteVideo: "Are you sure you want to delete this video?",
    deleteVideoTitle: "Delete Video",
    added: "Item added successfully",
    updated: "Item updated successfully",
    deleted: "Item deleted successfully",
    statusToggled: "Status updated successfully",
    failedAdd: "Failed to add item",
    failedUpdate: "Failed to update item",
    failedDelete: "Failed to delete item",
    failedToggle: "Failed to update status",
    videoSections: "Video Sections",
    addVideo: "Add Video",
    editVideo: "Edit Video",
    noVideos: "No video sections",
    addVideos: "Add videos to display on the homepage",
    videoUrl: "Video URL",
    thumbnail: "Thumbnail",
    setAsActive: "Set as active video",
    onlyOneActive: "Only one video can be active at a time",
    currentThumbnail: "Current thumbnail",
    watchVideo: "Watch Video",
    playVideo: "Play Video",
    active: "Active",
    inactive: "Inactive",
    untitled: "Untitled",
    youtubeEmbedUrl: "Use YouTube embed URL (e.g., https://www.youtube.com/embed/VIDEO_ID)",
    enterVideoTitle: "Enter video title",
    enterVideoDescription: "Enter video description",
    setActive: "Set as Active",
    whyChooseUsItems: "Why Choose Us Items",
    addItem: "Add Item",
    editItem: "Edit Item",
    noWhyChooseUsItems: "No Why Choose Us items",
    addWhyChooseUsItems: "Add items to display on the homepage",
    icon: "Icon",
    title: "Title",
    description: "Description",
    sortOrder: "Sort Order",
    status: "Status",
    actions: "Actions",
    iconPreview: "Icon Preview",
    enterTitle: "Enter title",
    enterDescription: "Enter description",
currentPassword: 'Current Password',
enterCurrentPassword: 'Enter current password',
passwordsDoNotMatch: 'Passwords do not match',
passwordTooShort: 'Password must be at least 6 characters',
passwordChanged: 'Password changed successfully!',
failedChangePassword: 'Failed to change password',
changing: 'Changing...',
changePassword: 'Change Password',

    // Contract Management Translations
contracts: 'My Contracts',
activeContracts: 'Active Contracts',
contractHistory: 'Contract History',
completedContracts: 'Completed',
expiringSoon: 'Expiring Soon',
noActiveContracts: 'No Active Contracts',
noActiveContractsDesc: "You don't have any active contracts at the moment.",
noContractHistory: 'No Contract History',
noContractHistoryDesc: "You don't have any completed or terminated contracts.",
contractDetails: 'Contract Details',
contractId: 'Contract ID',
period: 'Period',
startDate: 'Start Date',
endDate: 'End Date',
daysRemaining: 'Days Remaining',
status: 'Status',
terminationReason: 'Termination Reason',
renew: 'Renew',
renewNow: 'Renew Now',
terminate: 'Terminate',
viewDetails: 'View Details',
renewContract: 'Renew Contract',
terminateContract: 'Terminate Contract',
renewContractInfo: 'Current contract expires on:',
selectContractPeriod: 'Select contract period',
customMonths: 'Custom months...',
months: 'months',
sendEmailNotification: 'Send email confirmation',
renewContractNote: 'Renewing the contract will create a new contract period. The current contract will be marked as renewed.',
renewing: 'Renewing...',
terminating: 'Terminating...',
warning: 'Warning',
terminateContractWarning: 'This action cannot be undone.',
selectReason: 'Select a reason',
workCompleted: 'Work completed',
performance: 'Performance issues',
budgetConstraints: 'Budget constraints',
restructuring: 'Company restructuring',
mutualAgreement: 'Mutual agreement',
other: 'Other',
customReason: 'Custom reason',
enterTerminationReason: 'Enter termination reason',
effectiveDate: 'Effective date',
effectiveDateNote: 'Leave empty for immediate termination',
sendTerminationEmail: 'Send termination confirmation email',
womanInformation: 'Woman Information',
name: 'Name',
age: 'Age',
department: 'Department',
skills: 'Skills',
experience: 'Experience',
years: 'years',
phone: 'Phone',
email: 'Email',
contractInformation: 'Contract Information',
terminationDetails: 'Termination Details',
terminatedOn: 'Terminated on',
renewalInformation: 'Renewal Information',
renewedFrom: 'Renewed from',
renewedTo: 'Renewed to',
notes: 'Notes',
close: 'Close',
expired: 'Expired',
active: 'Active',
searchContracts: 'Search contracts...',
refresh: 'Refresh',
viewAll: 'View All',
exportList: 'Export List',
exportSuccessful: 'Export completed successfully',
exportFailed: 'Export failed. Please try again.',
exportingContracts: 'Exporting contracts...',
    exportOptions: 'Export Options',
exportAsCSV: 'Export as CSV',
exportAsExcel: 'Export as Excel',
exportAsPDF: 'Export as PDF',
exportSuccessful: 'Export completed successfully',
exportFailed: 'Export failed. Please try again.',
exportingContracts: 'Exporting contracts...',
    successfullyAssignedWomenWithEmail:'Successfull Assigned Women With Email',
    amountBreakdown: '{employees} × 10,000 RWF',
contractDuration: '{months} months',
pricePerEmployee: '10,000 RWF per employee',
contractDoesNotAffectPrice: 'Contract duration does not affect price',

enterEmailAddress: 'Please enter your email address',
resetEmailSent: 'Password reset email sent. Please check your inbox.',
resetRequestFailed: 'Failed to process reset request. Please try again.',
forgotPasswordDescription: 'Enter your email to reset your password',
backToLogin: 'Back to Login',
sendResetLink: 'Send Reset Link',
sending: 'Sending...',
resetInstructions: 'You\'ll receive an email with a link to reset your password. The link will expire in 1 hour.',
amountNote: 'Fixed amount of 10,000 RWF per woman, regardless of contract duration',

// New keys
contractPeriod: 'Contract Period',
selectContractPeriod: 'Select contract period',
requiredSkills: 'Required Competence Skills',
selectRelevantSkills: 'Select relevant skills required for this position',
contractExpiring: 'Contract Expiring Soon',
daysRemaining: 'days remaining',
viewAllContracts: 'View All Contracts',
importWomenProfiles: 'Import Women Profiles',
uploadCSVFile: 'Upload CSV File',
csvTemplateInstructions: 'CSV should have columns: name, age, department, skills, experience_years, education_level, phone, email, location, bio, skill_names',
importInstructions: 'Download template to ensure correct format',
downloadTemplate: 'Download Template',
importing: 'Importing...',
import: 'Import',
importProfiles: 'Import Profiles',
cannotAssignDifferentDept: 'Cannot assign women from different departments',
validationFailed: 'Validation failed',
viewCertificate: 'View Certificate',
certified: 'Certified',
certificatePending: 'Certificate Pending',
requestThisWoman: 'Request this woman',
currentlyEmployed: 'Currently Employed',
noSkillsForDepartment: 'No skills available for this department',
expiringContracts: 'Expiring Contracts',
showContractsExpiringIn: 'Show contracts expiring in:',
noExpiringContracts: 'No Expiring Contracts',
noContractsExpiringSoon: 'No contracts are expiring soon',
daysLeft: 'days left',
sendReminder: 'Send reminder',
renewContract: 'Renew contract',
contractRenewed: 'Contract renewed successfully',
months: 'months',
sendCustomEmail: 'Send Custom Email',
emailRecipients: 'Email Recipients',
enterEmailRecipients: 'Enter email addresses (comma-separated)',
commaSeparatedEmails: 'Enter multiple email addresses separated by commas',
customEmailDescription: 'Send emails to any email addresses (not limited to system users)',
allFieldsRequired: 'All fields are required',
invalidEmails: 'Invalid email addresses',
emailSentSuccessfully: 'Email sent successfully to recipients',
failedToSendEmail: 'Failed to send email',
customEmail: 'Custom Email',
attachments: 'Attachments',
maxFileSize: 'Maximum file size',
manageAllContracts:'Manage All Contracts',

// Contract periods
'3 months': '3 months',
'6 months': '6 months',
'1 year': '1 year',
'2 years': '2 years',
'3 years': '3 years',

// Skill proficiency levels
beginner: 'Beginner',
intermediate: 'Intermediate',
advanced: 'Advanced',
expert: 'Expert',

contractExpiration: 'Contract Expiration',
showContractsExpiringIn: 'Show contracts expiring in',
days: 'days',
refresh: 'Refresh',
manageAllContracts: 'Manage All Contracts',
activeContracts: 'Active Contracts',
expiringThisMonth: 'Expiring This Month',
renewedThisMonth: 'Renewed This Month',
expiringNextMonth: 'Expiring Next Month',
noExpiringContracts: 'No Expiring Contracts',
noContractsExpiringSoon: 'No contracts are expiring within the selected period.',
contractsExpiringInNext: 'contracts expiring in the next',
woman: 'Woman',
department: 'Department',
contractPeriod: 'Contract Period',
startDate: 'Start Date',
endDate: 'End Date',
daysRemaining: 'Days Remaining',
employer: 'Employer',
contact: 'Contact',
actions: 'Actions',
noPhone: 'No phone',
general: 'General',
months: 'months',
sendEmail: 'Send Email',
call: 'Call',
viewDetails: 'View Details',
sendReminder: 'Send Reminder',
extendContract: 'Extend Contract',
exportExpiringContracts: 'Export List',

// Additional export-related translations
exportContracts: 'Export Contracts',
exportAsCSV: 'Export as CSV',
exportAsExcel: 'Export as Excel',
exportAsPDF: 'Export as PDF',
exportingContracts: 'Exporting contracts...',
exportSuccessful: 'Export completed successfully',
exportFailed: 'Export failed. Please try again.',
downloadExportedFile: 'Download Exported File',
selectExportFormat: 'Select Export Format',
includeInactiveContracts: 'Include inactive contracts',
exportAllContracts: 'Export All Contracts',
exportFilteredContracts: 'Export Filtered Contracts',
contractExportTitle: 'Contracts Export',
generatingExport: 'Generating export file...',
contractList: 'Contract List',
totalContracts: 'Total Contracts',
exportDate: 'Export Date',
exportedBy: 'Exported By',
contractDetails: 'Contract Details',
womanName: 'Woman Name',
employerName: 'Employer Name',
employerEmail: 'Employer Email',
employerPhone: 'Employer Phone',
contractStart: 'Contract Start',
contractEnd: 'Contract End',
contractMonths: 'Contract Months',
status: 'Status',
active: 'Active',
expired: 'Expired',
expiringSoon: 'Expiring Soon',
critical: 'Critical',
warning: 'Warning',
good: 'Good',
exportSummary: 'Export Summary',
rowsExported: 'rows exported',
exportTime: 'Export Time',

// Additional missing translations from the code
contractStats: 'Contract Statistics',
fetchingContracts: 'Fetching contracts...',
noContractsFound: 'No contracts found',
viewContract: 'View Contract',
contractId: 'Contract ID',
contractStatus: 'Contract Status',
renewContract: 'Renew Contract',
contractRenewed: 'Contract renewed successfully',
renewalDate: 'Renewal Date',
previousContract: 'Previous Contract',
nextContract: 'Next Contract',
contractHistory: 'Contract History',
renewalHistory: 'Renewal History',
confirmRenewContract: 'Are you sure you want to renew this contract?',
enterRenewalMonths: 'Enter number of months for renewal',
renewalPeriod: 'Renewal Period',
newEndDate: 'New End Date',
contractNotes: 'Contract Notes',
addContractNote: 'Add Note',
viewAllContracts: 'View All Contracts',
filterContracts: 'Filter Contracts',
searchContracts: 'Search contracts...',
clearFilters: 'Clear Filters',
applyFilters: 'Apply Filters',

  partnersDescription:'Partners Description',
    // Privacy Policy
  privacyPolicy: 'Privacy Policy',

  lastUpdated: 'Last Updated',
  privacyIntroTitle: 'Introduction',
  privacyIntroText: 'Urugo Women Opportunity Center values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information.',
  informationWeCollect: 'Information We Collect',
  personalInformation: 'Personal Information',
  infoNameEmail: 'Name and email address',
  infoPhoneAddress: 'Phone number and physical address',
  infoPaymentDetails: 'Payment information for donations',
  infoEmploymentHistory: 'Employment history and skills information',
  usageData: 'Usage Data',
  dataIPAddress: 'IP address and browser type',
  dataBrowserType: 'Device information',
  dataPagesVisited: 'Pages visited and time spent',
  dataTimeSpent: 'Referring website information',
  howWeUseInformation: 'How We Use Your Information',
  useProvideServices: 'To provide and maintain our services',
  useProcessDonations: 'To process donations and payments',
  useMatchEmployees: 'To match women with employment opportunities',
  useCommunication: 'To communicate with you',
  useImproveServices: 'To improve our services and website',
  useLegalCompliance: 'To comply with legal obligations',
  informationSharing: 'Information Sharing',
  sharingIntro: 'We do not sell your personal information. We only share information in the following circumstances:',
  withEmployers: 'With Employers',
  sharingEmployers: 'Only with your consent for job matching',
  withServiceProviders: 'With Service Providers',
  sharingProviders: 'Trusted partners who assist our operations',
  legalRequirements: 'Legal Requirements',
  sharingLegal: 'When required by law or legal process',
  withConsent: 'With Your Consent',
  sharingConsent: 'When you explicitly give us permission',
  dataSecurity: 'Data Security',
  securityMeasures: 'We implement appropriate security measures to protect your information.',
  securityEncryption: 'SSL encryption for data transmission',
  securityAccessControl: 'Access controls and authentication',
  securityRegularAudits: 'Regular security audits',
  securityTraining: 'Staff privacy training',
  yourRights: 'Your Rights',
  rightAccess: 'Right to access your personal data',
  rightCorrection: 'Right to correct inaccurate data',
  rightDeletion: 'Right to delete your data',
  rightObject: 'Right to object to processing',
  rightDataPortability: 'Right to data portability',
  rightWithdrawConsent: 'Right to withdraw consent',
  cookies: 'Cookies',
  cookiesDescription: 'We use cookies to improve your experience on our website.',
  essentialCookies: 'Essential Cookies',
  essentialCookiesDesc: 'Required for basic site functionality',
  analyticsCookies: 'Analytics Cookies',
  analyticsCookiesDesc: 'Help us understand how visitors use our site',
  preferenceCookies: 'Preference Cookies',
  preferenceCookiesDesc: 'Remember your settings and preferences',
  childrenPrivacy: "Children's Privacy",
  childrenPrivacyText: 'Our services are not directed to children under 18.',
  changesToPolicy: 'Changes to This Privacy Policy',
  policyChangesText: 'We may update our Privacy Policy periodically.',
  contactUsPrivacy: 'Contact Us',
  contactPrivacyText: 'If you have questions about this Privacy Policy, contact us at:',
  
  // Terms of Service
  termsOfService: 'Terms of Service',
  termsAgreement: 'Agreement to Terms',
  termsAgreementText: 'By accessing and using our platform, you agree to these Terms of Service.',
  definitions: 'Definitions',
  platform: 'Platform',
  platformDefinition: 'Urugo WOC Website',
  services: 'Services',
  servicesDefinition: 'Employment matching, training, and donation services',
  user: 'User',
  userDefinition: 'Anyone accessing or using the platform',
  employer: 'Employer',
  employerDefinition: 'Individuals or companies seeking to hire',
  employee: 'Employee',
  employeeDefinition: 'Women seeking employment opportunities',
  donor: 'Donor',
  donorDefinition: 'Individuals or organizations making donations',
  accountRegistration: 'Account Registration',
  accountRegistrationText: 'To use certain features, you must register for an account.',
  accountAgeRequirement: 'You must be at least 18 years old',
  accountAccurateInfo: 'Provide accurate and complete information',
  accountSecurity: 'Maintain account security',
  accountTransfer: 'Do not transfer your account to others',
  servicesDescription: 'Services Description',
  employmentServices: 'Employment Services',
  employmentMatch: 'Matching qualified women with employers',
  employmentVerification: 'Verification of skills and qualifications',
  employmentTraining: 'Training and skill development',
  employmentSupport: 'Ongoing employment support',
  donationServices: 'Donation Services',
  donationProcessing: 'Processing of monetary donations',
  donationTracking: 'Tracking donation impact',
  donationReporting: 'Regular impact reporting',
  donationTransparency: 'Transparent fund allocation',
  userObligations: 'User Obligations',
  generalUserObligations: 'General User Obligations',
  obeyLaws: 'Obey all applicable laws and regulations',
  respectOthers: 'Respect other users and their privacy',
  noFraud: 'Do not engage in fraudulent activities',
  accurateInfo: 'Provide accurate information',
  noHarassment: 'Do not harass or discriminate',
  employerObligations: 'Employer Obligations',
  fairTreatment: 'Provide fair employment terms',
  timelyPayment: 'Make timely payments',
  safeEnvironment: 'Provide a safe working environment',
  complianceLaws: 'Comply with employment laws',
  employeeObligations: 'Employee Obligations',
  professionalConduct: 'Maintain professional conduct',
  honestSkills: 'Honestly represent skills and availability',
  commitment: 'Fulfill employment commitments',
  respectEmployer: 'Respect employer property and rules',
  paymentsFees: 'Payments and Fees',
  serviceFees: 'Service fees may apply for certain services',
  donationFees: 'Donation processing fees',
  paymentMethods: 'Accepted payment methods',
  refundPolicy: 'Refund policy for donations',
  taxResponsibility: 'Tax responsibilities',
  intellectualProperty: 'Intellectual Property',
  ipOwnership: 'We own all intellectual property rights to the platform.',
  ipLicense: 'We grant you a limited license to use the platform.',
  userContentLicense: 'You grant us a license to use your content for platform operations.',
  limitationLiability: 'Limitation of Liability',
  liabilityDisclaimer: 'We provide services "as is" without warranties.',
  liabilityLimit: 'Limitation of our liability',
  liabilityForceMajeure: 'Force majeure events',
  termination: 'Termination',
  terminationClause: 'We may terminate or suspend access to your account.',
  terminationBreach: 'For breach of these terms',
  terminationInactivity: 'For prolonged inactivity',
  terminationRequest: 'At your request',
  terminationPlatform: 'For platform maintenance or security',
  disputeResolution: 'Dispute Resolution',
  governingLaw: 'Governing law jurisdiction',
  disputeProcess: 'Dispute resolution process',
  mediationClause: 'Mediation before litigation',
  changesToTerms: 'Changes to Terms',
  termsChangesText: 'We may modify these terms at any time.',
  contactUsTerms: 'Contact Us',
  contactTermsText: 'For questions about these terms, contact us at:',
  
  // Sitemap
  sitemap: 'Sitemap',
  sitemapDescription: 'Complete overview of all pages and services available on Urugo WOC',
  mainPages: 'Main Pages',
  accountPages: 'Account Pages',
  policyPages: 'Policy Pages',
  servicePages: 'Service Pages',
  departmentPages: 'Department Pages',
  trainingServices: 'Training Services',
  donationServices: 'Donation Services',
  supportServices: 'Support Services',
  contactInformation: 'Contact Information',
  quickActions: 'Quick Actions',
  donateNow: 'Donate Now',
  registerNow: 'Register Now',
  totalPages: 'Total Pages',
  websiteVersion: 'Website Version',
  viewPrivacy: 'View Privacy Policy',
  viewTerms: 'View Terms of Service',
  viewSitemap: 'View Sitemap',
  backToHome: 'Back to Home',
     // Modal Alert translations
  alertSuccess: 'Success',
  alertError: 'Error',
  alertWarning: 'Warning',
  alertInfo: 'Information',
  okButton: 'OK',
  confirmButton: 'Confirm',
  cancelButton: 'Cancel',
  tryAgainButton: 'Try Again',
  close: 'Close',
  
  // Request Modal translations
  step1Title: 'Tell us about you',
  step1Description: 'Find trained women in our diverse community',
  step2Title: 'Create Your Account',
  step2Description: 'Join our community to hire skilled women',
  loginTitle: 'Login to Your Account',
  loginDescription: 'Already have an account? Sign in to continue',
  step3Title: 'Request Trained Women',
  step3Description: 'Fill out the form below to request skilled women from our center',
  successTitle: 'Request Submitted Successfully!',
  successMessage: 'Your request has been received. We will contact you shortly.',
  
  // Account types
  individual: 'Individual',
  individualDesc: 'I\'m hiring for myself',
  company: 'Company',
  companyDesc: 'I\'m hiring for my company',
  
  // Form labels
  companyNameLabel: 'Company name',
  companyNamePlaceholder: 'Enter company name',
  fullNameLabel: 'Full Name',
  fullNamePlaceholder: 'Enter your full name',
  usernameLabel: 'Username',
  usernamePlaceholder: 'Choose a username',
  workEmailLabel: 'Work email',
  workEmailPlaceholder: 'Enter your work email',
  phoneLabel: 'Phone Number',
  phonePlaceholder: 'Enter your phone number',
  emailLabel: 'Email Address',
  emailPlaceholder: 'Enter your email',
  passwordLabel: 'Password',
  passwordPlaceholder: 'Enter your password',
  createPasswordPlaceholder: 'Create a password',
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordPlaceholder: 'Confirm your password',
  passwordMinLength: 'At least 10 characters',
  agreeToTerms: 'I agree to the Terms of Service and Privacy Policy',
  
  // Request form
  selectDepartment: 'Select Department',
  chooseDepartment: 'Choose a department',
  employeesNeeded: 'Number of Employees',
  costPerEmployee: '10,000 RWF per employee per month',
  workType: 'Work Type',
  fullTime: 'Full Time',
  partTime: 'Part Time',
  contract: 'Contract',
  seasonal: 'Seasonal',
  duration: 'Duration (Days)',
  days: 'days',
  totalAmount: 'Total Amount',
  woman: 'woman',
  'employee(s)': 'employee(s)',
  personalInformation: 'Personal Information',
  yourFullName: 'Your Full Name',
  email: 'Email',
  phoneNumber: 'Phone Number',
  
  // Specifications
  womanSpecifications: 'Woman Specifications (Optional)',
  specificationsDescription: 'Provide additional requirements for the women you want to hire',
  ageRange: 'Preferred Age Range',
  experienceLevel: 'Experience Level',
  skillLevel: 'Skill Level Required',
  educationLevel: 'Education Level',
  languageRequirements: 'Language Requirements',
  specialSkills: 'Special Skills Needed',
  otherSpecifications: 'Other Specifications',
  noPreference: 'No preference',
  years: 'years',
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  expert: 'Expert',
  basic: 'Basic Skills',
  kinyarwanda: 'Kinyarwanda',
  french: 'French',
  kinyarwandaEnglish: 'Kinyarwanda & English',
  anyLanguage: 'Any language',
  primary: 'Primary Education',
  secondary: 'Secondary Education',
  vocational: 'Vocational Training',
  university: 'University Degree',
  specialSkillsPlaceholder: 'e.g., Computer skills, leadership, etc.',
  separateWithCommas: 'Separate with commas',
  otherSpecificationsPlaceholder: 'Any other specific requirements or preferences...',
  
  // Payment
  paymentInformation: 'Payment Information',
  mobileMoney: 'Mobile Money',
  bankAccount: 'Bank Account',
  paymentNote: 'Please complete the payment after submitting your request. Your request will be processed once payment is verified.',
  
  // Buttons and actions
  continue: 'Continue',
  back: 'Back',
  backToRegister: 'Back to Register',
  join: 'Join',
  loggingIn: 'Logging in...',
  creatingAccount: 'Creating Account...',
  submitting: 'Submitting...',
  submitRequest: 'Submit Request',
  alreadyHaveAccount: 'Already have an account?',
  loginHere: 'Login here',
  signIn: 'Login',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  
  // Status messages
  available: 'Available',
  working: 'Working',
  certificateVerified: 'Verified',
  certificateUnverified: 'Pending',
  specificWomanRequest: 'You are requesting',
  specifically: 'specifically',
  singleWomanNote: 'Number of employees is automatically set to 1 for individual woman requests.',
  requestingWoman: 'You are requesting:',
  youRequested: 'You requested:',
  yourSpecifications: 'Your Specifications:',
  languages: 'Languages',
  
  // Error messages
  passwordMismatch: 'Passwords do not match',
  passwordTooShort: 'Password must be at least 10 characters long',
  registrationFailed: 'Registration failed',
  loginFailed: 'Login failed',
  requestFailed: 'Failed to submit request',
  loginToRequest: 'Please login to request women',
  
  // Success messages
  loginSuccess: 'You have successfully logged in to your account.',
  registrationSuccess: 'Your account has been created successfully!',
  requestSuccess: 'Your request has been submitted successfully!',
  
  // Step labels
  accountType: 'Account Type',
  account: 'Account',
  request: 'Request',
    // Register Modal translations
    registerCreateAccount: 'Create Account',
    registerDescription: 'Join Urugo WOC to start hiring trained women',
    fullNameLabel: 'Full Name *',
    fullNamePlaceholder: 'Enter your full name',
    usernameLabel: 'Username *',
    usernamePlaceholder: 'Choose a username',
    emailLabel: 'Email Address *',
    emailPlaceholder: 'Enter your email',
    phoneLabel: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    passwordLabel: 'Password *',
    passwordPlaceholder: 'Create a password',
    confirmPasswordLabel: 'Confirm Password *',
    confirmPasswordPlaceholder: 'Confirm your password',
    passwordStrength: 'Strength',
    passwordVeryWeak: 'Very weak',
    passwordWeak: 'Weak',
    passwordFair: 'Fair',
    passwordGood: 'Good',
    passwordStrong: 'Strong',
    userTypeTitle: 'I am registering as:',
    userTypeEmployer: 'Employer',
    userTypeEmployerDesc: 'Hire trained women',
    creatingAccount: 'Creating account...',
    createAccount: 'Create Account',
    registerErrorGeneric: 'Registration failed. Please try again.',
    registerErrorPasswordMatch: 'Passwords do not match',
    registerErrorPasswordWeak: 'Please use a stronger password',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign in',
    // Donate Modal translations
    donateTitle: 'Support Our Women',
    donateDescription: 'Your donation helps train more women and create sustainable livelihoods',
    quickSelectAmount: 'Quick Select Amount (RWF):',
    donationAmountLabel: 'Donation Amount (RWF) *',
    donationAmountPlaceholder: 'Enter amount',
    donorNameLabel: 'Your Name *',
    donorNamePlaceholder: 'Enter your name',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter your email',
    phoneLabel: 'Phone',
    phonePlaceholder: 'Enter your phone number',
    messageLabel: 'Message (Optional)',
    messagePlaceholder: 'Add a message of encouragement...',
    donationInfo1: '💝 100% of your donation goes directly to training programs',
    donationInfo2: '🌍 Your contribution transforms lives and communities',
    donationInfo3: '🌍 Mobile Money: *182*8*1*270591#',
    donationInfo4: '🏦 Bank Name: Bank of Kigali',
    donationInfo5: '👤 Account Name: WFW1 Empowerment Center LLC / Urugo Women\'s Opportunity Center',
    donationInfo6: '💰 RWF Account: 00059-06929965-20',
    donationInfo7: '💵 USD Account: 00059-06929966-21',
    cancelButton: 'Cancel',
    processingButton: 'Processing...',
    makeDonationButton: 'Make Donation',
    successTitle: 'Thank You for Your Generous Donation!',
    successMessage: 'Your support makes a difference in women\'s lives.',
    errorMessage: 'Error processing donation. Please try again.',
     // Login Modal translations
     close: 'Close',
     loginWelcome: 'Welcome Back',
     loginDescription: 'Sign in to your account to continue',
     emailPlaceholder: 'Email address',
     passwordPlaceholder: 'Password',
     showPassword: 'Show password',
     hidePassword: 'Hide password',
     rememberMe: 'Remember me',
     forgotPassword: 'Forgot password?',
     signingIn: 'Signing in...',
     signIn: 'Sign In',
     noAccount: "Don't have an account?",
     signUp: 'Sign up',
     loginErrorGeneric: 'Login failed. Please check your credentials.',

          // ===== Passwordless Auth Flow (Employer email-only login) =====
     loginEmailOnlyHint: 'Enter your email to continue',
     loginStaffHint: 'Staff login — please enter your password',
     loggingInEmployer: 'Logging you in...',
     checking: 'Checking...',
     change: 'Change',
     invalidEmail: 'Please enter a valid email address',
     noAccountFound: 'No account found with this email. Please register first.',
     unknownUserType: 'Unknown user type. Please contact support.',
     emailLoginHint: "We'll look up your account by email. No password needed.",
     loginDescriptionEmailOnly: 'Enter your email to continue — no password needed',
     registerDescriptionNoPassword: 'Just enter your details — no password required',
     step2DescriptionNoPassword: 'Just enter your email — no password required',
     loginSuccessMessage: 'You are now logged in!',
    // Footer & Chat Bot Translations
  chatWelcome: "Hello! Welcome to Urugo Women Opportunity Center. How can I assist you today?",
  justNow: "Just now",
  chatQuestionHire: "How can I hire trained women?",
  chatQuestionDonate: "How can I donate to support women?",
  chatQuestionTraining: "How do I apply for training?",
  chatQuestionContact: "How can I contact you?",
  chatKeywordHire: "hire",
  chatResponseHire: "You can hire our trained women by creating an employer account on our portal. Visit the 'Hire Talent' section to view available women profiles and submit your hiring request. Trained women are ready for employment in various departments including coffee shop operation, housekeeping, sewing, and more.",
  chatKeywordEmployer: "employer",
  chatResponseEmployer: "As an employer, you can register on our portal to access skilled women profiles. We provide pre-screened, trained women ready for employment. You can submit specific requirements and we'll match you with suitable candidates.",
  chatKeywordRequest: "request",
  chatResponseRequest: "To request trained women, please login to your employer account and fill out the hiring request form. Specify the number of women needed, required skills, and employment duration. Our team will contact you within 24 hours.",
  chatKeywordDonate: "donate",
  chatResponseDonate: "Thank you for your interest in donating! You can donate online through our secure portal, via bank transfer, or by visiting our center. Your donations help train more women and provide them with employment opportunities.",
  chatKeywordSupport: "support",
  chatResponseSupport: "You can support us by donating, becoming a corporate sponsor, volunteering, or partnering with us. Contact our development team at info@urugowoc.com for more information.",
  chatKeywordTraining: "training",
  chatResponseTraining: "We offer vocational training in 7 departments. To apply, visit our center in Kayonza or apply online through our website. Training programs are free for eligible women and include certification upon completion.",
  chatKeywordApply: "apply",
  chatResponseApply: "To apply for training, visit our website and fill out the application form. You'll need to provide personal information and indicate which department you're interested in. Our team will contact you for an interview.",
  chatKeywordLogin: "login",
  chatResponseLogin: "To login, click the 'Login' button in the top navigation. Employers, trainees, and administrators have separate login portals. If you don't have an account, you can register from the login page.",
  chatKeywordRegister: "register",
  chatResponseRegister: "Registration is open for employers, women seeking training, and volunteers. Click 'Register' on the login page and select your user type. Fill in your details and our team will verify your account.",
  chatKeywordAbout: "about",
  chatResponseAbout: "Urugo Women Opportunity Center was established to empower women through vocational training and employment. We have trained over 600 women since 2013. Visit our About Us page to learn more about our mission, vision, and impact.",
  chatKeywordGallery: "gallery",
  chatResponseGallery: "Our Gallery showcases women in training, graduation ceremonies, and successful employment stories. You can see photos from all 7 training departments and witness the transformation happening at our center.",
  chatKeywordDepartments: "departments",
  chatResponseDepartments: "We have 7 training departments: 1) Coffee Shop Operation, 2) Housekeeping, 3) Reception, 4) Sewing, 5) Leather work, 6) Carpet making, and 7) Milk & Yogurt Production. Each program includes practical training and certification.",
  chatKeywordContact: "contact",
  chatResponseContact: "You can contact us via email at info@urugowoc.com, call +250788350577, visit our center in Kayonza, or use this chat bot. Our team is available Monday-Friday, 8AM-5PM.",
  chatKeywordLocation: "location",
  chatResponseLocation: "We are located in Kayonza, Rwanda. You can find us at Urugo Women Opportunity Center, Kayonza District. Visit us to see our training facilities and meet our team.",
  chatResponseDefault: "Thank you for your question! For more specific information, please contact us directly at info@urugowoc.com or call +250788350577.",
  chatTitle: "Urugo WOC Assistant",
  close: "Close",
  chatQuickQuestions: "Quick Questions",
  chatPlaceholder: "Type your message here...",
  send: "Send",
  chatToggleTooltip: "Chat with us",
  whatsappDefaultMessage: "Hello Urugo WOC, I have a question about hiring trained women/donating/training...",
  whatsappTooltip: "Chat with us on WhatsApp",
  footerTitle: "WfWI/Urugo WOC",
  footerDescription: "Empowering women through skills training and employment opportunities since 2013. Transforming communities by creating sustainable livelihoods.",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  youtube: "YouTube",
  whatsapp: "WhatsApp",
  quickLinks: "Quick Links",
  home: "Home",
  about: "About Us",
  departments: "Departments",
  women: "Our Women",
  gallery: "Gallery",
  donate: "Donate",
  hire: "Hire",
  login: "Login",
  contactInfo: "Contact Info",
  location: "Kayonza, Rwanda",
  phoneNumber: "+250 788350577",
  email: "info@urugowoc.com",
  hireWomen: "Hire Trained Women",
  donateNow: "Donate Now",
  loginRegister: "Login/Register",
  ourDepartments: "Our Departments",
  coffeeShopOperation: "Coffee Shop Operation",
  housekeepingOperation: "Housekeeping Operation",
  receptionOperation: "Reception Operation",
  sewingOperation: "Sewing Operation",
  leatherOperation: "Leather Operation",
  carpetOperation: "Carpet Operation",
  milkYogurtProduction: "Milk & Yogurt Production",
  copyright: "Urugo Women Opportunity Center. All rights reserved.",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  sitemap: "Sitemap",

departments: 'Departments',
departmentsManagement: 'Departments Management',
addDepartment: 'Add Department',
editDepartment: 'Edit Department',
departmentAdded: 'Department added successfully',
departmentUpdated: 'Department updated successfully',
departmentDeleted: 'Department deleted successfully',
departmentStatusToggled: 'Department status updated',
confirmDeleteDepartment: 'Are you sure you want to delete this department?',
activityImages: 'Activity Images',
activityImagesManagement: 'Activity Images Management',
addActivityImage: 'Add Activity Image',
editActivityImage: 'Edit Activity Image',
activityImageAdded: 'Activity image added',
activityImageUpdated: 'Activity image updated',
activityImageDeleted: 'Activity image deleted',
activityImageStatusToggled: 'Activity image status updated',
confirmDeleteActivityImage: 'Are you sure you want to delete this image?',
searchActivityImages: 'Search activity images...',

  // Partners Management
  partners: 'Partners & Sponsors',
  partnersManagement: 'Partners Management',
  addPartner: 'Add Partner',
  editPartner: 'Edit Partner',
  partnerName: 'Partner Name',
  partnerType: 'Partner Type',
  partnerLogo: 'Partner Logo',
  websiteUrl: 'Website URL',
  sortOrder: 'Sort Order',
  enterPartnerName: 'Enter partner/organization name',
  selectType: 'Select partner type',
  enterPartnerDescription: 'Enter partner description',
  currentLogo: 'Current logo',
  updatePartner: 'Update Partner',
  failedAddPartner: 'Failed to add partner',
  failedUpdatePartner: 'Failed to update partner',
  failedDeletePartner: 'Failed to delete partner',
  failedLoadPartners: 'Failed to load partners',
  failedTogglePartnerStatus: 'Failed to toggle partner status',
  partnerAdded: 'Partner added successfully',
  partnerUpdated: 'Partner updated successfully',
  partnerDeleted: 'Partner deleted successfully',
  partnerStatusToggled: 'Partner status updated successfully',
  confirmDeletePartnerTitle: 'Delete Partner',
  confirmDeletePartner: 'Are you sure you want to delete this partner? This action cannot be undone.',
  searchPartners: 'Search partners...',
  allTypes: 'All Types',
  noPartnersFound: 'No partners found',
  noPartnersMatchCriteria: 'No partners match your filter criteria',
  showingPartners: 'Showing {showing} of {total} partners',
  deactivate: 'Deactivate',
  activate: 'Activate',
  visit: 'Visit',
  noDescription: 'No description',
  partnerDescriptionDefault: 'Partner organization',
  visitWebsite: 'Visit Website',
  government: 'Government',
  internationalNGO: 'International NGO',
  localNGO: 'Local NGO',
  corporate: 'Corporate',
  private: 'Private',
  educational: 'Educational',
  other: 'Other',
  partnersCount: 'Partners count',
  activePartners: 'Active Partners',
  inactivePartners: 'Inactive Partners',
  partnerStats: 'Partner Statistics',
  exportPartners: 'Export Partners',
  importPartners: 'Import Partners',
  partnerDetails: 'Partner Details',
  establishedDate: 'Established',
  lastUpdated: 'Last Updated',
  // English translations
  whyChooseUs: "Why Choose Us",
  expiringContracts: 'Expiring Contracts',
  showContractsExpiringIn: 'Show contracts expiring in',
  days: 'days',
  noExpiringContracts: 'No Expiring Contracts',
  noContractsExpiringSoon: 'No contracts are expiring within the selected period.',
  contractPeriod: 'Contract Period',
  startDate: 'Start Date',
  endDate: 'End Date',
  daysRemaining: 'Days Remaining',
  daysLeft: 'days left',
  sendReminder: 'Send Reminder',
  renewContract: 'Renew Contract',
  sendContractReminder: 'Send Contract Reminder',
  confirmSendReminder: 'Send contract expiration reminder for {{woman}} to {{employer}}? {{days}} days remaining.',
  reminderSent: 'Reminder sent successfully!',
  failedSendReminder: 'Failed to send reminder',
  enterRenewalMonths: 'Enter number of months to renew contract:',
  contractRenewed: 'Contract renewed successfully!',
  failedRenewContract: 'Failed to renew contract',
  default: 'Default',
  events: 'Events & Updates',
  stayUpdated: 'Stay informed about our latest activities and upcoming events',
  latestUpdates: 'Latest Updates',
  upcomingEvents: 'Upcoming Events',
  noEvents: 'No events to display',
  readMore: 'Click to read more',
    events: 'Events',
    eventsManagement: 'Events Management',
    addEvent: 'Add Event',
    editEvent: 'Edit Event',
    eventDate: 'Event Date',
    eventImage: 'Event Image',
    organizer: 'Organizer',
    enterEventTitle: 'Enter event title',
    enterEventDescription: 'Enter event description',
    searchEvents: 'Search events...',
    allEvents: 'All Events',
    noEventsFound: 'No events found',
    noEventsMatchCriteria: 'No events match your filter criteria',
    showingEvents: 'Showing {showing} of {total} events',
    eventAdded: 'Event added successfully',
    eventUpdated: 'Event updated successfully',
    eventDeleted: 'Event deleted successfully',
    eventStatusToggled: 'Event status updated',
    confirmDeleteEventTitle: 'Delete Event',
    confirmDeleteEvent: 'Are you sure you want to delete this event?',
    failedLoadEvents: 'Failed to load events',
    failedAddEvent: 'Failed to add event',
    failedUpdateEvent: 'Failed to update event',
    failedDeleteEvent: 'Failed to delete event',
    failedToggleEventStatus: 'Failed to update event status',
    // Manager Dashboard Translations
    dashboard: "Dashboard",
    requests: "Requests",
    women: "Women",
    users: "Users",
    donations: "Donations",
    gallery: "Gallery",
    about: "About",
    reports: "Reports",
    settings: "Settings",
    manager: "Manager",
    totalUsers: "Total Users",
    totalRequests: "Total Requests",
    totalRevenue: "Total Revenue",
    activeWomen: "Active Women",
    recentActivity: "Recent Activity",
    totalWomen: "Total Women",
    employerCount: "Employers",
    newThisMonth: "New This Month",
    activeToday: "Active Today",
    pendingRequests: "Pending Requests",
    approvedRequests: "Approved Requests",
    rejectedRequests: "Rejected Requests",
    loadingDashboard: "Loading dashboard...",
    failedLoadDashboard: "Failed to load dashboard data",
    justNow: "Just now",
    notificationPendingRequests: "You have pending request(s)",
    newUsersThisWeek: "new users this week",
    newDonations: "new donations",
    failedLoadEmployerDetails: "Failed to load employer details",
    selectWomenToAssign: "Please select women to assign first",
    selectRequestEmployer: "Please select a request/employer",
    noWomenSelected: "No women selected",
    successfullyAssignedWomen: "Successfully assigned women to {employer}",
    failedToAssignWomen: "Failed to assign women",
    failedLoadWomenProfiles: "Failed to load women profiles",
    accessDenied: "Access denied. Please login again.",
    requestStatusUpdated: "Request status updated to {status}",
    failedUpdateRequest: "Failed to update request",
    userStatusUpdated: "User {status} successfully",
    suspended: "suspended",
    activated: "activated",
    failedUpdateUser: "Failed to update user",
    confirmDeleteUser: "Are you sure you want to delete this user?",
    userDeleted: "User deleted successfully",
    failedDeleteUser: "Failed to delete user",
    profileAvailabilityUpdated: "Profile availability updated to {status}",
    available: "Available",
    hired: "Hired",
    failedUpdateProfile: "Failed to update profile",
    confirmDeleteProfile: "Are you sure you want to delete this profile?",
    profileDeleted: "Profile deleted successfully",
    failedDeleteProfile: "Failed to delete profile",
    profileAdded: "Profile added successfully",
    failedAddProfile: "Failed to add profile",
    profileUpdated: "Profile updated successfully",
    exportSuccessful: "Export successful! File downloaded",
    failedExportData: "Failed to export data",
    searchRequests: "Search requests...",
    clearFilters: "Clear Filters",
    filterBy: "Filter by",
    allStatus: "All Status",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancelled",
    to: "to",
    exportRequests: "Export Requests",
    noRequestsFound: "No Requests Found",
    noRequestsMatch: "No requests match your criteria",
    noRequestsAvailable: "No requests available",
    showingRequests: "Showing request(s)",
    id: "ID",
    date: "Date",
    employer: "Employer",
    department: "Department",
    employees: "Employees",
    duration: "Duration",
    amount: "Amount",
    status: "Status",
    actions: "Actions",
    days: "days",
    n_a: "N/A",
    viewRequest: "View Request",
    approveRequest: "Approve Request",
    rejectRequest: "Reject Request",
    womenProfilesManagement: "Women Profiles Management",
    searchWomen: "Search women...",
    assignSelected: "Assign Selected",
    addNewProfile: "Add New Profile",
    allDepartments: "All Departments",
    clearFilters: "Clear Filters",
    womenSelectedForAssignment: "women selected for assignment",
    selected: "selected",
    assignSelectedWomen: "Assign Selected Women",
    noWomenProfilesFound: "No Women Profiles Found",
    noProfilesMatchCriteria: "No profiles match your criteria",
    showingProfiles: "Showing {showing} of {total} profiles",
    previous: "Previous",
    pageInfo: "Page {page} of {pages}",
    next: "Next",
    selectAllAvailable: "Select all available women",
    photo: "Photo",
    name: "Name",
    age: "Age",
    skills: "Skills",
    experience: "Experience",
    phone: "Phone",
    years: "years",
    womanNotAvailable: "This woman is not available",
    selectForAssignment: "Select for assignment",
    editProfile: "Edit Profile",
    markAsHired: "Mark as Hired",
    markAsAvailable: "Mark as Available",
    deleteProfile: "Delete Profile",
    employedBy: "Employed By",
    requestId: "Request ID",
    assigned: "Assigned",
    userManagement: "User Management",
    searchUsers: "Search users...",
    allTypes: "All Types",
    admin: "Admin",
    manager: "Manager",
    employer: "Employer",
    exportUsers: "Export Users",
    noUsersFound: "No Users Found",
    noUsersMatchCriteria: "No users match your criteria",
    noUsersAvailable: "No users available",
    showingUsers: "Showing user(s)",
    user: "User",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    type: "Type",
    joined: "Joined",
    editUser: "Edit User",
    suspendUser: "Suspend User",
    activateUser: "Activate User",
    deleteUser: "Delete User",
    galleryManagement: "Gallery Management",
    searchGallery: "Search gallery...",
    addImage: "Add Image",
    noGalleryImagesFound: "No Gallery Images Found",
    noImagesMatchCriteria: "No images match your criteria",
    showingImages: "Showing {showing} of {total} images",
    general: "General",
    edit: "Edit",
    delete: "Delete",
    featured: "Featured",
    aboutUsManagement: "About Us Management",
    pageContent: "Page Content",
    coreValues: "Core Values",
    teamMembers: "Team Members",
    aboutPageContent: "About Page Content",
    editContent: "Edit Content",
    defaultAboutTitle: "Empowering Women Through Skills Training",
    defaultMission: "Our mission is to empower women through vocational training and sustainable employment opportunities",
    defaultVision: "Our vision is a world where every woman has the skills and opportunities to achieve economic independence",
    defaultHistory: "Founded in 2013, Urugo Women Opportunity Center has transformed the lives of hundreds of women through skills training",
    noMissionStatement: "No mission statement added yet",
    noVisionStatement: "No vision statement added yet",
    noHistoryContent: "No history content added yet",
    noAboutPageContent: "No about page content added",
    clickEditContentToAdd: "Click 'Edit Content' to add information",
    addValue: "Add Value",
    noCoreValues: "No Core Values",
    addCoreValues: "Add your organization's core values",
    addTeamMember: "Add Team Member",
    noTeamMembers: "No Team Members",
    addTeamMembers: "Add your team members",
    donationManagement: "Donation Management",
    reset: "Reset",
    exportDonations: "Export Donations",
    donor: "Donor",
    message: "Message",
    viewDetails: "View Details",
    sendThankYou: "Send Thank You",
    noDonationsFound: "No donations found",
    reportsAnalytics: "Reports & Analytics",
    generateReports: "Generate Reports",
    usersReport: "Users Report",
    requestsReport: "Requests Report",
    donationsReport: "Donations Report",
    fullDatabaseExport: "Full Database Export",
    systemStatistics: "System Statistics",
    totalUsers: "Total Users",
    activeWomen: "Active Women",
    totalRevenue: "Total Revenue",
    successRate: "Success Rate",
    requestStatistics: "Request Statistics",
    generalSettings: "General Settings",
    siteName: "Site Name",
    emailNotifications: "Email Notifications",
    autoApproveRequests: "Auto-Approve Requests",
    saveSettings: "Save Settings",
    accountSettings: "Account Settings",
    changePassword: "Change Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    confirmNewPassword: "Confirm New Password",
    saveChanges: "Save Changes",
    editGalleryImage: "Edit Gallery Image",
    addGalleryImage: "Add Gallery Image",
    title: "Title",
    description: "Description",
    department: "Department",
    featuredImage: "Featured Image",
    imageFile: "Image File",
    currentImage: "Current Image",
    current: "Current",
    cancel: "Cancel",
    updateImage: "Update Image",
    editAboutPageContent: "Edit About Page Content",
    pageTitle: "Page Title",
    enterPageTitle: "Enter page title",
    missionStatement: "Mission Statement",
    enterMissionStatement: "Enter mission statement",
    visionStatement: "Vision Statement",
    enterVisionStatement: "Enter vision statement",
    historyAboutUs: "History / About Us",
    enterHistoryContent: "Enter history content",
    aboutPageSaved: "About page saved successfully",
    failedSaveAboutPage: "Failed to save about page",
    editCoreValue: "Edit Core Value",
    addCoreValue: "Add Core Value",
    coreValueText: "Core Value Text",
    enterCoreValueText: "Enter core value text",
    sortOrder: "Sort Order",
    updateCoreValue: "Update Core Value",
    confirmDeleteCoreValue: "Are you sure you want to delete this core value?",
    coreValueDeleted: "Core value deleted successfully",
    failedDeleteCoreValue: "Failed to delete core value",
    coreValueAdded: "Core value added successfully",
    failedAddCoreValue: "Failed to add core value",
    coreValueUpdated: "Core value updated successfully",
    failedUpdateCoreValue: "Failed to update core value",
    editTeamMember: "Edit Team Member",
    addTeamMember: "Add Team Member",
    position: "Position",
    department: "Department",
    bioDescription: "Bio/Description",
    enterTeamMemberBio: "Enter team member bio",
    profilePhoto: "Profile Photo",
    activeTeamMember: "Active Team Member",
    currentPhoto: "Current Photo",
    updateTeamMember: "Update Team Member",
    confirmDeleteTeamMember: "Are you sure you want to delete this team member?",
    teamMemberDeleted: "Team member deleted successfully",
    failedDeleteTeamMember: "Failed to delete team member",
    teamMemberAdded: "Team member added successfully",
    failedAddTeamMember: "Failed to add team member",
    teamMemberUpdated: "Team member updated successfully",
    failedUpdateTeamMember: "Failed to update team member",
    addNewProfile: "Add New Profile",
    name: "Name",
    age: "Age",
    selectDepartment: "Select Department",
    experienceYears: "Experience (Years)",
    commaSeparatedSkills: "Comma-separated skills",
    location: "Location",
    educationLevel: "Education Level",
    selectEducation: "Select Education Level",
    primary: "Primary",
    secondary: "Secondary",
    vocational: "Vocational",
    university: "University",
    other: "Other",
    profilePhoto: "Profile Photo",
    addProfile: "Add Profile",
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    refresh: "Refresh",
    logout: "Logout",
    toggleMenu: "Toggle menu",
    urugoWOC: "Urugo WOC",
    notifications: "Notifications",
    noNotifications: "No notifications",
    home: "Home",
    requests: "Requests",
    women: "Women",
    users: "Users",
    donations: "Donations",
    gallery: "Gallery",
    about: "About",
    reports: "Reports",
    settings: "Settings",
    export: "Export",
    csvFormat: "CSV format",
    manageWomen: "Manage Women",
    profiles: "profiles",
    manageUsers: "Manage Users",
    quickActions: "Quick Actions",
    reviewRequests: "Review Requests",
    exportAllData: "Export All Data",
    exportAll: "Export All",
    clearAll: "Clear All",
    allCaughtUp: "All caught up!",
    noNewNotifications: "No new notifications",
    departments: "Departments",
    employers: "Employers",
    activeToday: "Active Today",
    thisMonth: "this month",
    currentlyActive: "currently active",
    average: "Average",
    womenTrained: "Registered women through Job Hub",
    selectAllAvailable: "Select All Available",
    selectForAssignment: "Select for Assignment",
    inactive: "Inactive",
    active: "Active",
    enterImageDescription: "Enter image description",
    enterCoreValueText: "Enter core value text",
    enterTeamMemberBio: "Enter team member bio",
    bio: "Bio",
    confirmDeleteImage: "Are you sure you want to delete this image?",
    imageDeleted: "Image deleted successfully",
    failedDeleteImage: "Failed to delete image",
    galleryImageAdded: "Gallery image added successfully",
    failedAddGalleryImage: "Failed to add gallery image",
    galleryImageUpdated: "Gallery image updated successfully",
    failedUpdateGalleryImage: "Failed to update gallery image",
    selectDepartment: "Select Department",
    successRate: "Success Rate",
    activeWomen: "Active Women",
    
    // Employer Dashboard Translations (existing - kept for compatibility)
    employerDashboard: "Employer Dashboard",
    myRequests: "My Requests",
    hiredWomen: "Hired Women",
    payments: "Payments",
    newRequest: "New Request",
    markAsPaid: "Mark as Paid",
    exportData: "Export Data",
    makePayment: "Make Payment",
    downloadReceipt: "Download Receipt",
    totalSpent: "Total Spent",
    totalHired: "Total Hired",
    approvalRate: "Approval Rate",
    avgEmployees: "Avg Employees",
    avgDuration: "Avg Duration",
    pendingPayments: "Pending Payments",
    paymentHistory: "Payment History",
    payNow: "Pay Now",
    profileSettings: "Profile Settings",
    companyName: "Company Name",
    contactPerson: "Contact Person",
    requestTrainedWomen: "Request trained women",
    perRequest: "per request",
    womenHired: "women hired",
    avgPerRequest: "avg/request",
    browseHired: "Browse Hired",
    viewHiredWomen: "View hired women",
    downloadAllRequests: "Download all requests",
    unknownDepartment: "Unknown Department",
    unknownDate: "Unknown date",
    allCaughtUp: "All caught up!",
    noNewNotifications: "No new notifications",
    exportList: "Export List",
    unknownName: "Unknown Name",
    yearsExp: "years exp",
    hiredOn: "Hired on",
    unknown: "Unknown",
    notSpecified: "Not specified",
    noHiredWomen: "No Hired Women",
    noHiredWomenDesc: "You haven't hired any women yet. Approved requests will appear here",
    makeRequest: "Make a Request",
    managePayments: "Manage your payments and invoices",
    totalPendingPayments: "Total Pending Payments",
    requests: "request(s)",
    allCompletedPayments: "All completed payments",
    viewAllRequests: "View All Requests",
    request: "Request",
    due: "Due",
    noPendingPayments: "No pending payments",
    paidOn: "Paid on",
    noPaymentHistory: "No payment history yet",
    loadingDashboard: "Loading your dashboard...",
    failedLoadHiredWomen: "Failed to load hired women data",
    notificationPendingRequests: "You have pending request(s)",
    notificationPendingPayments: "payment(s) pending",
    justNow: "Just now",
    requestSubmittedSuccess: "Request submitted successfully!",
    failedSubmitRequest: "Failed to submit request. Please try again",
    requestUpdatedSuccess: "Request updated successfully!",
    failedUpdateRequest: "Failed to update request. Please try again",
    confirmCancelRequest: "Are you sure you want to cancel this request?",
    requestCancelledSuccess: "Request cancelled successfully!",
    failedCancelRequest: "Failed to cancel request. Please try again",
    confirmMarkAsPaid: "Mark this request as paid?",
    requestMarkedAsPaid: "Request marked as paid!",
    failedUpdatePayment: "Failed to update payment status. Please try again",
    exportSuccessful: "Export successful! File downloaded",
    failedExportRequests: "Failed to export requests",
    confirmDeleteRequest: "Are you sure you want to delete this request? This action cannot be undone",
    requestDeletedSuccess: "Request deleted successfully!",
    failedDeleteRequest: "Failed to delete request. Please try again",
    downloadingReceipt: "Downloading receipt...",
    paymentCompleted: "Payment completed successfully!",
    // Certificate related
certificate: 'Certificate',
uploadCertificate: 'Upload Certificate',
updateCertificate: 'Update Certificate',
deleteCertificate: 'Delete Certificate',
viewCertificate: 'View Certificate',
certificateNumber: 'Certificate Number',
certificateType: 'Certificate Type',
certificateFile: 'Certificate File',
issuingOrganization: 'Issuing Organization',
issueDate: 'Issue Date',
expiryDate: 'Expiry Date',
certificateVerified: 'Verified',
certificateUnverified: 'Unverified',
noCertificate: 'No Certificate',
currentCertificate: 'Current Certificate',
viewCurrentCertificate: 'View Current Certificate',
selectCertificateType: 'Select Certificate Type',
vocationalCertificate: 'Vocational Certificate',
skillCertificate: 'Skill Certificate',
trainingCertificate: 'Training Certificate',
professionalCertificate: 'Professional Certificate',
otherCertificate: 'Other Certificate',
confirmDeleteCertificate: 'Are you sure you want to delete this certificate?',
certificateUploaded: 'Certificate uploaded successfully',
certificateDeleted: 'Certificate deleted successfully',
certificateUpdated: 'Certificate updated successfully',
failedUploadCertificate: 'Failed to upload certificate',
failedDeleteCertificate: 'Failed to delete certificate',
maxFileSize: 'Maximum file size',

confirmVerifyCertificate: 'Are you sure you want to verify this certificate?',
confirmUnverifyCertificate: 'Are you sure you want to mark this certificate as unverified?',
certificateVerifiedSuccess: 'Certificate verified successfully!',
certificateUnverifiedSuccess: 'Certificate marked as unverified.',
failedVerifyCertificate: 'Failed to verify certificate',
failedUnverifyCertificate: 'Failed to update certificate verification',
verifyCertificate: 'Verify Certificate',
markAsUnverified: 'Mark as Unverified',

confirmDeleteUserTitle: 'Delete User',
confirmDeleteProfileTitle: 'Delete Profile',
confirmDeleteImageTitle: 'Delete Image',
confirmDeleteCoreValueTitle: 'Delete Core Value',
confirmDeleteCertificateTitle: 'Delete Certificate',
confirmDeleteTeamMemberTitle: 'Delete Team Member',
confirmVerifyCertificateTitle: 'Verify Certificate',
confirmUnverifyCertificateTitle: 'Unverify Certificate',
delete: 'Delete',
verify: 'Verify',
unverify: 'Unverify',
cancel: 'Cancel',
request: 'Request',
requestThisWoman: 'Request this woman',
certified: 'Certified',
certificatePending: 'Certificate Pending',
currentlyEmployed: 'Currently Employed',
verifiedCertificate: 'Verified Certificate',
pendingVerification: 'Pending Verification',
availableForHire: 'Available for Hire',
viewAllWomen: 'View All Women',
womanNotAvailable: 'This woman is not currently available for hire',
loginToRequest: 'Please login to request women',
requestWoman: 'Request {{name}}',

// Custom Email Translations
customEmail: 'Send Custom Email',
customEmailDescription: 'Send emails to any email address (not limited to database users)',
sendCustomEmail: 'Send Custom Email',
customEmailInfo: 'Send emails to any email address. You can enter multiple email addresses separated by commas.',
enterRecipients: 'Enter email addresses separated by commas',
multipleEmailsInfo: 'Multiple emails: separate with commas. Max 100 recipients per batch.',
messageFormatInfo: 'Plain text or basic HTML supported. Line breaks will be preserved.',
attachments: 'Attachments',
attachmentsInfo: 'Maximum 5 files, 10MB each. Supported: PDF, Word, Excel, Images',
selectedAttachments: 'Selected attachments',
emailPreview: 'Email Preview',
noMessagePreview: 'Message will appear here...',
emailSentSuccess: 'Email sent successfully!',

// Email verification translations
verifyingEmail: 'Verifying your email...',
emailVerified: 'Email Verified Successfully!',
completeRegistration: 'Please complete your registration',
verificationEmailSent: 'Verification Email Sent!',
verificationEmailSentTo: 'A verification email has been sent to:',
checkYourEmailInbox: 'Check your email inbox (and spam folder)',
clickVerifyButton: 'Click the \'Verify Email Address\' button in the email',
setYourPasswordPage: 'Set your password on the verification page',
accountReadyToUse: 'Your account will be ready to use',
verificationLinkExpires: 'The verification link expires in 24 hours',
didNotReceiveEmail: 'Didn\'t receive the email?',
resendVerification: 'Click here to resend',
invalidVerificationLink: 'Invalid verification link',
verificationFailed: 'Verification Failed',
registerAgain: 'Register Again',
basicInfo: 'Basic Info',
password: 'Password',
checkingEmail: 'Checking email...',
continueToPassword: 'Continue to Password',
setYourPassword: 'Set Your Password',
passwordStepDescription: 'Create a secure password for your account',
yourInformation: 'Your Information',
sendingVerification: 'Sending verification...',
sendVerificationEmail: 'Send Verification Email',
emailAvailable: 'Email available',
emailPendingVerification: 'Email pending verification',
verificationEmailWillBeResent: 'A new verification email will be sent',
nextSteps: 'Next Steps',
note: 'Note',
accountCreatedSuccess: 'Account Created Successfully!',
redirectingToDashboard: 'Redirecting to dashboard...',
registrationVerificationSent: 'Registration successful! Please check your email to verify your account.',
emailNotVerified: 'Your email is not verified. Please check your inbox for the verification email.',
invalidVerificationToken: 'Invalid or expired verification token',
completeRegistrationButton: 'Complete Registration',

// Password strength translations
passwordVeryWeak: 'Very Weak',
passwordWeak: 'Weak',
passwordFair: 'Fair',
passwordGood: 'Good',
passwordStrong: 'Strong',
       // Add these new translations:
  skilledProfessionals: "Skilled professionals with verified certificates",
  verifiedCertificate: "Verified Certificate",
  pendingVerification: "Pending Verification",
  availableForHire: "Available for Hire",
  viewCertificate: "View Certificate",
  request: "Request",
  requestThisWoman: "Request this woman",
  currentlyEmployed: "Currently Employed",
  womanNotAvailable: "This woman is not currently available for hire",
  loginToRequest: "Please login to request women",
  certificateVerified: "Verified Certificate",
  certificateUnverified: "Certificate Pending Verification",
  certified: "Certified",
  certificatePending: "Certificate Pending",
  viewAllWomen: "View All Women",
    // New keys for request specifications
requestManagementWithSpecs: 'Request Management (with Specifications)',
specifications: 'Specifications',
noSpecifications: 'No Specifications',
viewSpecifications: 'View Specifications',
hasSpecifications: 'Has Specifications',
withSpecifications: 'With Specifications',
noSpecificationsProvided: 'No additional specifications provided for this request.',
requestDetails: 'Request Details',
employerInformation: 'Employer Information',
statusInformation: 'Status Information',
employeesNeeded: 'Employees Needed',
workType: 'Work Type',
duration: 'Duration',
amount: 'Amount',
paymentVerified: 'Payment Verified',
assignedWomen: 'Assigned Women',
availableWomen: 'Available Women',
created: 'Created',
ageRange: 'Age Range',
experienceLevel: 'Experience Level',
skillLevel: 'Skill Level',
educationLevel: 'Education Level',
languageRequirements: 'Language Requirements',
specialSkills: 'Special Skills',
otherSpecifications: 'Other Specifications',
approveRequest: 'Approve Request',
rejectRequest: 'Reject Request',
assignWomen: 'Assign Women',
close: 'Close',

// Certificate related
uploadCertificate: 'Upload Certificate',
certificateNumber: 'Certificate Number',
certificateType: 'Certificate Type',
selectCertificateType: 'Select Certificate Type',
vocationalCertificate: 'Vocational Certificate',
skillCertificate: 'Skill Certificate',
trainingCertificate: 'Training Certificate',
professionalCertificate: 'Professional Certificate',
otherCertificate: 'Other Certificate',
issuingOrganization: 'Issuing Organization',
issueDate: 'Issue Date',
expiryDate: 'Expiry Date',
certificateFile: 'Certificate File',
maxFileSize: 'Maximum file size',
currentCertificate: 'Current Certificate',
viewCurrentCertificate: 'View Current Certificate',
updateCertificate: 'Update Certificate',
certificateVerified: 'Certificate Verified',
certificateUnverified: 'Certificate Unverified',
noCertificate: 'No Certificate',
viewCertificate: 'View Certificate',
markAsUnverified: 'Mark as Unverified',
verifyCertificate: 'Verify Certificate',
deleteCertificate: 'Delete Certificate',
confirmDeleteCertificateTitle: 'Delete Certificate',
confirmDeleteCertificate: 'Are you sure you want to delete this certificate? This action cannot be undone.',
confirmVerifyCertificateTitle: 'Verify Certificate',
confirmVerifyCertificate: 'Are you sure you want to verify this certificate?',
confirmUnverifyCertificateTitle: 'Unverify Certificate',
confirmUnverifyCertificate: 'Are you sure you want to mark this certificate as unverified?',
certificateUploaded: 'Certificate uploaded successfully',
certificateDeleted: 'Certificate deleted successfully',
certificateVerifiedSuccess: 'Certificate verified successfully',
certificateUnverifiedSuccess: 'Certificate unverified successfully',
failedUploadCertificate: 'Failed to upload certificate',
failedDeleteCertificate: 'Failed to delete certificate',
failedVerifyCertificate: 'Failed to verify certificate',
failedUnverifyCertificate: 'Failed to unverify certificate',

// Women management
selectAllAvailable: 'Select all available women',
womanNotAvailable: 'Woman not available for assignment',
selectForAssignment: 'Select for assignment',
womenSelectedForAssignment: 'Women Selected for Assignment',
selected: 'selected',
assignSelectedWomen: 'Assign Selected Women',

// Request status
completed: 'Completed',
cancelled: 'Cancelled',

     // Add to your translation context
emailSettings: 'Email Settings',
emailBroadcast: 'Email Broadcast',
emailBroadcastDescription: 'Send announcements and updates to all users in the system',
sendEmailBroadcast: 'Send Email Broadcast',
sendTestEmail: 'Send Test Email',
broadcastAllUsersWarning: 'This email will be sent to ALL users in the system.',
broadcastEmployersWarning: 'This email will be sent to EMPLOYERS only.',
broadcastAdminsWarning: 'This email will be sent to ADMINS only.',
broadcastManagersWarning: 'This email will be sent to MANAGERS only.',
currentPassword: 'Current Password',
newPassword: 'New Password',
confirmPassword: 'Confirm Password',
enterCurrentPassword: 'Enter your current password',
enterNewPassword: 'Enter new password',
confirmNewPassword: 'Confirm new password',
changing: 'Changing...',
systemSettings: 'System Settings',
timezone: 'Timezone',
dateFormat: 'Date Format',
itemsPerPage: 'Items per page',
resetToDefaults: 'Reset to Defaults',
recipients: 'Recipients',
allUsers: 'All Users',
employersOnly: 'Employers Only',
adminsOnly: 'Admins Only',
managersOnly: 'Managers Only',
testEmailAddress: 'Test Email Address',
enterTestEmail: 'Enter test email address',
testEmailDescription: 'Send a test email to verify formatting',
sending: 'Sending...',
sendBroadcast: 'Send Broadcast',
enterEmailSubject: 'Enter email subject',
enterEmailMessage: 'Enter your email message here...',
    // Gallery Page Translations
    barista: "Barista",
    coffee: "Coffee",
    training: "Training",
    womenLearning: "Women learning",
    preparation: "Preparation",
    machine: "machine",
    customerService: "Customer Service",
    serving: "Serving",
    customers: "customers",
    withProfessionalism: "with professionalism",
    grinding: "Grinding",
    learning: "Learning",
    proper: "proper",
    techniques: "techniques",
    art: "Art",
    creating: "Creating",
    beautiful: "beautiful",
    designs: "designs",
    teamCollaboration: "Team Collaboration",
    working: "Working",
    together: "together",
    in: "in",
    shop: "shop",
    roomCleaning: "Room Cleaning",
    professional: "Professional",
    room: "room",
    cleaning: "cleaning",
    linenManagement: "Linen Management",
    linen: "linen",
    folding: "folding",
    and: "and",
    storage: "storage",
    cleaningEquipment: "Cleaning Equipment",
    using: "Using",
    modern: "modern",
    equipment: "equipment",
    hotelStandards: "Hotel Standards",
    maintaining: "Maintaining",
    high: "high",
    standards: "standards",
    frontDesk: "Front Desk",
    managing: "Managing",
    hotel: "hotel",
    front: "front",
    desk: "desk",
    operations: "operations",
    guestCheckin: "Guest Check-in",
    guest: "guest",
    checkin: "check-in",
    process: "process",
    phoneEtiquette: "Phone Etiquette",
    telephone: "telephone",
    communication: "communication",
    skills: "skills",
    computerSkills: "Computer Skills",
    software: "software",
    sewingMachine: "Sewing Machine",
    industrial: "industrial",
    sewing: "sewing",
    machines: "machines",
    patternMaking: "Pattern Making",
    clothing: "clothing",
    patterns: "patterns",
    fabricCutting: "Fabric Cutting",
    precision: "precision",
    fabric: "fabric",
    cutting: "cutting",
    qualityControl: "Quality Control",
    checking: "Checking",
    finished: "finished",
    garments: "garments",
    leatherCutting: "Leather Cutting",
    leather: "leather",
    for: "for",
    products: "products",
    handStitching: "Hand Stitching",
    traditional: "traditional",
    stitching: "stitching",
    leatherDyeing: "Leather Dyeing",
    coloring: "Coloring",
    productAssembly: "Product Assembly",
    assembling: "Assembling",
    goods: "goods",
    weaving: "Weaving",
    carpet: "carpet",
    knotting: "Knotting",
    handknotting: "Hand-knotting",
    designPlanning: "Design Planning",
    designs: "designs",
    finishing: "Finishing",
    final: "Final",
    touches: "touches",
    on: "on",
    carpets: "carpets",
    milkProcessing: "Milk Processing",
    milk: "milk",
    processing: "processing",
    yogurtMaking: "Yogurt Making",
    yogurt: "Yogurt",
    fermentation: "fermentation",
    qualityTesting: "Quality Testing",
    testing: "Testing",
    dairy: "dairy",
    packaging: "Packaging",
    hygienic: "Hygienic",
    
    // UI Translations for Gallery
    images: "Images",
    tryAgain: "Try Again",
    noImagesFound: "No images found",
    tryDifferentFilter: "Try selecting a different department or search term",
    tryDifferentSearch: "Try a different search term",
    noImagesInDepartment: "No images available for this department yet",
    galleryImage: "Gallery Image",
    noDescription: "No description available",
    loadMore: "Load More",
    trainingImages: "Training Images",
    womenEmpowered: "Women Empowered",
    learningOpportunities: "Learning Opportunities",
    witnessTransformation: "Witness the journey of women transforming their lives through vocational training",
    search: "Search",
    viewAll: "View All",
    tailoringFashion: "Tailoring & Fashion",
    organicFarming: "Organic Farming",
    culinaryArts: "Culinary Arts",
    cosmetology: "Cosmetology",
    literacyProgram: "Literacy Program",
    handicrafts: "Handicrafts",
    leatherwork: "Leatherwork",
    farming: "Farming",
    cooking: "Cooking",
    tailoring: "Tailoring",
    housekeeping: "Housekeeping",
    reception: "Reception",
    sewing: "Sewing",
    carpetWeaving: "Carpet Weaving",
    dairyProduction: "Dairy Production",
    
    // About Us Page Translations
    aboutUs: "About Us",
    empoweringWomenTransformingCommunities: "Empowering women, transforming communities since 2013",
    ourMission: "Our Mission",
    ourVision: "Our Vision",
    ourStory: "Our Story",
    ourCoreValues: "Our Core Values",
    ourTrainingDepartments: "Our Training Departments",
    meetOurTeam: "Meet Our Team",
    contactUs: "Contact Us",
    connectWithUs: "Connect With Us",
    sendUsAMessage: "Send Us a Message",
    wellGetBackToYou: "We'll get back to you as soon as possible",
    ourPartnersSponsors: "Our Partners & Sponsors",
    
    // Contact Information Labels
    address: "Address",
    workingHours: "Working Hours",
    alternate: "Alternate",
    fullName: "Full Name *",
    emailAddress: "Email Address *",
    subject: "Subject *",
    sendMessage: "Send Message",
    sending: "Sending...",
    thankYouMessageSent: "Thank you! Your message has been sent successfully.",
    sorryErrorSending: "Sorry, there was an error sending your message. Please try again.",
    
    // Placeholders and Messages
    loadingAboutInfo: "Loading about information...",
    
    // Form Labels
    formNamePlaceholder: "Enter your full name",
    formEmailPlaceholder: "Enter your email address",
    formSubjectPlaceholder: "Enter subject",
    formMessagePlaceholder: "Type your message here...",
    
    // Social Media Platforms
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    whatsapp: "WhatsApp",
    
    // Partner Types
    sponsor: "Sponsor",
    partner: "Partner",
    donor: "Donor",

    // Existing translations (kept for compatibility)
    home: "Home",
    exploreDepartments: "Explore Departments",
    meetOurWomen: "Meet Our Women",
    hireTrainedWomen: "Hire Trained Women",
    empoweringWomen: "Empowering Women",
    throughSkillsTraining: "Through Skills Training",
    buildingSustainable: "Building Sustainable",
    futures: "Futures",
    transformingCommunities: "Transforming Communities",
    together: "Together",
    employersConnected: "Employers Connected",
    chooseSpecializedPrograms: "Choose from our specialized training programs designed for success",
    requestTrainedWomen: "Request Trained Women",
    certifiedTraining: "Certified Training",
    flexibleHours: "Flexible Hours",
    ourWomenInAction: "Our Women in Action",
    witnessTransformation: "Witness the transformation through their work",
    meetTalentedWomen: "Meet Our Talented Women",
    skilledProfessionals: "Skilled professionals ready to make a difference",
    availableNow: "Available Now",
    currentlyWorking: "Currently Working",
    empowerMoreWomen: "Empower More Women Today",
    supportProvidesHope: "Your support provides training, opportunities, and hope. Join us in creating lasting change.",
    donateNow: "Donate Now",
    hireTalent: "Hire Talent",
    woman: "Woman",
    skilledProfessional: "Skilled professional",
    womenEmpowermentActivity: "Women empowerment activity",
    makeDonation: "Make a donation to support women's training",
    
    // Department names and descriptions
    tailoringDesc: "Professional sewing and fashion design training",
    farmingDesc: "Sustainable agriculture practices and techniques",
    culinaryDesc: "Professional cooking and food preparation skills",
    cosmetologyDesc: "Beauty and skincare product making",
    literacyDesc: "Basic education and literacy skills",
    handicraftsDesc: "Traditional and modern craft making",
    leatherworkDesc: "Shoemaking and leather goods production",
    
    // Hero slides descriptions
    heroSlide1Desc: "Urugo Women Opportunity Center has trained over 600 women in various vocational skills, helping them build sustainable livelihoods and transform their communities.",
    heroSlide2Desc: "Our vocational training programs equip women with marketable skills for today's competitive job market, ensuring long-term employment and financial independence.",
    heroSlide3Desc: "By empowering one woman, we empower an entire community. Join us in creating lasting change through education, support, and opportunity.",
    
    // Additional UI elements
    working: "Working",
    loadingContent: "Loading amazing content...",
  },

  kinyarwanda: {


    deptCoffeeShop: 'Ibikorwa by\'Ikawa',
deptCoffeeShopDesc: 'Amahugurwa ya barista, gutegura ikawa, no gucunga café',
deptHousekeeping: 'Ibikorwa byo Kubungabunga Inzu',
deptHousekeepingDesc: 'Isuku ya professional, gutunganya, no gucunga ubukerarugendo',
deptCarpetYarn: 'Gukora Amakapeti n\'Ubwoya',
deptCarpetYarnDesc: 'Gukora amakapeti n\'ubwoya hakoreshejwe uburyo bwa gakondo na kijyambere',
deptLeatherFootwear: 'Gukora Ibikoresho by\'Uruhu n\'Inkweto',
deptLeatherFootwearDesc: 'Gukora ibikoresho by\'uruhi harimo amasakoshi, inkweto, n\'ibindi',
deptSewingGarment: 'Kudoda no Gukora Imyambaro',
deptSewingGarmentDesc: 'Kudoda kwa professional, gukora imyambaro, no kudoda',
deptMilkProcessing: 'Gutunganya Amata',
deptMilkProcessingDesc: 'Gutunganya amata na yoguriti, gupakira, no gukora ibikomoka ku mata',
deptBakeryPastry: 'Gukora Umugati na Pastry',
deptBakeryPastryDesc: 'Gukora umugati, pastry, na confectionery',
deptNutritionalFood: 'Gukora Ibiryo Birimo Intungamubiri',
deptNutritionalFoodDesc: 'Gukora ibiryo birimo intungamubiri no gutegura amafunguro yuzuye',
deptReception: 'Ibikorwa byo Kwakira Abashyitsi',
deptReceptionDesc: 'Kwakira abashyitsi, serivisi y\'abakiriya, no gucunga ibiro',
deptHorticulture: 'Ubuhinzi bw\'Imbuto n\'Imboga',
deptHorticultureDesc: 'Ubuhinzi burambye bw\'imbuto n\'imboga, n\'ubuhinzi rusange',

unemployedWomenFound: 'abagore badafite akazi babonetse',
noUnemployedWomenInDepartment: 'Nta bagore badafite akazi babonetse muri iri shami.',

        // ===== Trainee Stats Page =====
        stats: 'Imibare',
        traineeStats: 'Imibare y\'Abahuguwe',
        traineeStatsIntro: 'Reba Abarangije Bacu Bemewe',
        ourImpact: 'Ingaruka Zacu',
        totalTrainees: 'Abarangije Bemewe',
        employedByCompany: 'Bakoreshejwe n\'Isosiyete',
        unemployed: 'Ntagakazi',
        professionalInternship: 'Imyitozo Ngiro',
        selfEmployed: 'Abikorera',
        traineesFound: 'abahuguwe babonetse',
        noTraineesFound: 'Nta bahuguwe babonetse',
        tryDifferentFilters: 'Gerageza guhindura ibyunguruzo cyangwa gushakisha.',
        searchTrainees: 'Shakisha ku izina, ubuhanga...',
        allDepartments: 'Amashami Yose',
        yearsExp: 'imyaka y\'uburambe',

    employed: 'Akazi',
studying: 'Ariga',
workingForOthers: 'Akorera abandi',
notAvailableForHire: 'Ntaboneka ku kazi',
womenFound: 'abagore babonetse',
noWomenInDepartment: 'Nta bagore babonetse muri iri shami.',
exportExcel: 'Kuramo muri Excel',
exportPDF: 'Kuramo muri PDF',
noWomenFoundWithStatus: 'Nta bagore babonetse bafite iyi mimerere',
    
  fullName: 'Amazina Yuzuye',
  age: 'Imyaka',
  cohort: 'Itsinda',
  phone: 'Telefoni',
  email: 'Imeri',
  placementLocation: 'Aho Ushyirwa',
  competenceSkills: 'Ubuhanga',
  commaSeparated: 'bitandukanyijwe n\'imirongo',
  optional: 'Ntabwo ari ngombwa',
  emailOptional: 'Imeri ntibisabwa ariko ni byiza kuyitanga',
  enterName: 'Shyiramo amazina yawe yuzuye',
  enterAge: 'Imyaka yawe',
  enterPhone: '+250 78X XXX XXX',
  enterEmail: 'imeri@example.com (ntabwo ari ngombwa)',
  enterPlacementLocation: 'Umujyi, Akarere, Igihugu',
  enterCompetenceSkills: 'Urugero: Ubuhanga bwa Mudasobwa, Ibyemezo, Ubuyobozi',
  separateWithCommas: 'Tandukanya ubuhanga bwinshi n\'imirongo',
  enterCompanyName: 'Izina ry\'isosiyete/umuryango',
  enterWorkingPosition: 'Umwanya w\'akazi',
  enterWorkingLocation: 'Aho ukorera',
  enterYears: 'Imyaka',
  enterBio: 'Incamake y\'ubuzima',
  uploadPhoto: 'Kuzana Ifoto',

  fullNameRequired: 'Amazina yuzuye arasabwa',
  nameMinLength: 'Izina rigomba kugira byibuze inyuguti 2',
  selectDepartmentRequired: 'Nyamuneka hitamo ishami',
  selectEmploymentStatus: 'Nyamuneka hitamo imimerere yawe y\'akazi',
  selectJobSecured: 'Nyamuneka hitamo uko wabonye akazi',

  employmentStatusDesc: 'Tubwire ibyerekeye imimerere yawe y\'akazi.',
  unemployedInfo: 'Wahisemo "Ntagakazi". Ibindi bisobanuro by\'akazi ntibisabwa.',

  wocPlacement: 'Binyuze mu Gufasha WOC mu Gushaka Akazi',
  wocInternship: 'Gutozwa Akazi/Inzego ku Kazi i WOC',
  wocRecommendation: 'Inyigisho z\'Abahugura i WOC',
  familyFriends: 'Umuryango/Inshuti',
  socialMedia: 'Imbuga Nkoranyambaga',
  onlinePortal: 'Urubuga rwo Gushakira Akazi',
  walkIn: 'Kwinjira bwite',
  newspaper: 'I tangazo mu Ikinyamakuru',

  jobRelevanceDesc: 'Ese akazi ukora ubu ni uguhuza n\'amahugurwa wakiriye i WOC?',

  jobChallengesDesc: 'Ni izihe mpamvu zitera ko udakora? (Hitamo byose bikubiyemo)',
  lackJobOpportunities: 'Kubura amahirwe y\'akazi',
  lackWorkExperience: 'Kubura uburambe bw\'akazi',
  insufficientSkills: 'Ubuhanga buke',
  familyResponsibilities: 'Inshingano zo mu muryango',
  continuingEducation: 'Gukomeza amashuri',
  healthReasons: 'Impamvu z\'ubuzima',
  lackStartupCapital: 'Kubura ifunguzo ryo gutangira',
  locationTransport: 'Ibibazo by\'ahantu no gutwara',

  entrepreneurshipDesc: 'Ese watangije ubucuruzi bwawe nyuma yo kurangiza amahugurwa?',
  employeesEmployed: 'Ni bangahe bakoresha wakoze?',
  moreThan5: 'Barenga 5',

  supportNeededDesc: 'Ni ikihe gishyigikire cyakugirira akamaro mu kurengera ubucuruzi bwawe? (Hitamo byose bikubiyemo)',
  accessFinance: 'Kubona amafaranga',
  businessMentorship: 'Inkura y\'ubucuruzi',
  marketingSupport: 'Gushyigikira mu kwamamaza',
  advancedTraining: 'Amahugurwa makuru',
  equipment: 'Ibikoresho',
  marketLinkage: 'Ihuza n\'isoko',
  businessRegistration: 'Gufasha kwiyandikisha ubucuruzi',
  selectNumber: 'Hitamo umubare',

  confidenceDesc: 'Amahugurwa yagutereye ikihe cyizere mu gufata ibyemezo by\'ubuzima?',

  financialSupportChanged: 'Ubushobozi bwo kwiyigisha mu by\'amafaranga bwihinduye gute?',
  financialStability: 'Ugereranije n\'imbere y\'amahugurwa, wahinduraga gute imikorere yawe mu by\'amafaranga?',
  savedMoney: 'Wigeze ubika amafaranga bisanzwe nyuma y\'amahugurwa?',
  incomeManagement: 'Ufite ikihe cyizere mu gucunga amafaranga yawe?',

  communityImpactDesc: 'Ni gute usobanura ingaruka z\'amahugurwa ya WOC ku buzima bwawe no ku muryango wawe?',
  leadershipInvolvement: 'Wigeze ugira uruhare mu buyobozi cyangwa mu gufata ibyemezo mu muryango wawe cyangwa mu mugwi wawe?',

  editTraineeProfile: 'Hindura Umwirondoro w\'Umunyeshuri',
  updateProfile: 'Vugurura Umwirondoro',
  editing: 'Urahindura:',

  step: 'Intambwe',
  of: 'muri',
  skipped: 'Yasimbuwe',
  notApplicable: 'Ntibikora',

  continue: 'Komeza',
  previous: 'Ibibanje',
  next: 'Ibikurikira',
  submit: 'Rangiza Kwiyandikisha',
  submitting: 'Irirakora...',
  updateProfile: 'Vugurura Umwirondoro',

  noServerResponse: 'Nta bisubizo byavuye kuri seriveri. Nyamuneka ogerageze ugahagarika.',
  registrationFailed: 'Kwiyandikisha byanze. Ongera ugerageze.',
  pleaseFillRequiredFields: 'Nyamuneka uzuze imyanya yose isabwa',

  above200k: 'Hejuru ya 200,000 RWF',
  selectOption: 'Hitamo igisubizo',
  selectRating: 'Hitamo urwego',
  selectImpact: 'Hitamo urwego rw\'ingaruka',
  yes: 'Yego',
  no: 'Oya',
  none: 'Nta na kimwe',
  selectCohort: 'Hitamo itsinda',
  selectDepartment: 'Hitamo ishami',
  selectStatus: 'Hitamo imimerere',

    // In kinyarwanda section, add:

pleaseFillRequiredFields: 'Nyamuneka uzuze imyanya yose isabwa',
stepErrorBasicInfo: 'Nyamuneka uzuze imyanya yose isabwa mu makuru y\'ibanze',
stepErrorEmployment: 'Nyamuneka hitamo imimerere yawe y\'akazi',
stepErrorJobSecured: 'Nyamuneka hitamo uko wabonye akazi',
stepSkippedUnemployed: 'Wahisemo "Ntagakazi" mu ntambwe ibanziriza. Iyi ntambwe ntigikorwa.',
stepSkippedNotUnemployed: 'Nturi mu batagira akazi. Iyi ntambwe ntigikorwa.',
stepSkippedNotEntrepreneur: 'Wahisemo "Oya" ku bucuruzi. Iyi ntambwe ntigikorwa.',
skipToNextStep: 'Reka ujye ku ntambwe ikurikira',
editTraineeProfile: 'Hindura Umwirondoro w\'Umunyeshuri',
updateProfile: 'Vugurura Umwirondoro',
profileUpdatedSuccess: 'Umwirondoro wavuguruwe neza!',
profileAddedSuccess: 'Umwirondoro wongeweho neza!',
editing: 'Urahindura:',
currentPhotoLabel: 'Ifoto y\'ubu:',
noDepartmentsAvailable: 'Nta mashami aboneka',
noGalleryImages: 'Nta mashusho yo muri galeri aboneka ubu.',
noWomenProfiles: 'Nta makuru y\'abagore aboneka ubu.',
noEvents: 'Nta bikorwa byo kwerekana',
welcomeToGallery: 'Murakaza neza muri Galeri Yacu',
gallerySubtitle: 'Reba urugendo rwo guha imbaraga abagore',
viewAll: 'Reba Byose',
matching: 'bihuje',
resetFilters: 'Subiza Ibyunguruzo',
noImagesInDatabase: 'Nta mashusho yabonetse muri database. Herekana amashusho nk\'urugero.',
errorLoadingImages: 'Byanze kuzana amashusho. Herekana amashusho nk\'urugero.',
errorLoadingDepartments: 'Byanze kuzana amashami. Ukoresha urutonde rw\'ibanze.',
unknownDepartment: 'Ishami Ritazwi',
noImagesForDepartment: 'Nta mashusho aboneka muri iri shami.',
clickToView: 'Kanda urebe',
department: 'Ishami',
category: 'Icyiciro',
date: 'Itariki',
close: 'Funga',
viewDetails: 'Reba Ibisobanuro',
viewAllDepartments: 'Reba Amashami Yose',
viewAllWomen: 'Reba Abagore Bose',
loadMoreImages: 'Zana Ibindi Bishusho',
noDescription: 'Nta bisobanuro bihari',
featured: 'Byerekana',

    // Search Bar Translations - KINYARWANDA
searchPlaceholder: 'Shakisha abagore, amashami, ibikorwa...',
trainedWomen: 'Abagore Barangije',
trainingDepartments: 'Amashami y\'Amahugurwa',
activities: 'Ibikorwa',
galleryImages: 'Amashusho ya Galeri',
viewAllResults: 'Reba byose kuri',
searchResultsFor: 'Ibisubizo byo gushaka kuri',
viewAllItems: 'Reba byose →',
noResultsFound: 'Nta bisubizo bibonetse kuri',
trySearchingFor: 'Gerageza gushaka:',
searchSuggestions: 'kudoda, guteka, ubuhinzi, kudoda, inkanda',
viewCompleteSearchResults: 'Reba Ibisubizo Byose',

    // Trainee Registration - Additional Fields Translations - KINYARWANDA
enterName: 'Shyiramo amazina yuzuye',
enterAge: 'Imyaka',
enterPhone: '+250 78X XXX XXX',
enterEmail: 'email@example.com',
enterPlacementLocation: 'Umujyi, Akarere, Igihugu',
enterCompetenceSkills: 'Urugero: Ubuhanga bwa Mudasobwa, Ibyemezo, Ubuyobozi',
separateWithCommas: 'Tandukanya ubuhanga bwinshi n\'imirongo',
enterCompanyName: 'Izina ry\'isosiyete/umuryango',
enterWorkingPosition: 'Umwanya w\'akazi',
enterWorkingLocation: 'Aho ukorera',
enterYears: 'Imyaka',
enterLocation: 'Aho uherereye ubu',
enterBio: 'Incamake y\'ubuzima',
selectJobSecured: 'Hitamo uko wabonye akazi',
selectChallenges: 'Hitamo byose bikubiyemo',
selectSupport: 'Ni ikihe gishyigikire cyakugirira akamaro mu kurengera ubucuruzi bwawe? Hitamo byose bikubiyemo',
selectOption: 'Hitamo igisubizo',
selectNumber: 'Hitamo umubare',
selectRating: 'Hitamo urwego',
selectImpact: 'Hitamo urwego rw\'ingaruka',
startedBusiness: 'Wigeze gutangira ubucuruzi bwawe nyuma yo kurangiza amahugurwa?',
employeesEmployed: 'Ni bangahe bakoresha wakoze?',
none: 'Nta na kimwe',
moreThan5: 'Barenga 5',
yes: 'Yego',
no: 'Oya',
saving: 'Iribika...',
educationAndBio: 'Amashuri n\'Incamake y\'Ubuzima',
confidenceImproved: 'Amahugurwa yagutereye ikihe cyizere mu gufata ibyemezo by\'ubuzima?',
financialSupportChanged: 'Ubushobozi bwo kwiyigisha mu by\'amafaranga bwihinduye gute?',
financialStability: 'Ugereranije n\'imbere y\'amahugurwa, wahinduraga gute imikorere yawe mu by\'amafaranga?',
savedMoney: 'Wigeze ubika amafaranga bisanzwe nyuma y\'amahugurwa?',
incomeManagement: 'Ufite ikihe cyizere mu gucunga amafaranga yawe?',
communityImpactDesc: 'Ni gute usobanura ingaruka z\'amahugurwa ya WOC ku buzima bwawe no ku muryango wawe?',
leadershipInvolvement: 'Wigeze ugira uruhare mu buyobozi cyangwa mu gufata ibyemezo mu muryango wawe cyangwa mu mugwi wawe?',
currentPhoto: 'Ifoto y\'ubu',
yesEveryMonth: 'Yego, buri kwezi',
yesOccasionally: 'Yego, rimwe na rimwe',
noButPlan: 'Oya, ariko ndategura',
notChanged: 'Ntacyahindutse',
worsened: 'Byarushijeho kuba bibi',
fullyIndependent: 'Ndi ubwigenge mu by\'amafaranga',
significantlyContribute: 'Ngitira uruhare runini mu muryango wanjye',
occasionallyContribute: 'Ngitira uruhare rimwe na rimwe',
muchBetter: 'Byarushijeho kuba byiza cyane',
better: 'Byarushijeho kuba byiza',
same: 'Bisa nk\'aho',
worse: 'Byarushijeho kuba bibi',
muchWorse: 'Byarushijeho kuba bibi cyane',
veryGreatExtent: 'Cyane cyane',
greatExtent: 'Cyane',
moderateExtent: 'Hagati',
smallExtent: 'Gake',
notAtAll: 'Nta na gake',
veryConfident: 'Nzira cyane',
confident: 'Nzira',
moderatelyConfident: 'Nzira hagati',
slightlyConfident: 'Nzira gake',
notConfident: 'Sinzira na gake',
transformational: 'Ihinduka rikomeye',
significantPositive: 'Ingaruka nziza ikomeye',
moderatePositive: 'Ingaruka nziza hagati',
slightPositive: 'Ingaruka nziza gake',
noImpact: 'Nta ngaruka zagaragaye',
significantly: 'Yego, cyane',
toSomeExtent: 'Yego, mu rugero',
noChange: 'Nta hinduka',
lessInvolved: 'Ntagira uruhare nk\'uko byari',


    // Trainee Registration Translations - KINYARWANDA
traineeRegister: 'Iyandikishe nk\'Umunyeshuri',
traineeRegistration: 'Kwiyandikisha kw\'Umunyeshuri',
basicInformation: 'Amakuru y\'Ibanze',
employmentStatus: 'Imimerere y\'Akazi',
jobSecured: 'Uko Wabonye Akazi',
jobRelevance: 'Isano ry\'Akazi',
jobChallenges: 'Ibibazo byo Gushaka Akazi',
entrepreneurship: 'Ubucuruzi',
supportNeeded: 'Ubufasha Bufite',
confidenceImpact: 'Icyizere n\'Ingaruka',
financialSituation: 'Imimerere y\'Amafaranga',
communityImpact: 'Ingaruka ku Muryango',
registrationComplete: 'Kwiyandikisha Byarangiye!',
thankYouRegistration: 'Urakoze kurangiza kwiyandikisha kwawe.',
registrationSuccess: 'Amakuru yawe yabitswe neza.',
registrationSuccessSub: 'Ubu ushobora gukoresha ibintu byose bya porogaramu.',
previous: 'Ibabanje',
next: 'Ibikurikira',
submit: 'Rangiza Kwiyandikisha',
submitting: 'Irirakora...',
fullName: 'Amazina Yuzuye',
age: 'Imyaka',
cohort: 'Itsinda',
placementLocation: 'Aho Ushyirwa',
competenceSkills: 'Ubuhanga',
profilePhoto: 'Ifoto y\'Umwirondoro',
employmentSector: 'Urwego rw\'Akazi',
companyName: 'Izina ry\'Isosiyete',
workingPosition: 'Umwanya w\'Akazi',
workingLocation: 'Aho Ukorera',
modeOfEmployment: 'Uburyo bw\'Akazi',
yearsOfExperience: 'Imyaka y\'Uburambe',
monthlyIncome: 'Amafaranga Akwezi',
contractStartDate: 'Itariki y\'Itangiriro ry\'Amasezerano',
contractEndDate: 'Itariki yo Kurangiza ry\'Amasezerano',
selectCohort: 'Hitamo itsinda',
selectDepartment: 'Hitamo ishami',
selectStatus: 'Hitamo imimerere',
selectSector: 'Hitamo urwego',
selectMode: 'Hitamo uburyo',
selectIncome: 'Hitamo igiharuro',
selectRelevance: 'Hitamo isano',
selectConfidence: 'Hitamo urwego rw\'icyizere',
selfEmployed: 'Ukora wenyine',
unemployed: 'Ntagakazi',
employedByCompany: 'Akazi mu Isosiyete',
workForOthers: 'Gukorera Abandi',
continuingTraining: 'Gukomeza Amahugurwa',
publicSector: 'Leta',
privateSector: 'Abigenga',
ngo: 'NGO',
other: 'Ibindi',
permanent: 'Akazi Gahoraho',
internship: 'Gutozwa Akazi',
partTime: 'Akazi gato',
volunteer: 'Ubushake',
directlyRelated: 'Bifitanye Isano Rikomeye',
somewhatRelated: 'Bifitanye Isano',
notRelated: 'Nta Sano',
veryGreatExtent: 'Cyane cyane',
greatExtent: 'Cyane',
moderateExtent: 'Hagati',
smallExtent: 'Gake',
notAtAll: 'Nta na gake',
fullyIndependent: 'Ubu ndi ubwigenge mu by\'amafaranga',
significantlyContribute: 'Ngitira uruhare runini mu mafaranga y\'urugo',
occasionallyContribute: 'Ngitira uruhare rimwe na rimwe',
notChanged: 'Imimerere y\'amafaranga yanjye ntiyahindutse',
worsened: 'Imimerere y\'amafaranga yanjye yarushijeho kuba mbi',
muchBetter: 'Byarushijeho kuba byiza cyane',
better: 'Byarushijeho kuba byiza',
same: 'Bisa nk\'aho',
worse: 'Byarushijeho kuba bibi',
muchWorse: 'Byarushijeho kuba bibi cyane',
yesEveryMonth: 'Yego, buri kwezi',
yesOccasionally: 'Yego, rimwe na rimwe',
noButPlan: 'Oya, ariko ndategura',
no: 'Oya',
veryConfident: 'Nizera cyane',
confident: 'Nizera',
moderatelyConfident: 'Nzera hagati',
slightlyConfident: 'Nzera gake',
notConfident: 'Sinizera na gake',
transformational: 'Ihinduka rikomeye',
significantPositive: 'Ingaruka nziza ikomeye',
moderatePositive: 'Ingaruka nziza hagati',
slightPositive: 'Ingaruka nziza gake',
noImpact: 'Nta ngaruka zagaragaye',
significantly: 'Yego, cyane',
toSomeExtent: 'Yego, mu rugero',
noChange: 'Nta hinduka',
lessInvolved: 'Ntagira uruhare nk\'uko byari',
confirmToggleStatus: 'Hindura Imimerere',
confirmToggleTraineeStatus: 'Urazi neza ko ushaka guhindura imimerere y\'uwo wamenyekanye? Abatakora ntibagaragara ku rupapuro rw\'ibanze.',
traineeActivated: 'Uwamenyekanye yakozwe neza',
traineeDeactivated: 'Uwamenyekanye yahagaritswe neza',
failedToggleTraineeStatus: 'Byanze guhindura imimerere y\'uwamenyekanye',
traineeInactive: 'Uwamenyekanye ntagikora',
    homepageManagement: 'Gucunga Urubuga Rw\'ibanze',
heroSlides: 'Amashusho ya Hero',
addHeroSlide: 'Ongeraho Ishusho ya Hero',
editHeroSlide: 'Hindura Ishusho ya Hero',
noHeroSlides: 'Nta mashusho ya Hero',
addHeroSlidesDesc: 'Ongeraho amashusho yo kwerekana ku gice cya hero cy\'urubuga',
stats: 'Imibare',
noStats: 'Nta mibare',
addStatsDesc: 'Ongeraho imibare yo kwerekana ku rupapuro rw\'ibanze',
addStat: 'Ongeraho Imibare',
editStat: 'Hindura Imibare',
statAdded: 'Imibare yongeweho neza',
statUpdated: 'Imibare yavuguruwe neza',
statDeleted: 'Imibare yasibwe neza',
confirmDeleteStat: 'Urabizi ko ushaka gusiba iyi mibare?',
confirmDeleteStatTitle: 'Siba Imibare',
heroSlideAdded: 'Ishusho ya Hero yongeweho neza',
heroSlideUpdated: 'Ishusho ya Hero yavuguruwe neza',
heroSlideDeleted: 'Ishusho ya Hero yasibwe neza',
heroSlideStatusToggled: 'Imiterere y\'ishusho ya Hero yavuguruwe',
failedAddHeroSlide: 'Byanze kongeraho ishusho ya Hero',
failedUpdateHeroSlide: 'Byanze guhindura ishusho ya Hero',
failedDeleteHeroSlide: 'Byanze gusiba ishusho ya Hero',
failedToggleHeroSlideStatus: 'Byanze guhindura imiterere y\'ishusho ya Hero',
confirmDeleteHeroSlideTitle: 'Siba Ishusho ya Hero',
confirmDeleteHeroSlide: 'Urabizi ko ushaka gusiba iyi shusho ya Hero?',
failedLoadHeroSlides: 'Byanze gukura amashusho ya Hero',
failedLoadStats: 'Byanze gukura imibare',
failedAddStat: 'Byanze kongeraho imibare',
failedUpdateStat: 'Byanze guhindura imibare',
failedDeleteStat: 'Byanze gusiba imibare',

activityImages: 'Amashusho y\'Ibikorwa',
activityImagesManagement: 'Gucunga Amashusho y\'Ibikorwa',
addActivityImage: 'Ongeraho Ishusho y\'Ibikorwa',
editActivityImage: 'Hindura Ishusho y\'Ibikorwa',
activityImageAdded: 'Ishusho y\'ibikorwa yongeweho neza',
activityImageUpdated: 'Ishusho y\'ibikorwa yavuguruwe neza',
activityImageDeleted: 'Ishusho y\'ibikorwa yasibwe neza',
activityImageStatusToggled: 'Imiterere y\'ishusho y\'ibikorwa yavuguruwe',
confirmDeleteActivityImage: 'Urabizi ko ushaka gusiba iyi shusho y\'ibikorwa?',
searchActivityImages: 'Shakisha amashusho y\'ibikorwa...',
bulkUpload: 'Kuzana Benshi',
bulkUploadImages: 'Kuzana Amashusho Benshi',
bulkUploadComplete: 'Kuzana byose byakunze',
failedBulkUpload: 'Kuzana byose byanze',
selectImagesToUpload: 'Nyamuneka hitamo amashusho yo kuzana',
selectedFiles: 'Dosiye Zahitwe',
uploadAll: 'Zana Byose',
uploading: 'Birimo kuzanwa...',
imageRequired: 'Dosiye y\'ishusho irakenewe',
failedAddActivityImage: 'Byanze kongeraho ishusho y\'ibikorwa',
failedUpdateActivityImage: 'Byanze guhindura ishusho y\'ibikorwa',
failedDeleteImage: 'Byanze gusiba ishusho',
imageDeleted: 'Ishusho yasibwe neza',
imageRestored: 'Ishusho yasubijwe neza',
failedRestoreImage: 'Byanze gusubiza ishusho',
imageStatusToggled: 'Imiterere y\'ishusho yavuguruwe',
failedToggleImageStatus: 'Byanze guhindura imiterere y\'ishusho',
failedLoadActivityImages: 'Byanze gukura amashusho y\'ibikorwa',
exportActivityImages: 'Kuramo Amashusho y\'Ibikorwa',
activityImagesExported: 'Amashusho y\'ibikorwa yakuwe neza',
failedExportActivityImages: 'Byanze gukura amashusho y\'ibikorwa',
womenInAction: 'Abagore mu Bikorwa',
totalImages: 'Amashusho Yose',
activeImages: 'Amashusho Akora',
departmentsWithImages: 'Imyanya Ifite Amashusho',
lastUpload: 'Iheruka Kuzanwa',
never: 'Ntibigeze',
noActivityImages: 'Nta mashusho y\'ibikorwa yabonetse',
addActivityImagesDesc: 'Ongeraho amashusho yo kwerekana mu gice "Abagore mu Bikorwa" ku rupapuro rw\'ibanze',
    whyChooseUs: "Kuki Watuhitamo",
    deleteWhyChooseUs: "Wiboneye neza ko ushaka gusiba iki kintu?",
    deleteWhyChooseUsTitle: "Siba Ikintu",
    deleteVideo: "Wiboneye neza ko ushaka gusiba iyi video?",
    deleteVideoTitle: "Siba Video",
    added: "Ikintu cyongeweho neza",
    updated: "Ikintu cyavuguruwe neza",
    deleted: "Ikintu cyasibwe neza",
    statusToggled: "Imiterere yavuguruwe neza",
    failedAdd: "Kongeramo ikintu byananiwe",
    failedUpdate: "Kuvugurura ikintu byananiwe",
    failedDelete: "Kusiba ikintu byananiwe",
    failedToggle: "Kuvugurura imiterere byananiwe",
    videoSections: "Ibice bya Video",
    addVideo: "Ongeraho Video",
    editVideo: "Hindura Video",
    noVideos: "Nta bice bya video",
    addVideos: "Ongeraho video zerekana kuri page ya mbere",
    videoUrl: "URL ya Video",
    thumbnail: "Igishushanyo gito",
    setAsActive: "Shyiraho nka video ikora",
    onlyOneActive: "Video imwe gusa ishobora gukora icyarimwe",
    currentThumbnail: "Igishushanyo gito kigezweho",
    watchVideo: "Reba Video",
    playVideo: "Kina Video",
    active: "Ikora",
    inactive: "Ntigikora",
    untitled: "Nta mutwe",
    youtubeEmbedUrl: "Koresha URL ya YouTube (urugero: https://www.youtube.com/embed/VIDEO_ID)",
    enterVideoTitle: "Shyiramo umutwe wa video",
    enterVideoDescription: "Shyiramo ibisobanuro bya video",
    setActive: "Shyiraho nk'ikora",
    whyChooseUsItems: "Ibintu Kuki Watuhitamo",
    addItem: "Ongeraho Ikintu",
    editItem: "Hindura Ikintu",
    noWhyChooseUsItems: "Nta bintu Kuki Watuhitamo",
    addWhyChooseUsItems: "Ongeraho ibintu byerekanwa kuri page ya mbere",
    icon: "Akashusho",
    title: "Umutwe",
    description: "Ibisobanuro",
    sortOrder: "Gahunda yo Gutondeka",
    status: "Imiterere",
    actions: "Ibyo gukora",
    iconPreview: "Ibanzirizwa ry'Akashusho",
    enterTitle: "Shyiramo umutwe",
    enterDescription: "Shyiramo ibisobanuro",
    currentPassword: 'Ijambobanga Ririho Ubu',
enterCurrentPassword: 'Shyiramo ijambobanga ririho ubu',
passwordsDoNotMatch: 'Ijambobanga ntirisanzwe',
passwordTooShort: 'Ijambobanga rigomba kugira byibuze inyuguti 6',
passwordChanged: 'Ijambobanga ryahinduwe neza!',
failedChangePassword: 'Kubahindura ijambobanga byanze',
changing: 'Irirahindura...',
changePassword: 'Hindura Ijambobanga',
    // Contract Management Translations
contracts: 'Amasezerano Yange',
activeContracts: 'Amasezerano Akora',
contractHistory: 'Amateka y\'Amasezerano',
completedContracts: 'Yarangiye',
expiringSoon: 'Agiye Gushira Vuba',
noActiveContracts: 'Nta Masezerano Akora',
noActiveContractsDesc: 'Nta masezerano ukora ufite ubu.',
noContractHistory: 'Nta Mateka y\'Amasezerano',
noContractHistoryDesc: 'Nta masezerano warangije cyangwa wahagaritse ufite.',
contractDetails: 'Ibisobanuro by\'Amasezerano',
contractId: 'Indangamuntu y\'Amasezerano',
period: 'Igihe',
startDate: 'Itariki y\'Itangiriro',
endDate: 'Itariki yo Kurangiza',
daysRemaining: 'Iminsi Isigaye',
status: 'Imiterere',
terminationReason: 'Impamvu yo Guhagarika',
renew: 'Kongera',
renewNow: 'Kongera Ubu',
terminate: 'Hagarika',
viewDetails: 'Reba Ibisobanuro',
renewContract: 'Kongera Amasezerano',
terminateContract: 'Guhagarika Amasezerano',
renewContractInfo: 'Amasezerano ariho arangiye ku itariki:',
selectContractPeriod: 'Hitamo igihe cy\'amasezerano',
customMonths: 'Amezi y\'umwihariko...',
months: 'amezi',
sendEmailNotification: 'Ohereza imeri y\'ibyemezo',
renewContractNote: 'Kongera amasezerano bizatuma habaho igihe gishya. Amasezerano ariho azashyirwaho ikimenyetso cy\'uko yakongewe.',
renewing: 'Irakongera...',
terminating: 'Irahagarika...',
warning: 'Iburira',
terminateContractWarning: 'Iki gikorwa ntigishobora guseswa.',
selectReason: 'Hitamo impamvu',
workCompleted: 'Akazi karangiye',
performance: 'Ibibazo by\'imikorere',
budgetConstraints: 'Ibibazo by\'ingengo y\'imari',
restructuring: 'Guhindura imiterere y\'isosiyete',
mutualAgreement: 'Amasezerano y\'impande zombi',
other: 'Ibindi',
customReason: 'Impamvu yihariye',
enterTerminationReason: 'Shyiramo impamvu yo guhagarika',
effectiveDate: 'Itariki itangira gukora',
effectiveDateNote: 'Reka ari ubusa kugirango uhagarike ako kanya',
sendTerminationEmail: 'Ohereza imeri y\'ibyemezo byo guhagarika',
womanInformation: 'Amakuru y\'Umugore',
name: 'Izina',
age: 'Imyaka',
department: 'Ishami',
skills: 'Ubuhanga',
experience: 'Uburambe',
years: 'imyaka',
phone: 'Telefoni',
email: 'Imeri',
contractInformation: 'Amakuru y\'Amasezerano',
terminationDetails: 'Ibisobanuro byo Guhagarika',
terminatedOn: 'Yahagaritswe ku itariki',
renewalInformation: 'Amakuru yo Kongera',
renewedFrom: 'Yakongewe kuva',
renewedTo: 'Yakongewe kugeza',
notes: 'Inyandiko',
close: 'Funga',
expired: 'Irashize',
active: 'Irakora',
searchContracts: 'Shakisha amasezerano...',
refresh: 'Ongera ugarure',
viewAll: 'Reba Byose',
exportList: 'Kuramo Urutonde',
exportSuccessful: 'Gukuraho byakunze',
exportFailed: 'Gukuraho byanze. Ongera ugerageze.',
exportingContracts: 'Irarukura amasezerano...',
    exportOptions: 'Uburyo bwo Gukuraho',
exportAsCSV: 'Kuramo nka CSV',
exportAsExcel: 'Kuramo nka Excel',
exportAsPDF: 'Kuramo nka PDF',
exportSuccessful: 'Gukuraho byakunze',
exportFailed: 'Gukuraho byanze. Ongera ugerageze.',
exportingContracts: 'Irarukura amasezerano...',
    contractExpiration: 'Igihe Kontara Iheruka',
    showContractsExpiringIn: 'Erekana kontara zigiye gushira mu',
    days: 'iminsi',
    refresh: 'Ongera ugarure',
    manageAllContracts: 'Gucunga Kontira Zose',
    activeContracts: 'Kontara Zikora',
    expiringThisMonth: 'Zigiye Gushira Ukwezi',
    renewedThisMonth: 'Zongerewe Ukwezi',
    expiringNextMonth: 'Zigiye Gushira Ukwezi Gutaha',
    noExpiringContracts: 'Nta Kontara Zigenda Zishira',
    noContractsExpiringSoon: 'Nta kontara zigiye gushira mu gihe cyagenwe.',
    contractsExpiringInNext: 'kontara zigiye gushira mu',
    woman: 'Umugore',
    department: 'Ishami',
    contractPeriod: 'Igihe cy\'Amasezerano',
    startDate: 'Itariki y\'Itangiriro',
    endDate: 'Itariki yo Kurangiza',
    daysRemaining: 'Iminsi Isigaye',
    employer: 'Umukoresha',
    contact: 'Aho Twovugana',
    actions: 'Ibikorwa',
    noPhone: 'Nta terefone',
    general: 'Rusange',
    months: 'amezi',
    sendEmail: 'Ohereza Imeri',
    call: 'Hamagara',
    viewDetails: 'Reba Ibisobanuro',
    sendReminder: 'Ohereza Iwibutso',
    extendContract: 'Kwongera Igihe',
    exportExpiringContracts: 'Kuramo Urutonde',
    
    // Additional export-related translations
    exportContracts: 'Kuramo Amasezerano',
    exportAsCSV: 'Kuramo nka CSV',
    exportAsExcel: 'Kuramo nka Excel',
    exportAsPDF: 'Kuramo nka PDF',
    exportingContracts: 'Irarukura amasezerano...',
    exportSuccessful: 'Gukuraho byakunze',
    exportFailed: 'Gukuraho byanze. Ongera ugerageze.',
    downloadExportedFile: 'Kuramo Dosive Yasohotse',
    selectExportFormat: 'Hitamo Uburyo bwo Gukuraho',
    includeInactiveContracts: 'Shyiramo amasezerano adakora',
    exportAllContracts: 'Kuramo Amasezerano Yose',
    exportFilteredContracts: 'Kuramo Amasezerano Yaciwe',
    contractExportTitle: 'Gukuraho Amasezerano',
    generatingExport: 'Itegura dosive yo gukuraho...',
    contractList: 'Urutonde rw\'Amasezerano',
    totalContracts: 'Igiteranyo cy\'Amasezerano',
    exportDate: 'Itariki yo Gukuraho',
    exportedBy: 'Byakuwe Na',
    contractDetails: 'Ibisobanuro by\'Amasezerano',
    womanName: 'Izina ry\'Umugore',
    employerName: 'Izina ry\'Umukoresha',
    employerEmail: 'Imeri y\'Umukoresha',
    employerPhone: 'Terefone y\'Umukoresha',
    contractStart: 'Itangiriro ry\'Amasezerano',
    contractEnd: 'Iherezo ry\'Amasezerano',
    contractMonths: 'Amezi y\'Amasezerano',
    status: 'Imiterere',
    active: 'Irakora',
    expired: 'Irashize',
    expiringSoon: 'Iraje Vuba',
    critical: 'Ingirakamaro',
    warning: 'Iburira',
    good: 'Nziza',
    exportSummary: 'Incamake yo Gukuraho',
    rowsExported: 'imirongo yakuwe',
    exportTime: 'Igihe cyo Gukuraho',
    contractStats: 'Imibare y\'Amasezerano',
    fetchingContracts: 'Ishakisha amasezerano...',
    noContractsFound: 'Nta masezerano abonetse',
    viewContract: 'Reba Amasezerano',
    contractId: 'Indangamuntu y\'Amasezerano',
    contractStatus: 'Imiterere y\'Amasezerano',
    renewContract: 'Kongera Amasezerano',
    contractRenewed: 'Amasezerano yakongewe neza',
    renewalDate: 'Itariki yo Kongera',
    previousContract: 'Amasezerano Abanziriza',
    nextContract: 'Amasezerano Akurikira',
    contractHistory: 'Amateka y\'Amasezerano',
    renewalHistory: 'Amateka yo Kongera',
    confirmRenewContract: 'Emeza ko ushaka kongera aya masezerano?',
    enterRenewalMonths: 'Shyiramo umubare w\'amezi yo kongeraho',
    renewalPeriod: 'Igihe cyo Kongera',
    newEndDate: 'Itariki Nshya yo Kurangiza',
    contractNotes: 'Inyandiko z\'Amasezerano',
    addContractNote: 'Ongeraho Inyandiko',
    viewAllContracts: 'Reba Amasezerano Yose',
    filterContracts: 'Yungurura Amasezerano',
    searchContracts: 'Shakisha amasezerano...',
    clearFilters: 'Hanagura Ibyunguruzo',
    applyFilters: 'Shyiramo Ibyunguruzo',

     // Partners Management - Kinyarwanda
     partners: 'Abafatanyabikorwa & Abaterankunga',
     partnersManagement: 'Gucunga Abafatanyabikorwa',
     addPartner: 'Ongeraho Umunyamigabane',
     editPartner: 'Hindura Umunyamigabane',
     partnerName: 'Izina ry\'Umunyamigabane',
     partnerType: 'Ubwoko bw\'Umunyamigabane',
     partnerLogo: 'Ikirango cy\'Umunyamigabane',
     websiteUrl: 'URL y\'urubuga',
     sortOrder: 'Gutondekanya',
     enterPartnerName: 'Shyiramo izina ry\'umufatanyabikorwa',
     selectType: 'Hitamo ubwoko bw\'umufatanyabikorwa',
     enterPartnerDescription: 'Shyiramo ibisobanuro ku mufatanyabikorwa',
     currentLogo: 'Ikirango kigezweho',
     updatePartner: 'Vugurura Umunyamigabane',
     failedAddPartner: 'Kongera umunyamigabane byananiwe',
     failedUpdatePartner: 'Kuvugurura umunyamigabane byananiwe',
     failedDeletePartner: 'Gusiba umunyamigabane byananiwe',
     failedLoadPartners: 'Gupakura abafatanyabikorwa byananiwe',
     failedTogglePartnerStatus: 'Guhindura imiterere y\'umufatanyabikorwa byananiwe',
     partnerAdded: 'Umunyamigabane yongewemo neza',
     partnerUpdated: 'Umunyamigabane yavuguruwe neza',
     partnerDeleted: 'Umunyamigabane yasibwe neza',
     partnerStatusToggled: 'Imiterere y\'umufatanyabikorwa yahinduwe neza',
     confirmDeletePartnerTitle: 'Siba Umunyamigabane',
     confirmDeletePartner: 'Emeza niba ushaka gusiba uyu mufatanyabikorwa? Iki gikorwa ntigisubirwamo.',
     searchPartners: 'Shakisha abafatanyabikorwa...',
     allTypes: 'Ubwoko Bwose',
     noPartnersFound: 'Nta bafatanyabikorwa babonetse',
     noPartnersMatchCriteria: 'Nta bafatanyabikorwa bahuye n\'ibyo ushaka',
     showingPartners: 'Bwerekana {showing} kuri {total} bafatanyabikorwa',
     deactivate: 'Guhagarika',
     activate: 'Gukora',
     visit: 'Sura',
     noDescription: 'Nta bisobanuro',
     partnerDescriptionDefault: 'Umuryango mufatanyabikorwa',
     visitWebsite: 'Sura Urubuga',
     government: 'Leta',
     internationalNGO: 'NGO Mpuzamahanga',
     localNGO: 'NGO y\'Igihugu',
     corporate: 'Imikoranire',
     private: 'Abigenga',
     educational: 'Uburezi',
     other: 'Ibindi',
     partnersCount: 'Umubare w\'Abafatanyabikorwa',
     activePartners: 'Abafatanyabikorwa bakora',
     inactivePartners: 'Abafatanyabikorwa badakora',
     partnerStats: 'Ibarura ry\'Abafatanyabikorwa',
     exportPartners: 'Kuramo Abafatanyabikorwa',
     importPartners: 'Injiza Abafatanyabikorwa',
     partnerDetails: 'Ibisobanuro ku Mufatanyabikorwa',
     establishedDate: 'Itariki y\'ashyizweho',
     lastUpdated: 'Iheruka kuvugururwa',
    amountNote:'Amafaranga ya RWF 10,000 byuzuye ku mugore umwe, byaba yarikoze igihe kirekire cyangwa gito',
    enterEmailAddress: 'Shyiramo aderesi yawe ya email',
    resetEmailSent: 'Imeri yo gusubiza ijambobanga yoherejwe. Nyamuneka urebe mu birahuriwe byawe.',
    resetRequestFailed: 'Byanze gukora gusaba ko wasubiza ijambobanga. Nyamuneka ongera ugerageze.',
    forgotPasswordDescription: 'Shyiramo imeri yawe kugirango wasubize ijambobanga ryawe',
    backToLogin: 'Subira inyuma mu kwinjira',
    sendResetLink: 'Ohereza Ihuza ryo Gusubiza',
    sending: 'Irihereza...',
    resetInstructions: 'Uzabona imeri ifite ihuza ryo gusubiza ijambobanga ryawe. Ihuza rizaba rimara mu isaha 1.',
    
    // Kinyarwanda (Ikinyarwanda)
    contractPeriod: 'Igihe cyo Kontira',
    selectContractPeriod: 'Hitamo igihe cyo kontira',
    requiredSkills: 'Ubushobozi Bufunwa',
    selectRelevantSkills: 'Hitamo ubushobozi buhuye n\'iyi mafaranga',
    noSkillsForDepartment: 'Nta bushobozi buboneka kuri iki gice',
    expiringContracts: 'Kontira Ziba Isaha',
    showContractsExpiringIn: 'Erekana kontira ziba isaha mu:',
    noExpiringContracts: 'Nta Kontira Ziba Isaha',
    noContractsExpiringSoon: 'Nta kontira ziba isaha mu gihe gito',
    daysRemaining: 'Iminsi Isigaye',
    daysLeft: 'iminsi isigaye',
    sendReminder: 'Ohereza ibibutsa',
    renewContract: 'Kongera Kontira',
    contractRenewed: 'Kontira yakongewe neza',
    months: 'amezi',
    
    csvTemplateInstructions: 'CSV igomba kugira inkingi: izina, imyaka, umwanya, ubushobozi, imyaka y\'ubumenyi, urwego rw\'amashuri, telefoni, imeyili, aho aba, amakuru, amazina y\'ubushobozi',
    importInstructions: 'Kuramo ingero kugirango wizere ko format yayo ni yo',
    downloadTemplate: 'Kuramo Ingero',
    importing: 'Kuzana...',
    import: 'Zana',
    importProfiles: 'Zana Amakuru',
    cannotAssignDifferentDept: 'Ntushobora guha abagore baturuka mu bice bitandukanye',
    validationFailed: 'Guhuzwa atabonye',
    viewCertificate: 'Reba Sertifika',
    certified: 'Yemewe',
    certificatePending: 'Sertifika Irengera',
    requestThisWoman: 'Saba uyu mugore',
    currentlyEmployed: 'Ubu Akora',
    
    '3 months': 'amezi 3',
    '6 months': 'amezi 6',
    '1 year': 'umwaka 1',
    '2 years': 'imyaka 2',
    '3 years': 'imyaka 3',
    
    beginner: 'Umutangizi',
    intermediate: 'Uri Hagati',
    advanced: 'Ubarusha',
    expert: 'Umuhanga',
    
    sendCustomEmail: 'Ohereza Imeri Yihariye',
    emailRecipients: 'Abakiriya ba Imeri',
    enterEmailRecipients: 'Injiza imeyili (zitandukanyije n\'ikoma)',
    commaSeparatedEmails: 'Injiza imeyili nyinshi zitandukanyije n\'ikoma',
    customEmailDescription: 'Ohereza imeri kuri aya mayeri yose (ntawe uri mu bantu b\'urubuga)',
    allFieldsRequired: 'Imirima yose irakenerwa',
    invalidEmails: 'Imeri zitabonetse',
    emailSentSuccessfully: 'Imeri yoherejwe neza kuri abakiriya',
    failedToSendEmail: 'Kubohereza imeri byanze',
    customEmail: 'Imeri Yihariye',
    attachments: 'Ibyongewe',
    maxFileSize: 'Ingano ikomeye',
    uploadCSVFile: 'Shyiraho Dosye ya CSV',
    importWomenProfiles: 'Zana Amakuru y\'Abagore',
    // Privacy Policy
  privacyPolicy: 'Politike yo kubitiranya',
  lastUpdated: 'Yahinduwe nshya',
  privacyIntroTitle: 'Intangiriro',
  privacyIntroText: 'Urugo Women Opportunity Center yubahiriza ibanga ryawe. Iyi politike yo kubitiranya isobanura uko dukusanya, dukoresha, kandi dukingira amakuru yawe yihariye.',
  informationWeCollect: 'Amakuru dukusanya',
  personalInformation: 'Amakuru yihariye',
  infoNameEmail: 'Izina na email',
  infoPhoneAddress: 'Numero ya telefoni naho utuye',
  infoPaymentDetails: 'Amakuru ya kwishyura kwitera inkunga',
  infoEmploymentHistory: 'Amakuru yibyaranzwe nubuhanga',
  usageData: 'Amakuru yo gukoresha',
  dataIPAddress: 'Aderesi ya IP nubwoko bwa browser',
  dataBrowserType: 'Amakuru ya mudasobwa',
  dataPagesVisited: 'Ipaji wazanyweho nigihe wakoresheje',
  dataTimeSpent: 'Amakuru yurubuga rwatumiriwe',
  howWeUseInformation: 'Uko dukoresha amakuru yawe',
  useProvideServices: 'Kugira ngo tuhe nkunga kandi tuzirikane serivisi zacu',
  useProcessDonations: 'Gutunganya inkunga nibihembo',
  useMatchEmployees: 'Kuvanga abagore niamahirwe yo gukora',
  useCommunication: 'Kuvugana nawe',
  useImproveServices: 'Kongera serivisi zacu nurubuga',
  useLegalCompliance: 'Kubahiriza ibyo amategeko bitegeka',
  informationSharing: 'Kugabanya amakuru',
  sharingIntro: 'Ntitugurisha amakuru yawe yihariye. Dushyira hamwe amakuru gusa mubimukamo bikurikira:',
  withEmployers: 'Nabashinzwe gukoresha',
  sharingEmployers: 'Gusa nabwo bushake bwawe bwo gufatanya imirimo',
  withServiceProviders: 'Nabatanga serivisi',
  sharingProviders: 'Abafatanyabikorwa bemerwa batuma ibikorwa byacu bikomeza',
  legalRequirements: 'Ibibazwa nitegeko',
  sharingLegal: 'Iyo byabazwa nitegeko cyangwa gahunda zamategeko',
  withConsent: 'Nuburenganzira bwawe',
  sharingConsent: 'Iyo uduhaye uburenganzira bwihariye',
  dataSecurity: 'Umutekano wamakuru',
  securityMeasures: 'Dukora ibikorwa byo kurinda umutekano bigezweho kugirango dukingire amakuru yawe.',
  securityEncryption: 'Umutekano wa SSL wo kohereza amakuru',
  securityAccessControl: 'Igenzura ryinjira nuburenganzira',
  securityRegularAudits: 'Gusuzuma umutekano buri gihe',
  securityTraining: 'Imyigishirize yabakozi kubitiranya',
  yourRights: 'Ubururu bwawe',
  rightAccess: 'Ubururu bwo kubona amakuru yawe yihariye',
  rightCorrection: 'Ubururu bwo gukosora amakuru atari yo',
  rightDeletion: 'Ubururu bwo gusiba amakuru yawe',
  rightObject: 'Ubururu bwo guhakana ibikorwa',
  rightDataPortability: 'Ubururu bwo kohereza amakuru',
  rightWithdrawConsent: 'Ubururu bwo guhagarika uburenganzira',
  cookies: 'Cookies',
  cookiesDescription: 'Tukoresha cookies kugirango tuzamure ubukerarugendo bwawe kurubuga rwacu.',
  essentialCookies: 'Cookies zingengabitekerezo',
  essentialCookiesDesc: 'Zibazwa kugirango urubuga rukore',
  analyticsCookies: 'Cookies zo gusuzuma',
  analyticsCookiesDesc: 'Zituma dusobanukiwe uko abakundana bakoresha urubuga rwacu',
  preferenceCookies: 'Cookies zibidukikije',
  preferenceCookiesDesc: 'Zibuka igenamigere yawe nibyifuzo',
  childrenPrivacy: "Ibitiranya abana",
  childrenPrivacyText: 'Serivisi zacu ntizerekeza abana bari munsi yimyaka 18.',
  changesToPolicy: 'Ihindurwa ryiyi politike yo kubitiranya',
  policyChangesText: 'Dushobora guhindura politike yacu yo kubitiranya buri gihe.',
  contactUsPrivacy: 'Twandikire',
  contactPrivacyText: 'Niba ufite ibibazo kuri iyi politike yo kubitiranya, twandikire kuri:',
  
  // Terms of Service
  termsOfService: 'Amategeko yo gukoresha serivisi',
  termsAgreement: 'Kwirizana namategeko',
  termsAgreementText: 'Ukoresheje urubuga rwacu, ubyemera amategeko yo gukoresha serivisi.',
  definitions: 'Ibisobanuro',
  platform: 'Urubuga',
  platformDefinition: 'Urubuga rwa Urugo WOC',
  services: 'Serivisi',
  servicesDefinition: 'Serivisi zo gufatanya imirimo, myigishirize, nitera inkunga',
  user: 'Umukoresha',
  userDefinition: 'Uwo ariwe wese ukoresha urubuga',
  employer: 'Umushinzwe gukoresha',
  employerDefinition: 'Abantu cyangwa sosiyete bashaka gukoresha abantu',
  employee: 'Umukozi',
  employeeDefinition: 'Abagore bashaka amahirwe yo gukora',
  donor: 'Uwitanga inkunga',
  donorDefinition: 'Abantu cyangwa inganda zitanga inkunga',
  accountRegistration: 'Kwiyandikisha konti',
  accountRegistrationText: 'Kugira ngo ukoreshe imiterere ikiriya, ugomba kwiyandikisha konti.',
  accountAgeRequirement: 'Ugomba kuba ufite imyaka 18 nheze',
  accountAccurateInfo: 'Tanga amakuru yuzuye kandi yemewe',
  accountSecurity: 'Komeza umutekano wakonti',
  accountTransfer: 'Ntuzahindure akonti yawe ahandi',
  servicesDescription: 'Ibisobanuro bya serivisi',
  employmentServices: 'Serivisi zimirimo',
  employmentMatch: 'Kuvanga abagore bafite ubuhanga nabashinzwe gukoresha',
  employmentVerification: 'Gusuzuma ubuhanga nubushobozi',
  employmentTraining: 'Myigishirize nubukungu bwubuhanga',
  employmentSupport: 'Gufasha buri gihe mu mirimo',
  donationServices: 'Serivisi zitera inkunga',
  donationProcessing: 'Gutunganya inkunga',
  donationTracking: 'Gukurikirza ingaruka zitera inkunga',
  donationReporting: 'Kumenyesha ingaruka buri gihe',
  donationTransparency: 'Kugaragaza neza amafaranga yakoreshejwe',
  userObligations: 'Ibyo ukwiye gukora',
  generalUserObligations: 'Ibyo ukwiye gukora byose',
  obeyLaws: 'Kubahiriza amategeko nimirongo',
  respectOthers: 'Kubahiriza abandi mukoresha nibitiranya byabo',
  noFraud: 'Ntukagire ibikorwa byoburyarya',
  accurateInfo: 'Tanga amakuru yemewe',
  noHarassment: 'Ntukasuzugure cyangwa utandukanyije',
  employerObligations: 'Ibyo umushinzwe gukoresha akwiye gukora',
  fairTreatment: 'Tanga amategeko yimirimo ari mu buryo bwiza',
  timelyPayment: 'Shyura igihe cyagenwe',
  safeEnvironment: 'Tanga ahantu ho gukora huje umutekano',
  complianceLaws: 'Kubahiriza amategeko yimirimo',
  employeeObligations: 'Ibyo umukozi akwiye gukora',
  professionalConduct: 'Komeza imyitwarire nubucuruzi',
  honestSkills: 'Sobanura neza ubuhanga nubushobozi',
  commitment: 'Kuzuza icyifuzo cyo gukora',
  respectEmployer: 'Kubahiriza ibyashinzwe gukoresha nitegeko',
  paymentsFees: 'Ibishyurwa nibihembo',
  serviceFees: 'Ibishyurwa bya serivisi bishobora gushyirwa kuri serivisi zimwe na zimwe',
  donationFees: 'Ibishyurwa byo gutunganya inkunga',
  paymentMethods: 'Uburyo bwo kwishyura bwemewe',
  refundPolicy: 'Amategeko yo gusubiza amafaranga',
  taxResponsibility: 'Ibyo ukwiye kwishyura',
  intellectualProperty: 'Uburenganzira bwibitekerezo',
  ipOwnership: 'Dufite uburenganzira bwose bwibitekerezo kurubuga.',
  ipLicense: 'Duguha uburenganzira buke bwo gukoresha urubuga.',
  userContentLicense: 'Utuguha uburenganzira bwo gukoresha ibyanditswe byawe mu bikorwa byurubuga.',
  limitationLiability: 'Ikiranga uburenganzira',
  liabilityDisclaimer: 'Tanga serivisi "nkuko zimeze" nta garanti.',
  liabilityLimit: 'Ikiranga uburenganzira bwacu',
  liabilityForceMajeure: 'Ibintu bidashoboka gukumira',
  termination: 'Guhagarika',
  terminationClause: 'Dushobora guhagarika cyangwa guhagarika uburenganzira bwo kwinjira kuri konti yawe.',
  terminationBreach: 'Kubera gusenya amategeko',
  terminationInactivity: 'Kubera kutakora igihe kirekire',
  terminationRequest: 'Kubera gusaba kwawe',
  terminationPlatform: 'Kubera kubungabunga urubuga cyangwa umutekano',
  disputeResolution: 'Gusohora amakimbirane',
  governingLaw: 'Icyemezo cyamategeko',
  disputeProcess: 'Gahunda yo gusohora amakimbirane',
  mediationClause: 'Gutabara mbere yurubanza',
  changesToTerms: 'Ihindurwa ryamategeko',
  termsChangesText: 'Dushobora guhindura amategeko ari hose.',
  contactUsTerms: 'Twandikire',
  contactTermsText: 'Niba ufite ibibazo kuri aya mategeko, twandikire kuri:',
  
  // Sitemap
  sitemap: 'Ikarita yurubuga',
  sitemapDescription: 'Incamake yose yipaji niserivisi ziboneka kuri Urugo WOC',
  mainPages: 'Ipaji zingenzi',
  accountPages: 'Ipaji zikonti',
  policyPages: 'Ipaji zamategeko',
  servicePages: 'Ipaji zaserivisi',
  departmentPages: 'Ipaji zumuryango',
  trainingServices: 'Serivisi zimyigishirize',
  donationServices: 'Serivisi zitera inkunga',
  supportServices: 'Serivisi ziterambere',
  contactInformation: 'Amakuru yo kutwandikira',
  quickActions: 'Ibigomba gukora vuba',
  donateNow: 'Tanga inkunga none',
  registerNow: 'Iyandikishe none',
  totalPages: 'Ipaji zose',
  websiteVersion: 'Verisiyo yurubuga',
  viewPrivacy: 'Reba politike yo kubitiranya',
  viewTerms: 'Reba amategeko yo gukoresha serivisi',
  viewSitemap: 'Reba ikarita yurubuga',
  backToHome: 'Subira ahabanza',
     // Modal Alert translations
  alertSuccess: 'Intsinzi',
  alertError: 'Ikosa',
  alertWarning: 'Iburira',
  alertInfo: 'Amakuru',
  okButton: 'Yego',
  confirmButton: 'Emeza',
  cancelButton: 'Hagarika',
  tryAgainButton: 'Ongera ugerageze',
  close: 'Funga',
  
  // Request Modal translations
  step1Title: 'Tubwire ibyerekeye wowe',
  step1Description: 'Shakisha abagore barangije amahugurwa mu miryango yacu itandukanye',
  step2Title: 'Fungura Konti Yawe',
  step2Description: 'Uzanye umuryango wacu utangire gukorana abagore bafite ubumenyi',
  loginTitle: 'Injira muri Konti Yawe',
  loginDescription: 'Usanzwe ufite konti? Injira kugirango ukomeze',
  step3Title: 'Saba Abagore Barangije',
  step3Description: 'Uzuze ifomu ikurikira kugirango usabe abagore bafite ubumenyi bavuye kuri urwego rwacu',
  successTitle: 'Icyifuzo Cyohererejwe Neza!',
  successMessage: 'Icyifuzo cyawe cyakiriwe. Tuzakuganira vuba.',
  
  // Account types
  individual: 'Umuntu',
  individualDesc: 'Nkodesha kubwange',
  company: 'Sosiyete',
  companyDesc: 'Nkodesha ku bwanyirwanije',
  
  // Form labels
  companyNameLabel: 'Izina rya sosiyete',
  companyNamePlaceholder: 'Shyiramo izina rya sosiyete',
  fullNameLabel: 'Amazina Yuzuye',
  fullNamePlaceholder: 'Shyiramo amazina yawe yuzuye',
  usernameLabel: 'Izina Ukoresha',
  usernamePlaceholder: 'Hitamo izina ukoresha',
  workEmailLabel: 'Imeri y\'akazi',
  workEmailPlaceholder: 'Shyiramo imeri yawe y\'akazi',
  phoneLabel: 'Numero ya Telefone',
  phonePlaceholder: 'Shyiramo numero ya telefone',
  emailLabel: 'Aderesi ya Imeri',
  emailPlaceholder: 'Shyiramo imeri yawe',
  passwordLabel: 'Ijambobanga',
  passwordPlaceholder: 'Shyiramo ijambobanga ryawe',
  createPasswordPlaceholder: 'Kora ijambobanga',
  confirmPasswordLabel: 'Emeza Ijambobanga',
  confirmPasswordPlaceholder: 'Emeza ijambobanga ryawe',
  passwordMinLength: 'Ubare nibura inyuguti 10',
  agreeToTerms: 'Nemeranya n\'Amategeko yo Gukoresha n\'Ibyanga',
  
  // Request form
  selectDepartment: 'Hitamo Ishami',
  chooseDepartment: 'Hitamo ishami',
  employeesNeeded: 'Umubare w\'Abakozi',
  costPerEmployee: 'RWF 10,000 ku mukozi buri kwezi',
  workType: 'Ubwoko bw\'Akazi',
  fullTime: 'Akazi Gakondo',
  partTime: 'Akazi Gato',
  contract: 'Amasezerano',
  seasonal: 'Akarusho',
  duration: 'Igihe (Iminsi)',
  days: 'iminsi',
  totalAmount: 'Igiharuro Cyose',
  woman: 'umugore',
  'employee(s)': 'umukozi(zi)',
  personalInformation: 'Amakuru yawe',
  yourFullName: 'Amazina Yawe Yuzuye',
  email: 'Imeri',
  phoneNumber: 'Numero ya Telefone',
  
  // Specifications
  womanSpecifications: 'Ibyerekeye Umugore (Ntabwo ari ngombwa)',
  specificationsDescription: 'Tanga ibisabwa byongewaho kuri bagore ushaka kodesha',
  ageRange: 'Urwego rw\'Imiryango',
  experienceLevel: 'Urwego rw\'Ubusobanuro',
  skillLevel: 'Urwego rw\'Ubumenyi Bugenewe',
  educationLevel: 'Urwego rw\'Amashuri',
  languageRequirements: 'Ibisabwa by\'Ururimi',
  specialSkills: 'Ubumenyi Bw\'Icyitegererezo',
  otherSpecifications: 'Ibyatanzwe By\'Ikirindi',
  noPreference: 'Nta gihitamo',
  years: 'imyaka',
  beginner: 'Utangira',
  intermediate: 'Umwanya wo Hagati',
  advanced: 'Uburambe',
  expert: 'Inyangamugayo',
  basic: 'Ubumenyi Bw\'ibanze',
  kinyarwanda: 'Ikiyarwanda',
  french: 'Igifaransa',
  kinyarwandaEnglish: 'Ikiyarwanda n\'Icyongereza',
  anyLanguage: 'Icyo ari cyo cyose ururimi',
  primary: 'Amashuri abanza',
  secondary: 'Amashuri yisumbuye',
  vocational: 'Amahugurwa',
  university: 'Kaminuza',
  specialSkillsPlaceholder: 'urugero: Ubumenyi bwa mudasobwa, ubuyobozi, n\'ibindi',
  separateWithCommas: 'Tandukanya na virgule',
  otherSpecificationsPlaceholder: 'Icyo ari cyo cyose gisabwa cy\'icyitegererezo cyangwa ibyo wifuza...',
  
  // Payment
  paymentInformation: 'Amakuru y\'Amafaranga',
  mobileMoney: 'Mobile Money',
  bankAccount: 'Konti ya Banki',
  paymentNote: 'Nyamuneka uzuze amafaranga nyuma yo kohereza icyifuzo cyawe. Icyifuzo cyawe kizakorwa amafaranga yemewe.',
  
  // Buttons and actions
  continue: 'Komeza',
  back: 'Subira inyuma',
  backToRegister: 'Subira inyuma mu Kwiyandikisha',
  join: 'Injira',
  loggingIn: 'Ura Injira...',
  creatingAccount: 'Bubaka konti...',
  submitting: 'Irihereza...',
  submitRequest: 'Ohereza Icyifuzo',
  alreadyHaveAccount: 'Usanzwe ufite konti?',
  loginHere: 'Injira hano',
  signIn: 'Injira',
  showPassword: 'Erekana ijambobanga',
  hidePassword: 'Hisha ijambobanga',
  
  // Status messages
  available: 'Birabasha',
  working: 'Ari mu Kazi',
  certificateVerified: 'Byemejwe',
  certificateUnverified: 'Bitegereje',
  specificWomanRequest: 'Uri gusaba',
  specifically: 'mu buryo butaziguye',
  singleWomanNote: 'Umubare w\'abakozi ushyirwaho kuri 1 ku gisabwa cy\'umugore umwe.',
  requestingWoman: 'Uri gusaba:',
  youRequested: 'Wasabye:',
  yourSpecifications: 'Ibyatanzwe Byawe:',
  languages: 'Indimi',
  
  // Error messages
  passwordMismatch: 'Ijambobanga ntabwo bihuje',
  passwordTooShort: 'Ijambobanga kigomba kuba nibura inyuguti 10',
  registrationFailed: 'Kwiyandikisha byanze',
  loginFailed: 'Kwinjira byanze',
  requestFailed: 'Byanze guhera icyifuzo',
  loginToRequest: 'Nyamuneka winjire kugirango usabe abagore',
  
  // Success messages
  loginSuccess: 'Winjiye muri konti yawe neza.',
  registrationSuccess: 'Konti yawe yubatswe neza!',
  requestSuccess: 'Icyifuzo cyawe cyohererejwe neza!',
  
  // Step labels
  accountType: 'Ubwoko bwa Konti',
  account: 'Konti',
  request: 'Icyifuzo',
    // New keys for request specifications
requestManagementWithSpecs: 'Gucunga Ibisabwa (N\'Ibyatanzwe)',
specifications: 'Ibyatanzwe',
noSpecifications: 'Nta byatanzwe',
viewSpecifications: 'Reba ibyatanzwe',
hasSpecifications: 'Ifite ibyatanzwe',
withSpecifications: 'Ifite ibyatanzwe',
noSpecificationsProvided: 'Nta byatanzwe byongewe byatanzwe ku gisabwa.',
requestDetails: 'Ibyerekeye gisabwa',
employerInformation: 'Amakuru y\'umukoreshamabazi',
statusInformation: 'Amakuru y\'Imimerere',
employeesNeeded: 'Abakozi Bakeneye',
workType: 'Ubwoko bw\'Akazi',
duration: 'Igihe',
amount: 'Amafaranga',
paymentVerified: 'Amafaranga Yemejwe',
assignedWomen: 'Abagore Barimo',
availableWomen: 'Abagore Baboneka',
created: 'Yaremewe',
ageRange: 'Urwego rw\'Imiryango',
experienceLevel: 'Urwego rw\'Ubusobanuro',
skillLevel: 'Urwego rw\'Ubumenyi',
educationLevel: 'Urwego rw\'Amashuri',
languageRequirements: 'Ibyifuzo by\'Ururimi',
specialSkills: 'Ubumenyi Bw\'Icyitegererezo',
otherSpecifications: 'Ibyatanzwe By\'Ikirindi',
approveRequest: 'Emera Gisabwa',
rejectRequest: 'Hakanira Gisabwa',
assignWomen: 'Shyiraho Abagore',
close: 'Funga',

// Certificate related
uploadCertificate: 'Shyiraho Icyemezo',
certificateNumber: 'Numero y\'Icyemezo',
certificateType: 'Ubwoko bw\'Icyemezo',
selectCertificateType: 'Hitamo Ubwoko bw\'Icyemezo',
vocationalCertificate: 'Icyemezo cy\'Umwuga',
skillCertificate: 'Icyemezo cy\'Ubumenyi',
trainingCertificate: 'Icyemezo cy\'Imyigishirize',
professionalCertificate: 'Icyemezo cy\'Umwuga',
otherCertificate: 'Icyemezo Cy\'Ikirindi',
issuingOrganization: 'Ishami Ryatanze',
issueDate: 'Itariki Yatanzwe',
expiryDate: 'Itariki Yarangirira',
certificateFile: 'Dosiye y\'Icyemezo',
maxFileSize: 'Ingano y\'idosiye',
currentCertificate: 'Icyemezo Cy\'Ubu',
viewCurrentCertificate: 'Reba Icyemezo Cy\'Ubu',
updateCertificate: 'Kosora Icyemezo',
certificateVerified: 'Icyemezo Cyemejwe',
certificateUnverified: 'Icyemezo Kitacyemewe',
noCertificate: 'Nta Cye mezo',
viewCertificate: 'Reba Icyemezo',
markAsUnverified: 'Shyiraho nka Kitacyemewe',
verifyCertificate: 'Emeza Icyemezo',
deleteCertificate: 'Siba Icyemezo',
confirmDeleteCertificateTitle: 'Siba Icyemezo',
confirmDeleteCertificate: 'Urage neza ko ushaka gusiba iki cyemezo? Ibi ntibishobora guhindurwaho.',
confirmVerifyCertificateTitle: 'Emeza Icyemezo',
confirmVerifyCertificate: 'Urage neza ko ushaka kwemeza iki cyemezo?',
confirmUnverifyCertificateTitle: 'Kureka Icyemezo Kitacyemewe',
confirmUnverifyCertificate: 'Urage neza ko ushaka gushyiraho iki cyemezo nka kitacyemewe?',
certificateUploaded: 'Icyemezo cyashyizweho neza',
certificateDeleted: 'Icyemezo cyasibwe neza',
certificateVerifiedSuccess: 'Icyemezo cyemezwe neza',
certificateUnverifiedSuccess: 'Icyemezo cyarakatswe nka kitacyemewe',
failedUploadCertificate: 'Kutashobora gushyiraho icyemezo',
failedDeleteCertificate: 'Kutashobora gusiba icyemezo',
failedVerifyCertificate: 'Kutashobora kwemeza icyemezo',
failedUnverifyCertificate: 'Kutashobora kureka icyemezo kitacyemewe',

// Women management
selectAllAvailable: 'Hitamo abagore bose baboneka',
womanNotAvailable: 'Umugore ntaboneka mu gutanga',
selectForAssignment: 'Hitamo mu gutanga',
womenSelectedForAssignment: 'Abagore Bahitwe Mu Gutanga',
selected: 'byahitwe',
assignSelectedWomen: 'Shyiraho Abagore Bahitwe',

// Request status
completed: 'Byarakozwe',
cancelled: 'Byahagaritswe',
    emailSettings: 'Ibyerekeye Imeyili',
emailBroadcast: 'Kohereza Ibaruwa kuri bose',
emailBroadcastDescription: 'Kohereza amakuru n\'ibisubizo ku bose bakoresha sisitemu',
sendEmailBroadcast: 'Kohereza Ibaruwa kuri bose',
sendTestEmail: 'Kohereza Ibaruwa yo gusuzuma',
broadcastAllUsersWarning: 'Iyi imeyili izoherezwa ku BOSE bakoresha sisitemu.',
broadcastEmployersWarning: 'Iyi imeyili izoherezwa ku BAKORESHAMABYAZA gusa.',
broadcastAdminsWarning: 'Iyi imeyili izoherezwa ku BABOBOZI gusa.',
broadcastManagersWarning: 'Iyi imeyili izoherezwa ku BAMANEGERI gusa.',
currentPassword: 'Ijambobanga ririho',
newPassword: 'Ijambobanga rishya',
confirmPassword: 'Emeza ijambobanga',
enterCurrentPassword: 'Shyiramo ijambobanga ririho',
enterNewPassword: 'Shyiramo ijambobanga rishya',
confirmNewPassword: 'Emeza ijambobanga rishya',
changing: 'Rihindura...',
systemSettings: 'Igenamiterere ry\'sisitemu',
timezone: 'Igihe cy\'igihugu',
dateFormat: 'Imiterere y\'itariki',
itemsPerPage: 'Ibyatoranyijwe ku ipaji',
resetToDefaults: 'Subiza mu buryo bw\'ibanze',
recipients: 'Abakiriye',
allUsers: 'Abakoresha Bose',
employersOnly: 'Abakoreshamabazi Gusa',
adminsOnly: 'Ababobozi Gusa',
managersOnly: 'Abamanegeri Gusa',
testEmailAddress: 'Aderesi yo Gusuzuma',
enterTestEmail: 'Shyiramo aderesi yo gusuzuma',
testEmailDescription: 'Kohereza imeyili yo gusuzuma kugirango urebe imiterere',
sending: 'Irihereza...',
sendBroadcast: 'Kohereza ku bose',
enterEmailSubject: 'Shyiramo insanganyamatsiko y\'imeyili',
enterEmailMessage: 'Shyiramo ubutumwa bwawe hano...',
    // Donate Modal translations - Kinyarwanda
    donateTitle: 'Tera Inkunga ku Bagore',
    donateDescription: 'Inkunga yawe ifasha kwigisha abagore benshi no kubaka ubuzima buhagaze',
    quickSelectAmount: 'Hitamo Igiharuro (RWF):',
    donationAmountLabel: 'Ingano y\'Inkunga (RWF) *',
    donationAmountPlaceholder: 'Shyiramo igiharuro',
    donorNameLabel: 'Izina Ryawe *',
    donorNamePlaceholder: 'Shyiramo izina ryawe',
    emailLabel: 'Email',
    emailPlaceholder: 'Shyiramo email yawe',
    phoneLabel: 'Telefone',
    phonePlaceholder: 'Shyiramo numero ya telefone',
    messageLabel: 'Ubutumwa (Ntabwo ari ngombwa)',
    messagePlaceholder: 'Ongeraho ubutumwa bw\'ishyigikye...',
    donationInfo1: '💝 100% y\'inkunga yawe ijyana mu byigisho byihariye',
    donationInfo2: '🌍 Inkunga yawe ihindura ubuzima bw\'abantu n\'imiryango',
    donationInfo3: '🌍 Mobile Money: *182*8*1*270591#',
    donationInfo4: '🏦 Izina ry\'banki: Banki ya Kigali',
donationInfo5: '👤 Izina ry\'konte: WFW1 Empowerment Center LLC / Urugo Women\'s Opportunity Center',
donationInfo6: '💰 Konte ya RWF: 00059-06929965-20',
donationInfo7: '💵 Konte ya USD: 00059-06929966-21',
    cancelButton: 'Hagarika',
    processingButton: 'Birikora...',
    makeDonationButton: 'Tanga Inkunga',
    successTitle: 'Murakoze Inkunga Yanjye Nziza!',
    successMessage: 'Inkunga yawe ihindura ubuzima bw\'abagore.',
    errorMessage: 'Ikosa mu gutanga inkunga. Igerageza nanone.',
    // Register Modal translations - Kinyarwanda
    registerCreateAccount: 'Fungura Konti',
    registerDescription: 'Uzanye Urugo WOC utangire gukorana abagore bahuguwe',
    fullNameLabel: 'Amazina Yuzuye *',
    fullNamePlaceholder: 'Andika amazina yawe yuzuye',
    usernameLabel: 'Izina Ukoresha *',
    usernamePlaceholder: 'Hitamo izina ukoresha',
    emailLabel: 'Aderesi ya Email *',
    emailPlaceholder: 'Andika email yawe',
    phoneLabel: 'Numero ya Telefone',
    phonePlaceholder: 'Andika numero ya telefone',
    passwordLabel: 'Ijambobanga *',
    passwordPlaceholder: 'Kora ijambobanga',
    confirmPasswordLabel: 'Emeza Ijambobanga *',
    confirmPasswordPlaceholder: 'Emeza ijambobanga ryawe',
    passwordStrength: 'Imbaraga',
    passwordVeryWeak: 'Ifite imbaraga nke cyane',
    passwordWeak: 'Ifite imbaraga nke',
    passwordFair: 'Irabaraho',
    passwordGood: 'Ni nziza',
    passwordStrong: 'Ifite imbaraga',
    userTypeTitle: 'Niyandikisha nk\'uko:',
    userTypeEmployer: 'Ukoresha',
    userTypeEmployerDesc: 'Korana abagore bahuguwe',
    creatingAccount: 'Kubaka konti...',
    createAccount: 'Fungura Konti',
    registerErrorGeneric: 'Kwiyandikisha byanze. Igerageza nanone.',
    registerErrorPasswordMatch: 'Ijambobanga ntabwo bihuje',
    registerErrorPasswordWeak: 'Nyamuneka koresha ijambobanga rifite imbaraga',
    alreadyHaveAccount: 'Usanzwe ufite konti?',
    signIn: 'Injira',
    // Login Modal translations - Kinyarwanda
    close: 'Funga',
    loginWelcome: 'Murakaza neza',
    loginDescription: 'Injira muri konti yawe kugirango ukomeze',
    emailPlaceholder: 'Aderesi ya email',
    passwordPlaceholder: 'Ijambobanga',
    showPassword: 'Erekana ijambobanga',
    hidePassword: 'Hisha ijambobanga',
    rememberMe: 'Ntibibagirane',
    forgotPassword: 'Wibagiwe ijambobanga?',
    signingIn: 'Ura Injira...',
    signIn: 'Injira',
    noAccount: 'Nta konti ufite?',
    signUp: 'Iyandikishe',
    loginErrorGeneric: 'Kwinjira byanze. Igerageza gusesura amakuru yawe.',
        // ===== Passwordless Auth Flow - Kinyarwanda =====
    loginEmailOnlyHint: 'Shyiramo imeri yawe kugirango ukomeze',
    loginStaffHint: 'Kwinjira kw\'abakozi — nyamuneka shyiramo ijambobanga ryawe',
    loggingInEmployer: 'Turakwinjiza...',
    checking: 'Turagenzura...',
    change: 'Hindura',
    invalidEmail: 'Nyamuneka shyiramo aderesi ya imeri yemewe',
    noAccountFound: 'Nta konti ibonetse kuri iyi imeri. Nyamuneka banza wiyandikishe.',
    unknownUserType: 'Ubwoko bw\'umukoresha ntibuzwi. Nyamuneka vugana n\'ubufasha.',
    emailLoginHint: 'Tuzashakisha konti yawe ukoresheje imeri. Nta jambobanga rikenewe.',
    loginDescriptionEmailOnly: 'Shyiramo imeri yawe kugirango ukomeze — nta jambobanga rikenewe',
    registerDescriptionNoPassword: 'Shyiramo gusa amakuru yawe — nta jambobanga rikenewe',
    step2DescriptionNoPassword: 'Shyiramo gusa imeri yawe — nta jambobanga rikenewe',
    loginSuccessMessage: 'Ubu winjiye muri konti yawe!',
    // Footer & Chat Bot Translations
  chatWelcome: "Murakaza neza! Murakaza neza kuri Urugo Women Opportunity Center. Nshobora kubafasha mute uyu munsi?",
  justNow: "Vuba aha",
  chatQuestionHire: "Nshobora gute kodesha abagore barangije amahugurwa?",
  chatQuestionDonate: "Nshobora gute gutanga inkunga yo gushyigikira abagore?",
  chatQuestionTraining: "Nshobora gute kwiyandikisha mu mahugurwa?",
  chatQuestionContact: "Nshobora gute kuganira nawe?",
  chatKeywordHire: "kodesha",
  chatResponseHire: "Ushobora kodesha abagore bacu barangije amahugurwa ukora konti y'umukodesha kuri porotari yacu. Gera ku cyiciro 'Kodesha Abanyabwenge' kugirango urebe amakuru y'abagore bahari unatumire icyifuzo cyo kodesha. Abagore barangije amahugurwa bariteguye gukora mu myanya itandukanye harimo gukora ikawa, kubungabunga inzu, kudoda, n'ibindi.",
  chatKeywordEmployer: "umukodesha",
  chatResponseEmployer: "Nk'umukodesha, urashobora kwiyandikisha kuri porotari yacu kugirango ubone amakuru y'abagore bafite ubumenyi. Duteza abagore barangije amahugurwa kandi bariteguye gukora. Urashobora gutanga ibisabwa byihariye maze twe dukugerekeze n'abantu bahuje.",
  chatKeywordRequest: "icyifuzo",
  chatResponseRequest: "Kugirango usabe abagore barangije amahugurwa, nyamuneka winjire kuri konti yawe n'umukodesha uzuze ifomu yo gusaba kodesha. Sobanura umubare w'abagore usaba, ubumenyi bukenewe, n'igihe cyo gukora. Itsinda ryacu rizakuganira mu masaha 24.",
  chatKeywordDonate: "gutanga",
  chatResponseDonate: "Murakoze kwifuza gutanga! Urashobora gutanga kuri porotari yacu itekanye, binyuze mu kohereza ku banki, cyangwa ugasura urwego rwacu. Imigabane yawe ifasha kwigisha abagore benshi kandi ibaha amahirwe yo gukora.",
  chatKeywordSupport: "gushyigikira",
  chatResponseSupport: "Urashobora gushyigikira tukugira utanga, ukora umufatanyabikorwa, ukora ubujyanama, cyangwa ukora umufatanyabikorwa. Vugana n'itsinda ryacu ry'iterambere ku info@urugowoc.com kugirango ubone amakuru menshi.",
  chatKeywordTraining: "amahugurwa",
  chatResponseTraining: "Tanga amahugurwa mu buhinzi mu myanya 7. Kugirango wiyandikishe, gera kuri urwego rwacu mu Kayonza cyangwa wiyandikishe kuri urubuga rwacu. Amahugurwa ni y'ubuntu kuri bagore bihagije kandi ari na certificates nyuma yo kurangiza.",
  chatKeywordApply: "kwiyandikisha",
  chatResponseApply: "Kugirango wiyandikishe mu mahugurwa, gera kuri urubuga rwacu uzuze ifomu yo kwiyandikisha. Ukeneye gutanga amakuru yawe n'isano ukwereka ishami urifuza. Itsinda ryacu rizakuganira kugirango rigenzure.",
  chatKeywordLogin: "kwinjira",
  chatResponseLogin: "Kugirango winjire, kanda buto 'Kwinjira' mu buryo bwo hejuru. Abakodesha, abarimu, n'abayobozi bafite amasoko atandukanye yo kwinjira. Niba udafite konti, urashobora kwiyandikisha ukoresheje urupapuro rwo kwinjira.",
  chatKeywordRegister: "kwiyandikisha",
  chatResponseRegister: "Kwiyandikisha biri kugaragara kuri abakodesha, abagore bashaka amahugurwa, n'abavugizi. Kanda 'Kwiyandikisha' ku rupapuro rwo kwinjira uhitemo uburyo bwawe. Uzuze ibisobanuro byawe maze itsinda ryacu ryemeze konti yawe.",
  chatKeywordAbout: "ibyerekeye",
  chatResponseAbout: "Urugo Women Opportunity Center yashinzwe kugirango duhe imbaraga abagore binyuze mu mahugurwa y'ubumenyi n'amahirwe yo gukora. Twahuguye abagore barenga 600 kuva 2013. Gera kuri urupapuro rwacu 'Ibyerekeye' kugirango uzi ibirenzeho ku ntego, icyerekezo, n'ingaruka zacu.",
  chatKeywordGallery: "ifoto",
  chatResponseGallery: "Icyiciro cyacu cya 'Ifoto' kigaragaza abagore bari mu mahugurwa, iminsi yo kurangiza, n'inkuru z'intsinzi zo gukora. Urashobora kubona amafoto kuva mu myanya yose 7 yo kwigisha no kubona impinduka zikorwa kuri urwego rwacu.",
  chatKeywordDepartments: "imyanya",
  chatResponseDepartments: "Dufite imyanya 7 yo kwigisha: 1) Gukora ikawa, 2) Kubungabunga inzu, 3) Kwemera abashyitsi, 4) Kudoda, 5) Gukora inkanda, 6) Gukora amakapeti, na 7) Gukora amata na yoguriti. Buri gahunda iharimo amahugurwa y'ubumenyi na certificates.",
  chatKeywordContact: "kuganira",
  chatResponseContact: "Urashobora kuduhamagara ukoresheje imeri ya info@urugowoc.com, hamagara +250788350577, usure urwego rwacu mu Kayonza, cyangwa ukoreshe iyi chatbot. Itsinda ryacu rirabasha kuwa mbere kugeza kuwa gatandatu, saa munani z'amanywa kugeza saa tanu.",
  chatKeywordLocation: "aho turi",
  chatResponseLocation: "Turimo mu Kayonza, u Rwanda. Urashobora kutubona kuri Urugo Women Opportunity Center, Akarere ka Kayonza. Dusure kugirango urebe amashuri yacu n'umuryango wacu.",
  chatResponseDefault: "Murakoze kubaza! Kugirango ubone amakuru yihariye, nyamuneka twandikire neza kuri info@urugowoc.com cyangwa hamagara +250788350577.",
  chatTitle: "Urugo WOC Assistant",
  close: "Funga",
  chatQuickQuestions: "Ibibazo Vuba",
  chatPlaceholder: "Andika ubutumwa bwawe hano...",
  send: "Ohereza",
  chatToggleTooltip: "Tuvugishe",
  whatsappDefaultMessage: "Mwaramutse Urugo WOC, nfite ikibazo kirebana no kodesha abagore barangije amahugurwa/gutanga/mahugurwa...",
  whatsappTooltip: "Tuvugishe kuri WhatsApp",
  footerTitle: "WfWI/Urugo WOC",
  footerDescription: "Guharanira abagore binyuze mu mahugurwa y'ubumenyi n'amahirwe yo gukora kuva 2013. Guhindura imiryango binyuze mu kubaka ubuzima burambye.",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  youtube: "YouTube",
  whatsapp: "WhatsApp",
  quickLinks: "Amakarita Vuba",
  home: "Ahabanza",
  about: "Ibyerekeye Twese",
  departments: "Imyanya",
  women: "Abagore Bacu",
  gallery: "Ifoto",
  donate: "Tanga",
  hire: "Kodesha",
  login: "Injira",
  contactInfo: "Amakuru yo Guhura",
  location: "Kayonza, u Rwanda",
  phoneNumber: "+250 788350577",
  email: "info@urugowoc.com",
  hireWomen: "Kodesha Abagore Barangije",
  donateNow: "Tanga Nonaha",
  loginRegister: "Injira/Kwandika",
  ourDepartments: "Imyanya Yacu",
  coffeeShopOperation: "Gukora ikawa",
  housekeepingOperation: "Kubungabunga inzu",
  receptionOperation: "Kwemera abashyitsi",
  sewingOperation: "Kudoda",
  leatherOperation: "Gukora inkanda",
  carpetOperation: "Gukora amakapeti",
  milkYogurtProduction: "Gukora amata na yoguriti",
  copyright: "Urugo Women Opportunity Center. Amategeko Agenga Ibicuruzwa.",
  privacyPolicy: "Politiki y'Ibanga",
  termsOfService: "Amasezerano yo Gukoresha",
  sitemap: "Garagaza Urubuga",
    // Manager Dashboard Translations
    dashboard: "Ikibaho",
    requests: "Ibyifuzo",
    women: "Abagore",
    users: "Abakoresha",
    donations: "Inkunga",
    gallery: "Ifoto",
    about: "Ibyerekeye",
    reports: "Raporo",
    settings: "Igenamiterere",
    manager: "Umunyamabanga",
    totalUsers: "Abakoresha Bose",
    totalRequests: "Ibyifuzo Byose",
    totalRevenue: "Amafaranga Yose",
    activeWomen: "Abagore Bakora",
    recentActivity: "Ibikorwa vuba",
    totalWomen: "Abagore Bose",
    employerCount: "Abakodesha",
    newThisMonth: "Bishya muri iki kwezi",
    activeToday: "Bakora uyu munsi",
    pendingRequests: "Ibyifuzo Bitegereje",
    approvedRequests: "Ibyifuzo Byemewe",
    rejectedRequests: "Ibyifuzo Byanze",
    loadingDashboard: "Biri gukiranura ikibaho...",
    failedLoadDashboard: "Byanze gukiranura amakuru y'ikibaho",
    justNow: "Vuba aha",
    notificationPendingRequests: "Ufite ibyifuzo bitegereje",
    newUsersThisWeek: "abakoresha bashya muri iki cyumweru",
    newDonations: "inkunga nshya",
    failedLoadEmployerDetails: "Byanze gukiranura amakuru y'umukodesha",
    selectWomenToAssign: "Nyamuneka hitamo abagore mbere yo kugenera",
    selectRequestEmployer: "Nyamuneka hitamo icyifuzo/umukodesha",
    noWomenSelected: "Nta bagore bahitemewe",
    successfullyAssignedWomen: "Byakunzwe kwerekera abagore kuri {employer}",
    failedToAssignWomen: "Byanze kwerekera abagore",
    failedLoadWomenProfiles: "Byanze gukiranura amakuru y'abagore",
    accessDenied: "Ntabwo ubona uburenganzira. Nyamuneka ongera winjire.",
    requestStatusUpdated: "Imimerere y'icyifuzo yahinduwe kuri {status}",
    failedUpdateRequest: "Byanze guhindura icyifuzo",
    userStatusUpdated: "Umukoresha {status} byakunzwe",
    suspended: "yazibwe",
    activated: "yarangijwe",
    failedUpdateUser: "Byanze guhindura umukoresha",
    confirmDeleteUser: "Urabizi ko urifuza gusiba uyu mukoresha?",
    userDeleted: "Umukoresha yasibwe neza",
    failedDeleteUser: "Byanze gusiba umukoresha",
    profileAvailabilityUpdated: "Ubushobozi bwo kubona profile yahinduwe kuri {status}",
    available: "Birabasha",
    hired: "Yakodeshejwe",
    failedUpdateProfile: "Byanze guhindura profile",
    confirmDeleteProfile: "Urabizi ko urifuza gusiba iyi profile?",
    profileDeleted: "Profile yasibwe neza",
    failedDeleteProfile: "Byanze gusiba profile",
    profileAdded: "Profile yongerwaho neza",
    failedAddProfile: "Byanze kongeraho profile",
    profileUpdated: "Profile yahinduwe neza",
    exportSuccessful: "Kohereza amakuru byakunze! Inyandiko yakurwa",
    failedExportData: "Byanze guhera amakuru",
    searchRequests: "Shaka ibyifuzo...",
    clearFilters: "Siba Ibyacukumbuye",
    filterBy: "Suzuma",
    allStatus: "Byose",
    pending: "Bitegereje",
    approved: "Byemewe",
    rejected: "Byanze",
    cancelled: "Byahagaritswe",
    to: "kugera",
    exportRequests: "Kohereza Ibyifuzo",
    noRequestsFound: "Nta byifuzo byabonetse",
    noRequestsMatch: "Nta byifuzo bihuye n'ibisabwa byawe",
    noRequestsAvailable: "Nta byifuzo bihari",
    showingRequests: "Birabonereza ibyifuzo",
    id: "Indangamuntu",
    date: "Itariki",
    employer: "Umukodesha",
    department: "Ishami",
    employees: "Abakozi",
    duration: "Igihe",
    amount: "Amafaranga",
    status: "Imimerere",
    actions: "Ibikorwa",
    days: "iminsi",
    n_a: "N/A",
    viewRequest: "Reba Icyifuzo",
    approveRequest: "Emera Icyifuzo",
    rejectRequest: "Hakanira Icyifuzo",
    womenProfilesManagement: "Gucunga amakuru y'abagore",
    searchWomen: "Shaka abagore...",
    assignSelected: "Rekera Byahitemewe",
    addNewProfile: "Ongeraho Profile Nshya",
    allDepartments: "Imyanya Yose",
    clearFilters: "Siba Ibyacukumbuye",
    womenSelectedForAssignment: "Abagore bahitemewe yo kugenerwa",
    selected: "byahitemewe",
    assignSelectedWomen: "Rekera Abagore Byahitemewe",
    noWomenProfilesFound: "Nta Bagore Babonetse",
    noProfilesMatchCriteria: "Nta bagore bahuye n'ibisabwa byawe",
    showingProfiles: "Birabonereza abagore {showing} muri {total}",
    previous: "Ibanza",
    pageInfo: "Ipaji {page} muri {pages}",
    next: "Ibikurikira",
    selectAllAvailable: "Hitamo abagore bose bari kumwanya",
    photo: "Ifoto",
    name: "Izina",
    age: "Imwaka",
    skills: "Ubuhanga",
    experience: "Urugero",
    phone: "Telefoni",
    years: "imyaka",
    womanNotAvailable: "Uyu mugore ntabwo ari kumwanya",
    selectForAssignment: "Hitamo yo kugenerwa",
    editProfile: "Hindura Profile",
    markAsHired: "Shirako nk'Uwakodeshejwe",
    markAsAvailable: "Shirako nk'Uri kumwanya",
    deleteProfile: "Siba Profile",
    employedBy: "Yakodeshejwe na",
    requestId: "Indangamuntu y'icyifuzo",
    assigned: "Yagenewe",
    userManagement: "Gucunga Abakoresha",
    searchUsers: "Shaka abakoresha...",
    allTypes: "Ubwoko Bwose",
    admin: "Umuyobozi",
    manager: "Umunyamabanga",
    employer: "Umukodesha",
    exportUsers: "Kohereza Abakoresha",
    noUsersFound: "Nta Bakoresha Babonetse",
    noUsersMatchCriteria: "Nta bakoresha bahuye n'ibisabwa byawe",
    noUsersAvailable: "Nta bakoresha bahari",
    showingUsers: "Birabonereza abakoresha",
    user: "Umukoresha",
    fullName: "Amazina Yuzuye",
    email: "Imeri",
    phone: "Telefoni",
    type: "Ubwoko",
    joined: "Yinjiye",
    editUser: "Hindura Umukoresha",
    suspendUser: "Ziba Umukoresha",
    activateUser: "Kora Umukoresha",
    deleteUser: "Siba Umukoresha",
    galleryManagement: "Gucunga Ifoto",
    searchGallery: "Shaka ifoto...",
    addImage: "Ongeraho Ifoto",
    noGalleryImagesFound: "Nta Foto Zabonetse",
    noImagesMatchCriteria: "Nta foto zihuye n'ibisabwa byawe",
    showingImages: "Birabonereza ifoto {showing} muri {total}",
    general: "Bya rusange",
    edit: "Hindura",
    delete: "Siba",
    featured: "Byerekana",
    aboutUsManagement: "Gucunga Ibyerekeye Twese",
    pageContent: "Amakuru ku Ipaji",
    coreValues: "Indangagaciro",
    teamMembers: "Abanyamuryango b'Itsinda",
    aboutPageContent: "Amakuru ku Ipaji y'Ibyerekeye",
    editContent: "Hindura Amakuru",
    defaultAboutTitle: "Guharanira Abagore Binyuze mu Mahugurwa y'Ubumenyi",
    defaultMission: "Intego yacu ni uguharanira abagore binyuze mu mahugurwa y'ubumenyi n'amahirwe yo gukora akazi",
    defaultVision: "Icyerekezo cyacu ni isi hose aho buri mugore afite ubumenyi n'amahirwe yo kubona ubwigenge mu by'ubukungu",
    defaultHistory: "Yashinzwe mu 2013, Urugo Women Opportunity Center yahinduye ubuzima bw'abagore barenga 100 binyuze mu mahugurwa y'ubumenyi",
    noMissionStatement: "Nta masobanuro y'intego yongeweho",
    noVisionStatement: "Nta masobanuro y'icyerekezo yongeweho",
    noHistoryContent: "Nta makuru y'amateka yongeweho",
    noAboutPageContent: "Nta makuru ku ipaji y'ibyerekeye",
    clickEditContentToAdd: "Kanda 'Hindura Amakuru' kugirango wongeraho amakuru",
    addValue: "Ongeraho Agaciro",
    noCoreValues: "Nta Ndangagaciro",
    addCoreValues: "Ongeraho indangagaciro z'ishami ryawe",
    addTeamMember: "Ongeraho Umwe mu Banyamuryango",
    noTeamMembers: "Nta Banyamuryango b'Itsinda",
    addTeamMembers: "Ongeraho abanyamuryango b'itsinda ryawe",
    donationManagement: "Gucunga Inkunga",
    reset: "Subiramo",
    exportDonations: "Kohereza Inkunga",
    donor: "Umutanga",
    message: "Ubutumwa",
    viewDetails: "Reba Ibisobanuro",
    sendThankYou: "Ohereza Urakoze",
    noDonationsFound: "Nta nkunga zabonetse",
    reportsAnalytics: "Raporo & Ibisobanuro",
    generateReports: "Kora Raporo",
    usersReport: "Raporo y'Abakoresha",
    requestsReport: "Raporo y'Ibyifuzo",
    donationsReport: "Raporo y'Inkunga",
    fullDatabaseExport: "Kohereza Amakuru Yose",
    systemStatistics: "Ibisobanuro by'Umuyoboro",
    totalUsers: "Abakoresha Bose",
    activeWomen: "Abagore Bakora",
    totalRevenue: "Amafaranga Yose",
    successRate: "Ingano y'Intsinzi",
    requestStatistics: "Ibisobanuro by'Ibyifuzo",
    generalSettings: "Igenamiterere Bya Rusange",
    siteName: "Izina ry'Urubuga",
    emailNotifications: "Amatangazo ya Imeyili",
    autoApproveRequests: "Ibyifuzo Byemerwa Bikora",
    saveSettings: "Bika Igenamiterere",
    accountSettings: "Igenamiterere ry'Umugereka",
    changePassword: "Hindura Ijambobanga",
    newPassword: "Ijambobanga Rishya",
    confirmPassword: "Emeza Ijambobanga",
    confirmNewPassword: "Emeza Ijambobanga Rishya",
    saveChanges: "Bika Impinduka",
    editGalleryImage: "Hindura Ifoto",
    addGalleryImage: "Ongeraho Ifoto",
    title: "Umutwe",
    description: "Ibisobanuro",
    department: "Ishami",
    featuredImage: "Ifoto Yo Kwerekana",
    imageFile: "Inyandiko y'Ifoto",
    currentImage: "Ifoto Ihari",
    current: "Ihari",
    cancel: "Hagarika",
    updateImage: "Hindura Ifoto",
    editAboutPageContent: "Hindura Amakuru ku Ipaji y'Ibyerekeye",
    pageTitle: "Umutwe w'Ipaji",
    enterPageTitle: "Shyiramo umutwe w'ipaji",
    missionStatement: "Amagambo y'Intego",
    enterMissionStatement: "Shyiramo amagambo y'intego",
    visionStatement: "Amagambo y'Icyerekezo",
    enterVisionStatement: "Shyiramo amagambo y'icyerekezo",
    historyAboutUs: "Amateka / Ibyerekeye Twese",
    enterHistoryContent: "Shyiramo amakuru y'amateka",
    aboutPageSaved: "Ipaji y'ibyerekeye yakiriwe neza",
    failedSaveAboutPage: "Byanze kubika ipaji y'ibyerekeye",
    editCoreValue: "Hindura Agaciro",
    addCoreValue: "Ongeraho Agaciro",
    coreValueText: "Amagambo y'Agaciro",
    enterCoreValueText: "Shyiramo amagambo y'agaciro",
    sortOrder: "Itondekanya",
    updateCoreValue: "Hindura Agaciro",
    confirmDeleteCoreValue: "Urabizi ko urifuza gusiba iki gaciro?",
    coreValueDeleted: "Agaciro gasibwe neza",
    failedDeleteCoreValue: "Byanze gusiba agaciro",
    coreValueAdded: "Agaciro kongerwaho neza",
    failedAddCoreValue: "Byanze kongeraho agaciro",
    coreValueUpdated: "Agaciro gahinduwe neza",
    failedUpdateCoreValue: "Byanze guhindura agaciro",
    editTeamMember: "Hindura Umwe mu Banyamuryango",
    addTeamMember: "Ongeraho Umwe mu Banyamuryango",
    position: "Urwego",
    department: "Ishami",
    bioDescription: "Amakuru/Amagambo",
    enterTeamMemberBio: "Shyiramo amakuru y'umwe mu banyamuryango",
    profilePhoto: "Ifoto y'Umwirondoro",
    activeTeamMember: "Umwe mu Banyamuryango Ukora",
    currentPhoto: "Ifoto Ihari",
    updateTeamMember: "Hindura Umwe mu Banyamuryango",
    confirmDeleteTeamMember: "Urabizi ko urifuza gusiba uyu mwe mu banyamuryango?",
    teamMemberDeleted: "Umwe mu banyamuryango yasibwe neza",
    failedDeleteTeamMember: "Byanze gusiba umwe mu banyamuryango",
    teamMemberAdded: "Umwe mu banyamuryango yongerweho neza",
    failedAddTeamMember: "Byanze kongeraho umwe mu banyamuryango",
    teamMemberUpdated: "Umwe mu banyamuryango yahinduwe neza",
    failedUpdateTeamMember: "Byanze guhindura umwe mu banyamuryango",
    addNewProfile: "Ongeraho Profile Nshya",
    name: "Izina",
    age: "Imwaka",
    selectDepartment: "Hitamo Ishami",
    experienceYears: "Urugero (Imyaka)",
    commaSeparatedSkills: "Ubuhanga bukurikiranye na virgule",
    location: "Aho bari",
    educationLevel: "Urwego rw'Amashuri",
    selectEducation: "Hitamo Urwego rw'Amashuri",
    primary: "Amashuri abanza",
    secondary: "Amashuri yisumbuye",
    vocational: "Ubumenyi bwo gukora",
    university: "Kaminuza",
    other: "Ibindi",
    profilePhoto: "Ifoto y'Umwirondoro",
    addProfile: "Ongeraho Profile",
    editProfile: "Hindura Profile",
    saveChanges: "Bika Impinduka",
    refresh: "Ongera",
    logout: "Sohoka",
    toggleMenu: "Hindura Ibikubiye",
    urugoWOC: "Urugo WOC",
    notifications: "Amatangazo",
    noNotifications: "Nta matangazo",
    home: "Ahabanza",
    requests: "Ibyifuzo",
    women: "Abagore",
    users: "Abakoresha",
    donations: "Inkunga",
    gallery: "Ifoto",
    about: "Ibyerekeye",
    reports: "Raporo",
    settings: "Igenamiterere",
    export: "Kohereza",
    csvFormat: "Imiterere ya CSV",
    manageWomen: "Gucunga Abagore",
    profiles: "profiles",
    manageUsers: "Gucunga Abakoresha",
    quickActions: "Ibikorwa Vuba",
    reviewRequests: "Suzuma Ibyifuzo",
    exportAllData: "Kohereza Amakuru Yose",
    exportAll: "Kohereza Byose",
    clearAll: "Siba Byose",
    allCaughtUp: "Byose byakurikijwe!",
    noNewNotifications: "Nta matangazo mashya",
    departments: "Imyanya",
    employers: "Abakodesha",
    activeToday: "Bakora uyu munsi",
    thisMonth: "iki kwezi",
    currentlyActive: "bari gukora",
    average: "Kubera",
    womenTrained: "Abagore Barangije",
    selectAllAvailable: "Hitamo Abagore Bose Bari kumwanya",
    selectForAssignment: "Hitamo yo kugenerwa",
    inactive: "Ntabwo Ukora",
    active: "Ukora",
    enterImageDescription: "Shyiramo ibisobanuro by'ifoto",
    enterCoreValueText: "Shyiramo amagambo y'agaciro",
    enterTeamMemberBio: "Shyiramo amakuru y'umwe mu banyamuryango",
    bio: "Amakuru",
    confirmDeleteImage: "Urabizi ko urifuza gusiba iyi foto?",
    imageDeleted: "Ifoto yasibwe neza",
    failedDeleteImage: "Byanze gusiba ifoto",
    galleryImageAdded: "Ifoto yo muri gallery yongerweho neza",
    failedAddGalleryImage: "Byanze kongeraho ifoto yo muri gallery",
    galleryImageUpdated: "Ifoto yo muri gallery yahinduwe neza",
    failedUpdateGalleryImage: "Byanze guhindura ifoto yo muri gallery",
    selectDepartment: "Hitamo Ishami",
    successRate: "Ingano y'Intsinzi",
    activeWomen: "Abagore Bakora",
    
    // Existing translations from other sections...
    employerDashboard: "Ikibaho cy'Umukodesha",
    myRequests: "Ibyifuzo Byanjye",
    hiredWomen: "Abagore Bakod",
    payments: "Amafaranga",
    newRequest: "Icyifuzo Gishya",
    markAsPaid: "Shirako nk'Uwakaze",
    exportData: "Kohereza Amakuru",
    makePayment: "Wishyure",
    downloadReceipt: "Kuramo Inyemezabwishyu",
    totalSpent: "Amafaranga Yose Yakoreshejwe",
    totalHired: "Abagore Bose Bakodeshejwe",
    approvalRate: "Ingano y'Ukwemerera",
    avgEmployees: "Abakozi ku burebure",
    avgDuration: "Igihe ku burebure",
    pendingPayments: "Amafaranga Atarishyurwa",
    paymentHistory: "Amateka yo Kwishyura",
    payNow: "Wishyure Nonaha",
    profileSettings: "Igenamiterere ry'Umwirondoro",
    companyName: "Izina rya Sosiyete",
    contactPerson: "Umuntu wo Guhura",
    requestTrainedWomen: "Saba abagore barangije amahugurwa",
    perRequest: "ku cyifuzo",
    womenHired: "abagore bakodeshejwe",
    avgPerRequest: "ku burebure/icyifuzo",
    browseHired: "Shakisha Abakodeshejwe",
    viewHiredWomen: "Reba abagore bakodeshejwe",
    downloadAllRequests: "Kuramo ibyifuzo byose",
    unknownDepartment: "Ishami ridashaka",
    unknownDate: "Itariki ridashaka",
    exportList: "Kohereza Urutonde",
    unknownName: "Izina ridashaka",
    yearsExp: "imyaka yo gucukumbura",
    hiredOn: "Bakodeshejwe ku",
    unknown: "Ridashaka",
    notSpecified: "Ntabwo byasobanuwe",
    noHiredWomen: "Nta Bagore Bakodeshejwe",
    noHiredWomenDesc: "Nta bagore wakodesheje. Ibyifuzo byemewe bizaboneka hano",
    makeRequest: "Kora Icyifuzo",
    managePayments: "Gucunga amafaranga yawe n'inyemezabwishyu",
    totalPendingPayments: "Amafaranga Yose Atarishyurwa",
    requests: "ibyifuzo",
    allCompletedPayments: "Amafaranga yose yishyuwe",
    viewAllRequests: "Reba Ibyifuzo Byose",
    request: "Icyifuzo",
    due: "Igihe cyagenwe",
    noPendingPayments: "Nta mafaranga atarishyurwa",
    paidOn: "Yishyuwe ku",
    noPaymentHistory: "Nta mateka yo kwishyura",
    loadingDashboard: "Biri gukiranura kibaho cyawe...",
    failedLoadHiredWomen: "Byanze gukiranura amakuru y'abagore bakodeshejwe",
    notificationPendingRequests: "Ufite ibyifuzo bitegereje",
    notificationPendingPayments: "Amafaranga atarishyurwa",
    justNow: "Vuba aha",
    requestSubmittedSuccess: "Icyifuzo cyohererejwe neza!",
    failedSubmitRequest: "Byanze guhera icyifuzo. Ongera ugerageze",
    requestUpdatedSuccess: "Icyifuzo cyahinduwe neza!",
    failedUpdateRequest: "Byanze guhindura icyifuzo. Ongera ugerageze",
    confirmCancelRequest: "Urabizi ko urifuza guhagarika iki cyifuzo?",
    requestCancelledSuccess: "Icyifuzo cyahagaritswe neza!",
    failedCancelRequest: "Byanze guhagarika icyifuzo. Ongera ugerageze",
    confirmMarkAsPaid: "Shirako iki cyifuzo nk'uwakaze?",
    requestMarkedAsPaid: "Icyifuzo cyashizwe nk'uwakaze!",
    failedUpdatePayment: "Byanze guhindura imimerere yo kwishyura. Ongera ugerageze",
    exportSuccessful: "Gutanga amakuru byakunze! Inyandiko yakurwa",
    failedExportRequests: "Byanze guhera ibyifuzo",
    confirmDeleteRequest: "Urabizi ko urifuza gusiba iki cyifuzo? Iki gikorwa ntakigaragurwa",
    requestDeletedSuccess: "Icyifuzo cyasibwe neza!",
    failedDeleteRequest: "Byanze gusiba icyifuzo. Ongera ugerageze",
    downloadingReceipt: "Biri kuramo inyemezabwishyu...",
    paymentCompleted: "Kwishyura byakunze!",
    
    // Gallery Page Translations
    barista: "Umukeri w'ikawa",
    coffee: "Ikawa",
    training: "Amahugurwa",
    womenLearning: "Abagore bari kwiga",
    preparation: "Itegurwa",
    machine: "mashini",
    customerService: "Serivisi y'abakiriya",
    serving: "Gusabira",
    customers: "abakiriya",
    withProfessionalism: "mu buryo bwa professional",
    grinding: "Guhindura",
    learning: "Kwiga",
    proper: "by'ukuri",
    techniques: "uburyo",
    art: "Ubugeni",
    creating: "Gukora",
    beautiful: "byiza",
    designs: "imisusire",
    teamCollaboration: "Gukorera hamwe n'itsinda",
    working: "Gukora",
    together: "hamwe",
    in: "mu",
    shop: "ububiko",
    roomCleaning: "Gusukura amazu",
    professional: "Professional",
    room: "icyumba",
    cleaning: "gusukura",
    linenManagement: "Gucunga impu",
    linen: "impu",
    folding: "kuzingura",
    and: "na",
    storage: "ububiko",
    cleaningEquipment: "Ibikoresho byo gusukura",
    using: "Gukoresha",
    modern: "bya kisazwe",
    equipment: "ibikoresho",
    hotelStandards: "Ingamba z'ihoteli",
    maintaining: "Kurinda",
    high: "hejuru",
    standards: "ingamba",
    frontDesk: "Aho bagurana",
    managing: "Gucunga",
    hotel: "ihoteli",
    front: "imbere",
    desk: "ameza",
    operations: "ibikorwa",
    guestCheckin: "Kwemera abashyitsi",
    guest: "umushyitsi",
    checkin: "kwemera",
    process: "umurongo",
    phoneEtiquette: "Ubushobozi bwo kuvugisha telefoni",
    telephone: "telefoni",
    communication: "kubwira",
    skills: "ubushobozi",
    computerSkills: "Ubushobozi bwa mudasobwa",
    software: "porogaramu",
    sewingMachine: "Mashini yo kudoda",
    industrial: "ya industrial",
    sewing: "kudoda",
    machines: "mashini",
    patternMaking: "Gukora imisusire y'imyambaro",
    clothing: "imyambaro",
    patterns: "imisusire",
    fabricCutting: "Gutema ipamba",
    precision: "ubushobozi",
    fabric: "ipamba",
    cutting: "gutema",
    qualityControl: "Kugenzura ibyiza",
    checking: "Kugenzura",
    finished: "byarangiye",
    garments: "imyambaro",
    leatherCutting: "Gutema inkanda",
    leather: "inkanda",
    for: "ya",
    products: "ibicuruzwa",
    handStitching: "Kudoda n'amaboko",
    traditional: "gakondo",
    stitching: "kudoda",
    leatherDyeing: "Gusiga inkanda",
    coloring: "Gusiga",
    productAssembly: "Gukorera ibicuruzwa",
    assembling: "Gukorera",
    goods: "ibicuruzwa",
    weaving: "Kuboha",
    carpet: "ikapeti",
    knotting: "Gufunga amasuka",
    handknotting: "Gufunga amasuka n'amaboko",
    designPlanning: "Guteza imbere imisusire",
    designs: "imisusire",
    finishing: "Gusozera",
    final: "Bya nyuma",
    touches: "ibyiza",
    on: "ku",
    carpets: "amakapeti",
    milkProcessing: "Gukorera amata",
    milk: "amata",
    processing: "gukorera",
    yogurtMaking: "Gukora yoguriti",
    yogurt: "yoguriti",
    fermentation: "gukorera",
    qualityTesting: "Kugenzura ibyiza",
    testing: "Kugenzura",
    dairy: "amata",
    packaging: "Gupakira",
    hygienic: "by'isuku",
    
    // UI Translations for Gallery
    images: "Amashusho",
    tryAgain: "Ongera ugerageze",
    noImagesFound: "Nta mashusho yabonetse",
    tryDifferentFilter: "Gerageza guhitamo ishami ritari iryo cyangwa ijambo ryakoreshwa mu gushaka",
    tryDifferentSearch: "Gerageza ijambo ryo gushaka ritari iryo",
    noImagesInDepartment: "Nta mashusho ahari muri iyi shyirahamwe kugeza ubu",
    galleryImage: "Ishusho muri gallery",
    noDescription: "Nta bisobanuro bihari",
    loadMore: "Zana ibindi",
    trainingImages: "Amashusho y'amahugurwa",
    womenEmpowered: "Abagore bahabwa imbaraga",
    learningOpportunities: "Amahirwe yo kwiga",
    witnessTransformation: "Reba urugendo rw'abagore bahindura ubuzima bwabo binyuze mu mahugurwa y'ubumenyi",
    search: "Shaka",
    viewAll: "Reba Byose",
    tailoringFashion: "Kuboha n'Umwimerere",
    organicFarming: "Ubuhinzi Butaziguye",
    culinaryArts: "Ubumenyi bwo Guteka",
    cosmetology: "Ubumenyi bw'ubugororotsi",
    literacyProgram: "Gusoma no Kwandika",
    handicrafts: "Ibikorwa by'ibikoresho",
    leatherwork: "Gukora ibikoresho by'inkanda",
    farming: "Ubuhinzi",
    cooking: "Guteka",
    tailoring: "Kuboha",
    housekeeping: "Gucunga inzu",
    reception: "Kwemera abashyitsi",
    sewing: "Kudoda",
    carpetWeaving: "Kuboha amakapeti",
    dairyProduction: "Gukorera amata",
    
    // About Us Page Translations
    aboutUs: "Ibyerekeye Twese",
    empoweringWomenTransformingCommunities: "Guharanira abagore, guhindura imiryango kuva 2013",
    ourMission: "Intego Yacu",
    ourVision: "Icyerekezo Cyacu",
    ourStory: "Inkuru Yacu",
    ourCoreValues: "Indangagaciro Zacu",
    ourTrainingDepartments: "Imyanya Yacu yo Kwigisha",
    meetOurTeam: "Sangira Itsinda Ryacu",
    contactUs: "Twandikire",
    connectWithUs: "Duhuzemo",
    sendUsAMessage: "Tutumire Ubutumwa",
    wellGetBackToYou: "Tuzasubiza ubutumwa vuba bishoboka",
    ourPartnersSponsors: "Abafatanyabikorwa & Abatanga Inkunga",
    
    // Contact Information Labels
    address: "Aderesi",
    workingHours: "Amasaha yo gukora",
    alternate: "Ibindi",
    fullName: "Amazina Yuzuye *",
    emailAddress: "Aderesi ya imeri *",
    subject: "Insanganyamatsiko *",
    sendMessage: "Ohereza Ubutumwa",
    sending: "Biri Kuhererejwe...",
    thankYouMessageSent: "Murakoze! Ubutumwa bwawe buhererejwe neza.",
    sorryErrorSending: "Babuze, habaye ikosa mu kohereza ubutumwa bwawe. Ongera ugerageze.",
    
    // Placeholders and Messages
    loadingAboutInfo: "Biri gukira amakuru yerekeye...",
    
    // Form Labels
    formNamePlaceholder: "Shyiramo amazina yawe yuzuye",
    formEmailPlaceholder: "Shyiramo aderesi yawe ya imeri",
    formSubjectPlaceholder: "Shyiramo insanganyamatsiko",
    formMessagePlaceholder: "Andika ubutumwa bwawe hano...",
    
    // Social Media Platforms
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    whatsapp: "WhatsApp",
    
    // Partner Types
    sponsor: "Umutangankunga",
    partner: "Umufatanyabikorwa",
    donor: "Umutanga",

    // Existing translations
    home: "Ahabanza",
    exploreDepartments: "Shakisha Imyanya",
    meetOurWomen: "Sangira Abagore Bacu",
    hireTrainedWomen: "Kodesha Abagore Barangije",
    empoweringWomen: "Guharanira Abagore",
    throughSkillsTraining: "Binyuze mu buhinzi bw'ubumenyi",
    buildingSustainable: "Gushyiraho",
    futures: "Amanzure Y'imibereho",
    transformingCommunities: "Guhindura Imiryango",
    together: "Hamwe",
    employersConnected: "Abakodesha Bahuze",
    chooseSpecializedPrograms: "Hitamo mu byiciro byacu byihariye byo kwigisha byateguwe guhabwa intsinzi",
    requestTrainedWomen: "Saba Abagore Barangije",
    certifiedTraining: "Amahugurwa Yemejwe",
    flexibleHours: "Amasaha Ahuzuzanya",
    ourWomenInAction: "Abagore Bacu mu Bikorwa",
    witnessTransformation: "Reba impinduka binyuze mu bikorwa byabo",
    meetTalentedWomen: "Sangira Abagore Bacu Bafite Imanini",
    skilledProfessionals: "Abanyakazi bafite ubumenyi bwo gukora bakiriye gukora icyo ari cyo cyose",
    availableNow: "Birabasha Nonaha",
    currentlyWorking: "Bari mu Kazi",
    empowerMoreWomen: "Tangiza Abagore Benshi Uyu munsi",
    supportProvidesHope: "Inkunga yawe itanga amahugurwa, amahirwe, n'icyizere. Dufatanyije mu gukora impinduka zihoraho.",
    donateNow: "Tanga Nonaha",
    hireTalent: "Kodesha Abanyabwenge",
    woman: "Umugore",
    skilledProfessional: "Umunyamwuga ufite ubumenyi",
    womenEmpowermentActivity: "Umushinga wo gutanga imbaraga abagore",
    makeDonation: "Tanga inkunga yo gushyigikira amahugurwa y'abagore",
    
    // Department names and descriptions
    tailoringDesc: "Amahugurwa y'ubuhinzi n'umwimerere bwa professional",
    farmingDesc: "Uburyo n'ubumenyi bwo guhinga burambye",
    culinaryDesc: "Ubumenyi bwo guteka no gutegura ibiryo bya professional",
    cosmetologyDesc: "Gukora ibikoresho by'ubugororotsi n'iby'uruhu",
    literacyDesc: "Ubumenyi bwa mbere bwo gusoma no kwandika",
    handicraftsDesc: "Gukora ibikoresho bya gakondo n'ibya kisazwe",
    leatherworkDesc: "Gukora inkweto n'ibindi bikoresho by'inkanda",
    
    // Hero slides descriptions
    heroSlide1Desc: "Urugo Women Opportunity Center yarahuguye abagore barenga 600 mu buhinzi bw'ubumenyi butandukanye, ibafasha guha imibereho irambye no guhindura imiryango yabo.",
    heroSlide2Desc: "Amahugurwa yacu yo kwiga ubumenyi atanga abagore ubumenyi buhagije ku isoko ry'akazi rikomeje, bigatuma bahabwa akazi k'igihe kirekire n'ubwigenge mu by'ubukungu.",
    heroSlide3Desc: "Binyuze mu gutanga umugore imbaraga, duha imbaraga umuryango wose. Dufatanyije mu gukora impinduka zihoraho binyuze mu masomo, inkunga, n'amahirwe.",
    
    // Additional UI elements
    working: "Ari mu Kazi",
    loadingContent: "Biri gukurura amakuru...",
  },

  french: {

        // ===== Trainee Stats Page =====
        stats: 'Statistiques',
        traineeStats: 'Statistiques des Stagiaires',
        traineeStatsIntro: 'Explorez nos diplômés certifiés',
        ourImpact: 'Notre Impact',
        totalTrainees: 'Diplômés certifiés',
        employedByCompany: 'Employé par une Entreprise',
        unemployed: 'Sans Emploi',
        professionalInternship: 'Stage Professionnel',
        selfEmployed: 'Travailleur Indépendant',
        traineesFound: 'stagiaires trouvés',
        noTraineesFound: 'Aucun stagiaire trouvé',
        tryDifferentFilters: 'Essayez d\'ajuster vos filtres ou votre recherche.',
        searchTrainees: 'Rechercher par nom, compétences...',
        allDepartments: 'Tous les Départements',
        yearsExp: 'ans d\'exp.',

    employed: 'Employé',
studying: 'En cours d\'études',
workingForOthers: 'Travaille pour d\'autres',
notAvailableForHire: 'Non disponible pour embauche',
womenFound: 'femmes trouvées',
noWomenInDepartment: 'Aucune femme trouvée dans ce département.',
exportExcel: 'Exporter vers Excel',
exportPDF: 'Exporter en PDF',
noWomenFoundWithStatus: 'Aucune femme trouvée avec ce statut',
    
  fullName: 'Nom Complet',
  age: 'Âge',
  cohort: 'Cohorte',
  phone: 'Téléphone',
  email: 'Email',
  placementLocation: 'Lieu de Placement',
  competenceSkills: 'Compétences',
  commaSeparated: 'séparées par des virgules',
  optional: 'Optionnel',
  emailOptional: 'L\'email est facultative mais recommandée pour la communication',
  enterName: 'Entrez votre nom complet',
  enterAge: 'Votre âge',
  enterPhone: '+250 78X XXX XXX',
  enterEmail: 'votre@email.com (optionnel)',
  enterPlacementLocation: 'Ville, District, Pays',
  enterCompetenceSkills: 'Ex: Compétences informatiques, Prise de décision, Leadership',
  separateWithCommas: 'Séparez les compétences multiples par des virgules',
  enterCompanyName: 'Nom de l\'entreprise/organisation',
  enterWorkingPosition: 'Titre du poste',
  enterWorkingLocation: 'Lieu de travail',
  enterYears: 'Années',
  enterBio: 'Courte biographie',
  uploadPhoto: 'Télécharger une Photo',

  fullNameRequired: 'Le nom complet est requis',
  nameMinLength: 'Le nom doit contenir au moins 2 caractères',
  selectDepartmentRequired: 'Veuillez sélectionner un département',
  selectEmploymentStatus: 'Veuillez sélectionner votre statut d\'emploi',
  selectJobSecured: 'Veuillez sélectionner comment vous avez obtenu votre emploi',

  employmentStatusDesc: 'Parlez-nous de votre situation d\'emploi actuelle.',
  unemployedInfo: 'Vous avez sélectionné "Sans Emploi". Les détails supplémentaires sur l\'emploi ne sont pas requis.',

  wocPlacement: 'Via le soutien au placement de WOC',
  wocInternship: 'Stage/Attachement industriel chez WOC',
  wocRecommendation: 'Recommandation des formateurs WOC',
  familyFriends: 'Famille/Amis',
  socialMedia: 'Médias sociaux',
  onlinePortal: 'Portail d\'emploi en ligne',
  walkIn: 'Candidature spontanée',
  newspaper: 'Annonce dans le journal',

  jobRelevanceDesc: 'Votre emploi actuel est-il lié à la formation que vous avez reçue chez WOC?',

  jobChallengesDesc: 'Quelles sont les principales raisons de votre chômage? (Cochez tout ce qui s\'applique)',
  lackJobOpportunities: 'Manque d\'opportunités d\'emploi',
  lackWorkExperience: 'Manque d\'expérience professionnelle',
  insufficientSkills: 'Compétences insuffisantes',
  familyResponsibilities: 'Responsabilités familiales',
  continuingEducation: 'Formation continue',
  healthReasons: 'Raisons de santé',
  lackStartupCapital: 'Manque de capital de démarrage',
  locationTransport: 'Problèmes de localisation/transport',

  entrepreneurshipDesc: 'Avez-vous créé votre propre entreprise après avoir obtenu votre diplôme?',
  employeesEmployed: 'Combien de personnes avez-vous employées?',
  moreThan5: 'Plus de 5',

  supportNeededDesc: 'Quel soutien vous aiderait à développer votre entreprise? (Cochez tout ce qui s\'applique)',
  accessFinance: 'Accès au financement',
  businessMentorship: 'Mentorat d\'entreprise',
  marketingSupport: 'Soutien marketing',
  advancedTraining: 'Formation technique avancée',
  equipment: 'Équipement',
  marketLinkage: 'Liaison avec le marché',
  businessRegistration: 'Soutien à l\'enregistrement de l\'entreprise',
  selectNumber: 'Sélectionnez un nombre',

  confidenceDesc: 'Dans quelle mesure la formation chez WOC a-t-elle amélioré votre confiance et votre capacité à prendre des décisions de vie indépendantes?',

  financialSupportChanged: 'Comment votre capacité à subvenir à vos besoins financiers a-t-elle changé?',
  financialStability: 'Par rapport à avant de fréquenter WOC, comment évaluez-vous votre stabilité financière actuelle?',
  savedMoney: 'Avez-vous pu épargner régulièrement depuis la fin de votre formation?',
  incomeManagement: 'Quelle est votre confiance dans la gestion de vos revenus personnels?',

  communityImpactDesc: 'Comment décririez-vous l\'impact de la formation WOC sur votre vie et votre communauté?',
  leadershipInvolvement: 'Vous êtes-vous davantage impliqué dans le leadership ou la prise de décision au sein de votre famille ou de votre communauté après avoir obtenu votre diplôme chez WOC?',

  editTraineeProfile: 'Modifier le profil du stagiaire',
  updateProfile: 'Mettre à jour le profil',
  editing: 'Modification :',

  step: 'Étape',
  of: 'sur',
  skipped: 'Ignoré',
  notApplicable: 'Non applicable',

  continue: 'Continuer',
  previous: 'Précédent',
  next: 'Suivant',
  submit: 'Terminer l\'inscription',
  submitting: 'Soumission en cours...',
  updateProfile: 'Mettre à jour le profil',

  noServerResponse: 'Aucune réponse du serveur. Veuillez vérifier votre connexion.',
  registrationFailed: 'L\'inscription a échoué. Veuillez réessayer.',
  pleaseFillRequiredFields: 'Veuillez remplir tous les champs obligatoires',

  above200k: 'Au-dessus de 200 000 RWF',
  selectOption: 'Sélectionnez une option',
  selectRating: 'Sélectionnez une évaluation',
  selectImpact: 'Sélectionnez le niveau d\'impact',
  yes: 'Oui',
  no: 'Non',
  none: 'Aucun',
  selectCohort: 'Sélectionner la cohorte',
  selectDepartment: 'Sélectionner le département',
  selectStatus: 'Sélectionner le statut',

    // In french section, add:

pleaseFillRequiredFields: 'Veuillez remplir tous les champs obligatoires',
stepErrorBasicInfo: 'Veuillez remplir tous les champs obligatoires dans les Informations de Base',
stepErrorEmployment: 'Veuillez sélectionner votre statut d\'emploi',
stepErrorJobSecured: 'Veuillez sélectionner comment vous avez obtenu votre emploi',
stepSkippedUnemployed: 'Vous avez sélectionné "Sans Emploi" à l\'étape précédente. Cette étape ne s\'applique pas.',
stepSkippedNotUnemployed: 'Vous n\'êtes pas sans emploi. Cette étape ne s\'applique pas.',
stepSkippedNotEntrepreneur: 'Vous avez sélectionné "Non" pour l\'entrepreneuriat. Cette étape ne s\'applique pas.',
skipToNextStep: 'Passer à l\'étape suivante',
editTraineeProfile: 'Modifier le profil du stagiaire',
updateProfile: 'Mettre à jour le profil',
profileUpdatedSuccess: 'Profil mis à jour avec succès !',
profileAddedSuccess: 'Profil ajouté avec succès !',
editing: 'Modification :',
currentPhotoLabel: 'Photo actuelle :',
noDepartmentsAvailable: 'Aucun département disponible',
noGalleryImages: 'Aucune image de galerie disponible pour le moment.',
noWomenProfiles: 'Aucun profil de femme disponible pour le moment.',
noEvents: 'Aucun événement à afficher',
welcomeToGallery: 'Bienvenue dans notre Galerie',
gallerySubtitle: 'Explorez le parcours d\'autonomisation des femmes',
viewAll: 'Voir tout',
matching: 'correspondant',
resetFilters: 'Réinitialiser les filtres',
noImagesInDatabase: 'Aucune image trouvée dans la base de données. Affichage d\'images d\'exemple.',
errorLoadingImages: 'Erreur de chargement des images. Affichage d\'images d\'exemple.',
errorLoadingDepartments: 'Erreur de chargement des départements. Utilisation de la liste par défaut.',
unknownDepartment: 'Département inconnu',
noImagesForDepartment: 'Aucune image disponible pour ce département pour le moment.',
clickToView: 'Cliquez pour voir',
department: 'Département',
category: 'Catégorie',
date: 'Date',
close: 'Fermer',
viewDetails: 'Voir les détails',
viewAllDepartments: 'Voir tous les départements',
viewAllWomen: 'Voir toutes les femmes',
loadMoreImages: 'Charger plus d\'images',
noDescription: 'Aucune description disponible',
featured: 'En vedette',

    // Search Bar Translations - FRENCH
searchPlaceholder: 'Rechercher des femmes, départements, activités...',
trainedWomen: 'Femmes Formées',
trainingDepartments: 'Départements de Formation',
activities: 'Activités',
galleryImages: 'Images de la Galerie',
viewAllResults: 'Voir tous les résultats pour',
searchResultsFor: 'Résultats de recherche pour',
viewAllItems: 'Voir tous les →',
noResultsFound: 'Aucun résultat trouvé pour',
trySearchingFor: 'Essayez de rechercher :',
searchSuggestions: 'couture, cuisine, agriculture, travaux manuels, maroquinerie',
viewCompleteSearchResults: 'Voir Tous les Résultats',

    // Trainee Registration - Additional Fields Translations - FRENCH
enterName: 'Entrez le nom complet',
enterAge: 'Âge',
enterPhone: '+250 78X XXX XXX',
enterEmail: 'email@example.com',
enterPlacementLocation: 'Ville, District, Pays',
enterCompetenceSkills: 'Ex: Compétences informatiques, Prise de décision, Leadership',
separateWithCommas: 'Séparez les compétences multiples par des virgules',
enterCompanyName: 'Nom de l\'entreprise/organisation',
enterWorkingPosition: 'Titre du poste',
enterWorkingLocation: 'Lieu de travail',
enterYears: 'Années',
enterLocation: 'Localisation actuelle',
enterBio: 'Courte biographie',
selectJobSecured: 'Sélectionnez comment vous avez obtenu votre emploi',
selectChallenges: 'Sélectionnez toutes les options applicables',
selectSupport: 'Quel soutien vous aiderait à développer votre entreprise ? Sélectionnez toutes les options applicables',
selectOption: 'Sélectionnez une option',
selectNumber: 'Sélectionnez un nombre',
selectRating: 'Sélectionnez une évaluation',
selectImpact: 'Sélectionnez le niveau d\'impact',
startedBusiness: 'Avez-vous créé votre propre entreprise après avoir obtenu votre diplôme ?',
employeesEmployed: 'Combien de personnes avez-vous employées ?',
none: 'Aucun',
moreThan5: 'Plus de 5',
yes: 'Oui',
no: 'Non',
saving: 'Enregistrement...',
educationAndBio: 'Éducation et Biographie',
confidenceImproved: 'Dans quelle mesure la formation a-t-elle amélioré votre confiance ?',
financialSupportChanged: 'Comment votre capacité à subvenir à vos besoins financiers a-t-elle changé ?',
financialStability: 'Par rapport à avant la formation, comment évaluez-vous votre stabilité financière ?',
savedMoney: 'Avez-vous pu épargner régulièrement depuis la formation ?',
incomeManagement: 'Quelle est votre confiance dans la gestion de vos revenus personnels ?',
communityImpactDesc: 'Comment décririez-vous l\'impact de la formation WOC sur votre vie et votre communauté ?',
leadershipInvolvement: 'Vous êtes-vous davantage impliqué dans le leadership ou la prise de décision ?',
currentPhoto: 'Photo actuelle',
yesEveryMonth: 'Oui, tous les mois',
yesOccasionally: 'Oui, occasionnellement',
noButPlan: 'Non, mais j\'en ai l\'intention',
notChanged: 'N\'a pas changé',
worsened: 'S\'est aggravé',
fullyIndependent: 'Totalement indépendant financièrement',
significantlyContribute: 'Contribue de manière significative au foyer',
occasionallyContribute: 'Contribue occasionnellement au foyer',
muchBetter: 'Beaucoup mieux',
better: 'Mieux',
same: 'À peu près pareil',
worse: 'Pire',
muchWorse: 'Beaucoup pire',
veryGreatExtent: 'Dans une très grande mesure',
greatExtent: 'Dans une grande mesure',
moderateExtent: 'Dans une mesure modérée',
smallExtent: 'Dans une faible mesure',
notAtAll: 'Pas du tout',
veryConfident: 'Très confiant',
confident: 'Confiante',
moderatelyConfident: 'Modérément confiante',
slightlyConfident: 'Légèrement confiante',
notConfident: 'Pas du tout confiante',
transformational: 'Transformationnel',
significantPositive: 'Impact positif significatif',
moderatePositive: 'Impact positif modéré',
slightPositive: 'Impact positif léger',
noImpact: 'Aucun impact notable',
significantly: 'Oui, de manière significative',
toSomeExtent: 'Oui, dans une certaine mesure',
noChange: 'Pas de changement',
lessInvolved: 'Moins impliqué qu\'avant',
    // Trainee Registration Translations - FRENCH
traineeRegister: 'S\'inscrire en tant que Stagiaire',
traineeRegistration: 'Inscription du Stagiaire',
basicInformation: 'Informations de Base',
employmentStatus: 'Statut d\'Emploi',
jobSecured: 'Comment Vous Avez Obtenu l\'Emploi',
jobRelevance: 'Pertinence de l\'Emploi',
jobChallenges: 'Défis de Recherche d\'Emploi',
entrepreneurship: 'Entrepreneuriat',
supportNeeded: 'Soutien Nécessaire',
confidenceImpact: 'Confiance & Impact',
financialSituation: 'Situation Financière',
communityImpact: 'Impact Communautaire',
registrationComplete: 'Inscription Terminée !',
thankYouRegistration: 'Merci d\'avoir terminé votre inscription.',
registrationSuccess: 'Vos informations ont été enregistrées avec succès.',
registrationSuccessSub: 'Vous pouvez maintenant accéder à toutes les fonctionnalités de la plateforme.',
previous: 'Précédent',
next: 'Suivant',
submit: 'Terminer l\'Inscription',
submitting: 'Soumission en cours...',
fullName: 'Nom Complet',
age: 'Âge',
cohort: 'Cohorte',
placementLocation: 'Lieu de Placement',
competenceSkills: 'Compétences',
profilePhoto: 'Photo de Profil',
employmentSector: 'Secteur d\'Emploi',
companyName: 'Nom de l\'Entreprise',
workingPosition: 'Poste Occupé',
workingLocation: 'Lieu de Travail',
modeOfEmployment: 'Mode d\'Emploi',
yearsOfExperience: 'Années d\'Expérience',
monthlyIncome: 'Revenu Mensuel Approximatif',
contractStartDate: 'Date de Début du Contrat',
contractEndDate: 'Date de Fin du Contrat',
selectCohort: 'Sélectionner la cohorte',
selectDepartment: 'Sélectionner le département',
selectStatus: 'Sélectionner le statut',
selectSector: 'Sélectionner le secteur',
selectMode: 'Sélectionner le mode',
selectIncome: 'Sélectionner la fourchette',
selectRelevance: 'Sélectionner la pertinence',
selectConfidence: 'Sélectionner le niveau de confiance',
selfEmployed: 'Travailleur Indépendant',
unemployed: 'Sans Emploi',
employedByCompany: 'Employé par une Entreprise',
workForOthers: 'Travaille pour d\'Autres',
continuingTraining: 'Formation Continue',
publicSector: 'Public',
privateSector: 'Privé',
ngo: 'ONG',
other: 'Autre',
permanent: 'Contrat Permanent',
internship: 'Stage',
partTime: 'Contrat à Temps Partiel',
volunteer: 'Bénévole',
directlyRelated: 'Directement Lié',
somewhatRelated: 'Plus ou Moins Lié',
notRelated: 'Non Lié',
veryGreatExtent: 'Dans une très grande mesure',
greatExtent: 'Dans une grande mesure',
moderateExtent: 'Dans une mesure modérée',
smallExtent: 'Dans une faible mesure',
notAtAll: 'Pas du tout',
fullyIndependent: 'Je suis maintenant totalement indépendante financièrement',
significantlyContribute: 'Je contribue de manière significative au revenu de mon ménage',
occasionallyContribute: 'Je contribue occasionnellement au revenu de mon ménage',
notChanged: 'Ma situation financière n\'a pas changé',
worsened: 'Ma situation financière s\'est aggravée',
muchBetter: 'Beaucoup mieux',
better: 'Mieux',
same: 'À peu près pareil',
worse: 'Pire',
muchWorse: 'Beaucoup pire',
yesEveryMonth: 'Oui, tous les mois',
yesOccasionally: 'Oui, occasionnellement',
noButPlan: 'Non, mais j\'en ai l\'intention',
no: 'Non',
veryConfident: 'Très confiante',
confident: 'Confiante',
moderatelyConfident: 'Modérément confiante',
slightlyConfident: 'Légèrement confiante',
notConfident: 'Pas du tout confiante',
transformational: 'Transformationnel',
significantPositive: 'Impact positif significatif',
moderatePositive: 'Impact positif modéré',
slightPositive: 'Impact positif léger',
noImpact: 'Aucun impact notable',
significantly: 'Oui, de manière significative',
toSomeExtent: 'Oui, dans une certaine mesure',
noChange: 'Pas de changement',
lessInvolved: 'Moins impliqué qu\'avant',
confirmToggleStatus: 'Changer le Statut',
confirmToggleTraineeStatus: 'Êtes-vous sûr de vouloir changer le statut de ce stagiaire ? Les stagiaires inactifs n\'apparaîtront pas sur la page d\'accueil.',
traineeActivated: 'Stagiaire activé avec succès',
traineeDeactivated: 'Stagiaire désactivé avec succès',
failedToggleTraineeStatus: 'Échec du changement de statut du stagiaire',
traineeInactive: 'Le stagiaire est inactif',
    homepageManagement: 'Gestion de la Page d\'Accueil',
heroSlides: 'Diapositives Hero',
addHeroSlide: 'Ajouter une Diapositive Hero',
editHeroSlide: 'Modifier la Diapositive Hero',
noHeroSlides: 'Aucune diapositive Hero',
addHeroSlidesDesc: 'Ajoutez des diapositives à afficher dans la section hero de la page d\'accueil',
stats: 'Statistiques',
noStats: 'Aucune statistique',
addStatsDesc: 'Ajoutez des statistiques à afficher sur la page d\'accueil',
addStat: 'Ajouter une Statistique',
editStat: 'Modifier la Statistique',
statAdded: 'Statistique ajoutée avec succès',
statUpdated: 'Statistique mise à jour avec succès',
statDeleted: 'Statistique supprimée avec succès',
confirmDeleteStat: 'Êtes-vous sûr de vouloir supprimer cette statistique ?',
confirmDeleteStatTitle: 'Supprimer la Statistique',
heroSlideAdded: 'Diapositive Hero ajoutée avec succès',
heroSlideUpdated: 'Diapositive Hero mise à jour avec succès',
heroSlideDeleted: 'Diapositive Hero supprimée avec succès',
heroSlideStatusToggled: 'Statut de la diapositive Hero mis à jour',
failedAddHeroSlide: 'Échec de l\'ajout de la diapositive Hero',
failedUpdateHeroSlide: 'Échec de la mise à jour de la diapositive Hero',
failedDeleteHeroSlide: 'Échec de la suppression de la diapositive Hero',
failedToggleHeroSlideStatus: 'Échec de la mise à jour du statut de la diapositive Hero',
confirmDeleteHeroSlideTitle: 'Supprimer la Diapositive Hero',
confirmDeleteHeroSlide: 'Êtes-vous sûr de vouloir supprimer cette diapositive Hero ?',
failedLoadHeroSlides: 'Échec du chargement des diapositives Hero',
failedLoadStats: 'Échec du chargement des statistiques',
failedAddStat: 'Échec de l\'ajout de la statistique',
failedUpdateStat: 'Échec de la mise à jour de la statistique',
failedDeleteStat: 'Échec de la suppression de la statistique',

activityImages: 'Images d\'Activité',
activityImagesManagement: 'Gestion des Images d\'Activité',
addActivityImage: 'Ajouter une Image d\'Activité',
editActivityImage: 'Modifier l\'Image d\'Activité',
activityImageAdded: 'Image d\'activité ajoutée avec succès',
activityImageUpdated: 'Image d\'activité mise à jour avec succès',
activityImageDeleted: 'Image d\'activité supprimée avec succès',
activityImageStatusToggled: 'Statut de l\'image d\'activité mis à jour',
confirmDeleteActivityImage: 'Êtes-vous sûr de vouloir supprimer cette image d\'activité ?',
searchActivityImages: 'Rechercher des images d\'activité...',
bulkUpload: 'Téléversement en Masse',
bulkUploadImages: 'Téléverser des Images en Masse',
bulkUploadComplete: 'Téléversement en masse terminé avec succès',
failedBulkUpload: 'Échec du téléversement en masse',
selectImagesToUpload: 'Veuillez sélectionner des images à téléverser',
selectedFiles: 'Fichiers Sélectionnés',
uploadAll: 'Téléverser Tout',
uploading: 'Téléversement...',
imageRequired: 'Le fichier image est requis',
failedAddActivityImage: 'Échec de l\'ajout de l\'image d\'activité',
failedUpdateActivityImage: 'Échec de la mise à jour de l\'image d\'activité',
failedDeleteImage: 'Échec de la suppression de l\'image',
imageDeleted: 'Image supprimée avec succès',
imageRestored: 'Image restaurée avec succès',
failedRestoreImage: 'Échec de la restauration de l\'image',
imageStatusToggled: 'Statut de l\'image mis à jour',
failedToggleImageStatus: 'Échec de la mise à jour du statut de l\'image',
failedLoadActivityImages: 'Échec du chargement des images d\'activité',
exportActivityImages: 'Exporter les Images d\'Activité',
activityImagesExported: 'Images d\'activité exportées avec succès',
failedExportActivityImages: 'Échec de l\'exportation des images d\'activité',
womenInAction: 'Femmes en Action',
totalImages: 'Total d\'Images',
activeImages: 'Images Actives',
departmentsWithImages: 'Départements avec Images',
lastUpload: 'Dernier Téléversement',
never: 'Jamais',
noActivityImages: 'Aucune image d\'activité trouvée',
addActivityImagesDesc: 'Ajoutez des images à afficher dans la section Femmes en Action sur la page d\'accueil',
    deleteWhyChooseUs: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    deleteWhyChooseUsTitle: "Supprimer l'Élément",
    deleteVideo: "Êtes-vous sûr de vouloir supprimer cette vidéo ?",
    deleteVideoTitle: "Supprimer la Vidéo",
    added: "Élément ajouté avec succès",
    updated: "Élément mis à jour avec succès",
    deleted: "Élément supprimé avec succès",
    statusToggled: "Statut mis à jour avec succès",
    failedAdd: "Échec de l'ajout de l'élément",
    failedUpdate: "Échec de la mise à jour de l'élément",
    failedDelete: "Échec de la suppression de l'élément",
    failedToggle: "Échec de la mise à jour du statut",

    videoSections: "Sections Vidéo",
    addVideo: "Ajouter une Vidéo",
    editVideo: "Modifier la Vidéo",
    noVideos: "Aucune section vidéo",
    addVideos: "Ajoutez des vidéos à afficher sur la page d'accueil",
    videoUrl: "URL de la Vidéo",
    thumbnail: "Miniature",
    setAsActive: "Définir comme vidéo active",
    onlyOneActive: "Une seule vidéo peut être active à la fois",
    currentThumbnail: "Miniature actuelle",
    watchVideo: "Regarder la Vidéo",
    playVideo: "Lire la Vidéo",
    active: "Actif",
    inactive: "Inactif",
    untitled: "Sans titre",
    youtubeEmbedUrl: "Utilisez l'URL d'intégration YouTube (ex: https://www.youtube.com/embed/ID_VIDEO)",
    enterVideoTitle: "Entrez le titre de la vidéo",
    enterVideoDescription: "Entrez la description de la vidéo",
    setActive: "Définir comme Actif",
    whyChooseUsItems: "Éléments Pourquoi Nous Choisir",
    addItem: "Ajouter un Élément",
    editItem: "Modifier l'Élément",
    noWhyChooseUsItems: "Aucun élément Pourquoi Nous Choisir",
    addWhyChooseUsItems: "Ajoutez des éléments à afficher sur la page d'accueil",
    icon: "Icône",
    title: "Titre",
    description: "Description",
    sortOrder: "Ordre de Tri",
    status: "Statut",
    actions: "Actions",
    iconPreview: "Aperçu de l'Icône",
    enterTitle: "Entrez le titre",
    enterDescription: "Entrez la description",
    currentPassword: 'Mot de passe actuel',
    enterCurrentPassword: 'Entrez votre mot de passe actuel',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordChanged: 'Mot de passe modifié avec succès !',
    failedChangePassword: 'Échec de la modification du mot de passe',
    changing: 'Modification en cours...',
    changePassword: 'Changer le mot de passe',    
    // Contract Management Translations
contracts: 'Mes Contrats',
activeContracts: 'Contrats Actifs',
contractHistory: 'Historique des Contrats',
completedContracts: 'Terminés',
expiringSoon: 'Expire Bientôt',
noActiveContracts: 'Aucun Contrat Actif',
noActiveContractsDesc: "Vous n'avez aucun contrat actif pour le moment.",
noContractHistory: 'Aucun Historique de Contrat',
noContractHistoryDesc: "Vous n'avez aucun contrat terminé ou résilié.",
contractDetails: 'Détails du Contrat',
contractId: 'ID du Contrat',
period: 'Période',
startDate: 'Date de Début',
endDate: 'Date de Fin',
daysRemaining: 'Jours Restants',
status: 'Statut',
terminationReason: 'Motif de Résiliation',
renew: 'Renouveler',
renewNow: 'Renouveler Maintenant',
terminate: 'Résilier',
viewDetails: 'Voir les Détails',
renewContract: 'Renouveler le Contrat',
terminateContract: 'Résilier le Contrat',
renewContractInfo: 'Le contrat actuel expire le:',
selectContractPeriod: 'Sélectionner la période du contrat',
customMonths: 'Mois personnalisés...',
months: 'mois',
sendEmailNotification: 'Envoyer une confirmation par email',
renewContractNote: 'Le renouvellement du contrat créera une nouvelle période. Le contrat actuel sera marqué comme renouvelé.',
renewing: 'Renouvellement en cours...',
terminating: 'Résiliation en cours...',
warning: 'Attention',
terminateContractWarning: 'Cette action ne peut pas être annulée.',
selectReason: 'Sélectionnez un motif',
workCompleted: 'Travail terminé',
performance: 'Problèmes de performance',
budgetConstraints: 'Contraintes budgétaires',
restructuring: 'Restructuration d\'entreprise',
mutualAgreement: 'Accord mutuel',
other: 'Autre',
customReason: 'Motif personnalisé',
enterTerminationReason: 'Entrez le motif de résiliation',
effectiveDate: 'Date d\'effet',
effectiveDateNote: 'Laissez vide pour une résiliation immédiate',
sendTerminationEmail: 'Envoyer un email de confirmation de résiliation',
womanInformation: 'Informations sur la Femme',
name: 'Nom',
age: 'Âge',
department: 'Département',
skills: 'Compétences',
experience: 'Expérience',
years: 'ans',
phone: 'Téléphone',
email: 'Email',
contractInformation: 'Informations du Contrat',
terminationDetails: 'Détails de Résiliation',
terminatedOn: 'Résilié le',
renewalInformation: 'Informations de Renouvellement',
renewedFrom: 'Renouvelé depuis',
renewedTo: 'Renouvelé vers',
notes: 'Notes',
close: 'Fermer',
expired: 'Expiré',
active: 'Actif',
searchContracts: 'Rechercher des contrats...',
refresh: 'Actualiser',
viewAll: 'Voir Tout',
exportList: 'Exporter la Liste',
exportSuccessful: 'Exportation terminée avec succès',
exportFailed: 'Échec de l\'exportation. Veuillez réessayer.',
exportingContracts: 'Exportation des contrats...',
    exportOptions: 'Options d\'exportation',
exportAsCSV: 'Exporter en CSV',
exportAsExcel: 'Exporter en Excel',
exportAsPDF: 'Exporter en PDF',
exportSuccessful: 'Exportation terminée avec succès',
exportFailed: 'Échec de l\'exportation. Veuillez réessayer.',
exportingContracts: 'Exportation des contrats...',

    contractExpiration: 'Expiration du Contrat',
showContractsExpiringIn: 'Afficher les contrats expirant dans',
days: 'jours',
refresh: 'Actualiser',
manageAllContracts: 'Gérer Tous les Contrats',
activeContracts: 'Contrats Actifs',
expiringThisMonth: 'Expirant Ce Mois-ci',
renewedThisMonth: 'Renouvelés Ce Mois-ci',
expiringNextMonth: 'Expirant Le Mois Prochain',
noExpiringContracts: 'Aucun Contrat Expirant',
noContractsExpiringSoon: 'Aucun contrat n\'expire dans la période sélectionnée.',
contractsExpiringInNext: 'contrats expirant dans les',
woman: 'Femme',
department: 'Département',
contractPeriod: 'Période du Contrat',
startDate: 'Date de Début',
endDate: 'Date de Fin',
daysRemaining: 'Jours Restants',
employer: 'Employeur',
contact: 'Contact',
actions: 'Actions',
noPhone: 'Pas de téléphone',
general: 'Général',
months: 'mois',
sendEmail: 'Envoyer un Email',
call: 'Appeler',
viewDetails: 'Voir les Détails',
sendReminder: 'Envoyer un Rappel',
extendContract: 'Prolonger le Contrat',
exportExpiringContracts: 'Exporter la Liste',

// Additional export-related translations
exportContracts: 'Exporter les Contrats',
exportAsCSV: 'Exporter en CSV',
exportAsExcel: 'Exporter en Excel',
exportAsPDF: 'Exporter en PDF',
exportingContracts: 'Exportation des contrats...',
exportSuccessful: 'Exportation réussie',
exportFailed: 'Échec de l\'exportation. Veuillez réessayer.',
downloadExportedFile: 'Télécharger le Fichier Exporté',
selectExportFormat: 'Sélectionner le Format d\'Exportation',
includeInactiveContracts: 'Inclure les contrats inactifs',
exportAllContracts: 'Exporter Tous les Contrats',
exportFilteredContracts: 'Exporter les Contrats Filtrés',
contractExportTitle: 'Exportation des Contrats',
generatingExport: 'Génération du fichier d\'exportation...',
contractList: 'Liste des Contrats',
totalContracts: 'Total des Contrats',
exportDate: 'Date d\'Exportation',
exportedBy: 'Exporté Par',
contractDetails: 'Détails du Contrat',
womanName: 'Nom de la Femme',
employerName: 'Nom de l\'Employeur',
employerEmail: 'Email de l\'Employeur',
employerPhone: 'Téléphone de l\'Employeur',
contractStart: 'Début du Contrat',
contractEnd: 'Fin du Contrat',
contractMonths: 'Mois du Contrat',
status: 'Statut',
active: 'Actif',
expired: 'Expiré',
expiringSoon: 'Expire Bientôt',
critical: 'Critique',
warning: 'Attention',
good: 'Bon',
exportSummary: 'Résumé de l\'Exportation',
rowsExported: 'lignes exportées',
exportTime: 'Heure d\'Exportation',
contractStats: 'Statistiques des Contrats',
fetchingContracts: 'Récupération des contrats...',
noContractsFound: 'Aucun contrat trouvé',
viewContract: 'Voir le Contrat',
contractId: 'ID du Contrat',
contractStatus: 'Statut du Contrat',
renewContract: 'Renouveler le Contrat',
contractRenewed: 'Contrat renouvelé avec succès',
renewalDate: 'Date de Renouvellement',
previousContract: 'Contrat Précédent',
nextContract: 'Contrat Suivant',
contractHistory: 'Historique du Contrat',
renewalHistory: 'Historique des Renouvellements',
confirmRenewContract: 'Êtes-vous sûr de vouloir renouveler ce contrat ?',
enterRenewalMonths: 'Entrez le nombre de mois pour le renouvellement',
renewalPeriod: 'Période de Renouvellement',
newEndDate: 'Nouvelle Date de Fin',
contractNotes: 'Notes du Contrat',
addContractNote: 'Ajouter une Note',
viewAllContracts: 'Voir Tous les Contrats',
filterContracts: 'Filtrer les Contrats',
searchContracts: 'Rechercher des contrats...',
clearFilters: 'Effacer les Filtres',
applyFilters: 'Appliquer les Filtres',
     // Partners Management - French
     partners: 'Partenaires & Sponsors',
     partnersManagement: 'Gestion des Partenaires',
     addPartner: 'Ajouter un Partenaire',
     editPartner: 'Modifier le Partenaire',
     partnerName: 'Nom du Partenaire',
     partnerType: 'Type de Partenaire',
     partnerLogo: 'Logo du Partenaire',
     websiteUrl: 'URL du Site Web',
     sortOrder: 'Ordre de Tri',
     enterPartnerName: 'Entrez le nom du partenaire/organisation',
     selectType: 'Sélectionnez le type de partenaire',
     enterPartnerDescription: 'Entrez la description du partenaire',
     currentLogo: 'Logo actuel',
     updatePartner: 'Mettre à Jour le Partenaire',
     failedAddPartner: 'Échec de l\'ajout du partenaire',
     failedUpdatePartner: 'Échec de la mise à jour du partenaire',
     failedDeletePartner: 'Échec de la suppression du partenaire',
     failedLoadPartners: 'Échec du chargement des partenaires',
     failedTogglePartnerStatus: 'Échec de la modification du statut du partenaire',
     partnerAdded: 'Partenaire ajouté avec succès',
     partnerUpdated: 'Partenaire mis à jour avec succès',
     partnerDeleted: 'Partenaire supprimé avec succès',
     partnerStatusToggled: 'Statut du partenaire mis à jour avec succès',
     confirmDeletePartnerTitle: 'Supprimer le Partenaire',
     confirmDeletePartner: 'Êtes-vous sûr de vouloir supprimer ce partenaire ? Cette action est irréversible.',
     searchPartners: 'Rechercher des partenaires...',
     allTypes: 'Tous les Types',
     noPartnersFound: 'Aucun partenaire trouvé',
     noPartnersMatchCriteria: 'Aucun partenaire ne correspond à vos critères',
     showingPartners: 'Affichage de {showing} sur {total} partenaires',
     deactivate: 'Désactiver',
     activate: 'Activer',
     visit: 'Visiter',
     noDescription: 'Aucune description',
     partnerDescriptionDefault: 'Organisation partenaire',
     visitWebsite: 'Visiter le Site Web',
     government: 'Gouvernement',
     internationalNGO: 'ONG Internationale',
     localNGO: 'ONG Locale',
     corporate: 'Entreprise',
     private: 'Privé',
     educational: 'Éducatif',
     other: 'Autre',
     partnersCount: 'Nombre de partenaires',
     activePartners: 'Partenaires Actifs',
     inactivePartners: 'Partenaires Inactifs',
     partnerStats: 'Statistiques des Partenaires',
     exportPartners: 'Exporter les Partenaires',
     importPartners: 'Importer les Partenaires',
     partnerDetails: 'Détails du Partenaire',
     establishedDate: 'Établi',
     lastUpdated: 'Dernière Mise à Jour',

    amountNote:'Montant fixe de 10,000 RWF par femme, indépendamment de la durée du contrat',
    enterEmailAddress: 'Veuillez entrer votre adresse email',
    resetEmailSent: 'Email de réinitialisation du mot de passe envoyé. Veuillez vérifier votre boîte de réception.',
    resetRequestFailed: 'Échec du traitement de la demande de réinitialisation. Veuillez réessayer.',
    forgotPasswordDescription: 'Entrez votre email pour réinitialiser votre mot de passe',
    backToLogin: 'Retour à la connexion',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    sending: 'Envoi en cours...',
    resetInstructions: 'Vous recevrez un email avec un lien pour réinitialiser votre mot de passe. Le lien expirera dans 1 heure.',
    whyChooseUs: "Pourquoi Nous Choisir",
    // French (Français)
    contractPeriod: 'Période de Contrat',
    selectContractPeriod: 'Sélectionner la période de contrat',
    requiredSkills: 'Compétences Requises',
    selectRelevantSkills: 'Sélectionnez les compétences pertinentes pour ce poste',
    noSkillsForDepartment: 'Aucune compétence disponible pour ce département',
    expiringContracts: 'Contrats Expirants',
    showContractsExpiringIn: 'Afficher les contrats expirant dans:',
    noExpiringContracts: 'Aucun Contrat Expirant',
    noContractsExpiringSoon: 'Aucun contrat n\'expire bientôt',
    daysRemaining: 'Jours Restants',
    daysLeft: 'jours restants',
    sendReminder: 'Envoyer un rappel',
    renewContract: 'Renouveler le contrat',
    contractRenewed: 'Contrat renouvelé avec succès',
    months: 'mois',
    
    csvTemplateInstructions: 'Le CSV doit avoir les colonnes: nom, âge, département, compétences, années d\'expérience, niveau d\'éducation, téléphone, email, localisation, bio, noms des compétences',
    importInstructions: 'Téléchargez le modèle pour assurer le bon format',
    downloadTemplate: 'Télécharger le Modèle',
    importing: 'Importation...',
    import: 'Importer',
    importProfiles: 'Importer les Profils',
    cannotAssignDifferentDept: 'Impossible d\'assigner des femmes de différents départements',
    validationFailed: 'Validation échouée',
    viewCertificate: 'Voir le Certificat',
    certified: 'Certifié',
    certificatePending: 'Certificat en Attente',
    requestThisWoman: 'Demander cette femme',
    currentlyEmployed: 'Actuellement Employée',
    
    '3 months': '3 mois',
    '6 months': '6 mois',
    '1 year': '1 an',
    '2 years': '2 ans',
    '3 years': '3 ans',
    
    beginner: 'Débutant',
    intermediate: 'Intermédiaire',
    advanced: 'Avancé',
    expert: 'Expert',
    
    sendCustomEmail: 'Envoyer un Email Personnalisé',
    emailRecipients: 'Destinataires de l\'Email',
    enterEmailRecipients: 'Entrez les adresses email (séparées par des virgules)',
    commaSeparatedEmails: 'Entrez plusieurs adresses email séparées par des virgules',
    customEmailDescription: 'Envoyez des emails à n\'importe quelle adresse email (pas limité aux utilisateurs du système)',
    allFieldsRequired: 'Tous les champs sont requis',
    invalidEmails: 'Adresses email invalides',
    emailSentSuccessfully: 'Email envoyé avec succès à destinataires',
    failedToSendEmail: 'Échec d\'envoi de l\'email',
    customEmail: 'Email Personnalisé',
    attachments: 'Pièces Jointes',
    maxFileSize: 'Taille maximale du fichier',
    uploadCSVFile: 'Téléverser un Fichier CSV',
    importWomenProfiles: 'Importer les Profils des Femmes',
      // Privacy Policy
  privacyPolicy: 'Politique de confidentialité',
  lastUpdated: 'Dernière mise à jour',
  privacyIntroTitle: 'Introduction',
  privacyIntroText: 'Urugo Women Opportunity Center valorise votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles.',
  informationWeCollect: 'Informations que nous collectons',
  personalInformation: 'Informations personnelles',
  infoNameEmail: 'Nom et adresse email',
  infoPhoneAddress: 'Numéro de téléphone et adresse physique',
  infoPaymentDetails: 'Informations de paiement pour les dons',
  infoEmploymentHistory: 'Historique professionnel et informations sur les compétences',
  usageData: 'Données d\'utilisation',
  dataIPAddress: 'Adresse IP et type de navigateur',
  dataBrowserType: 'Informations sur l\'appareil',
  dataPagesVisited: 'Pages visitées et temps passé',
  dataTimeSpent: 'Informations sur le site web référent',
  howWeUseInformation: 'Comment nous utilisons vos informations',
  useProvideServices: 'Pour fournir et maintenir nos services',
  useProcessDonations: 'Pour traiter les dons et les paiements',
  useMatchEmployees: 'Pour mettre en relation les femmes avec des opportunités d\'emploi',
  useCommunication: 'Pour communiquer avec vous',
  useImproveServices: 'Pour améliorer nos services et notre site web',
  useLegalCompliance: 'Pour se conformer aux obligations légales',
  informationSharing: 'Partage d\'informations',
  sharingIntro: 'Nous ne vendons pas vos informations personnelles. Nous ne partageons des informations que dans les circonstances suivantes :',
  withEmployers: 'Avec les employeurs',
  sharingEmployers: 'Uniquement avec votre consentement pour la mise en relation d\'emploi',
  withServiceProviders: 'Avec les prestataires de services',
  sharingProviders: 'Partenaires de confiance qui assistent nos opérations',
  legalRequirements: 'Exigences légales',
  sharingLegal: 'Lorsque requis par la loi ou une procédure légale',
  withConsent: 'Avec votre consentement',
  sharingConsent: 'Lorsque vous nous donnez explicitement la permission',
  dataSecurity: 'Sécurité des données',
  securityMeasures: 'Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations.',
  securityEncryption: 'Chiffrement SSL pour la transmission des données',
  securityAccessControl: 'Contrôles d\'accès et authentification',
  securityRegularAudits: 'Audits de sécurité réguliers',
  securityTraining: 'Formation des employés sur la confidentialité',
  yourRights: 'Vos droits',
  rightAccess: 'Droit d\'accéder à vos données personnelles',
  rightCorrection: 'Droit de corriger les données inexactes',
  rightDeletion: 'Droit de supprimer vos données',
  rightObject: 'Droit de s\'opposer au traitement',
  rightDataPortability: 'Droit à la portabilité des données',
  rightWithdrawConsent: 'Droit de retirer le consentement',
  cookies: 'Cookies',
  cookiesDescription: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site web.',
  essentialCookies: 'Cookies essentiels',
  essentialCookiesDesc: 'Nécessaires pour les fonctionnalités de base du site',
  analyticsCookies: 'Cookies analytiques',
  analyticsCookiesDesc: 'Nous aident à comprendre comment les visiteurs utilisent notre site',
  preferenceCookies: 'Cookies de préférence',
  preferenceCookiesDesc: 'Se souviennent de vos paramètres et préférences',
  childrenPrivacy: 'Confidentialité des enfants',
  childrenPrivacyText: 'Nos services ne s\'adressent pas aux enfants de moins de 18 ans.',
  changesToPolicy: 'Modifications de cette politique de confidentialité',
  policyChangesText: 'Nous pouvons mettre à jour notre politique de confidentialité périodiquement.',
  contactUsPrivacy: 'Contactez-nous',
  contactPrivacyText: 'Si vous avez des questions concernant cette politique de confidentialité, contactez-nous à :',
  
  // Terms of Service
  termsOfService: 'Conditions d\'utilisation',
  termsAgreement: 'Acceptation des conditions',
  termsAgreementText: 'En accédant et utilisant notre plateforme, vous acceptez ces conditions d\'utilisation.',
  definitions: 'Définitions',
  platform: 'Plateforme',
  platformDefinition: 'Le site web Urugo WOC',
  services: 'Services',
  servicesDefinition: 'Services de mise en relation d\'emploi, de formation et de don',
  user: 'Utilisateur',
  userDefinition: 'Toute personne accédant ou utilisant la plateforme',
  employer: 'Employeur',
  employerDefinition: 'Particuliers ou entreprises cherchant à embaucher',
  employee: 'Employée',
  employeeDefinition: 'Femmes cherchant des opportunités d\'emploi',
  donor: 'Donateur',
  donorDefinition: 'Particuliers ou organisations faisant des dons',
  accountRegistration: 'Inscription au compte',
  accountRegistrationText: 'Pour utiliser certaines fonctionnalités, vous devez créer un compte.',
  accountAgeRequirement: 'Vous devez avoir au moins 18 ans',
  accountAccurateInfo: 'Fournir des informations exactes et complètes',
  accountSecurity: 'Maintenir la sécurité du compte',
  accountTransfer: 'Ne pas transférer votre compte à d\'autres',
  servicesDescription: 'Description des services',
  employmentServices: 'Services d\'emploi',
  employmentMatch: 'Mise en relation de femmes qualifiées avec des employeurs',
  employmentVerification: 'Vérification des compétences et qualifications',
  employmentTraining: 'Formation et développement des compétences',
  employmentSupport: 'Soutien continu à l\'emploi',
  donationServices: 'Services de don',
  donationProcessing: 'Traitement des dons monétaires',
  donationTracking: 'Suivi de l\'impact des dons',
  donationReporting: 'Rapports réguliers sur l\'impact',
  donationTransparency: 'Allocation transparente des fonds',
  userObligations: 'Obligations de l\'utilisateur',
  generalUserObligations: 'Obligations générales de l\'utilisateur',
  obeyLaws: 'Respecter toutes les lois et réglementations applicables',
  respectOthers: 'Respecter les autres utilisateurs et leur vie privée',
  noFraud: 'Ne pas s\'engager dans des activités frauduleuses',
  accurateInfo: 'Fournir des informations exactes',
  noHarassment: 'Ne pas harceler ou discriminer',
  employerObligations: 'Obligations de l\'employeur',
  fairTreatment: 'Fournir des conditions d\'emploi équitables',
  timelyPayment: 'Effectuer les paiements à temps',
  safeEnvironment: 'Fournir un environnement de travail sûr',
  complianceLaws: 'Se conformer aux lois sur l\'emploi',
  employeeObligations: 'Obligations de l\'employée',
  professionalConduct: 'Maintenir une conduite professionnelle',
  honestSkills: 'Représenter honnêtement les compétences et la disponibilité',
  commitment: 'Remplir les engagements d\'emploi',
  respectEmployer: 'Respecter la propriété et les règles de l\'employeur',
  paymentsFees: 'Paiements et frais',
  serviceFees: 'Des frais de service peuvent s\'appliquer pour certains services',
  donationFees: 'Frais de traitement des dons',
  paymentMethods: 'Méthodes de paiement acceptées',
  refundPolicy: 'Politique de remboursement pour les dons',
  taxResponsibility: 'Responsabilités fiscales',
  intellectualProperty: 'Propriété intellectuelle',
  ipOwnership: 'Nous détenons tous les droits de propriété intellectuelle sur la plateforme.',
  ipLicense: 'Nous vous accordons une licence limitée pour utiliser la plateforme.',
  userContentLicense: 'Vous nous accordez une licence pour utiliser votre contenu pour les opérations de la plateforme.',
  limitationLiability: 'Limitation de responsabilité',
  liabilityDisclaimer: 'Nous fournissons les services "tels quels" sans garanties.',
  liabilityLimit: 'Limitation de notre responsabilité',
  liabilityForceMajeure: 'Événements de force majeure',
  termination: 'Résiliation',
  terminationClause: 'Nous pouvons résilier ou suspendre l\'accès à votre compte.',
  terminationBreach: 'Pour violation de ces conditions',
  terminationInactivity: 'Pour inactivité prolongée',
  terminationRequest: 'À votre demande',
  terminationPlatform: 'Pour maintenance ou sécurité de la plateforme',
  disputeResolution: 'Résolution des litiges',
  governingLaw: 'Juridiction du droit applicable',
  disputeProcess: 'Processus de résolution des litiges',
  mediationClause: 'Médiation avant litige',
  changesToTerms: 'Modifications des conditions',
  termsChangesText: 'Nous pouvons modifier ces conditions à tout moment.',
  contactUsTerms: 'Contactez-nous',
  contactTermsText: 'Pour toute question concernant ces conditions, contactez-nous à :',
  
  // Sitemap
  sitemap: 'Plan du site',
  sitemapDescription: 'Aperçu complet de toutes les pages et services disponibles sur Urugo WOC',
  mainPages: 'Pages principales',
  accountPages: 'Pages de compte',
  policyPages: 'Pages de politique',
  servicePages: 'Pages de services',
  departmentPages: 'Pages des départements',
  trainingServices: 'Services de formation',
  donationServices: 'Services de don',
  supportServices: 'Services de soutien',
  contactInformation: 'Informations de contact',
  quickActions: 'Actions rapides',
  donateNow: 'Faire un don maintenant',
  registerNow: 'S\'inscrire maintenant',
  totalPages: 'Total des pages',
  websiteVersion: 'Version du site web',
  viewPrivacy: 'Voir la politique de confidentialité',
  viewTerms: 'Voir les conditions d\'utilisation',
  viewSitemap: 'Voir le plan du site',
  backToHome: 'Retour à l\'accueil',

     // Modal Alert translations
  alertSuccess: 'Succès',
  alertError: 'Erreur',
  alertWarning: 'Avertissement',
  alertInfo: 'Information',
  okButton: 'OK',
  confirmButton: 'Confirmer',
  cancelButton: 'Annuler',
  tryAgainButton: 'Réessayer',
  close: 'Fermer',
  
  // Request Modal translations
  step1Title: 'Parlez-nous de vous',
  step1Description: 'Trouvez des femmes formées dans notre communauté diversifiée',
  step2Title: 'Créez votre compte',
  step2Description: 'Rejoignez notre communauté pour embaucher des femmes qualifiées',
  loginTitle: 'Connectez-vous à votre compte',
  loginDescription: 'Vous avez déjà un compte? Connectez-vous pour continuer',
  step3Title: 'Demander des femmes formées',
  step3Description: 'Remplissez le formulaire ci-dessous pour demander des femmes qualifiées de notre centre',
  successTitle: 'Demande soumise avec succès!',
  successMessage: 'Votre demande a été reçue. Nous vous contacterons sous peu.',
  
  // Account types
  individual: 'Individu',
  individualDesc: 'J\'embauche pour moi-même',
  company: 'Entreprise',
  companyDesc: 'J\'embauche pour mon entreprise',
  
  // Form labels
  companyNameLabel: 'Nom de l\'entreprise',
  companyNamePlaceholder: 'Entrez le nom de l\'entreprise',
  fullNameLabel: 'Nom complet',
  fullNamePlaceholder: 'Entrez votre nom complet',
  usernameLabel: 'Nom d\'utilisateur',
  usernamePlaceholder: 'Choisissez un nom d\'utilisateur',
  workEmailLabel: 'Email professionnel',
  workEmailPlaceholder: 'Entrez votre email professionnel',
  phoneLabel: 'Numéro de téléphone',
  phonePlaceholder: 'Entrez votre numéro de téléphone',
  emailLabel: 'Adresse email',
  emailPlaceholder: 'Entrez votre email',
  passwordLabel: 'Mot de passe',
  passwordPlaceholder: 'Entrez votre mot de passe',
  createPasswordPlaceholder: 'Créez un mot de passe',
  confirmPasswordLabel: 'Confirmer le mot de passe',
  confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
  passwordMinLength: 'Au moins 10 caractères',
  agreeToTerms: 'J\'accepte les conditions d\'utilisation et la politique de confidentialité',
  
  // Request form
  selectDepartment: 'Sélectionner le département',
  chooseDepartment: 'Choisir un département',
  employeesNeeded: 'Nombre d\'employés',
  costPerEmployee: '10 000 RWF par employé par mois',
  workType: 'Type de travail',
  fullTime: 'Temps plein',
  partTime: 'Temps partiel',
  contract: 'Contrat',
  seasonal: 'Saisonnier',
  duration: 'Durée (Jours)',
  days: 'jours',
  totalAmount: 'Montant total',
  woman: 'femme',
  'employee(s)': 'employé(s)',
  personalInformation: 'Informations personnelles',
  yourFullName: 'Votre nom complet',
  email: 'Email',
  phoneNumber: 'Numéro de téléphone',
  
  // Specifications
  womanSpecifications: 'Spécifications des femmes (Optionnel)',
  specificationsDescription: 'Fournir des exigences supplémentaires pour les femmes que vous souhaitez embaucher',
  ageRange: 'Tranche d\'âge préférée',
  experienceLevel: 'Niveau d\'expérience',
  skillLevel: 'Niveau de compétence requis',
  educationLevel: 'Niveau d\'éducation',
  languageRequirements: 'Exigences linguistiques',
  specialSkills: 'Compétences spéciales nécessaires',
  otherSpecifications: 'Autres spécifications',
  noPreference: 'Pas de préférence',
  years: 'années',
  beginner: 'Débutant',
  intermediate: 'Intermédiaire',
  advanced: 'Avancé',
  expert: 'Expert',
  basic: 'Compétences de base',
  kinyarwanda: 'Kinyarwanda',
  french: 'Français',
  kinyarwandaEnglish: 'Kinyarwanda & Anglais',
  anyLanguage: 'Toute langue',
  primary: 'Éducation primaire',
  secondary: 'Éducation secondaire',
  vocational: 'Formation professionnelle',
  university: 'Diplôme universitaire',
  specialSkillsPlaceholder: 'ex: Compétences informatiques, leadership, etc.',
  separateWithCommas: 'Séparer par des virgules',
  otherSpecificationsPlaceholder: 'Toute autre exigence ou préférence spécifique...',
  
  // Payment
  paymentInformation: 'Informations de paiement',
  mobileMoney: 'Mobile Money',
  bankAccount: 'Compte bancaire',
  paymentNote: 'Veuillez effectuer le paiement après avoir soumis votre demande. Votre demande sera traitée une fois le paiement vérifié.',
  
  // Buttons and actions
  continue: 'Continuer',
  back: 'Retour',
  backToRegister: 'Retour à l\'inscription',
  join: 'Rejoindre',
  loggingIn: 'Connexion en cours...',
  creatingAccount: 'Création du compte...',
  submitting: 'Soumission en cours...',
  submitRequest: 'Soumettre la demande',
  alreadyHaveAccount: 'Vous avez déjà un compte?',
  loginHere: 'Connectez-vous ici',
  signIn: 'Se connecter',
  showPassword: 'Afficher le mot de passe',
  hidePassword: 'Masquer le mot de passe',
  
  // Status messages
  available: 'Disponible',
  working: 'Au travail',
  certificateVerified: 'Vérifié',
  certificateUnverified: 'En attente',
  specificWomanRequest: 'Vous demandez',
  specifically: 'spécifiquement',
  singleWomanNote: 'Le nombre d\'employés est automatiquement fixé à 1 pour les demandes de femmes individuelles.',
  requestingWoman: 'Vous demandez:',
  youRequested: 'Vous avez demandé:',
  yourSpecifications: 'Vos spécifications:',
  languages: 'Langues',
  
  // Error messages
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  passwordTooShort: 'Le mot de passe doit comporter au moins 10 caractères',
  registrationFailed: 'L\'inscription a échoué',
  loginFailed: 'La connexion a échoué',
  requestFailed: 'Échec de la soumission de la demande',
  loginToRequest: 'Veuillez vous connecter pour demander des femmes',
  
  // Success messages
  loginSuccess: 'Vous vous êtes connecté avec succès à votre compte.',
  registrationSuccess: 'Votre compte a été créé avec succès!',
  requestSuccess: 'Votre demande a été soumise avec succès!',
  
  // Step labels
  accountType: 'Type de compte',
  account: 'Compte',
  request: 'Demande',

    // New keys for request specifications
requestManagementWithSpecs: 'Gestion des Demandes (avec Spécifications)',
specifications: 'Spécifications',
noSpecifications: 'Aucune Spécification',
viewSpecifications: 'Voir les Spécifications',
hasSpecifications: 'A des Spécifications',
withSpecifications: 'Avec Spécifications',
noSpecificationsProvided: 'Aucune spécification supplémentaire fournie pour cette demande.',
requestDetails: 'Détails de la Demande',
employerInformation: 'Informations sur l\'Employeur',
statusInformation: 'Informations sur le Statut',
employeesNeeded: 'Employés Nécessaires',
workType: 'Type de Travail',
duration: 'Durée',
amount: 'Montant',
paymentVerified: 'Paiement Vérifié',
assignedWomen: 'Femmes Attribuées',
availableWomen: 'Femmes Disponibles',
created: 'Créé',
ageRange: 'Tranche d\'Âge',
experienceLevel: 'Niveau d\'Expérience',
skillLevel: 'Niveau de Compétence',
educationLevel: 'Niveau d\'Éducation',
languageRequirements: 'Exigences Linguistiques',
specialSkills: 'Compétences Spéciales',
otherSpecifications: 'Autres Spécifications',
approveRequest: 'Approuver la Demande',
rejectRequest: 'Rejeter la Demande',
assignWomen: 'Attribuer des Femmes',
close: 'Fermer',

// Certificate related
uploadCertificate: 'Télécharger le Certificat',
certificateNumber: 'Numéro de Certificat',
certificateType: 'Type de Certificat',
selectCertificateType: 'Sélectionner le Type de Certificat',
vocationalCertificate: 'Certificat Professionnel',
skillCertificate: 'Certificat de Compétence',
trainingCertificate: 'Certificat de Formation',
professionalCertificate: 'Certificat Professionnel',
otherCertificate: 'Autre Certificat',
issuingOrganization: 'Organisme Émetteur',
issueDate: 'Date d\'Émission',
expiryDate: 'Date d\'Expiration',
certificateFile: 'Fichier du Certificat',
maxFileSize: 'Taille maximale du fichier',
currentCertificate: 'Certificat Actuel',
viewCurrentCertificate: 'Voir le Certificat Actuel',
updateCertificate: 'Mettre à jour le Certificat',
certificateVerified: 'Certificat Vérifié',
certificateUnverified: 'Certificat Non Vérifié',
noCertificate: 'Pas de Certificat',
viewCertificate: 'Voir le Certificat',
markAsUnverified: 'Marquer comme Non Vérifié',
verifyCertificate: 'Vérifier le Certificat',
deleteCertificate: 'Supprimer le Certificat',
confirmDeleteCertificateTitle: 'Supprimer le Certificat',
confirmDeleteCertificate: 'Êtes-vous sûr de vouloir supprimer ce certificat ? Cette action ne peut pas être annulée.',
confirmVerifyCertificateTitle: 'Vérifier le Certificat',
confirmVerifyCertificate: 'Êtes-vous sûr de vouloir vérifier ce certificat ?',
confirmUnverifyCertificateTitle: 'Non Vérifier le Certificat',
confirmUnverifyCertificate: 'Êtes-vous sûr de vouloir marquer ce certificat comme non vérifié ?',
certificateUploaded: 'Certificat téléchargé avec succès',
certificateDeleted: 'Certificat supprimé avec succès',
certificateVerifiedSuccess: 'Certificat vérifié avec succès',
certificateUnverifiedSuccess: 'Certificat marqué comme non vérifié avec succès',
failedUploadCertificate: 'Échec du téléchargement du certificat',
failedDeleteCertificate: 'Échec de la suppression du certificat',
failedVerifyCertificate: 'Échec de la vérification du certificat',
failedUnverifyCertificate: 'Échec du marquage comme non vérifié',

// Women management
selectAllAvailable: 'Sélectionner toutes les femmes disponibles',
womanNotAvailable: 'Femme non disponible pour l\'affectation',
selectForAssignment: 'Sélectionner pour l\'affectation',
womenSelectedForAssignment: 'Femmes Sélectionnées pour l\'Affectation',
selected: 'sélectionné',
assignSelectedWomen: 'Affecter les Femmes Sélectionnées',

// Request status
completed: 'Terminé',
cancelled: 'Annulé',
    emailSettings: 'Paramètres Email',
emailBroadcast: 'Diffusion Email',
emailBroadcastDescription: 'Envoyer des annonces et mises à jour à tous les utilisateurs du système',
sendEmailBroadcast: 'Envoyer une Diffusion Email',
sendTestEmail: 'Envoyer un Email de Test',
broadcastAllUsersWarning: 'Cet email sera envoyé à TOUS les utilisateurs du système.',
broadcastEmployersWarning: 'Cet email sera envoyé aux EMPLOYEURS uniquement.',
broadcastAdminsWarning: 'Cet email sera envoyé aux ADMINISTRATEURS uniquement.',
broadcastManagersWarning: 'Cet email sera envoyé aux GESTIONNAIRES uniquement.',
currentPassword: 'Mot de Passe Actuel',
newPassword: 'Nouveau Mot de Passe',
confirmPassword: 'Confirmer le Mot de Passe',
enterCurrentPassword: 'Entrez votre mot de passe actuel',
enterNewPassword: 'Entrez le nouveau mot de passe',
confirmNewPassword: 'Confirmez le nouveau mot de passe',
changing: 'Modification...',
systemSettings: 'Paramètres Système',
timezone: 'Fuseau Horaire',
dateFormat: 'Format de Date',
itemsPerPage: 'Éléments par Page',
resetToDefaults: 'Réinitialiser aux Valeurs par Défaut',
recipients: 'Destinataires',
allUsers: 'Tous les Utilisateurs',
employersOnly: 'Employeurs Seulement',
adminsOnly: 'Administrateurs Seulement',
managersOnly: 'Gestionnaires Seulement',
testEmailAddress: 'Adresse Email de Test',
enterTestEmail: 'Entrez l\'adresse email de test',
testEmailDescription: 'Envoyer un email de test pour vérifier le formatage',
sending: 'Envoi...',
sendBroadcast: 'Envoyer la Diffusion',
enterEmailSubject: 'Entrez le sujet de l\'email',
enterEmailMessage: 'Entrez votre message ici...',
    // Donate Modal translations - French
    donateTitle: 'Soutenez Nos Femmes',
    donateDescription: 'Votre don aide à former plus de femmes et à créer des moyens de subsistance durables',
    quickSelectAmount: 'Montant Rapide (RWF):',
    donationAmountLabel: 'Montant du Don (RWF) *',
    donationAmountPlaceholder: 'Entrez le montant',
    donorNameLabel: 'Votre Nom *',
    donorNamePlaceholder: 'Entrez votre nom',
    emailLabel: 'Email',
    emailPlaceholder: 'Entrez votre email',
    phoneLabel: 'Téléphone',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    messageLabel: 'Message (Optionnel)',
    messagePlaceholder: 'Ajoutez un message d\'encouragement...',
    donationInfo1: '💝 100% de votre don va directement aux programmes de formation',
    donationInfo2: '🌍 Votre contribution transforme des vies et des communautés',
    donationInfo3: '🌍 Mobile Money: *182*8*1*270591#',
    donationInfo4: '🏦 Nom de la banque : Bank of Kigali',
donationInfo5: '👤 Nom du compte : WFW1 Empowerment Center LLC / Urugo Women\'s Opportunity Center',
donationInfo6: '💰 Compte RWF : 00059-06929965-20',
donationInfo7: '💵 Compte USD : 00059-06929966-21',
    cancelButton: 'Annuler',
    processingButton: 'Traitement en cours...',
    makeDonationButton: 'Faire un Don',
    successTitle: 'Merci pour votre don généreux!',
    successMessage: 'Votre soutien fait une différence dans la vie des femmes.',
    errorMessage: 'Erreur lors du traitement du don. Veuillez réessayer.',
    // Register Modal translations - French
    registerCreateAccount: 'Créer un compte',
    registerDescription: 'Rejoignez Urugo WOC pour commencer à embaucher des femmes formées',
    fullNameLabel: 'Nom Complet *',
    fullNamePlaceholder: 'Entrez votre nom complet',
    usernameLabel: "Nom d'utilisateur *",
    usernamePlaceholder: 'Choisissez un nom d\'utilisateur',
    emailLabel: 'Adresse Email *',
    emailPlaceholder: 'Entrez votre email',
    phoneLabel: 'Numéro de Téléphone',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    passwordLabel: 'Mot de Passe *',
    passwordPlaceholder: 'Créez un mot de passe',
    confirmPasswordLabel: 'Confirmer le Mot de Passe *',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    passwordStrength: 'Solidité',
    passwordVeryWeak: 'Très faible',
    passwordWeak: 'Faible',
    passwordFair: 'Moyen',
    passwordGood: 'Bon',
    passwordStrong: 'Fort',
    userTypeTitle: 'Je m\'inscris en tant que:',
    userTypeEmployer: 'Employeur',
    userTypeEmployerDesc: 'Embaucher des femmes formées',
    creatingAccount: 'Création du compte...',
    createAccount: 'Créer le Compte',
    registerErrorGeneric: 'L\'inscription a échoué. Veuillez réessayer.',
    registerErrorPasswordMatch: 'Les mots de passe ne correspondent pas',
    registerErrorPasswordWeak: 'Veuillez utiliser un mot de passe plus fort',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    signIn: 'Se connecter',
     // Login Modal translations - French
     close: 'Fermer',
     loginWelcome: 'Bon retour',
     loginDescription: 'Connectez-vous à votre compte pour continuer',
     emailPlaceholder: 'Adresse e-mail',
     passwordPlaceholder: 'Mot de passe',
     showPassword: 'Afficher le mot de passe',
     hidePassword: 'Masquer le mot de passe',
     rememberMe: 'Se souvenir de moi',
     forgotPassword: 'Mot de passe oublié ?',
     signingIn: 'Connexion en cours...',
     signIn: 'Se connecter',
     noAccount: "Vous n'avez pas de compte ?",
     signUp: "S'inscrire",
     loginErrorGeneric: 'Échec de la connexion. Veuillez vérifier vos identifiants.',
          // ===== Passwordless Auth Flow - French =====
     loginEmailOnlyHint: 'Entrez votre email pour continuer',
     loginStaffHint: 'Connexion du personnel — veuillez entrer votre mot de passe',
     loggingInEmployer: 'Connexion en cours...',
     checking: 'Vérification...',
     change: 'Changer',
     invalidEmail: 'Veuillez entrer une adresse email valide',
     noAccountFound: 'Aucun compte trouvé avec cet email. Veuillez d\'abord vous inscrire.',
     unknownUserType: 'Type d\'utilisateur inconnu. Veuillez contacter le support.',
     emailLoginHint: 'Nous chercherons votre compte par email. Aucun mot de passe requis.',
     loginDescriptionEmailOnly: 'Entrez votre email pour continuer — aucun mot de passe requis',
     registerDescriptionNoPassword: 'Entrez simplement vos informations — aucun mot de passe requis',
     step2DescriptionNoPassword: 'Entrez simplement votre email — aucun mot de passe requis',
     loginSuccessMessage: 'Vous êtes maintenant connecté !',
    // Footer & Chat Bot Translations
  chatWelcome: "Bonjour! Bienvenue au Centre d'Opportunités pour les Femmes Urugo. Comment puis-je vous aider aujourd'hui?",
  justNow: "À l'instant",
  chatQuestionHire: "Comment puis-je embaucher des femmes formées?",
  chatQuestionDonate: "Comment puis-je faire un don pour soutenir les femmes?",
  chatQuestionTraining: "Comment postuler à une formation?",
  chatQuestionContact: "Comment puis-je vous contacter?",
  chatKeywordHire: "embaucher",
  chatResponseHire: "Vous pouvez embaucher nos femmes formées en créant un compte employeur sur notre portail. Visitez la section 'Embaucher des Talents' pour voir les profils des femmes disponibles et soumettre votre demande d'embauche. Les femmes formées sont prêtes à travailler dans divers départements incluant l'exploitation de café, l'entretien ménager, la couture, et plus encore.",
  chatKeywordEmployer: "employeur",
  chatResponseEmployer: "En tant qu'employeur, vous pouvez vous inscrire sur notre portail pour accéder aux profils de femmes qualifiées. Nous fournissons des femmes présélectionnées et formées prêtes à l'emploi. Vous pouvez soumettre des exigences spécifiques et nous vous mettrons en relation avec des candidates appropriées.",
  chatKeywordRequest: "demande",
  chatResponseRequest: "Pour demander des femmes formées, veuillez vous connecter à votre compte employeur et remplir le formulaire de demande d'embauche. Spécifiez le nombre de femmes nécessaires, les compétences requises et la durée de l'emploi. Notre équipe vous contactera dans les 24 heures.",
  chatKeywordDonate: "donner",
  chatResponseDonate: "Merci de votre intérêt à faire un don! Vous pouvez faire un don en ligne via notre portail sécurisé, par virement bancaire, ou en visitant notre centre. Vos dons aident à former plus de femmes et leur offrent des opportunités d'emploi.",
  chatKeywordSupport: "soutenir",
  chatResponseSupport: "Vous pouvez nous soutenir en faisant un don, en devenant un sponsor corporatif, en faisant du bénévolat ou en partenariat avec nous. Contactez notre équipe de développement à info@urugowoc.com pour plus d'informations.",
  chatKeywordTraining: "formation",
  chatResponseTraining: "Nous offrons une formation professionnelle dans 7 départements. Pour postuler, visitez notre centre à Kayonza ou postulez en ligne via notre site web. Les programmes de formation sont gratuits pour les femmes éligibles et incluent une certification à la fin.",
  chatKeywordApply: "postuler",
  chatResponseApply: "Pour postuler à une formation, visitez notre site web et remplissez le formulaire de demande. Vous devrez fournir des informations personnelles et indiquer le département qui vous intéresse. Notre équipe vous contactera pour un entretien.",
  chatKeywordLogin: "connexion",
  chatResponseLogin: "Pour vous connecter, cliquez sur le bouton 'Connexion' dans la navigation supérieure. Les employeurs, les stagiaires et les administrateurs ont des portails de connexion séparés. Si vous n'avez pas de compte, vous pouvez vous inscrire depuis la page de connexion.",
  chatKeywordRegister: "s'inscrire",
  chatResponseRegister: "L'inscription est ouverte aux employeurs, aux femmes cherchant une formation et aux bénévoles. Cliquez sur 'S'inscrire' sur la page de connexion et sélectionnez votre type d'utilisateur. Remplissez vos détails et notre équipe vérifiera votre compte.",
  chatKeywordAbout: "à propos",
  chatResponseAbout: "Le Centre d'Opportunités pour les Femmes Urugo a été créé pour autonomiser les femmes par la formation professionnelle et l'emploi. Nous avons formé plus de 600 femmes depuis 2013. Visitez notre page À Propos pour en savoir plus sur notre mission, notre vision et notre impact.",
  chatKeywordGallery: "galerie",
  chatResponseGallery: "Notre Galerie présente des femmes en formation, des cérémonies de remise des diplômes et des histoires de réussite professionnelle. Vous pouvez voir des photos des 7 départements de formation et témoigner de la transformation qui se produit dans notre centre.",
  chatKeywordDepartments: "départements",
  chatResponseDepartments: "Nous avons 7 départements de formation: 1) Exploitation de café, 2) Entretien ménager, 3) Réception, 4) Couture, 5) Travail du cuir, 6) Fabrication de tapis, et 7) Production de lait et yaourt. Chaque programme comprend une formation pratique et une certification.",
  chatKeywordContact: "contact",
  chatResponseContact: "Vous pouvez nous contacter par email à info@urugowoc.com, appeler au +250788350577, visiter notre centre à Kayonza, ou utiliser ce chatbot. Notre équipe est disponible du lundi au vendredi, de 8h à 17h.",
  chatKeywordLocation: "localisation",
  chatResponseLocation: "Nous sommes situés à Kayonza, Rwanda. Vous pouvez nous trouver au Centre d'Opportunités pour les Femmes Urugo, District de Kayonza. Visitez-nous pour voir nos installations de formation et rencontrer notre équipe.",
  chatResponseDefault: "Merci pour votre question! Pour des informations plus spécifiques, veuillez nous contacter directement à info@urugowoc.com ou appeler au +250788350577.",
  chatTitle: "Assistant Urugo WOC",
  close: "Fermer",
  chatQuickQuestions: "Questions Rapides",
  chatPlaceholder: "Tapez votre message ici...",
  send: "Envoyer",
  chatToggleTooltip: "Discutez avec nous",
  whatsappDefaultMessage: "Bonjour Urugo WOC, j'ai une question concernant l'embauche de femmes formées/faire un don/formation...",
  whatsappTooltip: "Discutez avec nous sur WhatsApp",
  footerTitle: "WfWI/Urugo WOC",
  footerDescription: "Autonomiser les femmes par la formation professionnelle et les opportunités d'emploi depuis 2013. Transformer les communautés en créant des moyens de subsistance durables.",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  youtube: "YouTube",
  whatsapp: "WhatsApp",
  quickLinks: "Liens Rapides",
  home: "Accueil",
  about: "À Propos",
  departments: "Départements",
  women: "Nos Femmes",
  gallery: "Galerie",
  donate: "Faire un Don",
  hire: "Embaucher",
  login: "Connexion",
  contactInfo: "Informations de Contact",
  location: "Kayonza, Rwanda",
  phoneNumber: "+250 788350577",
  email: "info@urugowoc.com",
  hireWomen: "Embaucher des Femmes Formées",
  donateNow: "Faire un Don",
  loginRegister: "Connexion/Inscription",
  ourDepartments: "Nos Départements",
  coffeeShopOperation: "Exploitation de Café",
  housekeepingOperation: "Entretien Ménager",
  receptionOperation: "Réception",
  sewingOperation: "Couture",
  leatherOperation: "Travail du Cuir",
  carpetOperation: "Fabrication de Tapis",
  milkYogurtProduction: "Production de Lait et Yaourt",
  copyright: "Centre d'Opportunités pour les Femmes Urugo. Tous droits réservés.",
  privacyPolicy: "Politique de Confidentialité",
  termsOfService: "Conditions d'Utilisation",
  sitemap: "Plan du Site",
    // Manager Dashboard Translations
    dashboard: "Tableau de Bord",
    requests: "Demandes",
    women: "Femmes",
    users: "Utilisateurs",
    donations: "Dons",
    gallery: "Galerie",
    about: "À propos",
    reports: "Rapports",
    settings: "Paramètres",
    manager: "Gestionnaire",
    totalUsers: "Total Utilisateurs",
    totalRequests: "Total Demandes",
    totalRevenue: "Revenu Total",
    activeWomen: "Femmes Actives",
    recentActivity: "Activité Récente",
    totalWomen: "Total Femmes",
    employerCount: "Employeurs",
    newThisMonth: "Nouveau ce Mois",
    activeToday: "Actif Aujourd'hui",
    pendingRequests: "Demandes en Attente",
    approvedRequests: "Demandes Approuvées",
    rejectedRequests: "Demandes Rejetées",
    loadingDashboard: "Chargement du tableau de bord...",
    failedLoadDashboard: "Échec du chargement des données du tableau de bord",
    justNow: "À l'instant",
    notificationPendingRequests: "Vous avez demande(s) en attente",
    newUsersThisWeek: "nouveaux utilisateurs cette semaine",
    newDonations: "nouveaux dons",
    failedLoadEmployerDetails: "Échec du chargement des détails de l'employeur",
    selectWomenToAssign: "Veuillez d'abord sélectionner les femmes à assigner",
    selectRequestEmployer: "Veuillez sélectionner une demande/employeur",
    noWomenSelected: "Aucune femme sélectionnée",
    successfullyAssignedWomen: "femmes assignées avec succès à {employer}",
    failedToAssignWomen: "Échec de l'assignation des femmes",
    failedLoadWomenProfiles: "Échec du chargement des profils des femmes",
    accessDenied: "Accès refusé. Veuillez vous reconnecter.",
    requestStatusUpdated: "Statut de la demande mis à jour à {status}",
    failedUpdateRequest: "Échec de la mise à jour de la demande",
    userStatusUpdated: "Utilisateur {status} avec succès",
    suspended: "suspendu",
    activated: "activé",
    failedUpdateUser: "Échec de la mise à jour de l'utilisateur",
    confirmDeleteUser: "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
    userDeleted: "Utilisateur supprimé avec succès",
    failedDeleteUser: "Échec de la suppression de l'utilisateur",
    profileAvailabilityUpdated: "Disponibilité du profil mise à jour à {status}",
    available: "Disponible",
    hired: "Embauchée",
    failedUpdateProfile: "Échec de la mise à jour du profil",
    confirmDeleteProfile: "Êtes-vous sûr de vouloir supprimer ce profil?",
    profileDeleted: "Profil supprimé avec succès",
    failedDeleteProfile: "Échec de la suppression du profil",
    profileAdded: "Profil ajouté avec succès",
    failedAddProfile: "Échec de l'ajout du profil",
    profileUpdated: "Profil mis à jour avec succès",
    exportSuccessful: "Export réussi! Fichier téléchargé",
    failedExportData: "Échec de l'exportation des données",
    searchRequests: "Rechercher des demandes...",
    clearFilters: "Effacer les Filtres",
    filterBy: "Filtrer par",
    allStatus: "Tous les Statuts",
    pending: "En attente",
    approved: "Approuvé",
    rejected: "Rejeté",
    cancelled: "Annulé",
    to: "à",
    exportRequests: "Exporter les Demandes",
    noRequestsFound: "Aucune Demande Trouvée",
    noRequestsMatch: "Aucune demande ne correspond à vos critères",
    noRequestsAvailable: "Aucune demande disponible",
    showingRequests: "Affichage de demande(s)",
    id: "ID",
    date: "Date",
    employer: "Employeur",
    department: "Département",
    employees: "Employés",
    duration: "Durée",
    amount: "Montant",
    status: "Statut",
    actions: "Actions",
    days: "jours",
    n_a: "N/A",
    viewRequest: "Voir la Demande",
    approveRequest: "Approuver la Demande",
    rejectRequest: "Rejeter la Demande",
    womenProfilesManagement: "Gestion des Profils de Femmes",
    searchWomen: "Rechercher des femmes...",
    assignSelected: "Assigner Sélectionné",
    addNewProfile: "Ajouter un Nouveau Profil",
    allDepartments: "Tous les Départements",
    clearFilters: "Effacer les Filtres",
    womenSelectedForAssignment: "femmes sélectionnées pour assignation",
    selected: "sélectionné(s)",
    assignSelectedWomen: "Assigner les Femmes Sélectionnées",
    noWomenProfilesFound: "Aucun Profil de Femme Trouvé",
    noProfilesMatchCriteria: "Aucun profil ne correspond à vos critères",
    showingProfiles: "Affichage de {showing} sur {total} profils",
    previous: "Précédent",
    pageInfo: "Page {page} sur {pages}",
    next: "Suivant",
    selectAllAvailable: "Sélectionner toutes les femmes disponibles",
    photo: "Photo",
    name: "Nom",
    age: "Âge",
    skills: "Compétences",
    experience: "Expérience",
    phone: "Téléphone",
    years: "années",
    womanNotAvailable: "Cette femme n'est pas disponible",
    selectForAssignment: "Sélectionner pour assignation",
    editProfile: "Modifier le Profil",
    markAsHired: "Marquer comme Embauchée",
    markAsAvailable: "Marquer comme Disponible",
    deleteProfile: "Supprimer le Profil",
    employedBy: "Employée par",
    requestId: "ID de la Demande",
    assigned: "Assignée",
    userManagement: "Gestion des Utilisateurs",
    searchUsers: "Rechercher des utilisateurs...",
    allTypes: "Tous les Types",
    admin: "Administrateur",
    manager: "Gestionnaire",
    employer: "Employeur",
    exportUsers: "Exporter les Utilisateurs",
    noUsersFound: "Aucun Utilisateur Trouvé",
    noUsersMatchCriteria: "Aucun utilisateur ne correspond à vos critères",
    noUsersAvailable: "Aucun utilisateur disponible",
    showingUsers: "Affichage de utilisateur(s)",
    user: "Utilisateur",
    fullName: "Nom Complet",
    email: "E-mail",
    phone: "Téléphone",
    type: "Type",
    joined: "Rejoint",
    editUser: "Modifier l'Utilisateur",
    suspendUser: "Suspendre l'Utilisateur",
    activateUser: "Activer l'Utilisateur",
    deleteUser: "Supprimer l'Utilisateur",
    galleryManagement: "Gestion de la Galerie",
    searchGallery: "Rechercher dans la galerie...",
    addImage: "Ajouter une Image",
    noGalleryImagesFound: "Aucune Image de Galerie Trouvée",
    noImagesMatchCriteria: "Aucune image ne correspond à vos critères",
    showingImages: "Affichage de {showing} sur {total} images",
    general: "Général",
    edit: "Modifier",
    delete: "Supprimer",
    featured: "En vedette",
    aboutUsManagement: "Gestion À propos de Nous",
    pageContent: "Contenu de la Page",
    coreValues: "Valeurs Fondamentales",
    teamMembers: "Membres de l'Équipe",
    aboutPageContent: "Contenu de la Page À propos",
    editContent: "Modifier le Contenu",
    defaultAboutTitle: "Autonomiser les Femmes par la Formation Professionnelle",
    defaultMission: "Notre mission est d'autonomiser les femmes par la formation professionnelle et les opportunités d'emploi durables",
    defaultVision: "Notre vision est un monde où chaque femme a les compétences et les opportunités pour atteindre l'indépendance économique",
    defaultHistory: "Fondé en 2013, le Centre d'Opportunités pour les Femmes Urugo a transformé la vie de centaines de femmes par la formation professionnelle",
    noMissionStatement: "Aucune déclaration de mission ajoutée",
    noVisionStatement: "Aucune déclaration de vision ajoutée",
    noHistoryContent: "Aucun contenu historique ajouté",
    noAboutPageContent: "Aucun contenu sur la page À propos",
    clickEditContentToAdd: "Cliquez sur 'Modifier le Contenu' pour ajouter des informations",
    addValue: "Ajouter une Valeur",
    noCoreValues: "Aucune Valeur Fondamentale",
    addCoreValues: "Ajoutez les valeurs fondamentales de votre organisation",
    addTeamMember: "Ajouter un Membre d'Équipe",
    noTeamMembers: "Aucun Membre d'Équipe",
    addTeamMembers: "Ajoutez les membres de votre équipe",
    donationManagement: "Gestion des Dons",
    reset: "Réinitialiser",
    exportDonations: "Exporter les Dons",
    donor: "Donateur",
    message: "Message",
    viewDetails: "Voir les Détails",
    sendThankYou: "Envoyer un Merci",
    noDonationsFound: "Aucun don trouvé",
    reportsAnalytics: "Rapports & Analyses",
    generateReports: "Générer des Rapports",
    usersReport: "Rapport des Utilisateurs",
    requestsReport: "Rapport des Demandes",
    donationsReport: "Rapport des Dons",
    fullDatabaseExport: "Exportation Complète de la Base de Données",
    systemStatistics: "Statistiques du Système",
    totalUsers: "Total Utilisateurs",
    activeWomen: "Femmes Actives",
    totalRevenue: "Revenu Total",
    successRate: "Taux de Réussite",
    requestStatistics: "Statistiques des Demandes",
    generalSettings: "Paramètres Généraux",
    siteName: "Nom du Site",
    emailNotifications: "Notifications par E-mail",
    autoApproveRequests: "Demandes d'Auto-Appro",
    saveSettings: "Enregistrer les Paramètres",
    accountSettings: "Paramètres du Compte",
    changePassword: "Changer le Mot de Passe",
    newPassword: "Nouveau Mot de Passe",
    confirmPassword: "Confirmer le Mot de Passe",
    confirmNewPassword: "Confirmer le Nouveau Mot de Passe",
    saveChanges: "Enregistrer les Modifications",
    editGalleryImage: "Modifier l'Image de la Galerie",
    addGalleryImage: "Ajouter une Image à la Galerie",
    title: "Titre",
    description: "Description",
    department: "Département",
    featuredImage: "Image en Vedette",
    imageFile: "Fichier Image",
    currentImage: "Image Actuelle",
    current: "Actuelle",
    cancel: "Annuler",
    updateImage: "Mettre à Jour l'Image",
    editAboutPageContent: "Modifier le Contenu de la Page À propos",
    pageTitle: "Titre de la Page",
    enterPageTitle: "Entrez le titre de la page",
    missionStatement: "Déclaration de Mission",
    enterMissionStatement: "Entrez la déclaration de mission",
    visionStatement: "Déclaration de Vision",
    enterVisionStatement: "Entrez la déclaration de vision",
    historyAboutUs: "Histoire / À propos de Nous",
    enterHistoryContent: "Entrez le contenu historique",
    aboutPageSaved: "Page À propos enregistrée avec succès",
    failedSaveAboutPage: "Échec de l'enregistrement de la page À propos",
    editCoreValue: "Modifier la Valeur Fondamentale",
    addCoreValue: "Ajouter une Valeur Fondamentale",
    coreValueText: "Texte de la Valeur Fondamentale",
    enterCoreValueText: "Entrez le texte de la valeur fondamentale",
    sortOrder: "Ordre de Tri",
    updateCoreValue: "Mettre à Jour la Valeur Fondamentale",
    confirmDeleteCoreValue: "Êtes-vous sûr de vouloir supprimer cette valeur fondamentale?",
    coreValueDeleted: "Valeur fondamentale supprimée avec succès",
    failedDeleteCoreValue: "Échec de la suppression de la valeur fondamentale",
    coreValueAdded: "Valeur fondamentale ajoutée avec succès",
    failedAddCoreValue: "Échec de l'ajout de la valeur fondamentale",
    coreValueUpdated: "Valeur fondamentale mise à jour avec succès",
    failedUpdateCoreValue: "Échec de la mise à jour de la valeur fondamentale",
    editTeamMember: "Modifier le Membre d'Équipe",
    addTeamMember: "Ajouter un Membre d'Équipe",
    position: "Poste",
    department: "Département",
    bioDescription: "Bio/Description",
    enterTeamMemberBio: "Entrez la bio du membre d'équipe",
    profilePhoto: "Photo de Profil",
    activeTeamMember: "Membre d'Équipe Actif",
    currentPhoto: "Photo Actuelle",
    updateTeamMember: "Mettre à Jour le Membre d'Équipe",
    confirmDeleteTeamMember: "Êtes-vous sûr de vouloir supprimer ce membre d'équipe?",
    teamMemberDeleted: "Membre d'équipe supprimé avec succès",
    failedDeleteTeamMember: "Échec de la suppression du membre d'équipe",
    teamMemberAdded: "Membre d'équipe ajouté avec succès",
    failedAddTeamMember: "Échec de l'ajout du membre d'équipe",
    teamMemberUpdated: "Membre d'équipe mis à jour avec succès",
    failedUpdateTeamMember: "Échec de la mise à jour du membre d'équipe",
    addNewProfile: "Ajouter un Nouveau Profil",
    name: "Nom",
    age: "Âge",
    selectDepartment: "Sélectionner un Département",
    experienceYears: "Expérience (Années)",
    commaSeparatedSkills: "Compétences séparées par des virgules",
    location: "Localisation",
    educationLevel: "Niveau d'Éducation",
    selectEducation: "Sélectionner le Niveau d'Éducation",
    primary: "Primaire",
    secondary: "Secondaire",
    vocational: "Professionnel",
    university: "Universitaire",
    other: "Autre",
    profilePhoto: "Photo de Profil",
    addProfile: "Ajouter le Profil",
    editProfile: "Modifier le Profil",
    saveChanges: "Enregistrer les Modifications",
    refresh: "Actualiser",
    logout: "Déconnexion",
    toggleMenu: "Basculer le menu",
    urugoWOC: "Urugo WOC",
    notifications: "Notifications",
    noNotifications: "Aucune notification",
    home: "Accueil",
    requests: "Demandes",
    women: "Femmes",
    users: "Utilisateurs",
    donations: "Dons",
    gallery: "Galerie",
    about: "À propos",
    reports: "Rapports",
    settings: "Paramètres",
    export: "Exporter",
    csvFormat: "Format CSV",
    manageWomen: "Gérer les Femmes",
    profiles: "profils",
    manageUsers: "Gérer les Utilisateurs",
    quickActions: "Actions Rapides",
    reviewRequests: "Examiner les Demandes",
    exportAllData: "Exporter Toutes les Données",
    exportAll: "Exporter Tout",
    clearAll: "Effacer Tout",
    allCaughtUp: "Tout est à jour!",
    noNewNotifications: "Aucune nouvelle notification",
    departments: "Départements",
    employers: "Employeurs",
    activeToday: "Actif Aujourd'hui",
    thisMonth: "ce mois-ci",
    currentlyActive: "actuellement actif",
    average: "Moyenne",
    womenTrained: "Femmes Formées",
    selectAllAvailable: "Sélectionner toutes les femmes disponibles",
    selectForAssignment: "Sélectionner pour assignation",
    inactive: "Inactif",
    active: "Actif",
    enterImageDescription: "Entrez la description de l'image",
    enterCoreValueText: "Entrez le texte de la valeur fondamentale",
    enterTeamMemberBio: "Entrez la bio du membre d'équipe",
    bio: "Bio",
    confirmDeleteImage: "Êtes-vous sûr de vouloir supprimer cette image?",
    imageDeleted: "Image supprimée avec succès",
    failedDeleteImage: "Échec de la suppression de l'image",
    galleryImageAdded: "Image de galerie ajoutée avec succès",
    failedAddGalleryImage: "Échec de l'ajout de l'image de galerie",
    galleryImageUpdated: "Image de galerie mise à jour avec succès",
    failedUpdateGalleryImage: "Échec de la mise à jour de l'image de galerie",
    selectDepartment: "Sélectionner un Département",
    successRate: "Taux de Réussite",
    activeWomen: "Femmes Actives",
    
    // Existing translations from other sections...
    employerDashboard: "Tableau de Bord Employeur",
    myRequests: "Mes Demandes",
    hiredWomen: "Femmes Embranchées",
    payments: "Paiements",
    newRequest: "Nouvelle Demande",
    markAsPaid: "Marquer comme payé",
    exportData: "Exporter les Données",
    makePayment: "Effectuer le Paiement",
    downloadReceipt: "Télécharger le Reçu",
    totalSpent: "Total Dépensé",
    totalHired: "Total Embranché",
    approvalRate: "Taux d'Appro",
    avgEmployees: "Moy. Employés",
    avgDuration: "Durée Moy.",
    pendingPayments: "Paiements en Attente",
    paymentHistory: "Historique des Paiements",
    payNow: "Payer Maintenant",
    profileSettings: "Paramètres du Profil",
    companyName: "Nom de l'Entreprise",
    contactPerson: "Personne de Contact",
    requestTrainedWomen: "Demander des femmes formées",
    perRequest: "par demande",
    womenHired: "femmes embranchées",
    avgPerRequest: "moy./demande",
    browseHired: "Parcourir Embranchés",
    viewHiredWomen: "Voir les femmes embranchées",
    downloadAllRequests: "Télécharger toutes les demandes",
    unknownDepartment: "Département Inconnu",
    unknownDate: "Date inconnue",
    exportList: "Exporter la Liste",
    unknownName: "Nom Inconnu",
    yearsExp: "ans d'expérience",
    hiredOn: "Embauché le",
    unknown: "Inconnu",
    notSpecified: "Non spécifié",
    noHiredWomen: "Aucune Femme Embranchée",
    noHiredWomenDesc: "Vous n'avez pas encore embauché de femmes. Les demandes approuvées apparaîtront ici",
    makeRequest: "Faire une Demande",
    managePayments: "Gérer vos paiements et factures",
    totalPendingPayments: "Total des Paiements en Attente",
    requests: "demande(s)",
    allCompletedPayments: "Tous les paiements effectués",
    viewAllRequests: "Voir Toutes les Demandes",
    request: "Demande",
    due: "Échéance",
    noPendingPayments: "Aucun paiement en attente",
    paidOn: "Payé le",
    noPaymentHistory: "Aucun historique de paiement",
    loadingDashboard: "Chargement de votre tableau de bord...",
    failedLoadHiredWomen: "Échec du chargement des données des femmes embranchées",
    notificationPendingRequests: "Vous avez demande(s) en attente",
    notificationPendingPayments: "paiement(s) en attente",
    justNow: "À l'instant",
    requestSubmittedSuccess: "Demande soumise avec succès!",
    failedSubmitRequest: "Échec de la soumission de la demande. Veuillez réessayer",
    requestUpdatedSuccess: "Demande mise à jour avec succès!",
    failedUpdateRequest: "Échec de la mise à jour de la demande. Veuillez réessayer",
    confirmCancelRequest: "Êtes-vous sûr de vouloir annuler cette demande?",
    requestCancelledSuccess: "Demande annulée avec succès!",
    failedCancelRequest: "Échec de l'annulation de la demande. Veuillez réessayer",
    confirmMarkAsPaid: "Marquer cette demande comme payée?",
    requestMarkedAsPaid: "Demande marquée comme payée!",
    failedUpdatePayment: "Échec de la mise à jour du statut de paiement. Veuillez réessayer",
    exportSuccessful: "Export réussi! Fichier téléchargé",
    failedExportRequests: "Échec de l'exportation des demandes",
    confirmDeleteRequest: "Êtes-vous sûr de vouloir supprimer cette demande? Cette action ne peut pas être annulée",
    requestDeletedSuccess: "Demande supprimée avec succès!",
    failedDeleteRequest: "Échec de la suppression de la demande. Veuillez réessayer",
    downloadingReceipt: "Téléchargement du reçu...",
    paymentCompleted: "Paiement effectué avec succès!",
    
    // Gallery Page Translations
    barista: "Barista",
    coffee: "Café",
    training: "Formation",
    womenLearning: "Femmes apprenant",
    preparation: "Préparation",
    machine: "machine",
    customerService: "Service client",
    serving: "Servir",
    customers: "clients",
    withProfessionalism: "avec professionnalisme",
    grinding: "Broyage",
    learning: "Apprentissage",
    proper: "approprié",
    techniques: "techniques",
    art: "Art",
    creating: "Création",
    beautiful: "beau",
    designs: "designs",
    teamCollaboration: "Collaboration d'équipe",
    working: "Travail",
    together: "ensemble",
    in: "dans",
    shop: "boutique",
    roomCleaning: "Nettoyage des chambres",
    professional: "Professionnel",
    room: "chambre",
    cleaning: "nettoyage",
    linenManagement: "Gestion du linge",
    linen: "linge",
    folding: "pliage",
    and: "et",
    storage: "stockage",
    cleaningEquipment: "Équipement de nettoyage",
    using: "Utilisation",
    modern: "moderne",
    equipment: "équipement",
    hotelStandards: "Normes hôtelières",
    maintaining: "Maintien",
    high: "élevé",
    standards: "normes",
    frontDesk: "Réception",
    managing: "Gestion",
    hotel: "hôtel",
    front: "avant",
    desk: "bureau",
    operations: "opérations",
    guestCheckin: "Enregistrement des clients",
    guest: "client",
    checkin: "enregistrement",
    process: "processus",
    phoneEtiquette: "Étiquette téléphonique",
    telephone: "téléphone",
    communication: "communication",
    skills: "compétences",
    computerSkills: "Compétences informatiques",
    software: "logiciel",
    sewingMachine: "Machine à coudre",
    industrial: "industriel",
    sewing: "couture",
    machines: "machines",
    patternMaking: "Création de patrons",
    clothing: "vêtements",
    patterns: "patrons",
    fabricCutting: "Découpe de tissu",
    precision: "précision",
    fabric: "tissu",
    cutting: "découpe",
    qualityControl: "Contrôle qualité",
    checking: "Vérification",
    finished: "fini",
    garments: "vêtements",
    leatherCutting: "Découpe du cuir",
    leather: "cuir",
    for: "pour",
    products: "produits",
    handStitching: "Couture à la main",
    traditional: "traditionnel",
    stitching: "couture",
    leatherDyeing: "Teinture du cuir",
    coloring: "Coloration",
    productAssembly: "Assemblage de produits",
    assembling: "Assemblage",
    goods: "marchandises",
    weaving: "Tissage",
    carpet: "tapis",
    knotting: "Nœuds",
    handknotting: "Nœuds à la main",
    designPlanning: "Planification de conception",
    designs: "conceptions",
    finishing: "Finition",
    final: "Final",
    touches: "touches",
    on: "sur",
    carpets: "tapis",
    milkProcessing: "Traitement du lait",
    milk: "lait",
    processing: "traitement",
    yogurtMaking: "Fabrication de yaourt",
    yogurt: "yaourt",
    fermentation: "fermentation",
    qualityTesting: "Test de qualité",
    testing: "test",
    dairy: "laitier",
    packaging: "Emballage",
    hygienic: "hygiénique",
    
    // UI Translations for Gallery
    images: "Images",
    tryAgain: "Réessayer",
    noImagesFound: "Aucune image trouvée",
    tryDifferentFilter: "Essayez de sélectionner un département différent ou un terme de recherche",
    tryDifferentSearch: "Essayez un autre terme de recherche",
    noImagesInDepartment: "Aucune image disponible pour ce département pour le moment",
    galleryImage: "Image de la galerie",
    noDescription: "Aucune description disponible",
    loadMore: "Charger plus",
    trainingImages: "Images de formation",
    womenEmpowered: "Femmes autonomisées",
    learningOpportunities: "Opportunités d'apprentissage",
    witnessTransformation: "Témoignez du parcours des femmes transformant leur vie grâce à la formation professionnelle",
    search: "Rechercher",
    viewAll: "Voir tout",
    tailoringFashion: "Couture & Mode",
    organicFarming: "Agriculture Biologique",
    culinaryArts: "Arts Culinaires",
    cosmetology: "Cosmétologie",
    literacyProgram: "Programme d'Alphabétisation",
    handicrafts: "Artisanat",
    leatherwork: "Travail du Cuir",
    farming: "Agriculture",
    cooking: "Cuisine",
    tailoring: "Couture",
    housekeeping: "Entretien ménager",
    reception: "Réception",
    sewing: "Couture",
    carpetWeaving: "Tissage de tapis",
    dairyProduction: "Production laitière",
    
    // About Us Page Translations
    aboutUs: "À Propos de Nous",
    empoweringWomenTransformingCommunities: "Autonomiser les femmes, transformer les communautés depuis 2013",
    ourMission: "Notre Mission",
    ourVision: "Notre Vision",
    ourStory: "Notre Histoire",
    ourCoreValues: "Nos Valeurs Fondamentales",
    ourTrainingDepartments: "Nos Départements de Formation",
    meetOurTeam: "Rencontrez Notre Équipe",
    contactUs: "Contactez-Nous",
    connectWithUs: "Connectez-Vous Avec Nous",
    sendUsAMessage: "Envoyez-Nous un Message",
    wellGetBackToYou: "Nous vous répondrons dès que possible",
    ourPartnersSponsors: "Nos Partenaires & Sponsors",
    
    // Contact Information Labels
    address: "Adresse",
    workingHours: "Heures de Travail",
    alternate: "Alternatif",
    fullName: "Nom Complet *",
    emailAddress: "Adresse E-mail *",
    subject: "Sujet *",
    sendMessage: "Envoyer le Message",
    sending: "Envoi en cours...",
    thankYouMessageSent: "Merci ! Votre message a été envoyé avec succès.",
    sorryErrorSending: "Désolé, une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
    
    // Placeholders and Messages
    loadingAboutInfo: "Chargement des informations...",
    
    // Form Labels
    formNamePlaceholder: "Entrez votre nom complet",
    formEmailPlaceholder: "Entrez votre adresse e-mail",
    formSubjectPlaceholder: "Entrez le sujet",
    formMessagePlaceholder: "Tapez votre message ici...",
    
    // Social Media Platforms
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    whatsapp: "WhatsApp",
    
    // Partner Types
    sponsor: "Sponsor",
    partner: "Partenaire",
    donor: "Donateur",

    // Existing translations
    home: "Accueil",
    exploreDepartments: "Explorer les Départements",
    meetOurWomen: "Rencontrer Nos Femmes",
    hireTrainedWomen: "Embaucher des Femmes Formées",
    empoweringWomen: "Autonomiser les Femmes",
    throughSkillsTraining: "Grâce à la Formation Professionnelle",
    buildingSustainable: "Construire des",
    futures: "Avenirs Durables",
    transformingCommunities: "Transformer les Communautés",
    together: "Ensemble",
    employersConnected: "Employeurs Connectés",
    chooseSpecializedPrograms: "Choisissez parmi nos programmes de formation spécialisés conçus pour la réussite",
    requestTrainedWomen: "Demander des Femmes Formées",
    certifiedTraining: "Formation Certifiée",
    flexibleHours: "Horaires Flexibles",
    ourWomenInAction: "Nos Femmes en Action",
    witnessTransformation: "Témoignez de la transformation à travers leur travail",
    meetTalentedWomen: "Rencontrez Nos Femmes Talentueuses",
    skilledProfessionals: "Professionnelles qualifiées prêtes à faire la différence",
    availableNow: "Disponible Maintenant",
    currentlyWorking: "Actuellement en Poste",
    empowerMoreWomen: "Autonomisez Plus de Femmes Aujourd'hui",
    supportProvidesHope: "Votre soutien fournit une formation, des opportunités et de l'espoir. Rejoignez-nous pour créer un changement durable.",
    donateNow: "Faire un Don",
    hireTalent: "Embaucher des Talents",
    woman: "Femme",
    skilledProfessional: "Professionnelle qualifiée",
    womenEmpowermentActivity: "Activité d'autonomisation des femmes",
    makeDonation: "Faire un don pour soutenir la formation des femmes",
    
    // Department names and descriptions
    tailoringDesc: "Formation professionnelle en couture et conception de mode",
    farmingDesc: "Pratiques et techniques agricoles durables",
    culinaryDesc: "Compétences professionnelles en cuisine et préparation des aliments",
    cosmetologyDesc: "Fabrication de produits de beauté et de soins de la peau",
    literacyDesc: "Éducation de base et compétences en lecture et écriture",
    handicraftsDesc: "Fabrication d'artisanat traditionnel et moderne",
    leatherworkDesc: "Fabrication de chaussures et d'articles en cuir",
    
    // Hero slides descriptions
    heroSlide1Desc: "Le Centre d'Opportunités pour les Femmes Urugo a formé plus de 600 femmes dans diverses compétences professionnelles, les aidant à construire des moyens de subsistance durables et à transformer leurs communautés.",
    heroSlide2Desc: "Nos programmes de formation professionnelle dotent les femmes de compétences commercialisables pour le marché du travail concurrentiel d'aujourd'hui, garantissant un emploi à long terme et une indépendance financière.",
    heroSlide3Desc: "En autonomisant une femme, nous autonomisons toute une communauté. Rejoignez-nous pour créer un changement durable grâce à l'éducation, au soutien et aux opportunités.",
    
    // Additional UI elements
    working: "Au Travail",
    loadingContent: "Chargement du contenu...",
  },

  kiswahili: {

        // ===== Trainee Stats Page =====
        stats: 'Takwimu',
        traineeStats: 'Takwimu za Wanafunzi',
        traineeStatsIntro: 'Chunguza Wahitimu Wetu Walioidhinishwa',
        ourImpact: 'Athari Yetu',
        totalTrainees: 'Wahitimu Walioidhinishwa',
        employedByCompany: 'Ameajiriwa na Kampuni',
        unemployed: 'Hana Kazi',
        professionalInternship: 'Mafunzo ya Kitaalamu',
        selfEmployed: 'Kujiajiri',
        traineesFound: 'wanafunzi wamepatikana',
        noTraineesFound: 'Hakuna wanafunzi waliopatikana',
        tryDifferentFilters: 'Jaribu kubadilisha vichujio au utafutaji wako.',
        searchTrainees: 'Tafuta kwa jina, ujuzi...',
        allDepartments: 'Idara Zote',
        yearsExp: 'miaka ya uzoefu',
    employed: 'Ameajiriwa',
studying: 'Anajifunza',
workingForOthers: 'Anafanya kazi kwa wengine',
notAvailableForHire: 'Haipatikani kwa kuajiri',
womenFound: 'wanawake waliopatikana',
noWomenInDepartment: 'Hakuna wanawake waliopatikana katika idara hii.',
exportExcel: 'Hamisha kwa Excel',
exportPDF: 'Hamisha kwa PDF',
noWomenFoundWithStatus: 'Hakuna wanawake waliopatikana na hali hii',

    fullName: 'Jina Kamili',
    age: 'Umri',
    cohort: 'Kikundi',
    phone: 'Simu',
    email: 'Barua Pepe',
    placementLocation: 'Mahali pa Kuwekwa',
    competenceSkills: 'Ujuzi',
    commaSeparated: 'vilivyotenganishwa na koma',
    optional: 'Hiari',
    emailOptional: 'Barua pepe ni hiari lakini inapendekezwa kwa mawasiliano',
    enterName: 'Weka jina lako kamili',
    enterAge: 'Umri wako',
    enterPhone: '+250 78X XXX XXX',
    enterEmail: 'barua@pepe.com (hiari)',
    enterPlacementLocation: 'Jiji, Wilaya, Nchi',
    enterCompetenceSkills: 'Mfano: Ujuzi wa Kompyuta, Maamuzi, Uongozi',
    separateWithCommas: 'Tenganisha ujuzi mwingi kwa koma',
    enterCompanyName: 'Jina la kampuni/shirika',
    enterWorkingPosition: 'Nafasi ya kazi',
    enterWorkingLocation: 'Mahali pa kazi',
    enterYears: 'Miaka',
    enterBio: 'Wasifu mfupi',
    uploadPhoto: 'Pakia Picha',
  
    fullNameRequired: 'Jina kamili linahitajika',
    nameMinLength: 'Jina lazima liwe na angalau herufi 2',
    selectDepartmentRequired: 'Tafadhali chagua idara',
    selectEmploymentStatus: 'Tafadhali chagua hali yako ya ajira',
    selectJobSecured: 'Tafadhali chagua jinsi ulivyopata kazi yako',
  
    employmentStatusDesc: 'Tuambie kuhusu hali yako ya sasa ya ajira.',
    unemployedInfo: 'Umechagua "Hana Kazi". Maelezo ya ziada ya ajira hayahitajiki.',
  
    wocPlacement: 'Kupitia Msaada wa Uwekaji Kazi wa WOC',
    wocInternship: 'Mafunzo Kazini/kiwanda katika WOC',
    wocRecommendation: 'Mapendekezo kutoka kwa Wakufunzi wa WOC',
    familyFriends: 'Familia/Marafiki',
    socialMedia: 'Mitandao ya Kijamii',
    onlinePortal: 'Lango la Ajira Mtandaoni',
    walkIn: 'Maombi ya Kujitokeza',
    newspaper: 'Tangazo la Gazeti',
  
    jobRelevanceDesc: 'Je, kazi yako ya sasa inahusiana na mafunzo uliyopata katika WOC?',
  
    jobChallengesDesc: 'Ni sababu gani kuu za ukosefu wako wa ajira? (Chagua zote zinazohusu)',
    lackJobOpportunities: 'Ukosefu wa fursa za ajira',
    lackWorkExperience: 'Ukosefu wa uzoefu wa kazi',
    insufficientSkills: 'Ujuzi usiotosha',
    familyResponsibilities: 'Majukumu ya familia',
    continuingEducation: 'Kuendelea na elimu',
    healthReasons: 'Sababu za kiafya',
    lackStartupCapital: 'Ukosefu wa mtaji wa kuanzia',
    locationTransport: 'Changamoto za eneo/usafiri',
  
    entrepreneurshipDesc: 'Je, umeanzisha biashara yako mwenyewe baada ya kuhitimu?',
    employeesEmployed: 'Je, umeajiri watu wangapi?',
    moreThan5: 'Zaidi ya 5',
  
    supportNeededDesc: 'Ni msaada gani ungekusaidia kukuza biashara yako? (Chagua zote zinazohusu)',
    accessFinance: 'Upataji wa fedha',
    businessMentorship: 'Ushauri wa biashara',
    marketingSupport: 'Msaada wa uuzaji',
    advancedTraining: 'Mafunzo ya juu ya kiufundi',
    equipment: 'Vifaa',
    marketLinkage: 'Uhusiano wa soko',
    businessRegistration: 'Msaada wa usajili wa biashara',
    selectNumber: 'Chagua nambari',
  
    confidenceDesc: 'Je, mafunzo katika WOC yameboresha imani yako na uwezo wa kufanya maamuzi huru ya maisha kwa kiasi gani?',
  
    financialSupportChanged: 'Je, uwezo wako wa kujitegemea kifedha umebadilikaje?',
    financialStability: 'Ikilinganishwa na kabla ya kuhudhuria WOC, ungepima utulivu wako wa kifedha kwa sasa?',
    savedMoney: 'Je, umeweza kuweka akiba mara kwa mara tangu kukamilisha mafunzo yako?',
    incomeManagement: 'Je, una imani gani katika kusimamia mapato yako ya kibinafsi?',
  
    communityImpactDesc: 'Unaelezaje athari ya mafunzo ya WOC kwenye maisha yako na jamii yako?',
    leadershipInvolvement: 'Je, umehusika zaidi katika uongozi au kufanya maamuzi ndani ya familia yako au jamii yako baada ya kuhitimu kutoka WOC?',
  
    editTraineeProfile: 'Hariri Wasifu wa Mwanafunzi',
    updateProfile: 'Sasisha Wasifu',
    editing: 'Inahaririwa:',
  
    step: 'Hatua',
    of: 'ya',
    skipped: 'Imerukwa',
    notApplicable: 'Haitumiki',
  
    continue: 'Endelea',
    previous: 'Iliyotangulia',
    next: 'Inayofuata',
    submit: 'Kamilisha Usajili',
    submitting: 'Inawasilisha...',
    updateProfile: 'Sasisha Wasifu',
  
    noServerResponse: 'Hakuna jibu kutoka kwa seva. Tafadhali angalia muunganisho wako.',
    registrationFailed: 'Usajili umeshindwa. Tafadhali jaribu tena.',
    pleaseFillRequiredFields: 'Tafadhali jaza sehemu zote zinazohitajika',
  
    above200k: 'Zaidi ya 200,000 RWF',
    selectOption: 'Chagua chaguo',
    selectRating: 'Chagua kiwango',
    selectImpact: 'Chagua kiwango cha athari',
    yes: 'Ndio',
    no: 'Hapana',
    none: 'Hakuna',
    selectCohort: 'Chagua kikundi',
    selectDepartment: 'Chagua idara',
    selectStatus: 'Chagua hali',

    // In kiswahili section, add:

pleaseFillRequiredFields: 'Tafadhali jaza sehemu zote zinazohitajika',
stepErrorBasicInfo: 'Tafadhali jaza sehemu zote zinazohitajika katika Taarifa za Msingi',
stepErrorEmployment: 'Tafadhali chagua hali yako ya ajira',
stepErrorJobSecured: 'Tafadhali chagua jinsi ulivyopata kazi yako',
stepSkippedUnemployed: 'Umechagua "Hana Kazi" katika hatua iliyotangulia. Hatua hii haitumiki.',
stepSkippedNotUnemployed: 'Wewe si miongoni mwa wasio na kazi. Hatua hii haitumiki.',
stepSkippedNotEntrepreneur: 'Umechagua "Hapana" kwa ujasiriamali. Hatua hii haitumiki.',
skipToNextStep: 'Ruka hadi Hatua Inayofuata',
editTraineeProfile: 'Hariri Wasifu wa Mwanafunzi',
updateProfile: 'Sasisha Wasifu',
profileUpdatedSuccess: 'Wasifu umesasishwa kwa mafanikio!',
profileAddedSuccess: 'Wasifu umeongezwa kwa mafanikio!',
editing: 'Inahaririwa:',
currentPhotoLabel: 'Picha ya sasa:',
noDepartmentsAvailable: 'Hakuna idara zinazopatikana',
noGalleryImages: 'Hakuna picha za galeri zinazopatikana kwa sasa.',
noWomenProfiles: 'Hakuna wasifu wa wanawake unaopatikana kwa sasa.',
noEvents: 'Hakuna matukio ya kuonyesha',
welcomeToGallery: 'Karibu kwenye Galeri Yetu',
gallerySubtitle: 'Gundua safari ya uwezeshaji wa wanawake',
viewAll: 'Tazama Zote',
matching: 'zinazolingana',
resetFilters: 'Weka Upya Vichujio',
noImagesInDatabase: 'Hakuna picha zilizopatikana kwenye hifadhidata. Inaonyesha picha za mfano.',
errorLoadingImages: 'Imeshindwa kupakia picha. Inaonyesha picha za mfano.',
errorLoadingDepartments: 'Imeshindwa kupakia idara. Inatumia orodha ya msingi.',
unknownDepartment: 'Idara Isiyojulikana',
noImagesForDepartment: 'Hakuna picha zinazopatikana kwa idara hii bado.',
clickToView: 'Bofya kuona',
department: 'Idara',
category: 'Kategoria',
date: 'Tarehe',
close: 'Funga',
viewDetails: 'Tazama Maelezo',
viewAllDepartments: 'Tazama Idara Zote',
viewAllWomen: 'Tazama Wanawake Wote',
loadMoreImages: 'Pakia Picha Zaidi',
noDescription: 'Hakuna maelezo yanayopatikana',
featured: 'Iliyoangaziwa',
    // Search Bar Translations - KISWAHILI
searchPlaceholder: 'Tafuta wanawake, idara, shughuli...',
trainedWomen: 'Wanawake Waliofunzwa',
trainingDepartments: 'Idara za Mafunzo',
activities: 'Shughuli',
galleryImages: 'Picha za Galeri',
viewAllResults: 'Tazama matokeo yote kwa',
searchResultsFor: 'Matokeo ya Utafutaji kwa',
viewAllItems: 'Tazama {count} zote {category} →',
noResultsFound: 'Hakuna matokeo yaliyopatikana kwa',
trySearchingFor: 'Jaribu kutafuta:',
searchSuggestions: 'ushonaji, upishi, kilimo, kushona, ngozi',
viewCompleteSearchResults: 'Tazama Matokeo Yote',

    // Trainee Registration - Additional Fields Translations - KISWAHILI
enterName: 'Weka jina kamili',
enterAge: 'Umri',
enterPhone: '+250 78X XXX XXX',
enterEmail: 'email@example.com',
enterPlacementLocation: 'Jiji, Wilaya, Nchi',
enterCompetenceSkills: 'Mfano: Ujuzi wa Kompyuta, Maamuzi, Uongozi',
separateWithCommas: 'Tenganisha ujuzi mwingi kwa koma',
enterCompanyName: 'Jina la kampuni/shirika',
enterWorkingPosition: 'Nafasi ya kazi',
enterWorkingLocation: 'Mahali pa kazi',
enterYears: 'Miaka',
enterLocation: 'Mahali ulipo sasa',
enterBio: 'Wasifu mfupi',
selectJobSecured: 'Chagua jinsi ulivyopata kazi yako',
selectChallenges: 'Chagua zote zinazohusu',
selectSupport: 'Ni msaada gani ungekusaidia kukuza biashara yako? Chagua zote zinazohusu',
selectOption: 'Chagua chaguo',
selectNumber: 'Chagua nambari',
selectRating: 'Chagua kiwango',
selectImpact: 'Chagua kiwango cha athari',
startedBusiness: 'Je, umeanzisha biashara yako mwenyewe baada ya kuhitimu?',
employeesEmployed: 'Je, umeajiri watu wangapi?',
none: 'Hakuna',
moreThan5: 'Zaidi ya 5',
yes: 'Ndio',
no: 'Hapana',
saving: 'Inahifadhi...',
educationAndBio: 'Elimu na Wasifu',
confidenceImproved: 'Je, mafunzo yameboresha imani yako kwa kiasi gani?',
financialSupportChanged: 'Je, uwezo wako wa kujitegemea kifedha umebadilikaje?',
financialStability: 'Ikilinganishwa na kabla ya mafunzo, ungepima utulivu wako wa kifedha?',
savedMoney: 'Je, umeweza kuweka akiba mara kwa mara tangu mafunzo?',
incomeManagement: 'Je, una imani gani katika kusimamia mapato yako ya kibinafsi?',
communityImpactDesc: 'Unaelezaje athari ya mafunzo ya WOC kwenye maisha yako na jamii yako?',
leadershipInvolvement: 'Je, umehusika zaidi katika uongozi au kufanya maamuzi?',
currentPhoto: 'Picha ya sasa',
yesEveryMonth: 'Ndio, kila mwezi',
yesOccasionally: 'Ndio, mara kwa mara',
noButPlan: 'Hapana, lakini nina mpango',
notChanged: 'Haijabadilika',
worsened: 'Imezidi kuwa mbaya',
fullyIndependent: 'Nimejitegemea kifedha kikamilifu',
significantlyContribute: 'Ninachangia kwa kiasi kikubwa kaya',
occasionallyContribute: 'Ninachangia mara kwa mara kaya',
muchBetter: 'Nzuri zaidi sana',
better: 'Nzuri zaidi',
same: 'Sawa',
worse: 'Mbaya zaidi',
muchWorse: 'Mbaya zaidi sana',
veryGreatExtent: 'Kwa kiwango kikubwa sana',
greatExtent: 'Kwa kiwango kikubwa',
moderateExtent: 'Kwa kiwango cha wastani',
smallExtent: 'Kwa kiwango kidogo',
notAtAll: 'Hata kidogo',
veryConfident: 'Nina imani kubwa',
confident: 'Nina imani',
moderatelyConfident: 'Nina imani ya wastani',
slightlyConfident: 'Nina imani kidogo',
notConfident: 'Sina imani hata kidogo',
transformational: 'Mabadiliko makubwa',
significantPositive: 'Athari nzuri kubwa',
moderatePositive: 'Athari nzuri ya wastani',
slightPositive: 'Athari nzuri kidogo',
noImpact: 'Hakuna athari iliyotambulika',
significantly: 'Ndio, kwa kiasi kikubwa',
toSomeExtent: 'Ndio, kwa kiasi fulani',
noChange: 'Hakuna mabadiliko',
lessInvolved: 'Sishiriki kama hapo awali',

    // Trainee Registration Translations - KISWAHILI
traineeRegister: 'Jisajili kama Mwanafunzi',
traineeRegistration: 'Usajili wa Mwanafunzi',
basicInformation: 'Taarifa za Msingi',
employmentStatus: 'Hali ya Ajira',
jobSecured: 'Ulipataje Kazi',
jobRelevance: 'Umuhimu wa Kazi',
jobChallenges: 'Changamoto za Kutafuta Kazi',
entrepreneurship: 'Ujasiriamali',
supportNeeded: 'Msaada Unaohitajika',
confidenceImpact: 'Imani & Athari',
financialSituation: 'Hali ya Kifedha',
communityImpact: 'Athari kwa Jamii',
registrationComplete: 'Usajili Umekamilika!',
thankYouRegistration: 'Asante kwa kukamilisha usajili wako.',
registrationSuccess: 'Taarifa zako zimehifadhiwa kwa mafanikio.',
registrationSuccessSub: 'Sasa unaweza kufikia vipengele vyote vya jukwaa.',
previous: 'Iliyotangulia',
next: 'Inayofuata',
submit: 'Kamilisha Usajili',
submitting: 'Inawasilisha...',
fullName: 'Jina Kamili',
age: 'Umri',
cohort: 'Kikundi',
placementLocation: 'Mahali pa Kuwekwa',
competenceSkills: 'Ujuzi wa Kitaalamu',
profilePhoto: 'Picha ya Wasifu',
employmentSector: 'Sekta ya Ajira',
companyName: 'Jina la Kampuni',
workingPosition: 'Nafasi ya Kazi',
workingLocation: 'Mahali pa Kazi',
modeOfEmployment: 'Aina ya Ajira',
yearsOfExperience: 'Miaka ya Uzoefu',
monthlyIncome: 'Mapato ya Mwezi',
contractStartDate: 'Tarehe ya Kuanza Mkataba',
contractEndDate: 'Tarehe ya Kuisha Mkataba',
selectCohort: 'Chagua kikundi',
selectDepartment: 'Chagua idara',
selectStatus: 'Chagua hali',
selectSector: 'Chagua sekta',
selectMode: 'Chagua aina',
selectIncome: 'Chagua kiasi',
selectRelevance: 'Chagua umuhimu',
selectConfidence: 'Chagua kiwango cha imani',
selfEmployed: 'Ajira ya Kujitegemea',
unemployed: 'Hana Kazi',
employedByCompany: 'Ameajiriwa na Kampuni',
workForOthers: 'Anafanya Kazi kwa Wengine',
continuingTraining: 'Anaendelea na Mafunzo',
publicSector: 'Sekta ya Umma',
privateSector: 'Sekta ya Kibinafsi',
ngo: 'NGO',
other: 'Nyingine',
permanent: 'Kazi ya Kudumu',
internship: 'Mafunzo Kazini',
partTime: 'Mkataba wa Muda',
volunteer: 'Kujitolea',
directlyRelated: 'Inahusiana Moja kwa Moja',
somewhatRelated: 'Inahusiana Kwa Kiasi',
notRelated: 'Hainahusiani',
veryGreatExtent: 'Kwa kiwango kikubwa sana',
greatExtent: 'Kwa kiwango kikubwa',
moderateExtent: 'Kwa kiwango cha wastani',
smallExtent: 'Kwa kiwango kidogo',
notAtAll: 'Hata kidogo',
fullyIndependent: 'Sasa nimejitegemea kifedha kikamilifu',
significantlyContribute: 'Ninachangia kwa kiasi kikubwa mapato ya kaya yangu',
occasionallyContribute: 'Ninachangia mara kwa mara mapato ya kaya yangu',
notChanged: 'Hali yangu ya kifedha haijabadilika',
worsened: 'Hali yangu ya kifedha imezidi kuwa mbaya',
muchBetter: 'Nzuri zaidi sana',
better: 'Nzuri zaidi',
same: 'Sawa',
worse: 'Mbaya zaidi',
muchWorse: 'Mbaya zaidi sana',
yesEveryMonth: 'Ndio, kila mwezi',
yesOccasionally: 'Ndio, mara kwa mara',
noButPlan: 'Hapana, lakini nina mpango',
no: 'Hapana',
veryConfident: 'Nina imani kubwa',
confident: 'Nina imani',
moderatelyConfident: 'Nina imani ya wastani',
slightlyConfident: 'Nina imani kidogo',
notConfident: 'Sina imani hata kidogo',
transformational: 'Mabadiliko makubwa',
significantPositive: 'Athari nzuri kubwa',
moderatePositive: 'Athari nzuri ya wastani',
slightPositive: 'Athari nzuri kidogo',
noImpact: 'Hakuna athari iliyotambulika',
significantly: 'Ndio, kwa kiasi kikubwa',
toSomeExtent: 'Ndio, kwa kiasi fulani',
noChange: 'Hakuna mabadiliko',
lessInvolved: 'Sishiriki kama hapo awali',
confirmToggleStatus: 'Badilisha Hali',
confirmToggleTraineeStatus: 'Je, una uhakika unataka kubadilisha hali ya mwanafunzi huyu? Wanafunzi wasio na kazi hawataonekana kwenye ukurasa wa mwanzo.',
traineeActivated: 'Mwanafunzi amewashwa kwa mafanikio',
traineeDeactivated: 'Mwanafunzi amezimwa kwa mafanikio',
failedToggleTraineeStatus: 'Imeshindwa kubadilisha hali ya mwanafunzi',
traineeInactive: 'Mwanafunzi hana kazi',
    homepageManagement: 'Usimamizi wa Ukurasa wa Mwanzo',
heroSlides: 'Slaidi za Hero',
addHeroSlide: 'Ongeza Slaidi ya Hero',
editHeroSlide: 'Hariri Slaidi ya Hero',
noHeroSlides: 'Hakuna slaidi za Hero',
addHeroSlidesDesc: 'Ongeza slaidi za kuonyesha kwenye sehemu ya hero ya ukurasa wa mwanzo',
stats: 'Takwimu',
noStats: 'Hakuna takwimu',
addStatsDesc: 'Ongeza takwimu za kuonyesha kwenye ukurasa wa mwanzo',
addStat: 'Ongeza Takwimu',
editStat: 'Hariri Takwimu',
statAdded: 'Takwimu imeongezwa kwa mafanikio',
statUpdated: 'Takwimu imesasishwa kwa mafanikio',
statDeleted: 'Takwimu imefutwa kwa mafanikio',
confirmDeleteStat: 'Una uhakika unataka kufuta takwimu hii?',
confirmDeleteStatTitle: 'Futa Takwimu',
heroSlideAdded: 'Slaidi ya Hero imeongezwa kwa mafanikio',
heroSlideUpdated: 'Slaidi ya Hero imesasishwa kwa mafanikio',
heroSlideDeleted: 'Slaidi ya Hero imefutwa kwa mafanikio',
heroSlideStatusToggled: 'Hali ya slaidi ya Hero imesasishwa',
failedAddHeroSlide: 'Imeshindwa kuongeza slaidi ya Hero',
failedUpdateHeroSlide: 'Imeshindwa kusasisha slaidi ya Hero',
failedDeleteHeroSlide: 'Imeshindwa kufuta slaidi ya Hero',
failedToggleHeroSlideStatus: 'Imeshindwa kusasisha hali ya slaidi ya Hero',
confirmDeleteHeroSlideTitle: 'Futa Slaidi ya Hero',
confirmDeleteHeroSlide: 'Una uhakika unataka kufuta slaidi hii ya Hero?',
failedLoadHeroSlides: 'Imeshindwa kupakia slaidi za Hero',
failedLoadStats: 'Imeshindwa kupakia takwimu',
failedAddStat: 'Imeshindwa kuongeza takwimu',
failedUpdateStat: 'Imeshindwa kusasisha takwimu',
failedDeleteStat: 'Imeshindwa kufuta takwimu',

activityImages: 'Picha za Shughuli',
activityImagesManagement: 'Usimamizi wa Picha za Shughuli',
addActivityImage: 'Ongeza Picha ya Shughuli',
editActivityImage: 'Hariri Picha ya Shughuli',
activityImageAdded: 'Picha ya shughuli imeongezwa kwa mafanikio',
activityImageUpdated: 'Picha ya shughuli imesasishwa kwa mafanikio',
activityImageDeleted: 'Picha ya shughuli imefutwa kwa mafanikio',
activityImageStatusToggled: 'Hali ya picha ya shughuli imesasishwa',
confirmDeleteActivityImage: 'Una uhakika unataka kufuta picha hii ya shughuli?',
searchActivityImages: 'Tafuta picha za shughuli...',
bulkUpload: 'Pakia Wingi',
bulkUploadImages: 'Pakia Picha Nyingi',
bulkUploadComplete: 'Upakiaji wingi umekamilika kwa mafanikio',
failedBulkUpload: 'Upakiaji wingi umeshindwa',
selectImagesToUpload: 'Tafadhali chagua picha za kupakia',
selectedFiles: 'Faili Zilizochaguliwa',
uploadAll: 'Pakia Zote',
uploading: 'Inapakia...',
imageRequired: 'Faili ya picha inahitajika',
failedAddActivityImage: 'Imeshindwa kuongeza picha ya shughuli',
failedUpdateActivityImage: 'Imeshindwa kusasisha picha ya shughuli',
failedDeleteImage: 'Imeshindwa kufuta picha',
imageDeleted: 'Picha imefutwa kwa mafanikio',
imageRestored: 'Picha imerejeshwa kwa mafanikio',
failedRestoreImage: 'Imeshindwa kurejesha picha',
imageStatusToggled: 'Hali ya picha imesasishwa',
failedToggleImageStatus: 'Imeshindwa kusasisha hali ya picha',
failedLoadActivityImages: 'Imeshindwa kupakia picha za shughuli',
exportActivityImages: 'Hamisha Picha za Shughuli',
activityImagesExported: 'Picha za shughuli zimehamishwa kwa mafanikio',
failedExportActivityImages: 'Imeshindwa kuhamisha picha za shughuli',
womenInAction: 'Wanawake Katika Vitendo',
totalImages: 'Jumla ya Picha',
activeImages: 'Picha Zinazotumika',
departmentsWithImages: 'Idara Zilizo na Picha',
lastUpload: 'Upakiaji wa Mwisho',
never: 'Haijawahi',
noActivityImages: 'Hakuna picha za shughuli zilizopatikana',
addActivityImagesDesc: 'Ongeza picha za kuonyesha kwenye sehemu ya Wanawake Katika Vitendo kwenye ukurasa wa mwanzo',
    whyChooseUs: "Kwa Nini Tuchague",
    deleteWhyChooseUs: "Je, una uhakika unataka kufuta kipengee hiki?",
    deleteWhyChooseUsTitle: "Futa Kipengee",
    deleteVideo: "Je, una uhakika unataka kufuta video hii?",
    deleteVideoTitle: "Futa Video",
    added: "Kipengele kimeongezwa kwa mafanikio",
    updated: "Kipengele kimesasishwa kwa mafanikio",
    deleted: "Kipengele kimefutwa kwa mafanikio",
    statusToggled: "Hali imesasishwa kwa mafanikio",
    failedAdd: "Imeshindwa kuongeza kipengele",
    failedUpdate: "Imeshindwa kusasisha kipengele",
    failedDelete: "Imeshindwa kufuta kipengele",
    failedToggle: "Imeshindwa kusasisha hali",
    videoSections: "Sehemu za Video",
    addVideo: "Ongeza Video",
    editVideo: "Hariri Video",
    noVideos: "Hakuna sehemu za video",
    addVideos: "Ongeza video za kuonyesha kwenye ukurasa wa mwanzo",
    videoUrl: "URL ya Video",
    thumbnail: "Kiwambo",
    setAsActive: "Weka kama video inayotumika",
    onlyOneActive: "Video moja tu inaweza kutumika kwa wakati mmoja",
    currentThumbnail: "Kiwambo cha sasa",
    watchVideo: "Tazama Video",
    playVideo: "Cheza Video",
    active: "Inayotumika",
    inactive: "Haitumiki",
    untitled: "Haina kichwa",
    youtubeEmbedUrl: "Tumia URL ya kupachika ya YouTube (mfano: https://www.youtube.com/embed/VIDEO_ID)",
    enterVideoTitle: "Weka kichwa cha video",
    enterVideoDescription: "Weka maelezo ya video",
    setActive: "Weka kama Inayotumika",
    whyChooseUsItems: "Vipengee vya Kwa Nini Tuchague",
    addItem: "Ongeza Kipengee",
    editItem: "Hariri Kipengee",
    noWhyChooseUsItems: "Hakuna vipengee vya Kwa Nini Tuchague",
    addWhyChooseUsItems: "Ongeza vipengee vya kuonyesha kwenye ukurasa wa mwanzo",
    icon: "Ikoni",
    title: "Kichwa",
    description: "Maelezo",
    sortOrder: "Utaratibu wa Kupanga",
    status: "Hali",
    actions: "Vitendo",
    iconPreview: "Onyesho la Ikoni",
    enterTitle: "Weka kichwa",
    enterDescription: "Weka maelezo",
    currentPassword: 'Nenosiri la Sasa',
enterCurrentPassword: 'Weka nenosiri lako la sasa',
passwordsDoNotMatch: 'Manenosiri hayalingani',
passwordTooShort: 'Nenosiri lazima liwe na angalau herufi 6',
passwordChanged: 'Nenosiri limebadilishwa kwa mafanikio!',
failedChangePassword: 'Imeshindwa kubadilisha nenosiri',
changing: 'Inabadilisha...',
changePassword: 'Badilisha Nenosiri',
    // Contract Management Translations
contracts: 'Mikataba Yangu',
activeContracts: 'Mikataba Inayotumika',
contractHistory: 'Historia ya Mikataba',
completedContracts: 'Imekamilika',
expiringSoon: 'Inakwisha Hivi Karibuni',
noActiveContracts: 'Hakuna Mikataba Inayotumika',
noActiveContractsDesc: 'Huna mikataba inayotumika kwa sasa.',
noContractHistory: 'Hakuna Historia ya Mikataba',
noContractHistoryDesc: 'Huna mikataba iliyokamilika au kusitishwa.',
contractDetails: 'Maelezo ya Mkataba',
contractId: 'Kitambulisho cha Mkataba',
period: 'Kipindi',
startDate: 'Tarehe ya Kuanza',
endDate: 'Tarehe ya Kuisha',
daysRemaining: 'Siku Zilizobaki',
status: 'Hali',
terminationReason: 'Sababu ya Kusitisha',
renew: 'Fanya Upya',
renewNow: 'Fanya Upya Sasa',
terminate: 'Sitisha',
viewDetails: 'Angalia Maelezo',
renewContract: 'Fanya Upya Mkataba',
terminateContract: 'Sitisha Mkataba',
renewContractInfo: 'Mkataba wa sasa unaisha tarehe:',
selectContractPeriod: 'Chagua kipindi cha mkataba',
customMonths: 'Miezi maalum...',
months: 'miezi',
sendEmailNotification: 'Tuma uthibitisho kwa barua pepe',
renewContractNote: 'Kufanya upya mkataba kutaunda kipindi kipya. Mkataba wa sasa utawekwa alama kuwa umefanywa upya.',
renewing: 'Inafanya upya...',
terminating: 'Inasitisha...',
warning: 'Onyo',
terminateContractWarning: 'Hatua hii haiwezi kutenguliwa.',
selectReason: 'Chagua sababu',
workCompleted: 'Kazi imekamilika',
performance: 'Matatizo ya utendaji',
budgetConstraints: 'Vikwazo vya bajeti',
restructuring: 'Urekebishaji wa kampuni',
mutualAgreement: 'Makubaliano ya pande zote',
other: 'Nyingine',
customReason: 'Sababu maalum',
enterTerminationReason: 'Weka sababu ya kusitisha',
effectiveDate: 'Tarehe ya kuanza kutumika',
effectiveDateNote: 'Acha wazi kwa kusitisha mara moja',
sendTerminationEmail: 'Tuma barua pepe ya uthibitisho wa kusitisha',
womanInformation: 'Maelezo ya Mwanamke',
name: 'Jina',
age: 'Umri',
department: 'Idara',
skills: 'Ujuzi',
experience: 'Uzoefu',
years: 'miaka',
phone: 'Simu',
email: 'Barua Pepe',
contractInformation: 'Maelezo ya Mkataba',
terminationDetails: 'Maelezo ya Kusitisha',
terminatedOn: 'Ilikomeshwa tarehe',
renewalInformation: 'Maelezo ya Kufanya Upya',
renewedFrom: 'Imefanywa upya kutoka',
renewedTo: 'Imefanywa upya hadi',
notes: 'Maelezo',
close: 'Funga',
expired: 'Imekwisha',
active: 'Inatumika',
searchContracts: 'Tafuta mikataba...',
refresh: 'Onyesha upya',
viewAll: 'Angalia Yote',
exportList: 'Hamisha Orodha',
exportSuccessful: 'Uhamishaji umekamilika kwa mafanikio',
exportFailed: 'Uhamishaji umeshindwa. Tafadhali jaribu tena.',
exportingContracts: 'Inahamisha mikataba...',

    exportOptions: 'Chaguzi za Uhamishaji',
exportAsCSV: 'Hamisha kama CSV',
exportAsExcel: 'Hamisha kama Excel',
exportAsPDF: 'Hamisha kama PDF',
exportSuccessful: 'Uhamishaji umekamilika kwa mafanikio',
exportFailed: 'Uhamishaji umeshindwa. Tafadhali jaribu tena.',
exportingContracts: 'Inahamisha mikataba...',
    contractExpiration: 'Mwisho wa Mkataba',
showContractsExpiringIn: 'Onyesha mikataba inayokwisha katika',
days: 'siku',
refresh: 'Onyesha upya',
manageAllContracts: 'Simamia Mikataba Yote',
activeContracts: 'Mikataba Inayotumika',
expiringThisMonth: 'Inayokwisha Mwezi Huu',
renewedThisMonth: 'Iliyofanywa Upya Mwezi Huu',
expiringNextMonth: 'Inayokwisha Mwezi Ujao',
noExpiringContracts: 'Hakuna Mikataba Inayokwisha',
noContractsExpiringSoon: 'Hakuna mikataba inayokwisha katika kipindi kilichochaguliwa.',
contractsExpiringInNext: 'mikataba inayokwisha ndani ya',
woman: 'Mwanamke',
department: 'Idara',
contractPeriod: 'Muda wa Mkataba',
startDate: 'Tarehe ya Kuanza',
endDate: 'Tarehe ya Kuisha',
daysRemaining: 'Siku Zilizobaki',
employer: 'Mwajiri',
contact: 'Wasiliana',
actions: 'Vitendo',
noPhone: 'Hakuna simu',
general: 'Jumla',
months: 'miezi',
sendEmail: 'Tuma Barua Pepe',
call: 'Piga Simu',
viewDetails: 'Angalia Maelezo',
sendReminder: 'Tuma Kumbusho',
extendContract: 'Panua Mkataba',
exportExpiringContracts: 'Hamisha Orodha',

// Additional export-related translations
exportContracts: 'Hamisha Mikataba',
exportAsCSV: 'Hamisha kama CSV',
exportAsExcel: 'Hamisha kama Excel',
exportAsPDF: 'Hamisha kama PDF',
exportingContracts: 'Inahamisha mikataba...',
exportSuccessful: 'Uhamishaji umefanikiwa',
exportFailed: 'Uhamishaji umeshindwa. Tafadhali jaribu tena.',
downloadExportedFile: 'Pakua Faili Iliyohamishwa',
selectExportFormat: 'Chagua Muundo wa Uhamishaji',
includeInactiveContracts: 'Jumuisha mikataba isiyotumika',
exportAllContracts: 'Hamisha Mikataba Yote',
exportFilteredContracts: 'Hamisha Mikataba Iliyochujwa',
contractExportTitle: 'Uhamishaji wa Mikataba',
generatingExport: 'Inatayarisha faili ya uhamishaji...',
contractList: 'Orodha ya Mikataba',
totalContracts: 'Jumla ya Mikataba',
exportDate: 'Tarehe ya Uhamishaji',
exportedBy: 'Iliyohamishwa Na',
contractDetails: 'Maelezo ya Mkataba',
womanName: 'Jina la Mwanamke',
employerName: 'Jina la Mwajiri',
employerEmail: 'Barua Pepe ya Mwajiri',
employerPhone: 'Simu ya Mwajiri',
contractStart: 'Kuanza kwa Mkataba',
contractEnd: 'Kuisha kwa Mkataba',
contractMonths: 'Miezi ya Mkataba',
status: 'Hali',
active: 'Inayotumika',
expired: 'Imekwisha',
expiringSoon: 'Inakwisha Hivi Karibuni',
critical: 'Muhimu',
warning: 'Onyo',
good: 'Nzuri',
exportSummary: 'Muhtasari wa Uhamishaji',
rowsExported: 'safu zilizohamishwa',
exportTime: 'Muda wa Uhamishaji',
contractStats: 'Takwimu za Mikataba',
fetchingContracts: 'Inatafuta mikataba...',
noContractsFound: 'Hakuna mikataba iliyopatikana',
viewContract: 'Angalia Mkataba',
contractId: 'Kitambulisho cha Mkataba',
contractStatus: 'Hali ya Mkataba',
renewContract: 'Fanya Upya Mkataba',
contractRenewed: 'Mkataba umefanywa upya kwa mafanikio',
renewalDate: 'Tarehe ya Kufanya Upya',
previousContract: 'Mkataba Uliopita',
nextContract: 'Mkataba Unaofuata',
contractHistory: 'Historia ya Mkataba',
renewalHistory: 'Historia ya Kufanya Upya',
confirmRenewContract: 'Je, una uhakika unataka kufanya upya mkataba huu?',
enterRenewalMonths: 'Weka idadi ya miezi ya kufanya upya',
renewalPeriod: 'Kipindi cha Kufanya Upya',
newEndDate: 'Tarehe Mpya ya Kuisha',
contractNotes: 'Maelezo ya Mkataba',
addContractNote: 'Ongeza Maelezo',
viewAllContracts: 'Angalia Mikataba Yote',
filterContracts: 'Chuja Mikataba',
searchContracts: 'Tafuta mikataba...',
clearFilters: 'Futa Vichujio',
applyFilters: 'Tumia Vichujio',
     // Partners Management - Kiswahili
     partners: 'Washirika & Wadhamini',
     partnersManagement: 'Usimamizi wa Washirika',
     addPartner: 'Ongeza Mshirika',
     editPartner: 'Hariri Mshirika',
     partnerName: 'Jina la Mshirika',
     partnerType: 'Aina ya Mshirika',
     partnerLogo: 'Nembo ya Mshirika',
     websiteUrl: 'URL ya Tovuti',
     sortOrder: 'Mpangilio',
     enterPartnerName: 'Ingiza jina la mshirika/shirika',
     selectType: 'Chagua aina ya mshirika',
     enterPartnerDescription: 'Ingiza maelezo ya mshirika',
     currentLogo: 'Nembo ya sasa',
     updatePartner: 'Sasisha Mshirika',
     failedAddPartner: 'Imeshindwa kuongeza mshirika',
     failedUpdatePartner: 'Imeshindwa kusasisha mshirika',
     failedDeletePartner: 'Imeshindwa kufuta mshirika',
     failedLoadPartners: 'Imeshindwa kupakia washirika',
     failedTogglePartnerStatus: 'Imeshindwa kubadilisha hali ya mshirika',
     partnerAdded: 'Mshirika ameongezwa kwa mafanikio',
     partnerUpdated: 'Mshirika amesasishwa kwa mafanikio',
     partnerDeleted: 'Mshirika amefutwa kwa mafanikio',
     partnerStatusToggled: 'Hali ya mshirika imebadilishwa kwa mafanikio',
     confirmDeletePartnerTitle: 'Futa Mshirika',
     confirmDeletePartner: 'Una uhakika unataka kufuta mshirika huyu? Hatua hii haiwezi kutenguliwa.',
     searchPartners: 'Tafuta washirika...',
     allTypes: 'Aina Zote',
     noPartnersFound: 'Hakuna washirika waliopatikana',
     noPartnersMatchCriteria: 'Hakuna washirika wanaolingana na vigezo vyako',
     showingPartners: 'Inaonyesha {showing} kati ya {total} washirika',
     deactivate: 'Zima',
     activate: 'Washa',
     visit: 'Tembelea',
     noDescription: 'Hakuna maelezo',
     partnerDescriptionDefault: 'Shirika mshirika',
     visitWebsite: 'Tembelea Tovuti',
     government: 'Serikali',
     internationalNGO: 'NGO ya Kimataifa',
     localNGO: 'NGO ya Kienyeji',
     corporate: 'Kampuni',
     private: 'Binafsi',
     educational: 'Kielimu',
     other: 'Nyingine',
     partnersCount: 'Idadi ya Washirika',
     activePartners: 'Washirika Wenye Kazi',
     inactivePartners: 'Washirika Wasiofanya Kazi',
     partnerStats: 'Takwimu za Washirika',
     exportPartners: 'Hamisha Washirika',
     importPartners: 'Ingiza Washirika',
     partnerDetails: 'Maelezo ya Mshirika',
     establishedDate: 'Ilianzishwa',
     lastUpdated: 'Ilisasishwa Mwisho',
    amountNote:'Kiasi cha RWF 10,000 kila mwanamke, bila kujali muda wa mkataba',
    enterEmailAddress: 'Tafadhali ingiza anwani yako ya barua pepe',
resetEmailSent: 'Barua pepe ya upya wa nenosiri imetumwa. Tafadhali angalia kikasha chako cha barua pepe.',
resetRequestFailed: 'Imeshindwa kusindika ombi la upya wa nenosiri. Tafadhali jaribu tena.',
forgotPasswordDescription: 'Ingiza barua pepe yako ili upya nenosiri lako',
backToLogin: 'Rudi kwenye kuingia',
sendResetLink: 'Tuma Kiungo cha Upya',
sending: 'Inatumwa...',
resetInstructions: 'Utapokea barua pepe na kiungo cha kupya nenosiri lako. Kiungo kitakwisha katika saa 1.',

// Kiswahili
contractPeriod: 'Muda wa Mkataba',
selectContractPeriod: 'Chagua muda wa mkataba',
requiredSkills: 'Ujuzi Unahitajika',
selectRelevantSkills: 'Chagua ujuzi unaofaa kwa nafasi hii',
noSkillsForDepartment: 'Hakuna ujuzi unaopatikana kwa idara hii',
expiringContracts: 'Mikataba Inayokwisha',
showContractsExpiringIn: 'Onyesha mikataba inayokwisha katika:',
noExpiringContracts: 'Hakuna Mikataba Inayokwisha',
noContractsExpiringSoon: 'Hakuna mikataba inayokwisha hivi karibuni',
daysRemaining: 'Siku Zilizosalia',
daysLeft: 'siku zilizosalia',
sendReminder: 'Tuma kumbusho',
renewContract: 'Sasisha mkataba',
contractRenewed: 'Mkataba umesasishwa kikamilifu',
months: 'miezi',

csvTemplateInstructions: 'CSV inapaswa kuwa na safu: jina, umri, idara, ujuzi, miaka ya uzoefu, kiwango cha elimu, simu, barua pepe, mahali, wasifu, majina ya ujuzi',
importInstructions: 'Pakua kiolezo ili kuhakikisha muundo sahihi',
downloadTemplate: 'Pakua Kiolezo',
importing: 'Inakaguliwa...',
import: 'Ingiza',
importProfiles: 'Ingiza Wasifu',
cannotAssignDifferentDept: 'Haiwezekani kupeana wanawake kutoka idara tofauti',
validationFailed: 'Uthibitishaji umeshindwa',
viewCertificate: 'Tazama Cheti',
certified: 'Imethibitishwa',
certificatePending: 'Cheti Linasubiri',
requestThisWoman: 'Omba mwanamke huyu',
currentlyEmployed: 'Anafanya Kazi Sasa',

'3 months': 'miezi 3',
'6 months': 'miezi 6',
'1 year': 'mwaka 1',
'2 years': 'miaka 2',
'3 years': 'miaka 3',

beginner: 'Mwanzo',
intermediate: 'Katikati',
advanced: 'Juujuu',
expert: 'Mtaalamu',

sendCustomEmail: 'Tuma Barua Pepe Maalum',
emailRecipients: 'Wapokeaji wa Barua Pepe',
enterEmailRecipients: 'Ingiza anwani za barua pepe (zilizotenganishwa na koma)',
commaSeparatedEmails: 'Ingiza anwani nyingi za barua pepe zilizotenganishwa na koma',
customEmailDescription: 'Tuma barua pepe kwa anwani yoyote ya barua pepe (sio tu kwa watumiaji wa mfumo)',
allFieldsRequired: 'Sehemu zote zinahitajika',
invalidEmails: 'Anwani zisizo sahihi za barua pepe',
emailSentSuccessfully: 'Barua pepe imetumwa kikamilifu kwa wapokeaji',
failedToSendEmail: 'Imeshindwa kutuma barua pepe',
customEmail: 'Barua Pepe Maalum',
attachments: 'Vibanusho',
maxFileSize: 'Ukubwa wa juu wa faili',
uploadCSVFile: 'Pakia Faili ya CSV',
importWomenProfiles: 'Ingiza Wasifu wa Wanawake',
     // Privacy Policy
  privacyPolicy: 'Sera ya Faragha',
  lastUpdated: 'Imesasishwa Mwisho',
  privacyIntroTitle: 'Utangulizi',
  privacyIntroText: 'Urugo Women Opportunity Center inathamini faragha yako. Sera hii ya faragha inaelezea jinsi tunavyokusanya, kutumia, na kulinda taarifa zako binafsi.',
  informationWeCollect: 'Taarifa Tunazokusanya',
  personalInformation: 'Taarifa Binafsi',
  infoNameEmail: 'Jina na anwani ya barua pepe',
  infoPhoneAddress: 'Nambari ya simu na anwani halisi',
  infoPaymentDetails: 'Taarifa za malipo kwa michango',
  infoEmploymentHistory: 'Historia ya ajira na taarifa za ujuzi',
  usageData: 'Data ya Matumizi',
  dataIPAddress: 'Anwani ya IP na aina ya kivinjari',
  dataBrowserType: 'Taarifa za kifaa',
  dataPagesVisited: 'Kurasa zilizotembelewa na muda uliotumia',
  dataTimeSpent: 'Taarifa za tovuti ya marejeo',
  howWeUseInformation: 'Jinsi Tunavyotumia Taarifa Zako',
  useProvideServices: 'Kutoa na kudumisha huduma zetu',
  useProcessDonations: 'Kusindika michango na malipo',
  useMatchEmployees: 'Kuwapatanisha wanawake na fursa za ajira',
  useCommunication: 'Kuwasiliana nawe',
  useImproveServices: 'Kuboresha huduma zetu na tovuti yetu',
  useLegalCompliance: 'Kufuata wajibu wa kisheria',
  informationSharing: 'Kushiriki Taarifa',
  sharingIntro: 'Hatuiuza taarifa zako binafsi. Tunashiriki taarifa tu katika hali zifuatazo:',
  withEmployers: 'Na Waajiri',
  sharingEmployers: 'Tu kwa idhini yako kwa ajili ya upatanishi wa ajira',
  withServiceProviders: 'Na Wadau wa Huduma',
  sharingProviders: 'Washirika wa kuaminika wanaosaidia shughuli zetu',
  legalRequirements: 'Mahitaji ya Kisheria',
  sharingLegal: 'Wakati inapohitajika na sheria au mchakato wa kisheria',
  withConsent: 'Kwa Idhini Yako',
  sharingConsent: 'Wakati unatupa idhini wazi',
  dataSecurity: 'Usalama wa Data',
  securityMeasures: 'Tunatekeleza hatua za usalama zinazofaa kulinda taarifa zako.',
  securityEncryption: 'Usimbuaji wa SSL kwa utumaji wa data',
  securityAccessControl: 'Udhibiti wa upatikanaji na uthibitishaji',
  securityRegularAudits: 'Ukaguzi wa usalama wa mara kwa mara',
  securityTraining: 'Mafunzo ya faragha kwa wafanyakazi',
  yourRights: 'Haki Zako',
  rightAccess: 'Haki ya kupata data yako binafsi',
  rightCorrection: 'Haki ya kusahihisha data isiyo sahihi',
  rightDeletion: 'Haki ya kufuta data yako',
  rightObject: 'Haki ya kupinga usindikaji',
  rightDataPortability: 'Haki ya uhamishaji wa data',
  rightWithdrawConsent: 'Haki ya kukataa idhini',
  cookies: 'Kuki',
  cookiesDescription: 'Tunatumia kuki kuboresha uzoefu wako kwenye tovuti yetu.',
  essentialCookies: 'Kuki Muhimu',
  essentialCookiesDesc: 'Inahitajika kwa utendaji wa msingi wa tovuti',
  analyticsCookies: 'Kuki za Uchambuzi',
  analyticsCookiesDesc: 'Zatusaidie kuelewa jinsi wageni wanavyotumia tovuti yetu',
  preferenceCookies: 'Kuki za Mapendeleo',
  preferenceCookiesDesc: 'Kumbuka mipangilio yako na mapendeleo',
  childrenPrivacy: 'Faragha ya Watoto',
  childrenPrivacyText: 'Huduma zetu hazielekezwi kwa watoto chini ya umri wa miaka 18.',
  changesToPolicy: 'Mabadiliko ya Sera hii ya Faragha',
  policyChangesText: 'Tunaweza kusasisha Sera yetu ya Faragha mara kwa mara.',
  contactUsPrivacy: 'Wasiliana Nasi',
  contactPrivacyText: 'Ikiwa una maswali kuhusu Sera hii ya Faragha, wasiliana nasi kwa:',
  
  // Terms of Service
  termsOfService: 'Masharti ya Huduma',
  termsAgreement: 'Makubaliano ya Masharti',
  termsAgreementText: 'Kwa kufikia na kutumia jukwaa letu, unakubali Masharti haya ya Huduma.',
  definitions: 'Ufafanuzi',
  platform: 'Jukwaa',
  platformDefinition: 'Tovuti ya Urugo WOC',
  services: 'Huduma',
  servicesDefinition: 'Huduma za upatanishi wa ajira, mafunzo, na michango',
  user: 'Mtumiaji',
  userDefinition: 'Mtu yeyote anayefikia au kutumia jukwaa',
  employer: 'Mwajiri',
  employerDefinition: 'Watu binafsi au kampuni zinazotafuta kuajiri',
  employee: 'Mfanyakazi',
  employeeDefinition: 'Wanawake wanaotafuta fursa za ajira',
  donor: 'Mchangiaji',
  donorDefinition: 'Watu binafsi au mashirika yanayotoa michango',
  accountRegistration: 'Usajili wa Akaunti',
  accountRegistrationText: 'Ili kutumia baadhi ya vipengele, lazima usajili akaunti.',
  accountAgeRequirement: 'Lazima uwe na umri wa miaka 18 na kuendelea',
  accountAccurateInfo: 'Toa taarifa sahihi na kamili',
  accountSecurity: 'Dumisha usalama wa akaunti',
  accountTransfer: 'Usihamishishe akaunti yako kwa wengine',
  servicesDescription: 'Maelezo ya Huduma',
  employmentServices: 'Huduma za Ajira',
  employmentMatch: 'Kuwapatanisha wanawake wenye sifa na waajiri',
  employmentVerification: 'Uthibitishaji wa ujuzi na sifa',
  employmentTraining: 'Mafunzo na ukuzaji wa ujuzi',
  employmentSupport: 'Usaidizi endelevu wa ajira',
  donationServices: 'Huduma za Michango',
  donationProcessing: 'Usindikaji wa michango ya kifedha',
  donationTracking: 'Ufuatiliaji wa athari za michango',
  donationReporting: 'Ripoti za mara kwa mara za athari',
  donationTransparency: 'Ugawaji wazi wa fedha',
  userObligations: 'Majukumu ya Mtumiaji',
  generalUserObligations: 'Majukumu ya Jumla ya Mtumiaji',
  obeyLaws: 'Tii sheria zote zinazotumika na kanuni',
  respectOthers: 'Heshimu watumiaji wengine na faragha yao',
  noFraud: 'Usifanye shughuli za udanganyifu',
  accurateInfo: 'Toa taarifa sahihi',
  noHarassment: 'Usikose au ubaguzi',
  employerObligations: 'Majukumu ya Mwajiri',
  fairTreatment: 'Toa masharti ya haki ya ajira',
  timelyPayment: 'Fanya malipo kwa wakati',
  safeEnvironment: 'Toa mazingira salama ya kazi',
  complianceLaws: 'Kufuata sheria za ajira',
  employeeObligations: 'Majukumu ya Mfanyakazi',
  professionalConduct: 'Dumisha mwenendo wa kitaalamu',
  honestSkills: 'Wakilisha ujuzi na upatikanaji kwa uaminifu',
  commitment: 'Timiza ahadi za ajira',
  respectEmployer: 'Heshimu mali na kanuni za mwajiri',
  paymentsFees: 'Malipo na Ada',
  serviceFees: 'Ada za huduma zinaweza kutumika kwa huduma fulani',
  donationFees: 'Ada za usindikaji wa michango',
  paymentMethods: 'Njia za malipo zinazokubaliwa',
  refundPolicy: 'Sera ya kurejesha fedha kwa michango',
  taxResponsibility: 'Majukumu ya kodi',
  intellectualProperty: 'Haki miliki',
  ipOwnership: 'Tunamiliki haki zote za haki miliki kwenye jukwaa.',
  ipLicense: 'Tunakupa leseni ndogo ya kutumia jukwaa.',
  userContentLicense: 'Unatupa leseni ya kutumia maudhui yako kwa shughuli za jukwaa.',
  limitationLiability: 'Kikomo cha Wajibu',
  liabilityDisclaimer: 'Tunatoa huduma "kama zilivyo" bila dhamana.',
  liabilityLimit: 'Kikomo cha wajibu wetu',
  liabilityForceMajeure: 'Matukio ya nguvu kubwa',
  termination: 'Kukomesha',
  terminationClause: 'Tunaweza kukomesha au kusimamisha ufikiaji wa akaunti yako.',
  terminationBreach: 'Kwa kukiuka masharti haya',
  terminationInactivity: 'Kwa kutokuwa na shughuli kwa muda mrefu',
  terminationRequest: 'Kwa ombi lako',
  terminationPlatform: 'Kwa matengenezo au usalama wa jukwaa',
  disputeResolution: 'Suluhisho la Migogoro',
  governingLaw: 'Mamlaka ya sheria inayotawala',
  disputeProcess: 'Mchakato wa suluhisho la migogoro',
  mediationClause: 'Upatanishi kabla ya mashitaka',
  changesToTerms: 'Mabadiliko ya Masharti',
  termsChangesText: 'Tunaweza kubadilisha masharti haya wakati wowote.',
  contactUsTerms: 'Wasiliana Nasi',
  contactTermsText: 'Kwa maswali yoyote kuhusu masharti haya, wasiliana nasi kwa:',
  
  // Sitemap
  sitemap: 'Ramani ya Tovuti',
  sitemapDescription: 'Muhtasari kamili wa kurasa zote na huduma zinazopatikana kwenye Urugo WOC',
  mainPages: 'Kurasa Kuu',
  accountPages: 'Kurasa za Akaunti',
  policyPages: 'Kurasa za Sera',
  servicePages: 'Kurasa za Huduma',
  departmentPages: 'Kurasa za Idara',
  trainingServices: 'Huduma za Mafunzo',
  donationServices: 'Huduma za Michango',
  supportServices: 'Huduma za Usaidizi',
  contactInformation: 'Maelezo ya Mawasiliano',
  quickActions: 'Vitendo vya Haraka',
  donateNow: 'Changia Sasa',
  registerNow: 'Jisajili Sasa',
  totalPages: 'Jumla ya Kurasa',
  websiteVersion: 'Toleo la Tovuti',
  viewPrivacy: 'Tazama Sera ya Faragha',
  viewTerms: 'Tazama Masharti ya Huduma',
  viewSitemap: 'Tazama Ramani ya Tovuti',
  backToHome: 'Rudi Nyumbani',
    // Modal Alert translations
  alertSuccess: 'Mafanikio',
  alertError: 'Hitilafu',
  alertWarning: 'Onyo',
  alertInfo: 'Habari',
  okButton: 'Sawa',
  confirmButton: 'Thibitisha',
  cancelButton: 'Ghairi',
  tryAgainButton: 'Jaribu Tena',
  close: 'Funga',
  
  // Request Modal translations
  step1Title: 'Tuambie kukuhusu wewe',
  step1Description: 'Pata wanawake waliofunzwa katika jamii yetu anuwai',
  step2Title: 'Unda Akaunti Yako',
  step2Description: 'Jiunge na jamii yetu kuajiri wanawake wenye ujuzi',
  loginTitle: 'Ingia kwenye Akaunti Yako',
  loginDescription: 'Tayari una akaunti? Ingia ili uendelee',
  step3Title: 'Omba Wanawake Waliofunzwa',
  step3Description: 'Jaza fomu hapa chini kuomba wanawake wenye ujuzi kutoka kituo chetu',
  successTitle: 'Ombi Limewasilishwa Kikamilifu!',
  successMessage: 'Ombi lako limepokelewa. Tutawasiliana nawe hivi karibuni.',
  
  // Account types
  individual: 'Mtu Binafsi',
  individualDesc: 'Ninaajiri kwa ajili yangu',
  company: 'Kampuni',
  companyDesc: 'Ninaajiri kwa ajili ya kampuni yangu',
  
  // Form labels
  companyNameLabel: 'Jina la kampuni',
  companyNamePlaceholder: 'Weka jina la kampuni',
  fullNameLabel: 'Jina Kamili',
  fullNamePlaceholder: 'Weka jina lako kamili',
  usernameLabel: 'Jina la Mtumiaji',
  usernamePlaceholder: 'Chagua jina la mtumiaji',
  workEmailLabel: 'Barua pepe ya kazi',
  workEmailPlaceholder: 'Weka barua pepe yako ya kazi',
  phoneLabel: 'Nambari ya Simu',
  phonePlaceholder: 'Weka nambari yako ya simu',
  emailLabel: 'Anwani ya Barua Pepe',
  emailPlaceholder: 'Weka barua pepe yako',
  passwordLabel: 'Nenosiri',
  passwordPlaceholder: 'Weka nenosiri lako',
  createPasswordPlaceholder: 'Unda nenosiri',
  confirmPasswordLabel: 'Thibitisha Nenosiri',
  confirmPasswordPlaceholder: 'Thibitisha nenosiri lako',
  passwordMinLength: 'Angalau herufi 10',
  agreeToTerms: 'Ninakubali Sheria za Matumizi na Sera ya Faragha',
  
  // Request form
  selectDepartment: 'Chagua Idara',
  chooseDepartment: 'Chagua idara',
  employeesNeeded: 'Idadi ya Wafanyakazi',
  costPerEmployee: 'RWF 10,000 kwa kila mfanyakazi kwa mwezi',
  workType: 'Aina ya Kazi',
  fullTime: 'Wakati Kamili',
  partTime: 'Wakati Mdogo',
  contract: 'Mkataba',
  seasonal: 'Msimu',
  duration: 'Muda (Siku)',
  days: 'siku',
  totalAmount: 'Jumla ya Kiasi',
  woman: 'mwanamke',
  'employee(s)': 'mfanyakazi(zi)',
  personalInformation: 'Taarifa ya Kibinafsi',
  yourFullName: 'Jina Lako Kamili',
  email: 'Barua Pepe',
  phoneNumber: 'Nambari ya Simu',
  
  // Specifications
  womanSpecifications: 'Vigezo vya Mwanamke (Hiari)',
  specificationsDescription: 'Toa mahitaji ya ziada kwa wanawake unawataka kuajiri',
  ageRange: 'Kiwango cha Umri Unachopendelea',
  experienceLevel: 'Kiwango cha Uzoefu',
  skillLevel: 'Kiwango cha Ujuzi Kinachohitajika',
  educationLevel: 'Kiwango cha Elimu',
  languageRequirements: 'Mahitaji ya Lugha',
  specialSkills: 'Ujuzi Maalum Unahitajika',
  otherSpecifications: 'Vigezo Vingine',
  noPreference: 'Hakuna upendeleo',
  years: 'miaka',
  beginner: 'Mwanzo',
  intermediate: 'Katikati',
  advanced: 'Uzoefu',
  expert: 'Mtaalamu',
  basic: 'Ujuzi wa Msingi',
  kinyarwanda: 'Kinyarwanda',
  french: 'Kifaransa',
  kinyarwandaEnglish: 'Kinyarwanda & Kiingereza',
  anyLanguage: 'Lugha yoyote',
  primary: 'Elimu ya Msingi',
  secondary: 'Elimu ya Upili',
  vocational: 'Mafunzo ya Ufundi',
  university: 'Shahada ya Chuo Kikuu',
  specialSkillsPlaceholder: 'mfano: Ujuzi wa kompyuta, uongozi, n.k.',
  separateWithCommas: 'Tenganisha na koma',
  otherSpecificationsPlaceholder: 'Mahitaji mengine yoyote maalum au mapendeleo...',
  
  // Payment
  paymentInformation: 'Taarifa ya Malipo',
  mobileMoney: 'Mobile Money',
  bankAccount: 'Akaunti ya Benki',
  paymentNote: 'Tafadhali kamilisha malipo baada ya kuwasilisha ombi lako. Ombi lako litachakatiwa mara tu malipo yamethibitishwa.',
  
  // Buttons and actions
  continue: 'Endelea',
  back: 'Nyuma',
  backToRegister: 'Nyuma kwa Usajili',
  join: 'Jiunge',
  loggingIn: 'Inakujia ndani...',
  creatingAccount: 'Inaunda akaunti...',
  submitting: 'Inawasilisha...',
  submitRequest: 'Wasilisha Ombi',
  alreadyHaveAccount: 'Tayari una akaunti?',
  loginHere: 'Ingia hapa',
  signIn: 'Ingia',
  showPassword: 'Onyesha nenosiri',
  hidePassword: 'Ficha nenosiri',
  
  // Status messages
  available: 'Inapatikana',
  working: 'Anafanya Kazi',
  certificateVerified: 'Imehakikiwa',
  certificateUnverified: 'Inasubiri',
  specificWomanRequest: 'Unaomba',
  specifically: 'hasa',
  singleWomanNote: 'Idadi ya wafanyakazi imewekwa kiotomatiki kwa 1 kwa maombi ya mwanamke mmoja.',
  requestingWoman: 'Unaomba:',
  youRequested: 'Uliomba:',
  yourSpecifications: 'Vigezo Vyako:',
  languages: 'Lugha',
  
  // Error messages
  passwordMismatch: 'Nenosiri halifanani',
  passwordTooShort: 'Nenosiri lazima liwe na angalau herufi 10',
  registrationFailed: 'Usajili umeshindwa',
  loginFailed: 'Kuingia kumeshindwa',
  requestFailed: 'Kushindwa kuwasilisha ombi',
  loginToRequest: 'Tafadhali ingia kuomba wanawake',
  
  // Success messages
  loginSuccess: 'Umeingia kwenye akaunti yako kwa mafanikio.',
  registrationSuccess: 'Akaunti yako imeundwa kwa mafanikio!',
  requestSuccess: 'Ombi lako limewasilishwa kwa mafanikio!',
  
  // Step labels
  accountType: 'Aina ya Akaunti',
  account: 'Akaunti',
  request: 'Ombi',
    // New keys for request specifications
requestManagementWithSpecs: 'Usimamizi wa Maombi (Na Vigezo)',
specifications: 'Vigezo',
noSpecifications: 'Hakuna Vigezo',
viewSpecifications: 'Tazama Vigezo',
hasSpecifications: 'Ina Vigezo',
withSpecifications: 'Na Vigezo',
noSpecificationsProvided: 'Hakuna vigezo vya ziada vilivyotolewa kwa ombi hili.',
requestDetails: 'Maelezo ya Ombiji',
employerInformation: 'Taarifa ya Mwajiri',
statusInformation: 'Taarifa ya Hali',
employeesNeeded: 'Wafanyakazi Wanahitajika',
workType: 'Aina ya Kazi',
duration: 'Muda',
amount: 'Kiasi',
paymentVerified: 'Malipo Yamethibitishwa',
assignedWomen: 'Wanawake Waliotajwa',
availableWomen: 'Wanawake Walio Patikana',
created: 'Imeundwa',
ageRange: 'Kiwango cha Umri',
experienceLevel: 'Kiwango cha Uzoefu',
skillLevel: 'Kiwango cha Ujuzi',
educationLevel: 'Kiwango cha Elimu',
languageRequirements: 'Mahitaji ya Lugha',
specialSkills: 'Ujuzi Maalum',
otherSpecifications: 'Vigezo Vingine',
approveRequest: 'Idhinisha Ombiji',
rejectRequest: 'Kataa Ombiji',
assignWomen: 'Weka Wanawake',
close: 'Funga',

// Certificate related
uploadCertificate: 'Pakia Cheti',
certificateNumber: 'Nambari ya Cheti',
certificateType: 'Aina ya Cheti',
selectCertificateType: 'Chagua Aina ya Cheti',
vocationalCertificate: 'Cheti cha Ufundi',
skillCertificate: 'Cheti cha Ujuzi',
trainingCertificate: 'Cheti cha Mafunzo',
professionalCertificate: 'Cheti cha Kitaaluma',
otherCertificate: 'Cheti Kingine',
issuingOrganization: 'Shirika Linalotoa',
issueDate: 'Tarehe ya Kutolewa',
expiryDate: 'Tarehe ya Kukoma',
certificateFile: 'Faili ya Cheti',
maxFileSize: 'Upeo wa ukubwa wa faili',
currentCertificate: 'Cheti cha Sasa',
viewCurrentCertificate: 'Tazama Cheti cha Sasa',
updateCertificate: 'Sasisha Cheti',
certificateVerified: 'Cheti Kimehakikiwa',
certificateUnverified: 'Cheti Hakijahakikiwa',
noCertificate: 'Hakuna Cheti',
viewCertificate: 'Tazama Cheti',
markAsUnverified: 'Weka kama Hakijahakikiwa',
verifyCertificate: 'Thibitisha Cheti',
deleteCertificate: 'Futa Cheti',
confirmDeleteCertificateTitle: 'Futa Cheti',
confirmDeleteCertificate: 'Una uhakika unataka kufuta cheti hiki? Hatua hii haiwezi kubatilishwa.',
confirmVerifyCertificateTitle: 'Thibitisha Cheti',
confirmVerifyCertificate: 'Una uhakika unataka kuthibitisha cheti hiki?',
confirmUnverifyCertificateTitle: 'Kataa Uthibitishaji wa Cheti',
confirmUnverifyCertificate: 'Una uhakika unataka kuweka cheti hiki kama hakijahakikiwa?',
certificateUploaded: 'Cheti kimepakuliwa kwa mafanikio',
certificateDeleted: 'Cheti kimefutwa kwa mafanikio',
certificateVerifiedSuccess: 'Cheti kimehakikiwa kwa mafanikio',
certificateUnverifiedSuccess: 'Cheti kimewekwa kama hakijahakikiwa kwa mafanikio',
failedUploadCertificate: 'Imeshindwa kupakia cheti',
failedDeleteCertificate: 'Imeshindwa kufuta cheti',
failedVerifyCertificate: 'Imeshindwa kuthibitisha cheti',
failedUnverifyCertificate: 'Imeshindwa kuweka cheti kama hakijahakikiwa',

// Women management
selectAllAvailable: 'Chagua wanawake wote walio patikana',
womanNotAvailable: 'Mwanamke hayupo kwa mgawo',
selectForAssignment: 'Chagua kwa mgawo',
womenSelectedForAssignment: 'Wanawake Waliochaguliwa kwa Mgawo',
selected: 'imechaguliwa',
assignSelectedWomen: 'Weka Wanawake Waliochaguliwa',

// Request status
completed: 'Imekamilika',
cancelled: 'Imebatilishwa',
    emailSettings: 'Mipangilio ya Barua pepe',
emailBroadcast: 'Tuma Barua pepe kwa Wote',
emailBroadcastDescription: 'Tuma tangazo na masasisho kwa watumiaji wote wa mfumo',
sendEmailBroadcast: 'Tuma Barua pepe kwa Wote',
sendTestEmail: 'Tuma Barua pepe ya Majaribio',
broadcastAllUsersWarning: 'Barua pepe hii itatumwa kwa WATUMIAJI WOTE wa mfumo.',
broadcastEmployersWarning: 'Barua pepe hii itatumwa kwa WAJIRI pekee.',
broadcastAdminsWarning: 'Barua pepe hii itatumwa kwa WASIMAMIZI pekee.',
broadcastManagersWarning: 'Barua pepe hii itatumwa kwa WAKURUGENZI pekee.',
currentPassword: 'Nywila ya Sasa',
newPassword: 'Nywila Mpya',
confirmPassword: 'Thibitisha Nywila',
enterCurrentPassword: 'Weka nywila yako ya sasa',
enterNewPassword: 'Weka nywila mpya',
confirmNewPassword: 'Thibitisha nywila mpya',
changing: 'Inabadilisha...',
systemSettings: 'Mipangilio ya Mfumo',
timezone: 'Eneo la Saa',
dateFormat: 'Muundo wa Tarehe',
itemsPerPage: 'Vipengee kwa Ukurasa',
resetToDefaults: 'Rudisha kwa Chaguomsingi',
recipients: 'Wapokeaji',
allUsers: 'Watumiaji Wote',
employersOnly: 'Wajiri Pekee',
adminsOnly: 'Wasimamizi Pekee',
managersOnly: 'Wakurugenzi Pekee',
testEmailAddress: 'Anwani ya Barua pepe ya Majaribio',
enterTestEmail: 'Weka anwani ya barua pepe ya majaribio',
testEmailDescription: 'Tuma barua pepe ya majaribio ili kuthibitisha muundo',
sending: 'Inatuma...',
sendBroadcast: 'Tuma kwa Wote',
enterEmailSubject: 'Weka mada ya barua pepe',
enterEmailMessage: 'Weka ujumbe wako hapa...',
     // Donate Modal translations - Kiswahili
     donateTitle: 'Tua Msaada kwa Wanawake Wetu',
     donateDescription: 'Mchango wako unasaidia kufundisha wanawake wengi na kuunda maisha endelevu',
     quickSelectAmount: 'Chagua Kiasi Haraka (RWF):',
     donationAmountLabel: 'Kiasi cha Mchango (RWF) *',
     donationAmountPlaceholder: 'Weka kiasi',
     donorNameLabel: 'Jina Lako *',
     donorNamePlaceholder: 'Weka jina lako',
     emailLabel: 'Barua Pepe',
     emailPlaceholder: 'Weka barua pepe yako',
     phoneLabel: 'Simu',
     phonePlaceholder: 'Weka nambari yako ya simu',
     messageLabel: 'Ujumbe (Hiari)',
     messagePlaceholder: 'Ongeza ujumbe wa kuwaamini...',
     donationInfo1: '💝 100% ya mchango wako unaenda moja kwa moja kwenye programu za mafunzo',
     donationInfo2: '🌍 Mchango wako unabadilisha maisha na jamii',
     donationInfo3: '🌍 *182*8*1*270591#',
     donationInfo4: '🏦 Jina la Benki: Benki ya Kigali',
donationInfo5: '👤 Jina la Akaunti: WFW1 Empowerment Center LLC / Urugo Women\'s Opportunity Center',
donationInfo6: '💰 Akaunti ya RWF: 00059-06929965-20',
donationInfo7: '💵 Akaunti ya USD: 00059-06929966-21',
     cancelButton: 'Ghairi',
     processingButton: 'Inachakata...',
     makeDonationButton: 'Toa Mchango',
     successTitle: 'Asante kwa Mchango Wako Mkuu!',
     successMessage: 'Msaada wako unaweza kubadilisha maisha ya wanawake.',
     errorMessage: 'Hitilafu katika kuchakata mchango. Tafadhali jaribu tena.',
     // Register Modal translations - Kiswahili
     registerCreateAccount: 'Fungua Akaunti',
     registerDescription: 'Jiunge na Urugo WOC kuanza kuajiri wanawake waliofunzwa',
     fullNameLabel: 'Jina Kamili *',
     fullNamePlaceholder: 'Weka jina lako kamili',
     usernameLabel: 'Jina la Mtumiaji *',
     usernamePlaceholder: 'Chagua jina la mtumiaji',
     emailLabel: 'Anwani ya Barua Pepe *',
     emailPlaceholder: 'Weka barua pepe yako',
     phoneLabel: 'Nambari ya Simu',
     phonePlaceholder: 'Weka nambari yako ya simu',
     passwordLabel: 'Nenosiri *',
     passwordPlaceholder: 'Unda nenosiri',
     confirmPasswordLabel: 'Thibitisha Nenosiri *',
     confirmPasswordPlaceholder: 'Thibitisha nenosiri lako',
     passwordStrength: 'Nguvu',
     passwordVeryWeak: 'Dhaifu sana',
     passwordWeak: 'Dhaifu',
     passwordFair: 'Wastani',
     passwordGood: 'Nzuri',
     passwordStrong: 'Imara',
     userTypeTitle: 'Ninajiandikisha kama:',
     userTypeEmployer: 'Mwajiri',
     userTypeEmployerDesc: 'Ajiri wanawake waliofunzwa',
     creatingAccount: 'Inaunda akaunti...',
     createAccount: 'Fungua Akaunti',
     registerErrorGeneric: 'Usajili umeshindwa. Tafadhali jaribu tena.',
     registerErrorPasswordMatch: 'Nenosiri halifanani',
     registerErrorPasswordWeak: 'Tafadhali tumia nenosiri lenye nguvu zaidi',
     alreadyHaveAccount: 'Tayari una akaunti?',
     signIn: 'Ingia',
    // Login Modal translations - Kiswahili
    close: 'Funga',
    loginWelcome: 'Karibu Tena',
    loginDescription: 'Ingia kwenye akaunti yako ili uendelee',
    emailPlaceholder: 'Anwani ya barua pepe',
    passwordPlaceholder: 'Nenosiri',
    showPassword: 'Onyesha nenosiri',
    hidePassword: 'Ficha nenosiri',
    rememberMe: 'Nikumbuke',
    forgotPassword: 'Umesahau nenosiri?',
    signingIn: 'Inakujia ndani...',
    signIn: 'Ingia',
    noAccount: 'Huna akaunti?',
    signUp: 'Jisajili',
    loginErrorGeneric: 'Ingia imeshindwa. Tafadhali angalia maelezo yako.',
        // ===== Passwordless Auth Flow - Kiswahili =====
    loginEmailOnlyHint: 'Weka barua pepe yako ili uendelee',
    loginStaffHint: 'Kuingia kwa wafanyakazi — tafadhali weka nenosiri lako',
    loggingInEmployer: 'Tunakuingiza...',
    checking: 'Inaangalia...',
    change: 'Badilisha',
    invalidEmail: 'Tafadhali weka anwani sahihi ya barua pepe',
    noAccountFound: 'Hakuna akaunti iliyopatikana na barua pepe hii. Tafadhali jisajili kwanza.',
    unknownUserType: 'Aina ya mtumiaji haijulikani. Tafadhali wasiliana na msaada.',
    emailLoginHint: 'Tutatafuta akaunti yako kwa barua pepe. Hakuna nenosiri linalohitajika.',
    loginDescriptionEmailOnly: 'Weka barua pepe yako ili uendelee — hakuna nenosiri linalohitajika',
    registerDescriptionNoPassword: 'Weka tu maelezo yako — hakuna nenosiri linalohitajika',
    step2DescriptionNoPassword: 'Weka tu barua pepe yako — hakuna nenosiri linalohitajika',
    loginSuccessMessage: 'Sasa umeingia kwenye akaunti yako!',
    // Footer & Chat Bot Translations
  chatWelcome: "Habari! Karibu kwenye Kituo cha Fursa cha Wanawake cha Urugo. Ninaweza kukusaidiaje leo?",
  justNow: "Hivi sasa",
  chatQuestionHire: "Nawezaje kuajiri wanawake waliofunzwa?",
  chatQuestionDonate: "Nawezaje kutoa mchango wa kusaidia wanawake?",
  chatQuestionTraining: "Nawezaje kujisajili kwa mafunzo?",
  chatQuestionContact: "Nawezaje kuwasiliana nawe?",
  chatKeywordHire: "ajiri",
  chatResponseHire: "Unaweza kuajiri wanawake wetu waliofunzwa kwa kuunda akaunti ya mwajiri kwenye portal yetu. Tembelea sehemu ya 'Ajiri Talanta' kuona wasifu wa wanawake waliopo na kuwasilisha ombi lako la kuajiri. Wanawake waliofunzwa wako tayari kwa ajira katika idara mbalimbali zikiwemo uendeshaji wa duka la kahawa, usimamizi wa nyumba, kushona, na mengineyo.",
  chatKeywordEmployer: "mwajiri",
  chatResponseEmployer: "Kama mwajiri, unaweza kujisajili kwenye portal yetu kupata wasifu wa wanawake wenye ujuzi. Tunatoa wanawake waliochunguzwa na kufunzwa tayari kwa ajira. Unaweza kuwasilisha mahitaji mahususi na tutakufananisha na wagombea waliofanana.",
  chatKeywordRequest: "omba",
  chatResponseRequest: "Kuomba wanawake waliofunzwa, tafadhali ingia kwenye akaunti yako ya mwajiri na jaza fomu ya kuomba ajira. Bainisha idadi ya wanawake unayohitaji, ujuzi unaohitajika, na muda wa ajira. Timu yetu itawasiliana nawe ndani ya masaa 24.",
  chatKeywordDonate: "toa",
  chatResponseDonate: "Asante kwa kupenda kutoa! Unaweza kutoa mtandaoni kupitia portal yetu salama, kupitia uhamisho wa benki, au kwa kutembelea kituo chetu. Michango yako inasaidia kufunza wanawake zaidi na kuwapa fursa za ajira.",
  chatKeywordSupport: "unga",
  chatResponseSupport: "Unaweza kutuunga mkono kwa kutoa, kuwa mdhamini wa kampuni, kujitolea, au kushirikiana nasi. Wasiliana na timu yetu ya maendeleo kwa info@urugowoc.com kwa maelezo zaidi.",
  chatKeywordTraining: "mafunzo",
  chatResponseTraining: "Tunatoa mafunzo ya ufundi katika idara 7. Kujisajili, tembelea kituo chetu huko Kayonza au jisajili mtandaoni kupitia tovuti yetu. Programu za mafunzo ni bure kwa wanawake wanaostahili na ni pamoja na cheti baada ya kukamilika.",
  chatKeywordApply: "jisajili",
  chatResponseApply: "Kujisajili kwa mafunzo, tembelea tovuti yetu na jaza fomu ya maombi. Utahitaji kutoa maelezo ya kibinafsi na kuonyesha idara unayopenda. Timu yetu itawasiliana nawe kwa mahojiano.",
  chatKeywordLogin: "ingia",
  chatResponseLogin: "Kuingia, bofya kitufe cha 'Ingia' kwenye urambazaji wa juu. Waajiri, wanaofunzwa, na wasimamizi wana vyombo tofauti vya kuingia. Ikiwa huna akaunti, unaweza kujisajili kutoka kwenye ukurasa wa kuingia.",
  chatKeywordRegister: "jisajili",
  chatResponseRegister: "Usajili umefunguliwa kwa waajiri, wanawake wanaotafuta mafunzo, na wanaojitolea. Bofya 'Jisajili' kwenye ukurasa wa kuingia na uchague aina yako ya mtumiaji. Jaza maelezo yako na timu yetu itathibitisha akaunti yako.",
  chatKeywordAbout: "kuhusu",
  chatResponseAbout: "Kituo cha Fursa cha Wanawake cha Urugo kilianzishwa kuwatia nguvu wanawake kupitia mafunzo ya ufundi na ajira. Tumewafunza wanawake zaidi ya 600 tangu 2013. Tembelea ukurasa wetu wa Kuhusu Sisi kujifunza zaidi kuhusu dhamira yetu, maono, na athari.",
  chatKeywordGallery: "galeri",
  chatResponseGallery: "Galeri yetu inaonyesha wanawake wakiwa kwenye mafunzo, sherehe za kuhitimu, na hadithi za mafanikio ya ajira. Unaweza kuona picha kutoka kwa idara zote 7 za mafunzo na kushuhudia mabadiliko yanayotokea kwenye kituo chetu.",
  chatKeywordDepartments: "idara",
  chatResponseDepartments: "Tuna idara 7 za mafunzo: 1) Uendeshaji wa Duka la Kahawa, 2) Usimamizi wa Nyumba, 3) Mapokezi, 4) Kushona, 5) Kazi ya Ngozi, 6) Kutengeneza Zulia, na 7) Uzalishaji wa Maziwa na Yogati. Kila programu inajumuisha mafunzo ya vitendo na cheti.",
  chatKeywordContact: "wasiliana",
  chatResponseContact: "Unaweza kuwasiliana nasi kupitia barua pepe kwa info@urugowoc.com, piga simu +250788350577, tembelea kituo chetu huko Kayonza, au tumia chatbot hii. Timu yetu inapatikana Jumatatu hadi Ijumaa, saa 8 asubuhi hadi saa 5 jioni.",
  chatKeywordLocation: "mahali",
  chatResponseLocation: "Tunapatikana Kayonza, Rwanda. Unaweza kutupata katika Kituo cha Fursa cha Wanawake cha Urugo, Wilaya ya Kayonza. Tufanye ziara kuona vifaa vyetu vya mafunzo na kukutana na timu yetu.",
  chatResponseDefault: "Asante kwa swali lako! Kwa maelezo zaidi mahususi, tafadhali wasiliana nasi moja kwa moja kwa info@urugowoc.com au piga simu +250788350577.",
  chatTitle: "Msaidizi Urugo WOC",
  close: "Funga",
  chatQuickQuestions: "Maswali ya Haraka",
  chatPlaceholder: "Chapa ujumbe wako hapa...",
  send: "Tuma",
  chatToggleTooltip: "Wasiliana nasi",
  whatsappDefaultMessage: "Habari Urugo WOC, nina swali kuhusu kuajiri wanawake waliofunzwa/kutoa/mafunzo...",
  whatsappTooltip: "Wasiliana nasi kwa WhatsApp",
  footerTitle: "WfWI/Urugo WOC",
  footerDescription: "Kuwatia nguvu wanawake kupitia mafunzo ya ujuzi na fursa za ajira tangu 2013. Kubadilisha jamii kwa kuunda maisha endelevu.",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  youtube: "YouTube",
  whatsapp: "WhatsApp",
  quickLinks: "Viungo vya Haraka",
  home: "Nyumbani",
  about: "Kuhusu Sisi",
  departments: "Idara",
  women: "Wanawake Wetu",
  gallery: "Galeri",
  donate: "Toa",
  hire: "Ajiri",
  login: "Ingia",
  contactInfo: "Maelezo ya Mawasiliano",
  location: "Kayonza, Rwanda",
  phoneNumber: "+250 788350577",
  email: "info@urugowoc.com",
  hireWomen: "Ajiri Wanawake Waliofunzwa",
  donateNow: "Toa Sasa",
  loginRegister: "Ingia/Jisajili",
  ourDepartments: "Idara Zetu",
  coffeeShopOperation: "Uendeshaji wa Duka la Kahawa",
  housekeepingOperation: "Usimamizi wa Nyumba",
  receptionOperation: "Mapokezi",
  sewingOperation: "Kushona",
  leatherOperation: "Kazi ya Ngozi",
  carpetOperation: "Kutengeneza Zulia",
  milkYogurtProduction: "Uzalishaji wa Maziwa na Yogati",
  copyright: "Kituo cha Fursa cha Wanawake cha Urugo. Haki zote zimehifadhiwa.",
  privacyPolicy: "Sera ya Faragha",
  termsOfService: "Sheria za Huduma",
  sitemap: "Ramani ya Tovuti",


    // Manager Dashboard Translations
    dashboard: "Dashibodi",
    requests: "Maombi",
    women: "Wanawake",
    users: "Watumiaji",
    donations: "Michango",
    gallery: "Galeri",
    about: "Kuhusu",
    reports: "Ripoti",
    settings: "Mipangilio",
    manager: "Msimamizi",
    totalUsers: "Watumiaji Wote",
    totalRequests: "Maombi Yote",
    totalRevenue: "Mapato Yote",
    activeWomen: "Wanawake Wanaofanya Kazi",
    recentActivity: "Shughuli za Hivi Karibuni",
    totalWomen: "Wanawake Wote",
    employerCount: "Waajiri",
    newThisMonth: "Mpya Mwezi Huu",
    activeToday: "Wanaofanya Kazi Leo",
    pendingRequests: "Maombi Yanayosubiri",
    approvedRequests: "Maombi Yaliyoidhinishwa",
    rejectedRequests: "Maombi Yaliyokataliwa",
    loadingDashboard: "Inapakia dashibodi...",
    failedLoadDashboard: "Imeshindwa kupakia data ya dashibodi",
    justNow: "Hivi sasa",
    notificationPendingRequests: "Una maombi yanayosubiri",
    newUsersThisWeek: "watumiaji wapya wiki hii",
    newDonations: "michango mipya",
    failedLoadEmployerDetails: "Imeshindwa kupakia maelezo ya mwajiri",
    selectWomenToAssign: "Tafadhali chagua wanawake kwanza kabla ya kuwaweka",
    selectRequestEmployer: "Tafadhali chagua ombi/mwajiri",
    noWomenSelected: "Hakuna wanawake waliochaguliwa",
    successfullyAssignedWomen: "wanawake wamewekwa kwa mafanikio kwa {employer}",
    failedToAssignWomen: "Imeshindwa kuwaweka wanawake",
    failedLoadWomenProfiles: "Imeshindwa kupakia wasifu wa wanawake",
    accessDenied: "Ufikiaji umekataliwa. Tafadhali ingia tena.",
    requestStatusUpdated: "Hali ya ombi imesasishwa hadi {status}",
    failedUpdateRequest: "Imeshindwa kusasisha ombi",
    userStatusUpdated: "Mtumiaji {status} kwa mafanikio",
    suspended: "imesimamishwa",
    activated: "imeamilishwa",
    failedUpdateUser: "Imeshindwa kusasisha mtumiaji",
    confirmDeleteUser: "Una uhakika unataka kufuta mtumiaji huyu?",
    userDeleted: "Mtumiaji amefutwa kwa mafanikio",
    failedDeleteUser: "Imeshindwa kufuta mtumiaji",
    profileAvailabilityUpdated: "Upatikanaji wa wasifu umesasishwa hadi {status}",
    available: "Inapatikana",
    hired: "Iliwekwa kazi",
    failedUpdateProfile: "Imeshindwa kusasisha wasifu",
    confirmDeleteProfile: "Una uhakika unataka kufuta wasifu huu?",
    profileDeleted: "Wasifu umefutwa kwa mafanikio",
    failedDeleteProfile: "Imeshindwa kufuta wasifu",
    profileAdded: "Wasifu umeongezwa kwa mafanikio",
    failedAddProfile: "Imeshindwa kuongeza wasifu",
    profileUpdated: "Wasifu umesasishwa kwa mafanikio",
    exportSuccessful: "Utoaji umefanikiwa! Faili imepakuliwa",
    failedExportData: "Imeshindwa kutoa data",
    searchRequests: "Tafuta maombi...",
    clearFilters: "Futa Vichujio",
    filterBy: "Chuja kwa",
    allStatus: "Hali Zote",
    pending: "Inasubiri",
    approved: "Imekubaliwa",
    rejected: "Imekataliwa",
    cancelled: "Imefutwa",
    to: "hadi",
    exportRequests: "Toa Maombi",
    noRequestsFound: "Hakuna Maombi Yaliyopatikana",
    noRequestsMatch: "Hakuna maombi yanayolingana na vigezo vyako",
    noRequestsAvailable: "Hakuna maombi yanayopatikana",
    showingRequests: "Inaonyesha maombi ",
    id: "Kitambulisho",
    date: "Tarehe",
    employer: "Mwajiri",
    department: "Idara",
    employees: "Wafanyakazi",
    duration: "Muda",
    amount: "Kiasi",
    status: "Hali",
    actions: "Vitendo",
    days: "siku",
    n_a: "N/A",
    viewRequest: "Tazama Ombi",
    approveRequest: "Idhinisha Ombi",
    rejectRequest: "Kataa Ombi",
    womenProfilesManagement: "Usimamizi wa Wasifu wa Wanawake",
    searchWomen: "Tafuta wanawake...",
    assignSelected: "Weka Waliochaguliwa",
    addNewProfile: "Ongeza Wasifu Mpya",
    allDepartments: "Idara Zote",
    clearFilters: "Futa Vichujio",
    womenSelectedForAssignment: " wanawake waliochaguliwa kwa ajili ya kuwekewa",
    selected: "imechaguliwa",
    assignSelectedWomen: "Weka Wanawake Waliochaguliwa",
    noWomenProfilesFound: "Hakuna Wasifu wa Wanawake Ulipatikana",
    noProfilesMatchCriteria: "Hakuna wasifu unaolingana na vigezo vyako",
    showingProfiles: "Inaonyesha {showing} kati ya {total} wasifu",
    previous: "Iliyopita",
    pageInfo: "Ukurasa {page} wa {pages}",
    next: "Ijayo",
    selectAllAvailable: "Chagua wanawake wote walio wazi",
    photo: "Picha",
    name: "Jina",
    age: "Umri",
    skills: "Ujuzi",
    experience: "Uzoefu",
    phone: "Simu",
    years: "miaka",
    womanNotAvailable: "Mwanamke huyu hayupo",
    selectForAssignment: "Chagua kwa ajili ya kuwekewa",
    editProfile: "Hariri Wasifu",
    markAsHired: "Weka kama Aliwekwa Kazi",
    markAsAvailable: "Weka kama Inapatikana",
    deleteProfile: "Futa Wasifu",
    employedBy: "Aliwekwa Kazi na",
    requestId: "Kitambulisho cha Ombi",
    assigned: "Iliwekwewa",
    userManagement: "Usimamizi wa Watumiaji",
    searchUsers: "Tafuta watumiaji...",
    allTypes: "Aina Zote",
    admin: "Msimamizi",
    manager: "Meneja",
    employer: "Mwajiri",
    exportUsers: "Toa Watumiaji",
    noUsersFound: "Hakuna Watumiaji Walipatikana",
    noUsersMatchCriteria: "Hakuna watumiaji waliofanana na vigezo vyako",
    noUsersAvailable: "Hakuna watumiaji waliopo",
    showingUsers: "Inaonyesha watumiaji",
    user: "Mtumiaji",
    fullName: "Jina Kamili",
    email: "Barua Pepe",
    phone: "Simu",
    type: "Aina",
    joined: "Alijiunga",
    editUser: "Hariri Mtumiaji",
    suspendUser: "Sitisha Mtumiaji",
    activateUser: "Amilisha Mtumiaji",
    deleteUser: "Futa Mtumiaji",
    galleryManagement: "Usimamizi wa Galeri",
    searchGallery: "Tafuta kwenye galeri...",
    addImage: "Ongeza Picha",
    noGalleryImagesFound: "Hakuna Picha za Galeri Zilizopatikana",
    noImagesMatchCriteria: "Hakuna picha zinazolingana na vigezo vyako",
    showingImages: "Inaonyesha {showing} kati ya {total} picha",
    general: "Jumla",
    edit: "Hariri",
    delete: "Futa",
    featured: "Iliyobeba",
    aboutUsManagement: "Usimamizi wa Kuhusu Sisi",
    pageContent: "Maudhui ya Ukurasa",
    coreValues: "Thamani za Msingi",
    teamMembers: "Wanachama wa Timu",
    aboutPageContent: "Maudhui ya Ukurasa wa Kuhusu",
    editContent: "Hariri Maudhui",
    defaultAboutTitle: "Kuwawezesha Wanawake Kupitia Mafunzo ya Ujuzi",
    defaultMission: "Dhamira yetu ni kuwawezesha wanawake kupitia mafunzo ya ujuzi na fursa za ajira endelevu",
    defaultVision: "Mtazamo wetu ni ulimwengu ambapo kila mwanamke ana ujuzi na fursa za kufikia uhuru wa kiuchumi",
    defaultHistory: "Ilianzishwa mwaka 2013, Kituo cha Fursa cha Wanawake cha Urugo kimebadilisha maisha ya mamia ya wanawake kupitia mafunzo ya ujuzi",
    noMissionStatement: "Hakuna tamko la dhamira lililoongezwa",
    noVisionStatement: "Hakuna tamko la mtazamo lililoongezwa",
    noHistoryContent: "Hakuna maudhui ya historia yaliyoongezwa",
    noAboutPageContent: "Hakuna maudhui ya ukurasa wa Kuhusu",
    clickEditContentToAdd: "Bofya 'Hariri Maudhui' ili kuongeza habari",
    addValue: "Ongeza Thamani",
    noCoreValues: "Hakuna Thamani za Msingi",
    addCoreValues: "Ongeza thamani za msingi za shirika lako",
    addTeamMember: "Ongeza Mwanachama wa Timu",
    noTeamMembers: "Hakuna Wanachama wa Timu",
    addTeamMembers: "Ongeza wanachama wa timu yako",
    donationManagement: "Usimamizi wa Michango",
    reset: "Weka Upya",
    exportDonations: "Toa Michango",
    donor: "Mchangiaji",
    message: "Ujumbe",
    viewDetails: "Tazama Maelezo",
    sendThankYou: "Tuma Asante",
    noDonationsFound: "Hakuna michango iliyopatikana",
    reportsAnalytics: "Ripoti & Uchambuzi",
    generateReports: "Tengeneza Ripoti",
    usersReport: "Ripoti ya Watumiaji",
    requestsReport: "Ripoti ya Maombi",
    donationsReport: "Ripoti ya Michango",
    fullDatabaseExport: "Utoaji wa Hifadhidata Yote",
    systemStatistics: "Takwimu za Mfumo",
    totalUsers: "Watumiaji Wote",
    activeWomen: "Wanawake Wanaofanya Kazi",
    totalRevenue: "Mapato Yote",
    successRate: "Kiwango cha Mafanikio",
    requestStatistics: "Takwimu za Maombi",
    generalSettings: "Mipangilio ya Jumla",
    siteName: "Jina la Tovuti",
    emailNotifications: "Arifa za Barua Pepe",
    autoApproveRequests: "Maombi ya Kukubali Kiotomatiki",
    saveSettings: "Hifadhi Mipangilio",
    accountSettings: "Mipangilio ya Akaunti",
    changePassword: "Badilisha Nenosiri",
    newPassword: "Nenosiri Jipya",
    confirmPassword: "Thibitisha Nenosiri",
    confirmNewPassword: "Thibitisha Nenosiri Jipya",
    saveChanges: "Hifadhi Mabadiliko",
    editGalleryImage: "Hariri Picha ya Galeri",
    addGalleryImage: "Ongeza Picha ya Galeri",
    title: "Kichwa",
    description: "Maelezo",
    department: "Idara",
    featuredImage: "Picha Iliyobeba",
    imageFile: "Faili ya Picha",
    currentImage: "Picha ya Sasa",
    current: "Ya sasa",
    cancel: "Ghairi",
    updateImage: "Sasisha Picha",
    editAboutPageContent: "Hariri Maudhui ya Ukurasa wa Kuhusu",
    pageTitle: "Kichwa cha Ukurasa",
    enterPageTitle: "Weka kichwa cha ukurasa",
    missionStatement: "Tamko la Dhamira",
    enterMissionStatement: "Weka tamko la dhamira",
    visionStatement: "Tamko la Mtazamo",
    enterVisionStatement: "Weka tamko la mtazamo",
    historyAboutUs: "Historia / Kuhusu Sisi",
    enterHistoryContent: "Weka maudhui ya historia",
    aboutPageSaved: "Ukurasa wa Kuhusu umehifadhiwa kwa mafanikio",
    failedSaveAboutPage: "Imeshindwa kuhifadhi ukurasa wa Kuhusu",
    editCoreValue: "Hariri Thamani ya Msingi",
    addCoreValue: "Ongeza Thamani ya Msingi",
    coreValueText: "Maandishi ya Thamani ya Msingi",
    enterCoreValueText: "Weka maandishi ya thamani ya msingi",
    sortOrder: "Mpangilio wa Kupanga",
    updateCoreValue: "Sasisha Thamani ya Msingi",
    confirmDeleteCoreValue: "Una uhakika unataka kufuta thamani hii ya msingi?",
    coreValueDeleted: "Thamani ya msingi imefutwa kwa mafanikio",
    failedDeleteCoreValue: "Imeshindwa kufuta thamani ya msingi",
    coreValueAdded: "Thamani ya msingi imeongezwa kwa mafanikio",
    failedAddCoreValue: "Imeshindwa kuongeza thamani ya msingi",
    coreValueUpdated: "Thamani ya msingi imesasishwa kwa mafanikio",
    failedUpdateCoreValue: "Imeshindwa kusasisha thamani ya msingi",
    editTeamMember: "Hariri Mwanachama wa Timu",
    addTeamMember: "Ongeza Mwanachama wa Timu",
    position: "Wadhifa",
    department: "Idara",
    bioDescription: "Wasifu/Maelezo",
    enterTeamMemberBio: "Weka wasifu wa mwanachama wa timu",
    profilePhoto: "Picha ya Profaili",
    activeTeamMember: "Mwanachama wa Timu Anayefanya Kazi",
    currentPhoto: "Picha ya Sasa",
    updateTeamMember: "Sasisha Mwanachama wa Timu",
    confirmDeleteTeamMember: "Una uhakika unataka kufuta mwanachama huyu wa timu?",
    teamMemberDeleted: "Mwanachama wa timu amefutwa kwa mafanikio",
    failedDeleteTeamMember: "Imeshindwa kufuta mwanachama wa timu",
    teamMemberAdded: "Mwanachama wa timu ameongezwa kwa mafanikio",
    failedAddTeamMember: "Imeshindwa kuongeza mwanachama wa timu",
    teamMemberUpdated: "Mwanachama wa timu amesasishwa kwa mafanikio",
    failedUpdateTeamMember: "Imeshindwa kusasisha mwanachama wa timu",
    addNewProfile: "Ongeza Wasifu Mpya",
    name: "Jina",
    age: "Umri",
    selectDepartment: "Chagua Idara",
    experienceYears: "Uzoefu (Miaka)",
    commaSeparatedSkills: "Ujuzi uliotenganishwa na koma",
    location: "Mahali",
    educationLevel: "Kiwango cha Elimu",
    selectEducation: "Chagua Kiwango cha Elimu",
    primary: "Msingi",
    secondary: "Sekondari",
    vocational: "Ufundi",
    university: "Chuo kikuu",
    other: "Nyingine",
    profilePhoto: "Picha ya Profaili",
    addProfile: "Ongeza Wasifu",
    editProfile: "Hariri Wasifu",
    saveChanges: "Hifadhi Mabadiliko",
    refresh: "Sasisha",
    logout: "Toka",
    toggleMenu: "Badilisha Menyu",
    urugoWOC: "Urugo WOC",
    notifications: "Arifa",
    noNotifications: "Hakuna arifa",
    home: "Nyumbani",
    requests: "Maombi",
    women: "Wanawake",
    users: "Watumiaji",
    donations: "Michango",
    gallery: "Galeri",
    about: "Kuhusu",
    reports: "Ripoti",
    settings: "Mipangilio",
    export: "Toa",
    csvFormat: "Umbizo la CSV",
    manageWomen: "Dhibiti Wanawake",
    profiles: "wasifu",
    manageUsers: "Dhibiti Watumiaji",
    quickActions: "Vitendo vya Haraka",
    reviewRequests: "Kagua Maombi",
    exportAllData: "Toa Data Yote",
    exportAll: "Toa Yote",
    clearAll: "Futa Zote",
    allCaughtUp: "Yote yamefuatiliwa!",
    noNewNotifications: "Hakuna arifa mpya",
    departments: "Idara",
    employers: "Waajiri",
    activeToday: "Wanaofanya Kazi Leo",
    thisMonth: "mwezi huu",
    currentlyActive: "wanaofanya kazi sasa",
    average: "Wastani",
    womenTrained: "Wanawake Waliofunzwa",
    selectAllAvailable: "Chagua Wanawake Wote Walio Wazi",
    selectForAssignment: "Chagua kwa ajili ya kuwekewa",
    inactive: "Haifanyi Kazi",
    active: "Inafanya Kazi",
    enterImageDescription: "Weka maelezo ya picha",
    enterCoreValueText: "Weka maandishi ya thamani ya msingi",
    enterTeamMemberBio: "Weka wasifu wa mwanachama wa timu",
    bio: "Wasifu",
    confirmDeleteImage: "Una uhakika unataka kufuta picha hii?",
    imageDeleted: "Picha imefutwa kwa mafanikio",
    failedDeleteImage: "Imeshindwa kufuta picha",
    galleryImageAdded: "Picha ya galeri imeongezwa kwa mafanikio",
    failedAddGalleryImage: "Imeshindwa kuongeza picha ya galeri",
    galleryImageUpdated: "Picha ya galeri imesasishwa kwa mafanikio",
    failedUpdateGalleryImage: "Imeshindwa kusasisha picha ya galeri",
    selectDepartment: "Chagua Idara",
    successRate: "Kiwango cha Mafanikio",
    activeWomen: "Wanawake Wanaofanya Kazi",
    
    // Existing translations from other sections...
    employerDashboard: "Dashibodi ya Mwajiri",
    myRequests: "Maombi Yangu",
    hiredWomen: "Wanawake Walioajiriwa",
    payments: "Malipo",
    newRequest: "Omba Mpya",
    markAsPaid: "Weka kama Ililipwa",
    exportData: "Toa Data",
    makePayment: "Fanya Malipo",
    downloadReceipt: "Pakua Risiti",
    totalSpent: "Jumla ya Tumika",
    totalHired: "Jumla ya Waliokodishwa",
    approvalRate: "Kiwango cha Kukubali",
    avgEmployees: "Wastani wa Wafanyakazi",
    avgDuration: "Muda wa Wastani",
    pendingPayments: "Malipo Yanayosubiri",
    paymentHistory: "Historia ya Malipo",
    payNow: "Lipa Sasa",
    profileSettings: "Mipangilio ya Profaili",
    companyName: "Jina la Kampuni",
    contactPerson: "Mtu wa Mawasiliano",
    requestTrainedWomen: "Omba wanawake waliopata mafunzo",
    perRequest: "kwa ombi",
    womenHired: "wanawake walioajiriwa",
    avgPerRequest: "wastani/ombi",
    browseHired: "Vinjari Waliokodishwa",
    viewHiredWomen: "Tazama wanawake walioajiriwa",
    downloadAllRequests: "Pakua maombi yote",
    unknownDepartment: "Idara Isiyojulikana",
    unknownDate: "Tarehe isiyojulikana",
    exportList: "Toa Orodha",
    unknownName: "Jina Lisilojulikana",
    yearsExp: "miaka ya uzoefu",
    hiredOn: "Iliwekwa kazi",
    unknown: "Haijulikani",
    notSpecified: "Haijabainishwa",
    noHiredWomen: "Hakuna Wanawake Walioajiriwa",
    noHiredWomenDesc: "Hujawai ajiri wanawake bado. Maombi yaliyoidhinishwa yataonekana hapa",
    makeRequest: "Fanya Ombi",
    managePayments: "Dhibiti malipo yako na ankara",
    totalPendingPayments: "Jumla ya Malipo Yanayosubiri",
    requests: "maombi",
    allCompletedPayments: "Malipo yote yaliyokamilika",
    viewAllRequests: "Tazama Maombi Yote",
    request: "Ombi",
    due: "Inatakiwa",
    noPendingPayments: "Hakuna malipo yanayosubiri",
    paidOn: "Ililipwa",
    noPaymentHistory: "Hakuna historia ya malipo bado",
    loadingDashboard: "Inapakia dashibodi yako...",
    failedLoadHiredWomen: "Imeshindwa kupakia data ya wanawake walioajiriwa",
    notificationPendingRequests: "Una maombi yanayosubiri",
    notificationPendingPayments: "Malipo yanayosubiri",
    justNow: "Hivi sasa",
    requestSubmittedSuccess: "Ombi limewasilishwa kwa mafanikio!",
    failedSubmitRequest: "Imeshindwa kuwasilisha ombi. Tafadhali jaribu tena",
    requestUpdatedSuccess: "Ombi limefasiliwa kwa mafanikio!",
    failedUpdateRequest: "Imeshindwa kusasisha ombi. Tafadhali jaribu tena",
    confirmCancelRequest: "Una uhakika unataka kughairi ombi hili?",
    requestCancelledSuccess: "Ombi limeghairiwa kwa mafanikio!",
    failedCancelRequest: "Imeshindwa kughairi ombi. Tafadhali jaribu tena",
    confirmMarkAsPaid: "Weka ombi hili kama lililolipwa?",
    requestMarkedAsPaid: "Ombi limewekwa kama lililolipwa!",
    failedUpdatePayment: "Imeshindwa kusasisha hali ya malipo. Tafadhali jaribu tena",
    exportSuccessful: "Utoaji umefanikiwa! Faili imepakuliwa",
    failedExportRequests: "Imeshindwa kutoa maombi",
    confirmDeleteRequest: "Una uhakika unataka kufuta ombi hili? Kitendo hiki hakiwezi kufutwa",
    requestDeletedSuccess: "Ombi limefutwa kwa mafanikio!",
    failedDeleteRequest: "Imeshindwa kufuta ombi. Tafadhali jaribu tena",
    downloadingReceipt: "Inapakua risiti...",
    paymentCompleted: "Malipo yamekamilika kwa mafanikio!",
    
    // Gallery Page Translations
    barista: "Barista",
    coffee: "Kahawa",
    training: "Mafunzo",
    womenLearning: "Wanawake wanaojifunza",
    preparation: "Utayarishaji",
    machine: "mashine",
    customerService: "Huduma ya wateja",
    serving: "Kutumikia",
    customers: "wateja",
    withProfessionalism: "kwa utaalamu",
    grinding: "Kusaga",
    learning: "Kujifunza",
    proper: "sahihi",
    techniques: "mbinu",
    art: "Sanaa",
    creating: "Kuunda",
    beautiful: "nzuri",
    designs: "miundo",
    teamCollaboration: "Ushirikiano wa timu",
    working: "Kufanya kazi",
    together: "pamoja",
    in: "katika",
    shop: "duka",
    roomCleaning: "Usafishaji wa vyumba",
    professional: "Kitaalamu",
    room: "chumba",
    cleaning: "usafishaji",
    linenManagement: "Usimamizi wa kitambaa",
    linen: "kitambaa",
    folding: "kunja",
    and: "na",
    storage: "uhifadhi",
    cleaningEquipment: "Vifaa vya usafishaji",
    using: "Kutumia",
    modern: "kisasa",
    equipment: "vifaa",
    hotelStandards: "Viashiria vya hoteli",
    maintaining: "Kudumisha",
    high: "juu",
    standards: "viwango",
    frontDesk: "Dawati la mbele",
    managing: "Kusimamia",
    hotel: "hoteli",
    front: "mbele",
    desk: "dawati",
    operations: "shughuli",
    guestCheckin: "Usajili wa wageni",
    guest: "mgeni",
    checkin: "usajili",
    process: "mchakato",
    phoneEtiquette: "Adabu ya simu",
    telephone: "simu",
    communication: "mawasiliano",
    skills: "ujuzi",
    computerSkills: "Ujuzi wa kompyuta",
    software: "programu",
    sewingMachine: "Mashine ya kushona",
    industrial: "viwanda",
    sewing: "kushona",
    machines: "mashine",
    patternMaking: "Kutengeneza muundo",
    clothing: "nguo",
    patterns: "muundo",
    fabricCutting: "Kukata kitambaa",
    precision: "usahihi",
    fabric: "kitambaa",
    cutting: "kukata",
    qualityControl: "Udhibiti wa ubora",
    checking: "Kuangalia",
    finished: "kumaliza",
    garments: "nguo",
    leatherCutting: "Kukata ngozi",
    leather: "ngoozi",
    for: "kwa",
    products: "bidhaa",
    handStitching: "Kushona kwa mkono",
    traditional: "kienyeji",
    stitching: "kushona",
    leatherDyeing: "Kupaka rangi ngozi",
    coloring: "Kupaka rangi",
    productAssembly: "Kukusanya bidhaa",
    assembling: "Kukusanya",
    goods: "bidhaa",
    weaving: "Kufuma",
    carpet: "zulia",
    knotting: "Kufunga",
    handknotting: "Kufunga kwa mkono",
    designPlanning: "Upangaji wa muundo",
    designs: "muundo",
    finishing: "Kumaliza",
    final: "Mwisho",
    touches: "kugusa",
    on: "kwenye",
    carpets: "mazulia",
    milkProcessing: "Usindikaji wa maziwa",
    milk: "maziwa",
    processing: "usindikaji",
    yogurtMaking: "Kutengeneza yogati",
    yogurt: "yogati",
    fermentation: "uchachushaji",
    qualityTesting: "Kupima ubora",
    testing: "kupima",
    dairy: "maziwa",
    packaging: "Ufungaji",
    hygienic: "usafi",
    
    // UI Translations for Gallery
    images: "Picha",
    tryAgain: "Jaribu tena",
    noImagesFound: "Hakuna picha zilizopatikana",
    tryDifferentFilter: "Jaribu kuchagua idara tofauti au neno la utafutaji",
    tryDifferentSearch: "Jaribu neno tofauti la utafutaji",
    noImagesInDepartment: "Hakuna picha zinazopatikana kwa idara hii bado",
    galleryImage: "Picha ya galerii",
    noDescription: "Hakuna maelezo yanayopatikana",
    loadMore: "Pakia zaidi",
    trainingImages: "Picha za mafunzo",
    womenEmpowered: "Wanawake wenye uwezo",
    learningOpportunities: "Fursa za kujifunza",
    witnessTransformation: "Shuhudia safari ya wanawake wanayobadilisha maisha yao kupitia mafunzo ya ujuzi",
    search: "Tafuta",
    viewAll: "Tazama Zote",
    tailoringFashion: "Kushona na Mitindo",
    organicFarming: "Kilimo Hai",
    culinaryArts: "Sanaa za Upishi",
    cosmetology: "Urembo",
    literacyProgram: "Mpango wa Kusoma na Kuandika",
    handicrafts: "Ufundi",
    leatherwork: "Ushonaji wa Ngozi",
    farming: "Kilimo",
    cooking: "Kupika",
    tailoring: "Kushona",
    housekeeping: "Usimamizi wa nyumba",
    reception: "Mapokezi",
    sewing: "Kushona",
    carpetWeaving: "Kufuma mazulia",
    dairyProduction: "Uzalishaji wa maziwa",
    
    // About Us Page Translations
    aboutUs: "Kuhusu Sisi",
    empoweringWomenTransformingCommunities: "Kuwawezesha wanawake, kubadilisha jamii tangu 2013",
    ourMission: "Dhamira Yetu",
    ourVision: "Maono Yetu",
    ourStory: "Hadithi Yetu",
    ourCoreValues: "Thamani Zetu Za Msingi",
    ourTrainingDepartments: "Idara Zetu za Mafunzo",
    meetOurTeam: "Kutana na Timu Yetu",
    contactUs: "Wasiliana Nasi",
    connectWithUs: "Ungana Nasi",
    sendUsAMessage: "Tutumie Ujumbe",
    wellGetBackToYou: "Tutakujibu haraka iwezekanavyo",
    ourPartnersSponsors: "Washirika & Wafadhili Wetu",
    
    // Contact Information Labels
    address: "Anwani",
    workingHours: "Saa za Kazi",
    alternate: "Mbadala",
    fullName: "Jina Kamili *",
    emailAddress: "Anwani ya Barua Pepe *",
    subject: "Mada *",
    sendMessage: "Tuma Ujumbe",
    sending: "Inatumwa...",
    thankYouMessageSent: "Asante! Ujumbe wako umetumwa kwa mafanikio.",
    sorryErrorSending: "Samahani, kulikuwa na hitilafu katika kutuma ujumbe wako. Tafadhali jaribu tena.",
    
    // Placeholders and Messages
    loadingAboutInfo: "Inapakia maelezo kuhusu...",
    
    // Form Labels
    formNamePlaceholder: "Weka jina lako kamili",
    formEmailPlaceholder: "Weka anwani yako ya barua pepe",
    formSubjectPlaceholder: "Weka mada",
    formMessagePlaceholder: "Chapa ujumbe wako hapa...",
    
    // Social Media Platforms
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    whatsapp: "WhatsApp",
    
    // Partner Types
    sponsor: "Mfadhili",
    partner: "Mshirika",
    donor: "Mchangiaji",

    // Existing translations
    home: "Nyumbani",
    exploreDepartments: "Gundua Idara",
    meetOurWomen: "Kutana na Wanawake Wetu",
    hireTrainedWomen: "Ajiri Wanawake Waliopata Mafunzo",
    empoweringWomen: "Kuwawezesha Wanawake",
    throughSkillsTraining: "Kupitia Mafunzo ya Ujuzi",
    buildingSustainable: "Kujenga",
    futures: "Mustakabali Endelevu",
    transformingCommunities: "Kubadilisha Jamii",
    together: "Pamoja",
    employersConnected: "Waajiri Waliounganishwa",
    chooseSpecializedPrograms: "Chagua kutoka kwa programu zetu maalum za mafunzo zilizoundwa kwa mafanikio",
    requestTrainedWomen: "Omba Wanawake Waliopata Mafunzo",
    certifiedTraining: "Mafunzo Yenye Cheti",
    flexibleHours: "Saa Zinazoweza Kubadilika",
    ourWomenInAction: "Wanawake Wetu Katika Vitendo",
    witnessTransformation: "Shuhudia mabadiliko kupitia kazi zao",
    meetTalentedWomen: "Kutana na Wanawake Wetu Wenye Talanta",
    skilledProfessionals: "Wataalamu wenye ujuzi tayari kufanya tofauti",
    availableNow: "Inapatikana Sasa",
    currentlyWorking: "Anafanya Kazi Sasa",
    empowerMoreWomen: "Wawezesha Wanawake Zaidi Leo",
    supportProvidesHope: "Msaada wako unatoa mafunzo, fursa, na matumaini. Jiunge nasi katika kuunda mabadiliko ya kudumu.",
    donateNow: "Changia Sasa",
    hireTalent: "Ajiri Talanta",
    woman: "Mwanamke",
    skilledProfessional: "Mtaalamu mwenye ujuzi",
    womenEmpowermentActivity: "Shughuli ya kuwawezesha wanawake",
    makeDonation: "Toa mchango wa kusaidia mafunzo ya wanawake",
    
    // Department names and descriptions
    tailoringDesc: "Mafunzo ya kitaalamu ya kushona na ubunifu wa mitindo",
    farmingDesc: "Mbinu na mazoezi ya kilimo endelevu",
    culinaryDesc: "Ujuzi wa kitaalamu wa kupishi na utayarishaji wa chakula",
    cosmetologyDesc: "Uzalishaji wa bidhaa za urembo na huduma za ngozi",
    literacyDesc: "Ujuzi wa msingi wa kusoma, kuandika na kuhesabu",
    handicraftsDesc: "Uzalishaji wa vitu vya ufundi vya kitamaduni na vya kisasa",
    leatherworkDesc: "Uzalishaji wa viatu na bidhaa za ngozi",
    
    // Hero slides descriptions
    heroSlide1Desc: "Kituo cha Fursa cha Wanawake cha Urugo kimewafunza wanawake zaidi ya 600 katika ujuzi mbalimbali wa kazi, na kuwasaidia kujenga maisha endelevu na kubadilisha jamii zao.",
    heroSlide2Desc: "Programu zetu za mafunzo ya ujuzi huwapatia wanawake ujuzi unaoweza kuuzwa kwa soko la ajira lenye ushindani wa leo, na kuhakikisha ajira ya muda mrefu na uhuru wa kifedha.",
    heroSlide3Desc: "Kwa kuwawezesha mwanamke mmoja, tunawawezesha jamii nzima. Jiunge nasi katika kuunda mabadiliko ya kudumu kupitia elimu, msaada, na fursa.",
    
    // Additional UI elements
    working: "Anafanya Kazi",
    loadingContent: "Inapakia yaliyomo mazuri...",
  },

  arabic: {

        // ===== Trainee Stats Page =====
        stats: 'الإحصائيات',
        traineeStats: 'إحصائيات المتدربات',
        traineeStatsIntro: 'استكشف خريجينا المعتمدين',
        ourImpact: 'تأثيرنا',
        totalTrainees: 'الخريجون المعتمدون',
        employedByCompany: 'موظفة في شركة',
        unemployed: 'عاطلة عن العمل',
        professionalInternship: 'تدريب مهني',
        selfEmployed: 'عاملة لحسابها الخاص',
        traineesFound: 'متدربة تم العثور عليها',
        noTraineesFound: 'لم يتم العثور على متدربات',
        tryDifferentFilters: 'حاول تعديل الفلاتر أو البحث.',
        searchTrainees: 'ابحث بالاسم أو المهارات...',
        allDepartments: 'جميع الأقسام',
        yearsExp: 'سنوات خبرة',
    employed: 'موظف',
studying: 'يدرس',
workingForOthers: 'يعمل لصالح الآخرين',
notAvailableForHire: 'غير متاح للتوظيف',
womenFound: 'نساء تم العثور عليهن',
noWomenInDepartment: 'لم يتم العثور على نساء في هذا القسم.',
exportExcel: 'تصدير إلى Excel',
exportPDF: 'تصدير إلى PDF',
noWomenFoundWithStatus: 'لم يتم العثور على نساء بهذه الحالة',

    fullName: 'الاسم الكامل',
    age: 'العمر',
    cohort: 'المجموعة',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    placementLocation: 'موقع التوظيف',
    competenceSkills: 'المهارات',
    commaSeparated: 'مفصولة بفواصل',
    optional: 'اختياري',
    emailOptional: 'البريد الإلكتروني اختياري لكنه مفضل للتواصل',
    enterName: 'أدخل اسمك الكامل',
    enterAge: 'عمرك',
    enterPhone: '+250 78X XXX XXX',
    enterEmail: 'بريدك@الإلكتروني.com (اختياري)',
    enterPlacementLocation: 'المدينة، المنطقة، البلد',
    enterCompetenceSkills: 'مثال: مهارات الكمبيوتر، اتخاذ القرار، القيادة',
    separateWithCommas: 'افصل المهارات المتعددة بفواصل',
    enterCompanyName: 'اسم الشركة/المؤسسة',
    enterWorkingPosition: 'المسمى الوظيفي',
    enterWorkingLocation: 'مكان العمل',
    enterYears: 'سنوات',
    enterBio: 'سيرة ذاتية مختصرة',
    uploadPhoto: 'تحميل صورة',
  
    fullNameRequired: 'الاسم الكامل مطلوب',
    nameMinLength: 'يجب أن يتكون الاسم من حرفين على الأقل',
    selectDepartmentRequired: 'يرجى اختيار قسم',
    selectEmploymentStatus: 'يرجى اختيار حالتك الوظيفية',
    selectJobSecured: 'يرجى اختيار كيفية حصولك على وظيفتك',
  
    employmentStatusDesc: 'أخبرنا عن وضعك الوظيفي الحالي.',
    unemployedInfo: 'لقد اخترت "عاطل عن العمل". التفاصيل الإضافية عن العمل غير مطلوبة.',
  
    wocPlacement: 'من خلال دعم التوظيف في WOC',
    wocInternship: 'تدريب/ارتباط صناعي في WOC',
    wocRecommendation: 'توصية من مدربي WOC',
    familyFriends: 'العائلة/الأصدقاء',
    socialMedia: 'وسائل التواصل الاجتماعي',
    onlinePortal: 'بوابة التوظيف عبر الإنترنت',
    walkIn: 'تقديم طلب مباشر',
    newspaper: 'إعلان في الجريدة',
  
    jobRelevanceDesc: 'هل وظيفتك الحالية مرتبطة بالتدريب الذي تلقيته في WOC؟',
  
    jobChallengesDesc: 'ما هي الأسباب الرئيسية لبطالتك؟ (اختر كل ما ينطبق)',
    lackJobOpportunities: 'نقص فرص العمل',
    lackWorkExperience: 'نقص الخبرة العملية',
    insufficientSkills: 'مهارات غير كافية',
    familyResponsibilities: 'مسؤوليات عائلية',
    continuingEducation: 'مواصلة التعليم',
    healthReasons: 'أسباب صحية',
    lackStartupCapital: 'نقص رأس المال لبدء المشروع',
    locationTransport: 'تحديات الموقع/النقل',
  
    entrepreneurshipDesc: 'هل بدأت عملك الخاص بعد التخرج؟',
    employeesEmployed: 'كم عدد الأشخاص الذين وظفتهم؟',
    moreThan5: 'أكثر من 5',
  
    supportNeededDesc: 'ما هو الدعم الذي سيساعدك في تنمية أعمالك؟ (اختر كل ما ينطبق)',
    accessFinance: 'الوصول إلى التمويل',
    businessMentorship: 'التوجيه التجاري',
    marketingSupport: 'الدعم التسويقي',
    advancedTraining: 'التدريب التقني المتقدم',
    equipment: 'المعدات',
    marketLinkage: 'ربط السوق',
    businessRegistration: 'دعم تسجيل الأعمال',
    selectNumber: 'اختر عدداً',
  
    confidenceDesc: 'إلى أي مدى حسّن التدريب في WOC ثقتك وقدرتك على اتخاذ قرارات حياتية مستقلة؟',
  
    financialSupportChanged: 'كيف تغيرت قدرتك على دعم نفسك مالياً؟',
    financialStability: 'مقارنة بما قبل حضور WOC، كيف تقيم استقرارك المالي الحالي؟',
    savedMoney: 'هل تمكنت من الادخار بانتظام منذ إكمال تدريبك؟',
    incomeManagement: 'ما مدى ثقتك في إدارة دخلك الشخصي؟',
  
    communityImpactDesc: 'كيف تصف تأثير تدريب WOC على حياتك ومجتمعك؟',
    leadershipInvolvement: 'هل أصبحت أكثر مشاركة في القيادة أو اتخاذ القرار داخل عائلتك أو مجتمعك بعد التخرج من WOC؟',
  
    editTraineeProfile: 'تعديل ملف المتدرب',
    updateProfile: 'تحديث الملف',
    editing: 'جاري التعديل:',
  
    step: 'الخطوة',
    of: 'من',
    skipped: 'تم تخطيها',
    notApplicable: 'غير قابل للتطبيق',
  
    continue: 'متابعة',
    previous: 'السابق',
    next: 'التالي',
    submit: 'إكمال التسجيل',
    submitting: 'جاري الإرسال...',
    updateProfile: 'تحديث الملف',
  
    noServerResponse: 'لا توجد استجابة من الخادم. يرجى التحقق من اتصالك.',
    registrationFailed: 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
    pleaseFillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
  
    above200k: 'أكثر من 200,000 فرنك رواندي',
    selectOption: 'اختر خياراً',
    selectRating: 'اختر تقييماً',
    selectImpact: 'اختر مستوى التأثير',
    yes: 'نعم',
    no: 'لا',
    none: 'لا شيء',
    selectCohort: 'اختر المجموعة',
    selectDepartment: 'اختر القسم',
    selectStatus: 'اختر الحالة',

    // In arabic section, add:

pleaseFillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
stepErrorBasicInfo: 'يرجى ملء جميع الحقول المطلوبة في المعلومات الأساسية',
stepErrorEmployment: 'يرجى تحديد حالتك الوظيفية',
stepErrorJobSecured: 'يرجى تحديد كيفية حصولك على وظيفتك',
stepSkippedUnemployed: 'لقد اخترت "عاطل عن العمل" في الخطوة السابقة. هذه الخطوة غير قابلة للتطبيق.',
stepSkippedNotUnemployed: 'أنت لست عاطلاً عن العمل. هذه الخطوة غير قابلة للتطبيق.',
stepSkippedNotEntrepreneur: 'لقد اخترت "لا" لريادة الأعمال. هذه الخطوة غير قابلة للتطبيق.',
skipToNextStep: 'تخطي إلى الخطوة التالية',
editTraineeProfile: 'تعديل ملف المتدرب',
updateProfile: 'تحديث الملف',
profileUpdatedSuccess: 'تم تحديث الملف بنجاح!',
profileAddedSuccess: 'تم إضافة الملف بنجاح!',
editing: 'جاري التعديل:',
currentPhotoLabel: 'الصورة الحالية:',
noDepartmentsAvailable: 'لا توجد أقسام متاحة',
noGalleryImages: 'لا توجد صور معرض متاحة حالياً.',
noWomenProfiles: 'لا توجد ملفات تعريف نساء متاحة حالياً.',
noEvents: 'لا توجد أحداث لعرضها',
welcomeToGallery: 'مرحباً بكم في معرضنا',
gallerySubtitle: 'استكشف رحلة تمكين المرأة',
viewAll: 'عرض الكل',
matching: 'مطابقة',
resetFilters: 'إعادة تعيين المرشحات',
noImagesInDatabase: 'لم يتم العثور على صور في قاعدة البيانات. عرض صور عينة.',
errorLoadingImages: 'خطأ في تحميل الصور. عرض صور عينة.',
errorLoadingDepartments: 'خطأ في تحميل الأقسام. استخدام القائمة الافتراضية.',
unknownDepartment: 'قسم غير معروف',
noImagesForDepartment: 'لا توجد صور متاحة لهذا القسم حتى الآن.',
clickToView: 'انقر للمشاهدة',
department: 'القسم',
category: 'التصنيف',
date: 'التاريخ',
close: 'إغلاق',
viewDetails: 'عرض التفاصيل',
viewAllDepartments: 'عرض جميع الأقسام',
viewAllWomen: 'عرض جميع النساء',
loadMoreImages: 'تحميل المزيد من الصور',
noDescription: 'لا يوجد وصف متاح',
featured: 'مميز',

    // Search Bar Translations - ARABIC
searchPlaceholder: 'ابحث عن النساء، الأقسام، الأنشطة...',
trainedWomen: 'النساء المدربات',
trainingDepartments: 'أقسام التدريب',
activities: 'الأنشطة',
galleryImages: 'صور المعرض',
viewAllResults: 'عرض جميع النتائج لـ',
searchResultsFor: 'نتائج البحث عن ',
viewAllItems: 'عرض جميع ←',
noResultsFound: 'لم يتم العثور على نتائج لـ',
trySearchingFor: 'حاول البحث عن:',
searchSuggestions: 'خياطة، طبخ، زراعة، حرف يدوية، جلود',
viewCompleteSearchResults: 'عرض جميع نتائج البحث',
    // Trainee Registration - Additional Fields Translations - ARABIC
enterName: 'أدخل الاسم الكامل',
enterAge: 'العمر',
enterPhone: '+250 78X XXX XXX',
enterEmail: 'email@example.com',
enterPlacementLocation: 'المدينة، المنطقة، البلد',
enterCompetenceSkills: 'مثال: مهارات الكمبيوتر، اتخاذ القرار، القيادة',
separateWithCommas: 'افصل المهارات المتعددة بفواصل',
enterCompanyName: 'اسم الشركة/المؤسسة',
enterWorkingPosition: 'المسمى الوظيفي',
enterWorkingLocation: 'مكان العمل',
enterYears: 'سنوات',
enterLocation: 'الموقع الحالي',
enterBio: 'سيرة ذاتية مختصرة',
selectJobSecured: 'اختر كيف حصلت على وظيفتك',
selectChallenges: 'اختر كل ما ينطبق',
selectSupport: 'ما هو الدعم الذي سيساعدك في تنمية أعمالك؟ اختر كل ما ينطبق',
selectOption: 'اختر خياراً',
selectNumber: 'اختر عدداً',
selectRating: 'اختر تقييماً',
selectImpact: 'اختر مستوى التأثير',
startedBusiness: 'هل بدأت عملك الخاص بعد التخرج؟',
employeesEmployed: 'كم عدد الأشخاص الذين وظفتهم؟',
none: 'لا شيء',
moreThan5: 'أكثر من 5',
yes: 'نعم',
no: 'لا',
saving: 'جاري الحفظ...',
educationAndBio: 'التعليم والسيرة الذاتية',
confidenceImproved: 'إلى أي مدى حسّن التدريب ثقتك بنفسك؟',
financialSupportChanged: 'كيف تغيرت قدرتك على دعم نفسك مالياً؟',
financialStability: 'مقارنة بما قبل التدريب، كيف تقيم استقرارك المالي؟',
savedMoney: 'هل تمكنت من الادخار بانتظام منذ التدريب؟',
incomeManagement: 'ما مدى ثقتك في إدارة دخلك الشخصي؟',
communityImpactDesc: 'كيف تصف تأثير تدريب WOC على حياتك ومجتمعك؟',
leadershipInvolvement: 'هل أصبحت أكثر مشاركة في القيادة أو اتخاذ القرار؟',
currentPhoto: 'الصورة الحالية',
yesEveryMonth: 'نعم، كل شهر',
yesOccasionally: 'نعم، أحياناً',
noButPlan: 'لا، لكنني أخطط للقيام بذلك',
notChanged: 'لم يتغير',
worsened: 'تدهور',
fullyIndependent: 'مستقل مالياً بالكامل',
significantlyContribute: 'أساهم بشكل كبير في الأسرة',
occasionallyContribute: 'أساهم أحياناً في الأسرة',
muchBetter: 'أفضل بكثير',
better: 'أفضل',
same: 'نفس الشيء تقريباً',
worse: 'أسوأ',
muchWorse: 'أسوأ بكثير',
veryGreatExtent: 'إلى حد كبير جداً',
greatExtent: 'إلى حد كبير',
moderateExtent: 'إلى حد معتدل',
smallExtent: 'إلى حد ضئيل',
notAtAll: 'إطلاقاً',
veryConfident: 'واثق جداً',
confident: 'واثق',
moderatelyConfident: 'واثق بشكل معتدل',
slightlyConfident: 'واثق بشكل طفيف',
notConfident: 'غير واثق إطلاقاً',
transformational: 'تحولي',
significantPositive: 'تأثير إيجابي كبير',
moderatePositive: 'تأثير إيجابي معتدل',
slightPositive: 'تأثير إيجابي طفيف',
noImpact: 'لا تأثير ملحوظ',
significantly: 'نعم، بشكل كبير',
toSomeExtent: 'نعم، إلى حد ما',
noChange: 'لا تغيير',
lessInvolved: 'أقل مشاركة من قبل',

    // Trainee Registration Translations - ARABIC
traineeRegister: 'سجل كمتدرب',
traineeRegistration: 'تسجيل المتدرب',
basicInformation: 'المعلومات الأساسية',
employmentStatus: 'الحالة الوظيفية',
jobSecured: 'كيف حصلت على الوظيفة',
jobRelevance: 'ملاءمة الوظيفة',
jobChallenges: 'تحديات البحث عن عمل',
entrepreneurship: 'ريادة الأعمال',
supportNeeded: 'الدعم المطلوب',
confidenceImpact: 'الثقة والتأثير',
financialSituation: 'الوضع المالي',
communityImpact: 'التأثير المجتمعي',
registrationComplete: 'اكتمل التسجيل!',
thankYouRegistration: 'شكراً لإكمال تسجيلك.',
registrationSuccess: 'تم حفظ معلوماتك بنجاح.',
registrationSuccessSub: 'يمكنك الآن الوصول إلى جميع ميزات المنصة.',
previous: 'السابق',
next: 'التالي',
submit: 'إكمال التسجيل',
submitting: 'جاري الإرسال...',
fullName: 'الاسم الكامل',
age: 'العمر',
cohort: 'المجموعة',
placementLocation: 'موقع التوظيف',
competenceSkills: 'المهارات الكفاءة',
profilePhoto: 'الصورة الشخصية',
employmentSector: 'قطاع العمل',
companyName: 'اسم الشركة',
workingPosition: 'المنصب الوظيفي',
workingLocation: 'موقع العمل',
modeOfEmployment: 'نوع التوظيف',
yearsOfExperience: 'سنوات الخبرة',
monthlyIncome: 'الدخل الشهري التقريبي',
contractStartDate: 'تاريخ بداية العقد',
contractEndDate: 'تاريخ نهاية العقد',
selectCohort: 'اختر المجموعة',
selectDepartment: 'اختر القسم',
selectStatus: 'اختر الحالة',
selectSector: 'اختر القطاع',
selectMode: 'اختر النوع',
selectIncome: 'اختر النطاق',
selectRelevance: 'اختر الملاءمة',
selectConfidence: 'اختر مستوى الثقة',
selfEmployed: 'عمل حر',
unemployed: 'عاطل عن العمل',
employedByCompany: 'موظف في شركة',
workForOthers: 'يعمل لدى آخرين',
continuingTraining: 'تدريب مستمر',
publicSector: 'قطاع عام',
privateSector: 'قطاع خاص',
ngo: 'منظمة غير حكومية',
other: 'أخرى',
permanent: 'وظيفة دائمة',
internship: 'تدريب داخلي',
partTime: 'عقد دوام جزئي',
volunteer: 'متطوع',
directlyRelated: 'مرتبط مباشرة',
somewhatRelated: 'مرتبط إلى حد ما',
notRelated: 'غير مرتبط',
veryGreatExtent: 'إلى حد كبير جداً',
greatExtent: 'إلى حد كبير',
moderateExtent: 'إلى حد معتدل',
smallExtent: 'إلى حد ضئيل',
notAtAll: 'إطلاقاً',
fullyIndependent: 'أنا الآن مستقلة مادياً بشكل كامل',
significantlyContribute: 'أنا أساهم بشكل كبير في دخل أسرتي',
occasionallyContribute: 'أنا أساهم أحياناً في دخل أسرتي',
notChanged: 'لم يتغير وضعي المالي',
worsened: 'تدهور وضعي المالي',
muchBetter: 'أفضل بكثير',
better: 'أفضل',
same: 'نفس الشيء تقريباً',
worse: 'أسوأ',
muchWorse: 'أسوأ بكثير',
yesEveryMonth: 'نعم، كل شهر',
yesOccasionally: 'نعم، أحياناً',
noButPlan: 'لا، لكنني أخطط للقيام بذلك',
no: 'لا',
veryConfident: 'واثقة جداً',
confident: 'واثقة',
moderatelyConfident: 'واثقة بشكل معتدل',
slightlyConfident: 'واثقة بشكل طفيف',
notConfident: 'غير واثقة إطلاقاً',
transformational: 'تحولي',
significantPositive: 'تأثير إيجابي كبير',
moderatePositive: 'تأثير إيجابي معتدل',
slightPositive: 'تأثير إيجابي طفيف',
noImpact: 'لا تأثير ملحوظ',
significantly: 'نعم، بشكل كبير',
toSomeExtent: 'نعم، إلى حد ما',
noChange: 'لا تغيير',
lessInvolved: 'أقل مشاركة من قبل',
confirmToggleStatus: 'تبديل الحالة',
confirmToggleTraineeStatus: 'هل أنت متأكد من رغبتك في تبديل حالة هذا المتدرب؟ لن يظهر المتدربون غير النشطين على الصفحة الرئيسية.',
traineeActivated: 'تم تفعيل المتدرب بنجاح',
traineeDeactivated: 'تم إلغاء تفعيل المتدرب بنجاح',
failedToggleTraineeStatus: 'فشل تبديل حالة المتدرب',
traineeInactive: 'المتدرب غير نشط',
    homepageManagement: 'إدارة الصفحة الرئيسية',
heroSlides: 'شرائح الهيرو',
addHeroSlide: 'إضافة شريحة هيرو',
editHeroSlide: 'تعديل شريحة الهيرو',
noHeroSlides: 'لا توجد شرائح هيرو',
addHeroSlidesDesc: 'أضف شرائح لعرضها في قسم الهيرو بالصفحة الرئيسية',
stats: 'الإحصائيات',
noStats: 'لا توجد إحصائيات',
addStatsDesc: 'أضف إحصائيات لعرضها على الصفحة الرئيسية',
addStat: 'إضافة إحصائية',
editStat: 'تعديل الإحصائية',
statAdded: 'تمت إضافة الإحصائية بنجاح',
statUpdated: 'تم تحديث الإحصائية بنجاح',
statDeleted: 'تم حذف الإحصائية بنجاح',
confirmDeleteStat: 'هل أنت متأكد من رغبتك في حذف هذه الإحصائية؟',
confirmDeleteStatTitle: 'حذف الإحصائية',
heroSlideAdded: 'تمت إضافة شريحة الهيرو بنجاح',
heroSlideUpdated: 'تم تحديث شريحة الهيرو بنجاح',
heroSlideDeleted: 'تم حذف شريحة الهيرو بنجاح',
heroSlideStatusToggled: 'تم تحديث حالة شريحة الهيرو',
failedAddHeroSlide: 'فشل في إضافة شريحة الهيرو',
failedUpdateHeroSlide: 'فشل في تحديث شريحة الهيرو',
failedDeleteHeroSlide: 'فشل في حذف شريحة الهيرو',
failedToggleHeroSlideStatus: 'فشل في تحديث حالة شريحة الهيرو',
confirmDeleteHeroSlideTitle: 'حذف شريحة الهيرو',
confirmDeleteHeroSlide: 'هل أنت متأكد من رغبتك في حذف شريحة الهيرو هذه؟',
failedLoadHeroSlides: 'فشل في تحميل شرائح الهيرو',
failedLoadStats: 'فشل في تحميل الإحصائيات',
failedAddStat: 'فشل في إضافة الإحصائية',
failedUpdateStat: 'فشل في تحديث الإحصائية',
failedDeleteStat: 'فشل في حذف الإحصائية',

activityImages: 'صور النشاط',
activityImagesManagement: 'إدارة صور النشاط',
addActivityImage: 'إضافة صورة نشاط',
editActivityImage: 'تعديل صورة النشاط',
activityImageAdded: 'تمت إضافة صورة النشاط بنجاح',
activityImageUpdated: 'تم تحديث صورة النشاط بنجاح',
activityImageDeleted: 'تم حذف صورة النشاط بنجاح',
activityImageStatusToggled: 'تم تحديث حالة صورة النشاط',
confirmDeleteActivityImage: 'هل أنت متأكد من رغبتك في حذف صورة النشاط هذه؟',
searchActivityImages: 'البحث عن صور النشاط...',
bulkUpload: 'رفع متعدد',
bulkUploadImages: 'رفع صور متعددة',
bulkUploadComplete: 'اكتمل الرفع المتعدد بنجاح',
failedBulkUpload: 'فشل الرفع المتعدد',
selectImagesToUpload: 'الرجاء تحديد صور للرفع',
selectedFiles: 'الملفات المحددة',
uploadAll: 'رفع الكل',
uploading: 'جاري الرفع...',
imageRequired: 'ملف الصورة مطلوب',
failedAddActivityImage: 'فشل في إضافة صورة النشاط',
failedUpdateActivityImage: 'فشل في تحديث صورة النشاط',
failedDeleteImage: 'فشل في حذف الصورة',
imageDeleted: 'تم حذف الصورة بنجاح',
imageRestored: 'تم استعادة الصورة بنجاح',
failedRestoreImage: 'فشل في استعادة الصورة',
imageStatusToggled: 'تم تحديث حالة الصورة',
failedToggleImageStatus: 'فشل في تحديث حالة الصورة',
failedLoadActivityImages: 'فشل في تحميل صور النشاط',
exportActivityImages: 'تصدير صور النشاط',
activityImagesExported: 'تم تصدير صور النشاط بنجاح',
failedExportActivityImages: 'فشل في تصدير صور النشاط',
womenInAction: 'النساء في العمل',
totalImages: 'إجمالي الصور',
activeImages: 'الصور النشطة',
departmentsWithImages: 'الأقسام التي تحتوي على صور',
lastUpload: 'آخر رفع',
never: 'أبداً',
noActivityImages: 'لم يتم العثور على صور نشاط',
addActivityImagesDesc: 'أضف صورًا لعرضها في قسم النساء في العمل على الصفحة الرئيسية',
    whyChooseUs: "لماذا تختارنا",
    added: "تمت إضافة العنصر بنجاح",
    updated: "تم تحديث العنصر بنجاح",
    deleted: "تم حذف العنصر بنجاح",
    statusToggled: "تم تحديث الحالة بنجاح",
    failedAdd: "فشل في إضافة العنصر",
    failedUpdate: "فشل في تحديث العنصر",
    failedDelete: "فشل في حذف العنصر",
    failedToggle: "فشل في تحديث الحالة",
    videoSections: "أقسام الفيديو",
    addVideo: "إضافة فيديو",
    editVideo: "تعديل الفيديو",
    noVideos: "لا توجد أقسام فيديو",
    addVideos: "أضف فيديوهات لعرضها على الصفحة الرئيسية",
    videoUrl: "رابط الفيديو",
    thumbnail: "صورة مصغرة",
    setAsActive: "تعيين كفيديو نشط",
    onlyOneActive: "يمكن لفيديو واحد فقط أن يكون نشطًا في كل مرة",
    currentThumbnail: "الصورة المصغرة الحالية",
    watchVideo: "شاهد الفيديو",
    playVideo: "تشغيل الفيديو",
    active: "نشط",
    inactive: "غير نشط",
    untitled: "بدون عنوان",
    youtubeEmbedUrl: "استخدم رابط تضمين YouTube (مثال: https://www.youtube.com/embed/VIDEO_ID)",
    enterVideoTitle: "أدخل عنوان الفيديو",
    enterVideoDescription: "أدخل وصف الفيديو",
    setActive: "تعيين كنشط",

    whyChooseUsItems: "عناصر لماذا تختارنا",
    addItem: "إضافة عنصر",
    editItem: "تعديل العنصر",
    noWhyChooseUsItems: "لا توجد عناصر لماذا تختارنا",
    addWhyChooseUsItems: "أضف عناصر لعرضها على الصفحة الرئيسية",
    icon: "أيقونة",
    title: "العنوان",
    description: "الوصف",
    sortOrder: "ترتيب الفرز",
    status: "الحالة",
    actions: "الإجراءات",
    iconPreview: "معاينة الأيقونة",
    enterTitle: "أدخل العنوان",
    enterDescription: "أدخل الوصف",
    currentPassword: 'كلمة المرور الحالية',
enterCurrentPassword: 'أدخل كلمة المرور الحالية',
passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
passwordTooShort: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
passwordChanged: 'تم تغيير كلمة المرور بنجاح!',
failedChangePassword: 'فشل تغيير كلمة المرور',
changing: 'جاري التغيير...',
changePassword: 'تغيير كلمة المرور',
    // Contract Management Translations
contracts: 'عقودي',
activeContracts: 'العقود النشطة',
contractHistory: 'سجل العقود',
completedContracts: 'مكتملة',
expiringSoon: 'تنتهي قريباً',
noActiveContracts: 'لا توجد عقود نشطة',
noActiveContractsDesc: 'ليس لديك أي عقود نشطة في الوقت الحالي.',
noContractHistory: 'لا يوجد سجل للعقود',
noContractHistoryDesc: 'ليس لديك أي عقود مكتملة أو منتهية.',
contractDetails: 'تفاصيل العقد',
contractId: 'معرف العقد',
period: 'الفترة',
startDate: 'تاريخ البدء',
endDate: 'تاريخ الانتهاء',
daysRemaining: 'الأيام المتبقية',
status: 'الحالة',
terminationReason: 'سبب الإنهاء',
renew: 'تجديد',
renewNow: 'تجديد الآن',
terminate: 'إنهاء',
viewDetails: 'عرض التفاصيل',
renewContract: 'تجديد العقد',
terminateContract: 'إنهاء العقد',
renewContractInfo: 'العقد الحالي ينتهي في:',
selectContractPeriod: 'اختر فترة العقد',
customMonths: 'أشهر مخصصة...',
months: 'أشهر',
sendEmailNotification: 'إرسال تأكيد عبر البريد الإلكتروني',
renewContractNote: 'سيؤدي تجديد العقد إلى إنشاء فترة عقد جديدة. سيتم وضع علامة على العقد الحالي كمجدّد.',
renewing: 'جاري التجديد...',
terminating: 'جاري الإنهاء...',
warning: 'تحذير',
terminateContractWarning: 'لا يمكن التراجع عن هذا الإجراء.',
selectReason: 'اختر سبباً',
workCompleted: 'العمل مكتمل',
performance: 'مشاكل في الأداء',
budgetConstraints: 'قيود الميزانية',
restructuring: 'إعادة هيكلة الشركة',
mutualAgreement: 'اتفاق متبادل',
other: 'أخرى',
customReason: 'سبب مخصص',
enterTerminationReason: 'أدخل سبب الإنهاء',
effectiveDate: 'تاريخ السريان',
effectiveDateNote: 'اتركه فارغاً للإنهاء الفوري',
sendTerminationEmail: 'إرسال بريد إلكتروني لتأكيد الإنهاء',
womanInformation: 'معلومات المرأة',
name: 'الاسم',
age: 'العمر',
department: 'القسم',
skills: 'المهارات',
experience: 'الخبرة',
years: 'سنوات',
phone: 'الهاتف',
email: 'البريد الإلكتروني',
contractInformation: 'معلومات العقد',
terminationDetails: 'تفاصيل الإنهاء',
terminatedOn: 'تم الإنهاء في',
renewalInformation: 'معلومات التجديد',
renewedFrom: 'تم التجديد من',
renewedTo: 'تم التجديد إلى',
notes: 'ملاحظات',
close: 'إغلاق',
expired: 'منتهي',
active: 'نشط',
searchContracts: 'البحث عن عقود...',
refresh: 'تحديث',
viewAll: 'عرض الكل',
exportList: 'تصدير القائمة',
exportSuccessful: 'تم التصدير بنجاح',
exportFailed: 'فشل التصدير. يرجى المحاولة مرة أخرى.',
exportingContracts: 'جاري تصدير العقود...',
    exportOptions: 'خيارات التصدير',
exportAsCSV: 'تصدير كـ CSV',
exportAsExcel: 'تصدير كـ Excel',
exportAsPDF: 'تصدير كـ PDF',
exportSuccessful: 'تم التصدير بنجاح',
exportFailed: 'فشل التصدير. يرجى المحاولة مرة أخرى.',
exportingContracts: 'جاري تصدير العقود...',
    contractExpiration: 'انتهاء العقد',
showContractsExpiringIn: 'عرض العقود المنتهية خلال',
days: 'أيام',
refresh: 'تحديث',
manageAllContracts: 'إدارة جميع العقود',
activeContracts: 'العقود النشطة',
expiringThisMonth: 'المنتهية هذا الشهر',
renewedThisMonth: 'المجددة هذا الشهر',
expiringNextMonth: 'المنتهية الشهر القادم',
noExpiringContracts: 'لا توجد عقود منتهية',
noContractsExpiringSoon: 'لا توجد عقود تنتهي في الفترة المحددة.',
contractsExpiringInNext: 'عقدًا ستنتهي خلال',
woman: 'المرأة',
department: 'القسم',
contractPeriod: 'فترة العقد',
startDate: 'تاريخ البدء',
endDate: 'تاريخ الانتهاء',
daysRemaining: 'الأيام المتبقية',
employer: 'صاحب العمل',
contact: 'الاتصال',
actions: 'الإجراءات',
noPhone: 'لا يوجد هاتف',
general: 'عام',
months: 'أشهر',
sendEmail: 'إرسال بريد إلكتروني',
call: 'اتصال',
viewDetails: 'عرض التفاصيل',
sendReminder: 'إرسال تذكير',
extendContract: 'تمديد العقد',
exportExpiringContracts: 'تصدير القائمة',

// Additional export-related translations
exportContracts: 'تصدير العقود',
exportAsCSV: 'تصدير كـ CSV',
exportAsExcel: 'تصدير كـ Excel',
exportAsPDF: 'تصدير كـ PDF',
exportingContracts: 'جاري تصدير العقود...',
exportSuccessful: 'تم التصدير بنجاح',
exportFailed: 'فشل التصدير. يرجى المحاولة مرة أخرى.',
downloadExportedFile: 'تنزيل الملف المصدر',
selectExportFormat: 'اختر تنسيق التصدير',
includeInactiveContracts: 'تضمين العقود غير النشطة',
exportAllContracts: 'تصدير جميع العقود',
exportFilteredContracts: 'تصدير العقود المصفاة',
contractExportTitle: 'تصدير العقود',
generatingExport: 'جاري إنشاء ملف التصدير...',
contractList: 'قائمة العقود',
totalContracts: 'إجمالي العقود',
exportDate: 'تاريخ التصدير',
exportedBy: 'تم التصدير بواسطة',
contractDetails: 'تفاصيل العقد',
womanName: 'اسم المرأة',
employerName: 'اسم صاحب العمل',
employerEmail: 'البريد الإلكتروني لصاحب العمل',
employerPhone: 'هاتف صاحب العمل',
contractStart: 'بداية العقد',
contractEnd: 'نهاية العقد',
contractMonths: 'أشهر العقد',
status: 'الحالة',
active: 'نشط',
expired: 'منتهي',
expiringSoon: 'سينتهي قريباً',
critical: 'حرج',
warning: 'تحذير',
good: 'جيد',
exportSummary: 'ملخص التصدير',
rowsExported: 'صف تم تصديرها',
exportTime: 'وقت التصدير',
contractStats: 'إحصائيات العقود',
fetchingContracts: 'جاري جلب العقود...',
noContractsFound: 'لم يتم العثور على عقود',
viewContract: 'عرض العقد',
contractId: 'معرف العقد',
contractStatus: 'حالة العقد',
renewContract: 'تجديد العقد',
contractRenewed: 'تم تجديد العقد بنجاح',
renewalDate: 'تاريخ التجديد',
previousContract: 'العقد السابق',
nextContract: 'العقد التالي',
contractHistory: 'سجل العقد',
renewalHistory: 'سجل التجديد',
confirmRenewContract: 'هل أنت متأكد من رغبتك في تجديد هذا العقد؟',
enterRenewalMonths: 'أدخل عدد أشهر التجديد',
renewalPeriod: 'فترة التجديد',
newEndDate: 'تاريخ الانتهاء الجديد',
contractNotes: 'ملاحظات العقد',
addContractNote: 'إضافة ملاحظة',
viewAllContracts: 'عرض جميع العقود',
filterContracts: 'تصفية العقود',
searchContracts: 'البحث عن عقود...',
clearFilters: 'مسح التصفية',
applyFilters: 'تطبيق التصفية',
     // Partners Management - Arabic
     partners: 'الشركاء والرعاة',
     partnersManagement: 'إدارة الشركاء',
     addPartner: 'إضافة شريك',
     editPartner: 'تعديل الشريك',
     partnerName: 'اسم الشريك',
     partnerType: 'نوع الشريك',
     partnerLogo: 'شعار الشريك',
     websiteUrl: 'رابط الموقع الإلكتروني',
     sortOrder: 'ترتيب الفرز',
     enterPartnerName: 'أدخل اسم الشريك/المؤسسة',
     selectType: 'اختر نوع الشريك',
     enterPartnerDescription: 'أدخل وصف الشريك',
     currentLogo: 'الشعار الحالي',
     updatePartner: 'تحديث الشريك',
     failedAddPartner: 'فشل في إضافة الشريك',
     failedUpdatePartner: 'فشل في تحديث الشريك',
     failedDeletePartner: 'فشل في حذف الشريك',
     failedLoadPartners: 'فشل في تحميل الشركاء',
     failedTogglePartnerStatus: 'فشل في تبديل حالة الشريك',
     partnerAdded: 'تمت إضافة الشريك بنجاح',
     partnerUpdated: 'تم تحديث الشريك بنجاح',
     partnerDeleted: 'تم حذف الشريك بنجاح',
     partnerStatusToggled: 'تم تحديث حالة الشريك بنجاح',
     confirmDeletePartnerTitle: 'حذف الشريك',
     confirmDeletePartner: 'هل أنت متأكد من رغبتك في حذف هذا الشريك؟ لا يمكن التراجع عن هذا الإجراء.',
     searchPartners: 'البحث عن شركاء...',
     allTypes: 'جميع الأنواع',
     noPartnersFound: 'لم يتم العثور على شركاء',
     noPartnersMatchCriteria: 'لا يوجد شركاء يطابقون معايير البحث',
     showingPartners: 'عرض {showing} من {total} شريك',
     deactivate: 'إلغاء التنشيط',
     activate: 'تنشيط',
     visit: 'زيارة',
     noDescription: 'لا يوجد وصف',
     partnerDescriptionDefault: 'منظمة شريكة',
     visitWebsite: 'زيارة الموقع الإلكتروني',
     government: 'حكومي',
     internationalNGO: 'منظمة غير حكومية دولية',
     localNGO: 'منظمة غير حكومية محلية',
     corporate: 'شركة',
     private: 'خاص',
     educational: 'تعليمي',
     other: 'آخر',
     partnersCount: 'عدد الشركاء',
     activePartners: 'الشركاء النشطون',
     inactivePartners: 'الشركاء غير النشطين',
     partnerStats: 'إحصائيات الشركاء',
     exportPartners: 'تصدير الشركاء',
     importPartners: 'استيراد الشركاء',
     partnerDetails: 'تفاصيل الشريك',
     establishedDate: 'تاريخ التأسيس',
     lastUpdated: 'آخر تحديث',
    amountNote: 'مبلغ ثابت قدره ١٠,٠٠٠ فرنك رواندي لكل امرأة، بغض النظر عن مدة العقد',
    enterEmailAddress: 'الرجاء إدخال عنوان بريدك الإلكتروني',
    resetEmailSent: 'تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور. يرجى التحقق من صندوق الوارد الخاص بك.',
    resetRequestFailed: 'فشل معالجة طلب إعادة التعيين. يرجى المحاولة مرة أخرى.',
    forgotPasswordDescription: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك',
    backToLogin: 'العودة إلى تسجيل الدخول',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    sending: 'جارٍ الإرسال...',
    resetInstructions: 'سوف تتلقى بريدًا إلكترونيًا يحتوي على رابط لإعادة تعيين كلمة المرور الخاصة بك. سينتهي الرابط خلال ساعة واحدة.',
    
    // Privacy Policy
    // Arabic (العربية)
    contractPeriod: 'فترة العقد',
    selectContractPeriod: 'اختر فترة العقد',
    requiredSkills: 'المهارات المطلوبة',
    selectRelevantSkills: 'اختر المهارات المناسبة لهذا المنصب',
    noSkillsForDepartment: 'لا توجد مهارات متاحة لهذا القسم',
    expiringContracts: 'العقود المنتهية',
    showContractsExpiringIn: 'عرض العقود المنتهية خلال:',
    noExpiringContracts: 'لا توجد عقود منتهية',
    noContractsExpiringSoon: 'لا توجد عقود تنتهي قريباً',
    daysRemaining: 'الأيام المتبقية',
    daysLeft: 'أيام متبقية',
    sendReminder: 'إرسال تذكير',
    renewContract: 'تجديد العقد',
    contractRenewed: 'تم تجديد العقد بنجاح',
    months: 'أشهر',
    
    csvTemplateInstructions: 'يجب أن يحتوي ملف CSV على الأعمدة: الاسم, العمر, القسم, المهارات, سنوات الخبرة, مستوى التعليم, الهاتف, البريد الإلكتروني, الموقع, السيرة الذاتية, أسماء المهارات',
    importInstructions: 'قم بتنزيل القالب لضمان التنسيق الصحيح',
    downloadTemplate: 'تنزيل القالب',
    importing: 'جاري الاستيراد...',
    import: 'استيراد',
    importProfiles: 'استيراد الملفات الشخصية',
    cannotAssignDifferentDept: 'لا يمكن تعيين نساء من أقسام مختلفة',
    validationFailed: 'فشل التحقق',
    viewCertificate: 'عرض الشهادة',
    certified: 'معتمد',
    certificatePending: 'شهادة قيد الانتظار',
    requestThisWoman: 'طلب هذه المرأة',
    currentlyEmployed: 'تعمل حالياً',
    
    '3 months': '3 أشهر',
    '6 months': '6 أشهر',
    '1 year': 'سنة واحدة',
    '2 years': 'سنتين',
    '3 years': '3 سنوات',
    
    beginner: 'مبتدئ',
    intermediate: 'متوسط',
    advanced: 'متقدم',
    expert: 'خبير',
    
    sendCustomEmail: 'إرسال بريد إلكتروني مخصص',
    emailRecipients: 'مستلمو البريد الإلكتروني',
    enterEmailRecipients: 'أدخل عناوين البريد الإلكتروني (مفصولة بفواصل)',
    commaSeparatedEmails: 'أدخل عناوين بريد إلكتروني متعددة مفصولة بفواصل',
    customEmailDescription: 'أرسل رسائل بريد إلكتروني إلى أي عناوين بريد إلكتروني (لا تقتصر على مستخدمي النظام)',
    allFieldsRequired: 'جميع الحقول مطلوبة',
    invalidEmails: 'عناوين بريد إلكتروني غير صالحة',
    emailSentSuccessfully: 'تم إرسال البريد الإلكتروني بنجاح إلى  مستلمين',
    failedToSendEmail: 'فشل إرسال البريد الإلكتروني',
    customEmail: 'بريد إلكتروني مخصص',
    attachments: 'المرفقات',
    maxFileSize: 'الحد الأقصى لحجم الملف',
    uploadCSVFile: 'رفع ملف CSV',
    importWomenProfiles: 'استيراد ملفات تعريف النساء',
    privacyPolicy: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',
    privacyIntroTitle: 'مقدمة',
    privacyIntroText: 'مركز أوروغو لفرص المرأة يقدر خصوصيتك. توضح سياسة الخصوصية هذه كيف نجمع ونستخدم ونحمي معلوماتك الشخصية.',
    informationWeCollect: 'المعلومات التي نجمعها',
    personalInformation: 'معلومات شخصية',
    infoNameEmail: 'الاسم والعنوان البريدي الإلكتروني',
    infoPhoneAddress: 'رقم الهاتف والعنوان الفعلي',
    infoPaymentDetails: 'معلومات الدفع للتبرعات',
    infoEmploymentHistory: 'تاريخ العمل ومعلومات المهارات',
    usageData: 'بيانات الاستخدام',
    dataIPAddress: 'عنوان IP ونوع المتصفح',
    dataBrowserType: 'معلومات الجهاز',
    dataPagesVisited: 'الصفحات التي تمت زيارتها والوقت المستغرق',
    dataTimeSpent: 'معلومات الموقع الإلكتروني المرجعي',
    howWeUseInformation: 'كيف نستخدم معلوماتك',
    useProvideServices: 'لتقديم وصيانة خدماتنا',
    useProcessDonations: 'لمعالجة التبرعات والمدفوعات',
    useMatchEmployees: 'لمطابقة النساء بفرص العمل',
    useCommunication: 'للتواصل معك',
    useImproveServices: 'لتحسين خدماتنا وموقعنا الإلكتروني',
    useLegalCompliance: 'للامتثال للالتزامات القانونية',
    informationSharing: 'مشاركة المعلومات',
    sharingIntro: 'نحن لا نبيع معلوماتك الشخصية. نشارك المعلومات فقط في الحالات التالية:',
    withEmployers: 'مع أصحاب العمل',
    sharingEmployers: 'فقط بموافقتك لمطابقة الوظائف',
    withServiceProviders: 'مع مقدمي الخدمات',
    sharingProviders: 'شركاء موثوق بهم يساعدون في عملياتنا',
    legalRequirements: 'المتطلبات القانونية',
    sharingLegal: 'عندما يقتضي القانون أو الإجراء القانوني',
    withConsent: 'بموافقتك',
    sharingConsent: 'عندما تمنحنا الإذن صراحة',
    dataSecurity: 'أمان البيانات',
    securityMeasures: 'ننفذ تدابير أمنية مناسبة لحماية معلوماتك.',
    securityEncryption: 'التشفير SSL لنقل البيانات',
    securityAccessControl: 'ضوابط الوصول والمصادقة',
    securityRegularAudits: 'عمليات تدقيق أمنية منتظمة',
    securityTraining: 'تدريب الموظفين على الخصوصية',
    yourRights: 'حقوقك',
    rightAccess: 'الحق في الوصول إلى بياناتك الشخصية',
    rightCorrection: 'الحق في تصحيح البيانات غير الدقيقة',
    rightDeletion: 'الحق في حذف بياناتك',
    rightObject: 'الحق في الاعتراض على المعالجة',
    rightDataPortability: 'الحق في نقل البيانات',
    rightWithdrawConsent: 'الحق في سحب الموافقة',
    cookies: 'ملفات تعريف الارتباط',
    cookiesDescription: 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا الإلكتروني.',
    essentialCookies: 'ملفات تعريف الارتباط الأساسية',
    essentialCookiesDesc: 'ضرورية لوظائف الموقع الأساسية',
    analyticsCookies: 'ملفات تعريف الارتباط التحليلية',
    analyticsCookiesDesc: 'تساعدنا على فهم كيفية استخدام الزوار لموقعنا',
    preferenceCookies: 'ملفات تعريف الارتباط التفضيلية',
    preferenceCookiesDesc: 'تتذكر إعداداتك وتفضيلاتك',
    childrenPrivacy: 'خصوصية الأطفال',
    childrenPrivacyText: 'خدماتنا لا تستهدف الأطفال تحت سن 18 عاماً.',
    changesToPolicy: 'تغييرات على سياسة الخصوصية هذه',
    policyChangesText: 'قد نقوم بتحديث سياسة الخصوصية لدينا بشكل دوري.',
    contactUsPrivacy: 'اتصل بنا',
    contactPrivacyText: 'إذا كان لديك أسئلة حول سياسة الخصوصية هذه، اتصل بنا على:',
    
    // Terms of Service
    termsOfService: 'شروط الخدمة',
    termsAgreement: 'الموافقة على الشروط',
    termsAgreementText: 'بالوصول إلى منصتنا واستخدامها، فإنك توافق على شروط الخدمة هذه.',
    definitions: 'تعريفات',
    platform: 'المنصة',
    platformDefinition: 'موقع أوروغو WOC الإلكتروني والخدمات',
    services: 'الخدمات',
    servicesDefinition: 'خدمات مطابقة الوظائف والتدريب والتبرعا',
    user: 'المستخدم',
    userDefinition: 'أي شخص يصل إلى المنصة أو يستخدمها',
    employer: 'صاحب العمل',
    employerDefinition: 'أفراد أو شركات تبحث عن التوظيف',
    employee: 'الموظفة',
    employeeDefinition: 'نساء يبحثن عن فرص عمل',
    donor: 'المتبرع',
    donorDefinition: 'أفراد أو منظمات تقدم تبرعات',
    accountRegistration: 'تسجيل الحساب',
    accountRegistrationText: 'لاستخدام ميزات معينة، يجب عليك تسجيل حساب.',
    accountAgeRequirement: 'يجب أن يكون عمرك 18 سنة على الأقل',
    accountAccurateInfo: 'تقديم معلومات دقيقة وكاملة',
    accountSecurity: 'الحفاظ على أمان الحساب',
    accountTransfer: 'لا تنقل حسابك إلى الآخرين',
    servicesDescription: 'وصف الخدمات',
    employmentServices: 'خدمات التوظيف',
    employmentMatch: 'مطابقة النساء المؤهلات مع أصحاب العمل',
    employmentVerification: 'التحقق من المهارات والمؤهلات',
    employmentTraining: 'التدريب وتطوير المهارات',
    employmentSupport: 'الدعم المستمر للتوظيف',
    donationServices: 'خدمات التبرعات',
    donationProcessing: 'معالجة التبرعات النقدية',
    donationTracking: 'تتبع تأثير التبرعات',
    donationReporting: 'تقارير تأثير منتظمة',
    donationTransparency: 'توزيع الأموال بشفافية',
    userObligations: 'التزامات المستخدم',
    generalUserObligations: 'التزامات المستخدم العامة',
    obeyLaws: 'الامتثال لجميع القوانين واللوائح المعمول بها',
    respectOthers: 'احترام المستخدمين الآخرين وخصوصيتهم',
    noFraud: 'عدم الانخراط في أنشطة احتيالية',
    accurateInfo: 'تقديم معلومات دقيقة',
    noHarassment: 'عدم المضايقة أو التمييز',
    employerObligations: 'التزامات صاحب العمل',
    fairTreatment: 'تقديم شروط عمل عادلة',
    timelyPayment: 'الدفع في الوقت المحدد',
    safeEnvironment: 'توفير بيئة عمل آمنة',
    complianceLaws: 'الامتثال لقوانين العمل',
    employeeObligations: 'التزامات الموظفة',
    professionalConduct: 'الحفاظ على السلوك المهني',
    honestSkills: 'تمثيل المهارات والتوفر بأمانة',
    commitment: 'الوفاء بالتزامات العمل',
    respectEmployer: 'احترام ممتلكات وقواعد صاحب العمل',
    paymentsFees: 'المدفوعات والرسوم',
    serviceFees: 'قد تنطبق رسوم الخدمة على خدمات معينة',
    donationFees: 'رسوم معالجة التبرعات',
    paymentMethods: 'طرق الدفع المقبولة',
    refundPolicy: 'سياسة استرداد الأموال للتبرعات',
    taxResponsibility: 'المسؤوليات الضريبية',
    intellectualProperty: 'الملكية الفكرية',
    ipOwnership: 'نحن نملك جميع حقوق الملكية الفكرية للمنصة.',
    ipLicense: 'نمنحك ترخيصاً محدوداً لاستخدام المنصة.',
    userContentLicense: 'تمنحنا ترخيصاً لاستخدام محتواك لعمليات المنصة.',
    limitationLiability: 'تحديد المسؤولية',
    liabilityDisclaimer: 'نقدم الخدمات "كما هي" بدون ضمانات.',
    liabilityLimit: 'تحديد مسؤوليتنا',
    liabilityForceMajeure: 'أحداث القوة القاهرة',
    termination: 'الإنهاء',
    terminationClause: 'يجوز لنا إنهاء أو تعليق الوصول إلى حسابك.',
    terminationBreach: 'لانتهاك هذه الشروط',
    terminationInactivity: 'لعدم النشاط لفترة طويلة',
    terminationRequest: 'بناءً على طلبك',
    terminationPlatform: 'لصيانة المنصة أو الأمان',
    disputeResolution: 'تسوية المنازعات',
    governingLaw: 'الاختصاص القانوني',
    disputeProcess: 'عملية تسوية المنازعات',
    mediationClause: 'الوساطة قبل التقاضي',
    changesToTerms: 'تغييرات على الشروط',
    termsChangesText: 'يجوز لنا تعديل هذه الشروط في أي وقت.',
    contactUsTerms: 'اتصل بنا',
    contactTermsText: 'لأي أسئلة حول هذه الشروط، اتصل بنا على:',
    
    // Sitemap
    sitemap: 'خريطة الموقع',
    sitemapDescription: 'نظرة عامة كاملة لجميع الصفحات والخدمات المتاحة على Urugo WOC',
    mainPages: 'الصفحات الرئيسية',
    accountPages: 'صفحات الحساب',
    policyPages: 'صفحات السياسات',
    servicePages: 'صفحات الخدمات',
    departmentPages: 'صفحات الأقسام',
    trainingServices: 'خدمات التدريب',
    donationServices: 'خدمات التبرعات',
    supportServices: 'خدمات الدعم',
    contactInformation: 'معلومات الاتصال',
    quickActions: 'إجراءات سريعة',
    donateNow: 'تبرع الآن',
    registerNow: 'سجل الآن',
    totalPages: 'إجمالي الصفحات',
    websiteVersion: 'إصدار الموقع الإلكتروني',
    viewPrivacy: 'عرض سياسة الخصوصية',
    viewTerms: 'عرض شروط الخدمة',
    viewSitemap: 'عرض خريطة الموقع',
    backToHome: 'العودة إلى الصفحة الرئيسية',
    // Modal Alert translations
  alertSuccess: 'نجاح',
  alertError: 'خطأ',
  alertWarning: 'تحذير',
  alertInfo: 'معلومات',
  okButton: 'موافق',
  confirmButton: 'تأكيد',
  cancelButton: 'إلغاء',
  tryAgainButton: 'حاول مرة أخرى',
  close: 'إغلاق',
  
  // Request Modal translations
  step1Title: 'أخبرنا عنك',
  step1Description: 'ابحث عن نساء مدربات في مجتمعنا المتنوع',
  step2Title: 'إنشاء حسابك',
  step2Description: 'انضم إلى مجتمعنا لتوظيف نساء ماهرات',
  loginTitle: 'تسجيل الدخول إلى حسابك',
  loginDescription: 'هل لديك حساب بالفعل؟ قم بتسجيل الدخول للمتابعة',
  step3Title: 'طلب نساء مدربات',
  step3Description: 'املأ النموذج أدناه لطلب نساء ماهرات من مركزنا',
  successTitle: 'تم تقديم الطلب بنجاح!',
  successMessage: 'تم استلام طلبك. سنتواصل معك قريباً.',
  
  // Account types
  individual: 'فرد',
  individualDesc: 'أقوم بالتوظيف لنفسي',
  company: 'شركة',
  companyDesc: 'أقوم بالتوظيف لشركتي',
  
  // Form labels
  companyNameLabel: 'اسم الشركة',
  companyNamePlaceholder: 'أدخل اسم الشركة',
  fullNameLabel: 'الاسم الكامل',
  fullNamePlaceholder: 'أدخل اسمك الكامل',
  usernameLabel: 'اسم المستخدم',
  usernamePlaceholder: 'اختر اسم مستخدم',
  workEmailLabel: 'البريد الإلكتروني للعمل',
  workEmailPlaceholder: 'أدخل بريدك الإلكتروني للعمل',
  phoneLabel: 'رقم الهاتف',
  phonePlaceholder: 'أدخل رقم هاتفك',
  emailLabel: 'عنوان البريد الإلكتروني',
  emailPlaceholder: 'أدخل بريدك الإلكتروني',
  passwordLabel: 'كلمة المرور',
  passwordPlaceholder: 'أدخل كلمة المرور الخاصة بك',
  createPasswordPlaceholder: 'إنشاء كلمة مرور',
  confirmPasswordLabel: 'تأكيد كلمة المرور',
  confirmPasswordPlaceholder: 'تأكيد كلمة المرور الخاصة بك',
  passwordMinLength: 'على الأقل 10 أحرف',
  agreeToTerms: 'أوافق على شروط الخدمة وسياسة الخصوصية',
  
  // Request form
  selectDepartment: 'اختر القسم',
  chooseDepartment: 'اختر قسمًا',
  employeesNeeded: 'عدد الموظفين',
  costPerEmployee: '10000 فرنك رواندي لكل موظف شهرياً',
  workType: 'نوع العمل',
  fullTime: 'دوام كامل',
  partTime: 'دوام جزئي',
  contract: 'عقد',
  seasonal: 'موسمي',
  duration: 'المدة (أيام)',
  days: 'أيام',
  totalAmount: 'المبلغ الإجمالي',
  woman: 'امرأة',
  'employee(s)': 'موظف(ين)',
  personalInformation: 'المعلومات الشخصية',
  yourFullName: 'اسمك الكامل',
  email: 'البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  
  // Specifications
  womanSpecifications: 'مواصفات المرأة (اختياري)',
  specificationsDescription: 'قدم متطلبات إضافية للنساء اللواتي تريد توظيفهن',
  ageRange: 'النطاق العمري المفضل',
  experienceLevel: 'مستوى الخبرة',
  skillLevel: 'مستوى المهارة المطلوب',
  educationLevel: 'المستوى التعليمي',
  languageRequirements: 'متطلبات اللغة',
  specialSkills: 'المهارات الخاصة المطلوبة',
  otherSpecifications: 'مواصفات أخرى',
  noPreference: 'لا توجد تفضيلات',
  years: 'سنوات',
  beginner: 'مبتدئ',
  intermediate: 'متوسط',
  advanced: 'متقدم',
  expert: 'خبير',
  basic: 'مهارات أساسية',
  kinyarwanda: 'كينيارواندا',
  french: 'الفرنسية',
  kinyarwandaEnglish: 'كينيارواندا والإنجليزية',
  anyLanguage: 'أي لغة',
  primary: 'التعليم الابتدائي',
  secondary: 'التعليم الثانوي',
  vocational: 'التدريب المهني',
  university: 'شهادة جامعية',
  specialSkillsPlaceholder: 'مثلاً: مهارات الكمبيوتر، القيادة، إلخ.',
  separateWithCommas: 'افصل بفواصل',
  otherSpecificationsPlaceholder: 'أي متطلبات أو تفضيلات أخرى محددة...',
  
  // Payment
  paymentInformation: 'معلومات الدفع',
  mobileMoney: 'المال المحمول',
  bankAccount: 'الحساب البنكي',
  paymentNote: 'يرجى إكمال الدفع بعد تقديم طلبك. سيتم معالجة طلبك بمجرد التحقق من الدفع.',
  
  // Buttons and actions
  continue: 'متابعة',
  back: 'رجوع',
  backToRegister: 'العودة إلى التسجيل',
  join: 'انضم',
  loggingIn: 'جاري تسجيل الدخول...',
  creatingAccount: 'جاري إنشاء الحساب...',
  submitting: 'جاري التقديم...',
  submitRequest: 'تقديم الطلب',
  alreadyHaveAccount: 'هل لديك حساب بالفعل؟',
  loginHere: 'تسجيل الدخول هنا',
  signIn: 'تسجيل الدخول',
  showPassword: 'إظهار كلمة المرور',
  hidePassword: 'إخفاء كلمة المرور',
  
  // Status messages
  available: 'متاح',
  working: 'يعمل',
  certificateVerified: 'تم التحقق',
  certificateUnverified: 'قيد الانتظار',
  specificWomanRequest: 'أنت تطلب',
  specifically: 'على وجه التحديد',
  singleWomanNote: 'يتم تعيين عدد الموظفين تلقائياً إلى 1 لطلبات المرأة الفردية.',
  requestingWoman: 'أنت تطلب:',
  youRequested: 'طلبت:',
  yourSpecifications: 'مواصفاتك:',
  languages: 'اللغات',
  
  // Error messages
  passwordMismatch: 'كلمات المرور غير متطابقة',
  passwordTooShort: 'يجب أن تكون كلمة المرور 10 أحرف على الأقل',
  registrationFailed: 'فشل التسجيل',
  loginFailed: 'فشل تسجيل الدخول',
  requestFailed: 'فشل تقديم الطلب',
  loginToRequest: 'يرجى تسجيل الدخول لطلب النساء',
  
  // Success messages
  loginSuccess: 'لقد سجلت الدخول إلى حسابك بنجاح.',
  registrationSuccess: 'تم إنشاء حسابك بنجاح!',
  requestSuccess: 'تم تقديم طلبك بنجاح!',
  
  // Step labels
  accountType: 'نوع الحساب',
  account: 'الحساب',
  request: 'الطلب',
    
    // New keys for request specifications
requestManagementWithSpecs: 'إدارة الطلبات (بالمواصفات)',
specifications: 'المواصفات',
noSpecifications: 'لا توجد مواصفات',
viewSpecifications: 'عرض المواصفات',
hasSpecifications: 'لديها مواصفات',
withSpecifications: 'مع المواصفات',
noSpecificationsProvided: 'لم يتم تقديم مواصفات إضافية لهذا الطلب.',
requestDetails: 'تفاصيل الطلب',
employerInformation: 'معلومات صاحب العمل',
statusInformation: 'معلومات الحالة',
employeesNeeded: 'الموظفين المطلوبين',
workType: 'نوع العمل',
duration: 'المدة',
amount: 'المبلغ',
paymentVerified: 'تم التحقق من الدفع',
assignedWomen: 'النساء المعينات',
availableWomen: 'النساء المتاحات',
created: 'تم الإنشاء',
ageRange: 'النطاق العمري',
experienceLevel: 'مستوى الخبرة',
skillLevel: 'مستوى المهارة',
educationLevel: 'المستوى التعليمي',
languageRequirements: 'متطلبات اللغة',
specialSkills: 'مهارات خاصة',
otherSpecifications: 'مواصفات أخرى',
approveRequest: 'الموافقة على الطلب',
rejectRequest: 'رفض الطلب',
assignWomen: 'تعيين نساء',
close: 'إغلاق',

// Certificate related
uploadCertificate: 'تحميل الشهادة',
certificateNumber: 'رقم الشهادة',
certificateType: 'نوع الشهادة',
selectCertificateType: 'اختر نوع الشهادة',
vocationalCertificate: 'شهادة مهنية',
skillCertificate: 'شهادة مهارة',
trainingCertificate: 'شهادة تدريب',
professionalCertificate: 'شهادة احترافية',
otherCertificate: 'شهادة أخرى',
issuingOrganization: 'المنظمة المصدرة',
issueDate: 'تاريخ الإصدار',
expiryDate: 'تاريخ الانتهاء',
certificateFile: 'ملف الشهادة',
maxFileSize: 'الحد الأقصى لحجم الملف',
currentCertificate: 'الشهادة الحالية',
viewCurrentCertificate: 'عرض الشهادة الحالية',
updateCertificate: 'تحديث الشهادة',
certificateVerified: 'شهادة موثقة',
certificateUnverified: 'شهادة غير موثقة',
noCertificate: 'لا توجد شهادة',
viewCertificate: 'عرض الشهادة',
markAsUnverified: 'تعليم كغير موثق',
verifyCertificate: 'التحقق من الشهادة',
deleteCertificate: 'حذف الشهادة',
confirmDeleteCertificateTitle: 'حذف الشهادة',
confirmDeleteCertificate: 'هل أنت متأكد أنك تريد حذف هذه الشهادة؟ لا يمكن التراجع عن هذا الإجراء.',
confirmVerifyCertificateTitle: 'التحقق من الشهادة',
confirmVerifyCertificate: 'هل أنت متأكد أنك تريد التحقق من هذه الشهادة؟',
confirmUnverifyCertificateTitle: 'إلغاء التحقق من الشهادة',
confirmUnverifyCertificate: 'هل أنت متأكد أنك تريد تعليم هذه الشهادة كغير موثقة؟',
certificateUploaded: 'تم تحميل الشهادة بنجاح',
certificateDeleted: 'تم حذف الشهادة بنجاح',
certificateVerifiedSuccess: 'تم التحقق من الشهادة بنجاح',
certificateUnverifiedSuccess: 'تم تعليم الشهادة كغير موثقة بنجاح',
failedUploadCertificate: 'فشل في تحميل الشهادة',
failedDeleteCertificate: 'فشل في حذف الشهادة',
failedVerifyCertificate: 'فشل في التحقق من الشهادة',
failedUnverifyCertificate: 'فشل في تعليم الشهادة كغير موثقة',

// Women management
selectAllAvailable: 'اختر جميع النساء المتاحات',
womanNotAvailable: 'المرأة غير متاحة للتخصيص',
selectForAssignment: 'اختر للتخصيص',
womenSelectedForAssignment: 'النساء المختارات للتخصيص',
selected: 'مختار',
assignSelectedWomen: 'تعيين النساء المختارات',

// Request status
completed: 'مكتمل',
cancelled: 'ملغى',
    emailSettings: 'إعدادات البريد الإلكتروني',
emailBroadcast: 'بث البريد الإلكتروني',
emailBroadcastDescription: 'إرسال الإعلانات والتحديثات لجميع مستخدمي النظام',
sendEmailBroadcast: 'إرسال بث بريد إلكتروني',
sendTestEmail: 'إرسال بريد إلكتروني تجريبي',
broadcastAllUsersWarning: 'سيتم إرسال هذا البريد الإلكتروني إلى جميع المستخدمين في النظام.',
broadcastEmployersWarning: 'سيتم إرسال هذا البريد الإلكتروني إلى أرباب العمل فقط.',
broadcastAdminsWarning: 'سيتم إرسال هذا البريد الإلكتروني إلى المشرفين فقط.',
broadcastManagersWarning: 'سيتم إرسال هذا البريد الإلكتروني إلى المدراء فقط.',
currentPassword: 'كلمة المرور الحالية',
newPassword: 'كلمة المرور الجديدة',
confirmPassword: 'تأكيد كلمة المرور',
enterCurrentPassword: 'أدخل كلمة المرور الحالية',
enterNewPassword: 'أدخل كلمة المرور الجديدة',
confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
changing: 'جاري التغيير...',
systemSettings: 'إعدادات النظام',
timezone: 'المنطقة الزمنية',
dateFormat: 'تنسيق التاريخ',
itemsPerPage: 'العناصر في الصفحة',
resetToDefaults: 'إعادة التعيين إلى الإعدادات الافتراضية',
recipients: 'المستلمون',
allUsers: 'جميع المستخدمين',
employersOnly: 'أرباب العمل فقط',
adminsOnly: 'المشرفون فقط',
managersOnly: 'المدراء فقط',
testEmailAddress: 'عنوان البريد الإلكتروني التجريبي',
enterTestEmail: 'أدخل عنوان البريد الإلكتروني التجريبي',
testEmailDescription: 'إرسال بريد إلكتروني تجريبي للتحقق من التنسيق',
sending: 'جاري الإرسال...',
sendBroadcast: 'إرسال البث',
enterEmailSubject: 'أدخل موضوع البريد الإلكتروني',
enterEmailMessage: 'أدخل رسالتك هنا...',
// Donate Modal translations - Arabic
donateTitle: 'ادعم نسائنا',
donateDescription: 'تبرعك يساعد في تدريب المزيد من النساء وخلق سبل عيش مستدامة',
quickSelectAmount: 'اختيار مبلغ سريع (RWF):',
donationAmountLabel: 'مبلغ التبرع (RWF) *',
donationAmountPlaceholder: 'أدخل المبلغ',
donorNameLabel: 'اسمك *',
donorNamePlaceholder: 'أدخل اسمك',
emailLabel: 'البريد الإلكتروني',
emailPlaceholder: 'أدخل بريدك الإلكتروني',
phoneLabel: 'الهاتف',
phonePlaceholder: 'أدخل رقم هاتفك',
messageLabel: 'رسالة (اختياري)',
messagePlaceholder: 'أضف رسالة تشجيع...',
donationInfo1: '💝 100% من تبرعك يذهب مباشرة إلى برامج التدريب',
donationInfo2: '🌍 مساهمتك تحول حياة ومجتمعات',
donationInfo3: '🌍 *182*8*1*270591#',
donationInfo4: '🏦 اسم البنك: بنك كيغالي',
donationInfo5: '👤 اسم الحساب: WFW1 Empowerment Center LLC / Urugo Women\'s Opportunity Center',
donationInfo6: '💰 حساب الفرنك الرواندي: 00059-06929965-20',
donationInfo7: '💵 حساب الدولار الأمريكي: 00059-06929966-21',
cancelButton: 'إلغاء',
processingButton: 'جاري المعالجة...',
makeDonationButton: 'تقديم التبرع',
successTitle: 'شكراً لك على تبرعك الكريم!',
successMessage: 'دعمك يصنع فرقاً في حياة النساء.',
errorMessage: 'خطأ في معالجة التبرع. الرجاء المحاولة مرة أخرى.',
    // Register Modal translations - Arabic
    registerCreateAccount: 'إنشاء حساب',
    registerDescription: 'انضم إلى Urugo WOC للبدء في توظيف النساء المدربات',
    fullNameLabel: 'الاسم الكامل *',
    fullNamePlaceholder: 'أدخل اسمك الكامل',
    usernameLabel: 'اسم المستخدم *',
    usernamePlaceholder: 'اختر اسم مستخدم',
    emailLabel: 'عنوان البريد الإلكتروني *',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    phoneLabel: 'رقم الهاتف',
    phonePlaceholder: 'أدخل رقم هاتفك',
    passwordLabel: 'كلمة المرور *',
    passwordPlaceholder: 'إنشاء كلمة مرور',
    confirmPasswordLabel: 'تأكيد كلمة المرور *',
    confirmPasswordPlaceholder: 'قم بتأكيد كلمة المرور الخاصة بك',
    passwordStrength: 'القوة',
    passwordVeryWeak: 'ضعيفة جدًا',
    passwordWeak: 'ضعيفة',
    passwordFair: 'متوسطة',
    passwordGood: 'جيدة',
    passwordStrong: 'قوية',
    userTypeTitle: 'أنا أسجل كـ:',
    userTypeEmployer: 'صاحب عمل',
    userTypeEmployerDesc: 'توظيف نساء مدربات',
    creatingAccount: 'جاري إنشاء الحساب...',
    createAccount: 'إنشاء الحساب',
    registerErrorGeneric: 'فشل التسجيل. الرجاء المحاولة مرة أخرى.',
    registerErrorPasswordMatch: 'كلمات المرور غير متطابقة',
    registerErrorPasswordWeak: 'يرجى استخدام كلمة مرور أقوى',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟',
    signIn: 'تسجيل الدخول',
     // Login Modal translations - Arabic
     close: 'إغلاق',
     loginWelcome: 'مرحبًا بعودتك',
     loginDescription: 'سجل الدخول إلى حسابك للمتابعة',
     emailPlaceholder: 'عنوان البريد الإلكتروني',
     passwordPlaceholder: 'كلمة المرور',
     showPassword: 'إظهار كلمة المرور',
     hidePassword: 'إخفاء كلمة المرور',
     rememberMe: 'تذكرني',
     forgotPassword: 'نسيت كلمة المرور؟',
     signingIn: 'جاري تسجيل الدخول...',
     signIn: 'تسجيل الدخول',
     noAccount: 'ليس لديك حساب؟',
     signUp: 'اشتراك',
     loginErrorGeneric: 'فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد الخاصة بك.',
          // ===== Passwordless Auth Flow - Arabic =====
     loginEmailOnlyHint: 'أدخل بريدك الإلكتروني للمتابعة',
     loginStaffHint: 'تسجيل دخول الموظفين — يرجى إدخال كلمة المرور',
     loggingInEmployer: 'جاري تسجيل دخولك...',
     checking: 'جاري التحقق...',
     change: 'تغيير',
     invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
     noAccountFound: 'لم يتم العثور على حساب بهذا البريد الإلكتروني. يرجى التسجيل أولاً.',
     unknownUserType: 'نوع المستخدم غير معروف. يرجى الاتصال بالدعم.',
     emailLoginHint: 'سنبحث عن حسابك بالبريد الإلكتروني. لا حاجة لكلمة مرور.',
     loginDescriptionEmailOnly: 'أدخل بريدك الإلكتروني للمتابعة — لا حاجة لكلمة مرور',
     registerDescriptionNoPassword: 'ما عليك سوى إدخال بياناتك — لا حاجة لكلمة مرور',
     step2DescriptionNoPassword: 'ما عليك سوى إدخال بريدك الإلكتروني — لا حاجة لكلمة مرور',
     loginSuccessMessage: 'لقد تم تسجيل دخولك الآن!',
    // Footer & Chat Bot Translations
  chatWelcome: "مرحباً! أهلاً بك في مركز فرص النساء أوروغو. كيف يمكنني مساعدتك اليوم؟",
  justNow: "الآن فقط",
  chatQuestionHire: "كيف يمكنني توظيف نساء مدربات؟",
  chatQuestionDonate: "كيف يمكنني التبرع لدعم النساء؟",
  chatQuestionTraining: "كيف أتقدم للتدريب؟",
  chatQuestionContact: "كيف يمكنني الاتصال بكم؟",
  chatKeywordHire: "توظيف",
  chatResponseHire: "يمكنك توظيف نسائنا المدربات عن طريق إنشاء حساب صاحب عمل على بوابتنا. زر قسم 'توظيف المواهب' لعرض ملفات تعريف النساء المتاحات وتقديم طلب التوظيف الخاص بك. النساء المدربات مستعدات للعمل في أقسام مختلفة تشمل تشغيل مقهى، الأعمال المنزلية، الخياطة، والمزيد.",
  chatKeywordEmployer: "صاحب عمل",
  chatResponseEmployer: "بصفتك صاحب عمل، يمكنك التسجيل على بوابتنا للوصول إلى ملفات تعريف النساء الماهرات. نوفر نساء تم فحصهن مسبقاً وتدريبهن وجاهزات للعمل. يمكنك تقديم متطلبات محددة وسنقوم بمطابقتك مع مرشحات مناسبات.",
  chatKeywordRequest: "طلب",
  chatResponseRequest: "لطلب نساء مدربات، يرجى تسجيل الدخول إلى حسابك كصاحب عمل وملء نموذج طلب التوظيف. حدد عدد النساء المطلوبات، المهارات المطلوبة، ومدة العمل. سيتصل بك فريقنا خلال 24 ساعة.",
  chatKeywordDonate: "تبرع",
  chatResponseDonate: "شكراً لاهتمامك بالتبرع! يمكنك التبرع عبر الإنترنت من خلال بوابتنا الآمنة، عبر التحويل البنكي، أو بزيارة مركزنا. تبرعاتك تساعد في تدريب المزيد من النساء وتزويدهن بفرص عمل.",
  chatKeywordSupport: "دعم",
  chatResponseSupport: "يمكنك دعمنا عن طريق التبرع، أو أن تصبح راعياً شركاتياً، أو التطوع، أو الشراكة معنا. اتصل بفريق التطوير الخاص بنا على info@urugowoc.com لمزيد من المعلومات.",
  chatKeywordTraining: "تدريب",
  chatResponseTraining: "نقدم تدريباً مهنياً في 7 أقسام. للتقدم، قم بزيارة مركزنا في كايونزا أو تقدم عبر الإنترنت من خلال موقعنا. برامج التدريب مجانية للنساء المؤهلات وتشمل شهادة عند الانتهاء.",
  chatKeywordApply: "تقدم",
  chatResponseApply: "للتقدم للتدريب، قم بزيارة موقعنا الإلكتروني واملأ نموذج الطلب. ستحتاج إلى تقديم معلومات شخصية والإشارة إلى القسم الذي تهتم به. سيتصل بك فريقنا لإجراء مقابلة.",
  chatKeywordLogin: "تسجيل دخول",
  chatResponseLogin: "لتسجيل الدخول، انقر على زر 'تسجيل الدخول' في التنقل العلوي. لأصحاب العمل، المتدربات، والمسؤولين بوابات تسجيل دخول منفصلة. إذا لم يكن لديك حساب، يمكنك التسجيل من صفحة تسجيل الدخول.",
  chatKeywordRegister: "تسجيل",
  chatResponseRegister: "التسجيل مفتوح لأصحاب العمل، النساء اللواتي يبحثن عن تدريب، والمتطوعين. انقر على 'تسجيل' في صفحة تسجيل الدخول وحدد نوع المستخدم الخاص بك. املأ تفاصيلك وسيقوم فريقنا بالتحقق من حسابك.",
  chatKeywordAbout: "من نحن",
  chatResponseAbout: "تم إنشاء مركز فرص النساء أوروغو لتمكين النساء من خلال التدريب المهني والعمل. لقد دربنا أكثر من 600 امرأة منذ 2013. قم بزيارة صفحة 'من نحن' لمعرفة المزيد عن مهمتنا، رؤيتنا، وتأثيرنا.",
  chatKeywordGallery: "معرض",
  chatResponseGallery: "يقدم معرضنا نساء في التدريب، حفلات التخرج، وقصص نجاح في العمل. يمكنك رؤية صور من جميع أقسام التدريب الـ7 وشاهد التحول الذي يحدث في مركزنا.",
  chatKeywordDepartments: "أقسام",
  chatResponseDepartments: "لدينا 7 أقسام تدريبية: 1) تشغيل مقهى، 2) الأعمال المنزلية، 3) الاستقبال، 4) الخياطة، 5) أعمال الجلود، 6) صناعة السجاد، و 7) إنتاج الحليب والزبادي. كل برنامج يشمل تدريباً عملياً وشهادة.",
  chatKeywordContact: "اتصال",
  chatResponseContact: "يمكنك الاتصال بنا عبر البريد الإلكتروني على info@urugowoc.com، الاتصال على +250 788350577، زيارة مركزنا في كايونزا، أو استخدام هذا الروبوت الدردشة. فريقنا متاح من الاثنين إلى الجمعة، من 8 صباحاً إلى 5 مساءً.",
  chatKeywordLocation: "موقع",
  chatResponseLocation: "نحن موجودون في كايونزا، رواندا. يمكنك العثور علينا في مركز فرص النساء أوروغو، منطقة كايونزا. زورنا لترى مرافق التدريب الخاصة بنا وتقابل فريقنا.",
  chatResponseDefault: "شكراً لسؤالك! لمزيد من المعلومات المحددة، يرجى الاتصال بنا مباشرة على info@urugowoc.com أو الاتصال على +250788350577.",
  chatTitle: "مساعد أوروغو WOC",
  close: "إغلاق",
  chatQuickQuestions: "أسئلة سريعة",
  chatPlaceholder: "اكتب رسالتك هنا...",
  send: "إرسال",
  chatToggleTooltip: "دردش معنا",
  whatsappDefaultMessage: "مرحباً أوروغو WOC، لدي سؤال حول توظيف نساء مدربات/التبرع/التدريب...",
  whatsappTooltip: "دردش معنا على واتساب",
  footerTitle: "WfWI/Urugo WOC",
  footerDescription: "تمكين النساء من خلال التدريب على المهارات وفرص العمل منذ 2013. تحويل المجتمعات من خلال خلق سبل عيش مستدامة.",
  facebook: "فيسبوك",
  twitter: "تويتر",
  instagram: "إنستغرام",
  youtube: "يوتيوب",
  whatsapp: "واتساب",
  quickLinks: "روابط سريعة",
  home: "الرئيسية",
  about: "من نحن",
  departments: "الأقسام",
  women: "نساؤنا",
  gallery: "المعرض",
  donate: "تبرع",
  hire: "وظف",
  login: "تسجيل دخول",
  contactInfo: "معلومات الاتصال",
  location: "كايونزا، رواندا",
  phoneNumber: "+250 788350577",
  email: "info@urugowoc.com",
  hireWomen: "وظف نساء مدربات",
  donateNow: "تبرع الآن",
  loginRegister: "تسجيل دخول/تسجيل",
  ourDepartments: "أقسامنا",
  coffeeShopOperation: "تشغيل مقهى",
  housekeepingOperation: "الأعمال المنزلية",
  receptionOperation: "الاستقبال",
  sewingOperation: "خياطة",
  leatherOperation: "أعمال الجلود",
  carpetOperation: "صناعة السجاد",
  milkYogurtProduction: "إنتاج الحليب والزبادي",
  copyright: "مركز فرص النساء أوروغو. جميع الحقوق محفوظة.",
  privacyPolicy: "سياسة الخصوصية",
  termsOfService: "شروط الخدمة",
  sitemap: "خريطة الموقع",
    // Manager Dashboard Translations
    dashboard: "لوحة التحكم",
    requests: "الطلبات",
    women: "النساء",
    users: "المستخدمين",
    donations: "التبرعات",
    gallery: "المعرض",
    about: "حول",
    reports: "التقارير",
    settings: "الإعدادات",
    manager: "المدير",
    totalUsers: "إجمالي المستخدمين",
    totalRequests: "إجمالي الطلبات",
    totalRevenue: "إجمالي الإيرادات",
    activeWomen: "النساء النشطات",
    recentActivity: "النشاط الأخير",
    totalWomen: "إجمالي النساء",
    employerCount: "أرباب العمل",
    newThisMonth: "جديد هذا الشهر",
    activeToday: "نشط اليوم",
    pendingRequests: "الطلبات المعلقة",
    approvedRequests: "الطلبات المعتمدة",
    rejectedRequests: "الطلبات المرفوضة",
    loadingDashboard: "جاري تحميل لوحة التحكم...",
    failedLoadDashboard: "فشل في تحميل بيانات لوحة التحكم",
    justNow: "الآن فقط",
    notificationPendingRequests: "لديك  طلب(ات) معلق(ة)",
    newUsersThisWeek: "مستخدمين جدد هذا الأسبوع",
    newDonations: "تبرعات جديدة",
    failedLoadEmployerDetails: "فشل في تحميل تفاصيل صاحب العمل",
    selectWomenToAssign: "الرجاء تحديد النساء أولاً لتخصيصهم",
    selectRequestEmployer: "الرجاء تحديد طلب/صاحب عمل",
    noWomenSelected: "لم يتم تحديد أي نساء",
    successfullyAssignedWomen: "تم تخصيص  امرأة بنجاح لـ {employer}",
    failedToAssignWomen: "فشل في تخصيص النساء",
    failedLoadWomenProfiles: "فشل في تحميل ملفات تعريف النساء",
    accessDenied: "تم رفض الوصول. يرجى تسجيل الدخول مرة أخرى.",
    requestStatusUpdated: "تم تحديث حالة الطلب إلى {status}",
    failedUpdateRequest: "فشل في تحديث الطلب",
    userStatusUpdated: "تم {status} المستخدم بنجاح",
    suspended: "تم تعليقه",
    activated: "تم تفعيله",
    failedUpdateUser: "فشل في تحديث المستخدم",
    confirmDeleteUser: "هل أنت متأكد من رغبتك في حذف هذا المستخدم؟",
    userDeleted: "تم حذف المستخدم بنجاح",
    failedDeleteUser: "فشل في حذف المستخدم",
    profileAvailabilityUpdated: "تم تحديث توفر الملف الشخصي إلى {status}",
    available: "متاح",
    hired: "تم توظيفها",
    failedUpdateProfile: "فشل في تحديث الملف الشخصي",
    confirmDeleteProfile: "هل أنت متأكد من رغبتك في حذف هذا الملف الشخصي؟",
    profileDeleted: "تم حذف الملف الشخصي بنجاح",
    failedDeleteProfile: "فشل في حذف الملف الشخصي",
    profileAdded: "تم إضافة الملف الشخصي بنجاح",
    failedAddProfile: "فشل في إضافة الملف الشخصي",
    profileUpdated: "تم تحديث الملف الشخصي بنجاح",
    exportSuccessful: "نجح التصدير! تم تنزيل الملف",
    failedExportData: "فشل في تصدير البيانات",
    searchRequests: "بحث في الطلبات...",
    clearFilters: "مسح المرشحات",
    filterBy: "تصفية حسب",
    allStatus: "جميع الحالات",
    pending: "قيد الانتظار",
    approved: "مقبول",
    rejected: "مرفوض",
    cancelled: "ملغي",
    to: "إلى",
    exportRequests: "تصدير الطلبات",
    noRequestsFound: "لم يتم العثور على طلبات",
    noRequestsMatch: "لا توجد طلبات تطابق معاييرك",
    noRequestsAvailable: "لا توجد طلبات متاحة",
    showingRequests: "عرض  طلب(ات)",
    id: "الرقم",
    date: "التاريخ",
    employer: "صاحب العمل",
    department: "القسم",
    employees: "الموظفين",
    duration: "المدة",
    amount: "المبلغ",
    status: "الحالة",
    actions: "الإجراءات",
    days: "أيام",
    n_a: "N/A",
    viewRequest: "عرض الطلب",
    approveRequest: "الموافقة على الطلب",
    rejectRequest: "رفض الطلب",
    womenProfilesManagement: "إدارة ملفات تعريف النساء",
    searchWomen: "بحث عن النساء...",
    assignSelected: "تخصيص المحدد",
    addNewProfile: "إضافة ملف تعريف جديد",
    allDepartments: "جميع الأقسام",
    clearFilters: "مسح المرشحات",
    womenSelectedForAssignment: " نساء محددة للتخصيص",
    selected: "محدد(ة)",
    assignSelectedWomen: "تخصيص النساء المحددات",
    noWomenProfilesFound: "لم يتم العثور على ملفات تعريف نساء",
    noProfilesMatchCriteria: "لا توجد ملفات تعريف تطابق معاييرك",
    showingProfiles: "عرض {showing} من أصل {total} ملف تعريف",
    previous: "السابق",
    pageInfo: "الصفحة {page} من {pages}",
    next: "التالي",
    selectAllAvailable: "تحديد جميع النساء المتاحات",
    photo: "الصورة",
    name: "الاسم",
    age: "العمر",
    skills: "المهارات",
    experience: "الخبرة",
    phone: "الهاتف",
    years: "سنوات",
    womanNotAvailable: "هذه المرأة غير متاحة",
    selectForAssignment: "تحديد للتخصيص",
    editProfile: "تعديل الملف الشخصي",
    markAsHired: "وضع علامة كمؤجَرة",
    markAsAvailable: "وضع علامة كمتاحة",
    deleteProfile: "حذف الملف الشخصي",
    employedBy: "موظفة لدى",
    requestId: "رقم الطلب",
    assigned: "تم تخصيصها",
    userManagement: "إدارة المستخدمين",
    searchUsers: "بحث عن المستخدمين...",
    allTypes: "جميع الأنواع",
    admin: "مدير",
    manager: "منسق",
    employer: "صاحب العمل",
    exportUsers: "تصدير المستخدمين",
    noUsersFound: "لم يتم العثور على مستخدمين",
    noUsersMatchCriteria: "لا يوجد مستخدمين يطابقون معاييرك",
    noUsersAvailable: "لا يوجد مستخدمين متاحين",
    showingUsers: "عرض  مستخدم(ين)",
    user: "المستخدم",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    type: "النوع",
    joined: "انضم",
    editUser: "تعديل المستخدم",
    suspendUser: "تعليق المستخدم",
    activateUser: "تفعيل المستخدم",
    deleteUser: "حذف المستخدم",
    galleryManagement: "إدارة المعرض",
    searchGallery: "بحث في المعرض...",
    addImage: "إضافة صورة",
    noGalleryImagesFound: "لم يتم العثور على صور للمعرض",
    noImagesMatchCriteria: "لا توجد صور تطابق معاييرك",
    showingImages: "عرض {showing} من أصل {total} صورة",
    general: "عام",
    edit: "تعديل",
    delete: "حذف",
    featured: "مميز",
    aboutUsManagement: "إدارة صفحة حولنا",
    pageContent: "محتوى الصفحة",
    coreValues: "القيم الأساسية",
    teamMembers: "أعضاء الفريق",
    aboutPageContent: "محتوى صفحة حولنا",
    editContent: "تعديل المحتوى",
    defaultAboutTitle: "تمكين النساء من خلال التدريب على المهارات",
    defaultMission: "مهمتنا هي تمكين النساء من خلال التدريب المهني وفرص العمل المستدامة",
    defaultVision: "رؤيتنا هي عالم حيث تمتلك كل امرأة المهارات والفرص لتحقيق الاستقلال الاقتصادي",
    defaultHistory: "تأسس عام 2013، مركز فرص النساء أوروغو قام بتحويل حياة المئات من النساء من خلال التدريب على المهارات",
    noMissionStatement: "لم تتم إضافة بيان المهمة بعد",
    noVisionStatement: "لم تتم إضافة بيان الرؤية بعد",
    noHistoryContent: "لم تتم إضافة محتوى تاريخي بعد",
    noAboutPageContent: "لا يوجد محتوى في صفحة حولنا",
    clickEditContentToAdd: "انقر على 'تعديل المحتوى' لإضافة معلومات",
    addValue: "إضافة قيمة",
    noCoreValues: "لا توجد قيم أساسية",
    addCoreValues: "أضف القيم الأساسية لمؤسستك",
    addTeamMember: "إضافة عضو فريق",
    noTeamMembers: "لا يوجد أعضاء فريق",
    addTeamMembers: "أضف أعضاء فريقك",
    donationManagement: "إدارة التبرعات",
    reset: "إعادة تعيين",
    exportDonations: "تصدير التبرعات",
    donor: "المتبرع",
    message: "الرسالة",
    viewDetails: "عرض التفاصيل",
    sendThankYou: "إرسال شكر",
    noDonationsFound: "لم يتم العثور على تبرعات",
    reportsAnalytics: "التقارير والتحليلات",
    generateReports: "إنشاء تقارير",
    usersReport: "تقرير المستخدمين",
    requestsReport: "تقرير الطلبات",
    donationsReport: "تقرير التبرعات",
    fullDatabaseExport: "تصدير قاعدة البيانات الكاملة",
    systemStatistics: "إحصائيات النظام",
    totalUsers: "إجمالي المستخدمين",
    activeWomen: "النساء النشطات",
    totalRevenue: "إجمالي الإيرادات",
    successRate: "معدل النجاح",
    requestStatistics: "إحصائيات الطلبات",
    generalSettings: "الإعدادات العامة",
    siteName: "اسم الموقع",
    emailNotifications: "إشعارات البريد الإلكتروني",
    autoApproveRequests: "الموافقة التلقائية على الطلبات",
    saveSettings: "حفظ الإعدادات",
    accountSettings: "إعدادات الحساب",
    changePassword: "تغيير كلمة المرور",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    saveChanges: "حفظ التغييرات",
    editGalleryImage: "تعديل صورة المعرض",
    addGalleryImage: "إضافة صورة للمعرض",
    title: "العنوان",
    description: "الوصف",
    department: "القسم",
    featuredImage: "صورة مميزة",
    imageFile: "ملف الصورة",
    currentImage: "الصورة الحالية",
    current: "الحالي",
    cancel: "إلغاء",
    updateImage: "تحديث الصورة",
    editAboutPageContent: "تعديل محتوى صفحة حولنا",
    pageTitle: "عنوان الصفحة",
    enterPageTitle: "أدخل عنوان الصفحة",
    missionStatement: "بيان المهمة",
    enterMissionStatement: "أدخل بيان المهمة",
    visionStatement: "بيان الرؤية",
    enterVisionStatement: "أدخل بيان الرؤية",
    historyAboutUs: "التاريخ / حولنا",
    enterHistoryContent: "أدخل المحتوى التاريخي",
    aboutPageSaved: "تم حفظ صفحة حولنا بنجاح",
    failedSaveAboutPage: "فشل في حفظ صفحة حولنا",
    editCoreValue: "تعديل القيمة الأساسية",
    addCoreValue: "إضافة قيمة أساسية",
    coreValueText: "نص القيمة الأساسية",
    enterCoreValueText: "أدخل نص القيمة الأساسية",
    sortOrder: "ترتيب الفرز",
    updateCoreValue: "تحديث القيمة الأساسية",
    confirmDeleteCoreValue: "هل أنت متأكد من رغبتك في حذف هذه القيمة الأساسية؟",
    coreValueDeleted: "تم حذف القيمة الأساسية بنجاح",
    failedDeleteCoreValue: "فشل في حذف القيمة الأساسية",
    coreValueAdded: "تم إضافة القيمة الأساسية بنجاح",
    failedAddCoreValue: "فشل في إضافة القيمة الأساسية",
    coreValueUpdated: "تم تحديث القيمة الأساسية بنجاح",
    failedUpdateCoreValue: "فشل في تحديث القيمة الأساسية",
    editTeamMember: "تعديل عضو الفريق",
    addTeamMember: "إضافة عضو فريق",
    position: "المنصب",
    department: "القسم",
    bioDescription: "السيرة الذاتية/الوصف",
    enterTeamMemberBio: "أدخل سيرة ذاتية لعضو الفريق",
    profilePhoto: "صورة الملف الشخصي",
    activeTeamMember: "عضو فريق نشط",
    currentPhoto: "الصورة الحالية",
    updateTeamMember: "تحديث عضو الفريق",
    confirmDeleteTeamMember: "هل أنت متأكد من رغبتك في حذف عضو الفريق هذا؟",
    teamMemberDeleted: "تم حذف عضو الفريق بنجاح",
    failedDeleteTeamMember: "فشل في حذف عضو الفريق",
    teamMemberAdded: "تم إضافة عضو الفريق بنجاح",
    failedAddTeamMember: "فشل في إضافة عضو الفريق",
    teamMemberUpdated: "تم تحديث عضو الفريق بنجاح",
    failedUpdateTeamMember: "فشل في تحديث عضو الفريق",
    addNewProfile: "إضافة ملف تعريف جديد",
    name: "الاسم",
    age: "العمر",
    selectDepartment: "اختر القسم",
    experienceYears: "الخبرة (سنوات)",
    commaSeparatedSkills: "المهارات مفصولة بفواصل",
    location: "الموقع",
    educationLevel: "المستوى التعليمي",
    selectEducation: "اختر المستوى التعليمي",
    primary: "ابتدائي",
    secondary: "ثانوي",
    vocational: "مهني",
    university: "جامعي",
    other: "أخرى",
    profilePhoto: "صورة الملف الشخصي",
    addProfile: "إضافة الملف الشخصي",
    editProfile: "تعديل الملف الشخصي",
    saveChanges: "حفظ التغييرات",
    refresh: "تحديث",
    logout: "تسجيل الخروج",
    toggleMenu: "تبديل القائمة",
    urugoWOC: "أوروغو WOC",
    notifications: "الإشعارات",
    noNotifications: "لا توجد إشعارات",
    home: "الرئيسية",
    requests: "الطلبات",
    women: "النساء",
    users: "المستخدمين",
    donations: "التبرعات",
    gallery: "المعرض",
    about: "حول",
    reports: "التقارير",
    settings: "الإعدادات",
    export: "تصدير",
    csvFormat: "تنسيق CSV",
    manageWomen: "إدارة النساء",
    profiles: "ملفات تعريف",
    manageUsers: "إدارة المستخدمين",
    quickActions: "إجراءات سريعة",
    reviewRequests: "مراجعة الطلبات",
    exportAllData: "تصدير جميع البيانات",
    exportAll: "تصدير الكل",
    clearAll: "مسح الكل",
    allCaughtUp: "تمت متابعة كل شيء!",
    noNewNotifications: "لا توجد إشعارات جديدة",
    departments: "الأقسام",
    employers: "أرباب العمل",
    activeToday: "نشط اليوم",
    thisMonth: "هذا الشهر",
    currentlyActive: "نشط حاليًا",
    average: "المتوسط",
    womenTrained: "النساء المدربات",
    selectAllAvailable: "تحديد جميع النساء المتاحات",
    selectForAssignment: "تحديد للتخصيص",
    inactive: "غير نشط",
    active: "نشط",
    enterImageDescription: "أدخل وصف الصورة",
    enterCoreValueText: "أدخل نص القيمة الأساسية",
    enterTeamMemberBio: "أدخل سيرة ذاتية لعضو الفريق",
    bio: "السيرة الذاتية",
    confirmDeleteImage: "هل أنت متأكد من رغبتك في حذف هذه الصورة؟",
    imageDeleted: "تم حذف الصورة بنجاح",
    failedDeleteImage: "فشل في حذف الصورة",
    galleryImageAdded: "تم إضافة صورة المعرض بنجاح",
    failedAddGalleryImage: "فشل في إضافة صورة المعرض",
    galleryImageUpdated: "تم تحديث صورة المعرض بنجاح",
    failedUpdateGalleryImage: "فشل في تحديث صورة المعرض",
    selectDepartment: "اختر القسم",
    successRate: "معدل النجاح",
    activeWomen: "النساء النشطات",
    
    // Existing translations from other sections...
    employerDashboard: "لوحة تحكم صاحب العمل",
    myRequests: "طلباتي",
    hiredWomen: "النساء المشغلات",
    payments: "المدفوعات",
    newRequest: "طلب جديد",
    markAsPaid: "علامة كمقبوض",
    exportData: "تصدير البيانات",
    makePayment: "إجراء الدفع",
    downloadReceipt: "تحميل الإيصال",
    totalSpent: "إجمالي المنفق",
    totalHired: "إجمالي المشغلين",
    approvalRate: "معدل القبول",
    avgEmployees: "متوسط الموظفين",
    avgDuration: "متوسط المدة",
    pendingPayments: "المدفوعات المعلقة",
    paymentHistory: "سجل المدفوعات",
    payNow: "ادفع الآن",
    profileSettings: "إعدادات الملف الشخصي",
    companyName: "اسم الشركة",
    contactPerson: "شخص الاتصال",
    requestTrainedWomen: "طلب نساء مدربات",
    perRequest: "لكل طلب",
    womenHired: "نساء مشغلات",
    avgPerRequest: "متوسط/طلب",
    browseHired: "تصفح المشغلين",
    viewHiredWomen: "عرض النساء المشغلات",
    downloadAllRequests: "تحميل جميع الطلبات",
    unknownDepartment: "قسم غير معروف",
    unknownDate: "تاريخ غير معروف",
    exportList: "تصدير القائمة",
    unknownName: "اسم غير معروف",
    yearsExp: "سنوات الخبرة",
    hiredOn: "تم التوظيف في",
    unknown: "غير معروف",
    notSpecified: "غير محدد",
    noHiredWomen: "لا توجد نساء مشغلات",
    noHiredWomenDesc: "لم تقم بتوظيف أي نساء بعد. ستظهر الطلبات المعتمدة هنا",
    makeRequest: "تقديم طلب",
    managePayments: "إدارة مدفوعاتك وفواتيرك",
    totalPendingPayments: "إجمالي المدفوعات المعلقة",
    requests: "طلب(ات)",
    allCompletedPayments: "جميع المدفوعات المكتملة",
    viewAllRequests: "عرض جميع الطلبات",
    request: "طلب",
    due: "استحق",
    noPendingPayments: "لا توجد مدفوعات معلقة",
    paidOn: "تم الدفع في",
    noPaymentHistory: "لا يوجد سجل دفع بعد",
    loadingDashboard: "جاري تحميل لوحة التحكم الخاصة بك...",
    failedLoadHiredWomen: "فشل في تحميل بيانات النساء المشغلات",
    notificationPendingRequests: "لديك  طلب(ات) معلق(ة)",
    notificationPendingPayments: " دفعة(ات) معلقة",
    justNow: "الآن فقط",
    requestSubmittedSuccess: "تم تقديم الطلب بنجاح!",
    failedSubmitRequest: "فشل في تقديم الطلب. يرجى المحاولة مرة أخرى",
    requestUpdatedSuccess: "تم تحديث الطلب بنجاح!",
    failedUpdateRequest: "فشل في تحديث الطلب. يرجى المحاولة مرة أخرى",
    confirmCancelRequest: "هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟",
    requestCancelledSuccess: "تم إلغاء الطلب بنجاح!",
    failedCancelRequest: "فشل في إلغاء الطلب. يرجى المحاولة مرة أخرى",
    confirmMarkAsPaid: "تحديد هذا الطلب كمقبوض؟",
    requestMarkedAsPaid: "تم تحديد الطلب كمقبوض!",
    failedUpdatePayment: "فشل في تحديث حالة الدفع. يرجى المحاولة مرة أخرى",
    exportSuccessful: "نجح التصدير! تم تنزيل الملف",
    failedExportRequests: "فشل في تصدير الطلبات",
    confirmDeleteRequest: "هل أنت متأكد من رغبتك في حذف هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء",
    requestDeletedSuccess: "تم حذف الطلب بنجاح!",
    failedDeleteRequest: "فشل في حذف الطلب. يرجى المحاولة مرة أخرى",
    downloadingReceipt: "جاري تنزيل الإيصال...",
    paymentCompleted: "تم إكمال الدفع بنجاح!",
    
    // Gallery Page Translations
    barista: "بارستا",
    coffee: "قهوة",
    training: "تدريب",
    womenLearning: "نساء يتعلمن",
    preparation: "تحضير",
    machine: "آلة",
    customerService: "خدمة العملاء",
    serving: "خدمة",
    customers: "العملاء",
    withProfessionalism: "بإحترافية",
    grinding: "طحن",
    learning: "تعلم",
    proper: "مناسب",
    techniques: "تقنيات",
    art: "فن",
    creating: "إنشاء",
    beautiful: "جميل",
    designs: "تصاميم",
    teamCollaboration: "تعاون الفريق",
    working: "عمل",
    together: "معًا",
    in: "في",
    shop: "محل",
    roomCleaning: "تنظيف الغرف",
    professional: "محترف",
    room: "غرفة",
    cleaning: "تنظيف",
    linenManagement: "إدارة المفروشات",
    linen: "مفروشات",
    folding: "طي",
    and: "و",
    storage: "تخزين",
    cleaningEquipment: "معدات التنظيف",
    using: "استخدام",
    modern: "حديث",
    equipment: "معدات",
    hotelStandards: "معايير الفندق",
    maintaining: "الحفاظ على",
    high: "عالي",
    standards: "معايير",
    frontDesk: "المكتب الأمامي",
    managing: "إدارة",
    hotel: "فندق",
    front: "أمامي",
    desk: "مكتب",
    operations: "عمليات",
    guestCheckin: "تسجيل الوصول",
    guest: "ضيف",
    checkin: "تسجيل الدخول",
    process: "عملية",
    phoneEtiquette: "آداب الهاتف",
    telephone: "هاتف",
    communication: "اتصال",
    skills: "مهارات",
    computerSkills: "مهارات الكمبيوتر",
    software: "برنامج",
    sewingMachine: "ماكينة الخياطة",
    industrial: "صناعي",
    sewing: "خياطة",
    machines: "آلات",
    patternMaking: "صنع الأنماط",
    clothing: "ملابس",
    patterns: "أنماط",
    fabricCutting: "قص القماش",
    precision: "دقة",
    fabric: "قماش",
    cutting: "قص",
    qualityControl: "مراقبة الجودة",
    checking: "فحص",
    finished: "منتهي",
    garments: "ملابس",
    leatherCutting: "قص الجلود",
    leather: "جلد",
    for: "لـ",
    products: "منتجات",
    handStitching: "خياطة يدوية",
    traditional: "تقليدي",
    stitching: "خياطة",
    leatherDyeing: "صبغ الجلود",
    coloring: "تلوين",
    productAssembly: "تجميع المنتجات",
    assembling: "تجميع",
    goods: "بضائع",
    weaving: "نسج",
    carpet: "سجادة",
    knotting: "عقد",
    handknotting: "عقد يدوي",
    designPlanning: "تخطيط التصميم",
    designs: "تصاميم",
    finishing: "إنهاء",
    final: "نهائي",
    touches: "لمسات",
    on: "على",
    carpets: "سجاد",
    milkProcessing: "معالجة الحليب",
    milk: "حليب",
    processing: "معالجة",
    yogurtMaking: "صنع اللبن",
    yogurt: "لبن",
    fermentation: "تخمير",
    qualityTesting: "اختبار الجودة",
    testing: "اختبار",
    dairy: "ألبان",
    packaging: "تغليف",
    hygienic: "صحي",
    
    // UI Translations for Gallery
    images: "الصور",
    tryAgain: "حاول مرة أخرى",
    noImagesFound: "لم يتم العثور على صور",
    tryDifferentFilter: "حاول تحديد قسم مختلف أو مصطلح بحث",
    tryDifferentSearch: "حاول مصطلح بحث مختلف",
    noImagesInDepartment: "لا توجد صور متاحة لهذا القسم بعد",
    galleryImage: "صورة المعرض",
    noDescription: "لا يوجد وصف متاح",
    loadMore: "تحميل المزيد",
    trainingImages: "صور التدريب",
    womenEmpowered: "نساء متمكنات",
    learningOpportunities: "فرص التعلم",
    witnessTransformation: "شاهدوا رحلة النساء اللواتي يغيرن حياتهن من خلال التدريب المهني",
    search: "بحث",
    viewAll: "عرض الكل",
    tailoringFashion: "الخياطة والموضة",
    organicFarming: "الزراعة العضوية",
    culinaryArts: "فنون الطهي",
    cosmetology: "التجميل",
    literacyProgram: "برنامج محو الأمية",
    handicrafts: "الحرف اليدوية",
    leatherwork: "صناعة الجلود",
    farming: "زراعة",
    cooking: "طبخ",
    tailoring: "خياطة",
    housekeeping: "تدبير منزلي",
    reception: "استقبال",
    sewing: "خياطة",
    carpetWeaving: "نسج السجاد",
    dairyProduction: "إنتاج الألبان",
    
    // About Us Page Translations
    aboutUs: "من نحن",
    empoweringWomenTransformingCommunities: "تمكين النساء، تحويل المجتمعات منذ 2013",
    ourMission: "مهمتنا",
    ourVision: "رؤيتنا",
    ourStory: "قصتنا",
    ourCoreValues: "قيمنا الأساسية",
    ourTrainingDepartments: "أقسامنا التدريبية",
    meetOurTeam: "التقِ بفريقنا",
    contactUs: "اتصل بنا",
    connectWithUs: "تواصل معنا",
    sendUsAMessage: "أرسل لنا رسالة",
    wellGetBackToYou: "سوف نعود إليك في أقرب وقت ممكن",
    ourPartnersSponsors: "شركاؤنا ورعاتنا",
    
    // Contact Information Labels
    address: "العنوان",
    workingHours: "ساعات العمل",
    alternate: "بديل",
    fullName: "الاسم الكامل *",
    emailAddress: "عنوان البريد الإلكتروني *",
    subject: "الموضوع *",
    sendMessage: "إرسال الرسالة",
    sending: "جارٍ الإرسال...",
    thankYouMessageSent: "شكراً لك! تم إرسال رسالتك بنجاح.",
    sorryErrorSending: "عذراً، حدث خطأ في إرسال رسالتك. يرجى المحاولة مرة أخرى.",
    
    // Placeholders and Messages
    loadingAboutInfo: "جارٍ تحميل معلومات عن...",
    
    // Form Labels
    formNamePlaceholder: "أدخل اسمك الكامل",
    formEmailPlaceholder: "أدخل عنوان بريدك الإلكتروني",
    formSubjectPlaceholder: "أدخل الموضوع",
    formMessagePlaceholder: "اكتب رسالتك هنا...",
    
    // Social Media Platforms
    facebook: "فيسبوك",
    twitter: "تويتر",
    instagram: "إنستغرام",
    linkedin: "لينكدإن",
    youtube: "يوتيوب",
    whatsapp: "واتساب",
    
    // Partner Types
    sponsor: "الراعي",
    partner: "الشريك",
    donor: "المانح",

    // Existing translations
    home: "الرئيسية",
    exploreDepartments: "استكشاف الأقسام",
    meetOurWomen: "التقِ بنسائنا",
    hireTrainedWomen: "وظف نساء مدربات",
    empoweringWomen: "تمكين النساء",
    throughSkillsTraining: "من خلال التدريب على المهارات",
    buildingSustainable: "بناء",
    futures: "مستقبلات مستدامة",
    transformingCommunities: "تحويل المجتمعات",
    together: "معاً",
    employersConnected: "أرباب عمل مرتبطين",
    chooseSpecializedPrograms: "اختر من بين  برنامج تدريبي متخصص مصمم للنجاح",
    requestTrainedWomen: "طلب نساء مدربات",
    certifiedTraining: "تدريب معتمد",
    flexibleHours: "ساعات مرنة",
    ourWomenInAction: "نساؤنا في العمل",
    witnessTransformation: "شاهد التحول من خلال عملهم",
    meetTalentedWomen: "التقِ بنسائنا الموهوبات",
    skilledProfessionals: "محترفات ماهرات جاهزات لإحداث فرق",
    availableNow: "متاح الآن",
    currentlyWorking: "تعمل حالياً",
    empowerMoreWomen: "مكن المزيد من النساء اليوم",
    supportProvidesHope: "دعمك يوفر التدريب والفرص والأمل. انضم إلينا في خلق تغيير دائم.",
    donateNow: "تبرع الآن",
    hireTalent: "وظف المواهب",
    woman: "امرأة",
    skilledProfessional: "محترفة ماهرة",
    womenEmpowermentActivity: "نشاط تمكين المرأة",
    makeDonation: "تقدم بتبرع لدعم تدريب النساء",
    
    // Department names and descriptions
    tailoringDesc: "تدريب احترافي على الخياطة وتصميم الأزياء",
    farmingDesc: "ممارسات وتقنيات الزراعة المستدامة",
    culinaryDesc: "مهارات احترافية في الطبخ وتحضير الطعام",
    cosmetologyDesc: "صناعة منتجات التجميل والعناية بالبشرة",
    literacyDesc: "التعليم الأساسي ومهارات القراءة والكتابة",
    handicraftsDesc: "صناعة الحرف التقليدية والحديثة",
    leatherworkDesc: "صناعة الأحذية والمنتجات الجلدية",
    
    // Hero slides descriptions
    heroSlide1Desc: "قام مركز فرص النساء أوروغو بتدريب أكثر من 600 امرأة في مختلف المهارات المهنية، مما يساعدهن على بناء سبل عيش مستدامة وتحويل مجتمعاتهن.",
    heroSlide2Desc: "توفر برامجنا التدريبية المهنية النساء بمهارات قابلة للتسويق لسوق العمل التنافسي اليوم، مما يضمن توظيفاً طويل الأجل واستقلالاً مالياً.",
    heroSlide3Desc: "من خلال تمكين امرأة واحدة، نمكن مجتمعاً بأكمله. انضم إلينا في خلق تغيير دائم من خلال التعليم والدعم والفرص.",
    
    // Additional UI elements
    working: "تعمل",
    loadingContent: "جارٍ تحميل المحتوى الرائع...",
    deleteWhyChooseUs: "هل أنت متأكد أنك تريد حذف هذا العنصر؟",
    deleteWhyChooseUsTitle: "حذف العنصر",
    deleteVideo: "هل أنت متأكد أنك تريد حذف هذا الفيديو؟",
    deleteVideoTitle: "حذف الفيديو",
  },

  chinese: {

    // ===== Trainee Stats Page =====
    stats: '统计数据',
    traineeStats: '学员统计',
    traineeStatsIntro: '探索我们认证的毕业生',
    ourImpact: '我们的影响',
    totalTrainees: '认证毕业生',
    employedByCompany: '公司雇员',
    unemployed: '失业',
    professionalInternship: '专业实习',
    selfEmployed: '自雇',
    traineesFound: '名学员已找到',
    noTraineesFound: '未找到学员',
    tryDifferentFilters: '尝试调整筛选条件或搜索。',
    searchTrainees: '按姓名、技能搜索...',
    allDepartments: '所有部门',
    yearsExp: '年经验',
    employed: '受雇',
studying: '学习中',
workingForOthers: '为他人工作',
notAvailableForHire: '不可雇佣',
womenFound: '找到的女性',
noWomenInDepartment: '该部门未找到女性。',
exportExcel: '导出到Excel',
exportPDF: '导出到PDF',
noWomenFoundWithStatus: '未找到该状态的女性',
    fullName: '全名',
  age: '年龄',
  cohort: '班级',
  phone: '电话',
  email: '电子邮件',
  placementLocation: '安置地点',
  competenceSkills: '能力技能',
  commaSeparated: '用逗号分隔',
  optional: '可选',
  emailOptional: '电子邮件可选，但建议用于沟通',
  enterName: '输入您的全名',
  enterAge: '您的年龄',
  enterPhone: '+250 78X XXX XXX',
  enterEmail: '您的@邮箱.com（可选）',
  enterPlacementLocation: '城市，地区，国家',
  enterCompetenceSkills: '例如：计算机技能、决策能力、领导力',
  separateWithCommas: '用逗号分隔多个技能',
  enterCompanyName: '公司/组织名称',
  enterWorkingPosition: '职位名称',
  enterWorkingLocation: '工作地点',
  enterYears: '年',
  enterBio: '简短简介',
  uploadPhoto: '上传照片',

  fullNameRequired: '全名是必填项',
  nameMinLength: '姓名至少需要2个字符',
  selectDepartmentRequired: '请选择一个部门',
  selectEmploymentStatus: '请选择您的就业状况',
  selectJobSecured: '请选择您如何获得工作',

  employmentStatusDesc: '请告诉我们您当前的就业状况。',
  unemployedInfo: '您选择了"失业"。不需要额外的就业详细信息。',

  wocPlacement: '通过WOC就业安置支持',
  wocInternship: '在WOC实习/工业实习',
  wocRecommendation: 'WOC培训师的推荐',
  familyFriends: '家人/朋友',
  socialMedia: '社交媒体',
  onlinePortal: '在线求职门户',
  walkIn: '直接申请',
  newspaper: '报纸广告',

  jobRelevanceDesc: '您目前的工作与您在WOC接受的培训相关吗？',

  jobChallengesDesc: '您失业的主要原因是什么？（请选择所有适用的选项）',
  lackJobOpportunities: '缺乏就业机会',
  lackWorkExperience: '缺乏工作经验',
  insufficientSkills: '技能不足',
  familyResponsibilities: '家庭责任',
  continuingEducation: '继续教育',
  healthReasons: '健康原因',
  lackStartupCapital: '缺乏创业资金',
  locationTransport: '地点/交通挑战',

  entrepreneurshipDesc: '您毕业后是否创办了自己的企业？',
  employeesEmployed: '您雇佣了多少人？',
  moreThan5: '超过5人',

  supportNeededDesc: '什么支持能帮助您发展业务？（请选择所有适用的选项）',
  accessFinance: '获得资金',
  businessMentorship: '商业指导',
  marketingSupport: '营销支持',
  advancedTraining: '高级技术培训',
  equipment: '设备',
  marketLinkage: '市场联系',
  businessRegistration: '企业注册支持',
  selectNumber: '选择数量',

  confidenceDesc: 'WOC的培训在多大程度上提高了您的信心和独立做出生活决策的能力？',

  financialSupportChanged: '您经济自立能力发生了怎样的变化？',
  financialStability: '与参加WOC之前相比，您如何评价您当前的财务稳定性？',
  savedMoney: '完成培训后您是否能够定期储蓄？',
  incomeManagement: '您对管理个人收入有多大信心？',

  communityImpactDesc: '您如何描述WOC培训对您生活和社区的影响？',
  leadershipInvolvement: '从WOC毕业后，您在家庭或社区中的领导或决策参与度是否提高了？',

  editTraineeProfile: '编辑学员资料',
  updateProfile: '更新资料',
  editing: '正在编辑：',

  step: '步骤',
  of: '共',
  skipped: '已跳过',
  notApplicable: '不适用',

  continue: '继续',
  previous: '上一步',
  next: '下一步',
  submit: '完成注册',
  submitting: '提交中...',
  updateProfile: '更新资料',

  noServerResponse: '服务器无响应。请检查您的网络连接。',
  registrationFailed: '注册失败。请重试。',
  pleaseFillRequiredFields: '请填写所有必填字段',

  above200k: '高于200,000卢旺达法郎',
  selectOption: '选择选项',
  selectRating: '选择评级',
  selectImpact: '选择影响程度',
  yes: '是',
  no: '否',
  none: '无',
  selectCohort: '选择班级',
  selectDepartment: '选择部门',
  selectStatus: '选择状态',

    // In chinese section, add:

pleaseFillRequiredFields: '请填写所有必填字段',
stepErrorBasicInfo: '请填写基本信息中的所有必填字段',
stepErrorEmployment: '请选择您的就业状况',
stepErrorJobSecured: '请选择您如何获得工作',
stepSkippedUnemployed: '您在上一步骤中选择了"失业"。此步骤不适用。',
stepSkippedNotUnemployed: '您并非失业。此步骤不适用。',
stepSkippedNotEntrepreneur: '您选择了"否"创业。此步骤不适用。',
skipToNextStep: '跳到下一步',
editTraineeProfile: '编辑学员资料',
updateProfile: '更新资料',
profileUpdatedSuccess: '资料更新成功！',
profileAddedSuccess: '资料添加成功！',
editing: '正在编辑：',
currentPhotoLabel: '当前照片：',
noDepartmentsAvailable: '没有可用部门',
noGalleryImages: '目前没有可用的图库图片。',
noWomenProfiles: '目前没有可用的女性资料。',
noEvents: '没有可显示的活动',
welcomeToGallery: '欢迎来到我们的画廊',
gallerySubtitle: '探索女性赋权之旅',
viewAll: '查看全部',
matching: '匹配',
resetFilters: '重置筛选',
noImagesInDatabase: '数据库中未找到图片。显示示例图片。',
errorLoadingImages: '加载图片出错。显示示例图片。',
errorLoadingDepartments: '加载部门出错。使用默认列表。',
unknownDepartment: '未知部门',
noImagesForDepartment: '该部门暂无可用图片。',
clickToView: '点击查看',
department: '部门',
category: '分类',
date: '日期',
close: '关闭',
viewDetails: '查看详情',
viewAllDepartments: '查看所有部门',
viewAllWomen: '查看所有女性',
loadMoreImages: '加载更多图片',
noDescription: '无可用描述',
featured: '精选',

    // Search Bar Translations - CHINESE
searchPlaceholder: '搜索女性、部门、活动...',
trainedWomen: '受训女性',
trainingDepartments: '培训部门',
activities: '活动',
galleryImages: '图库图片',
viewAllResults: '查看  的所有结果',
searchResultsFor: '搜索 的结果',
viewAllItems: '查看全部 个  →',
noResultsFound: '未找到  的结果',
trySearchingFor: '尝试搜索：',
searchSuggestions: '裁缝、烹饪、农业、缝纫、皮革制品',
viewCompleteSearchResults: '查看完整搜索结果',
    // Trainee Registration - Additional Fields Translations - CHINESE
enterName: '输入全名',
enterAge: '年龄',
enterPhone: '+250 78X XXX XXX',
enterEmail: 'email@example.com',
enterPlacementLocation: '城市，地区，国家',
enterCompetenceSkills: '例如：计算机技能、决策能力、领导力',
separateWithCommas: '用逗号分隔多个技能',
enterCompanyName: '公司/组织名称',
enterWorkingPosition: '职位名称',
enterWorkingLocation: '工作地点',
enterYears: '年',
enterLocation: '当前位置',
enterBio: '简短简介',
selectJobSecured: '选择您如何获得工作',
selectChallenges: '选择所有适用项',
selectSupport: '什么支持能帮助您发展业务？选择所有适用项',
selectOption: '选择选项',
selectNumber: '选择数量',
selectRating: '选择评级',
selectImpact: '选择影响程度',
startedBusiness: '您毕业后是否创办了自己的企业？',
employeesEmployed: '您雇佣了多少人？',
none: '无',
moreThan5: '超过5人',
yes: '是',
no: '否',
saving: '保存中...',
educationAndBio: '教育与简介',
confidenceImproved: '培训在多大程度上提高了您的自信心？',
financialSupportChanged: '您经济自立能力发生了怎样的变化？',
financialStability: '与培训前相比，您如何评价您当前的财务稳定性？',
savedMoney: '培训后您是否能够定期储蓄？',
incomeManagement: '您对管理个人收入有多大信心？',
communityImpactDesc: '您如何描述WOC培训对您生活和社区的影响？',
leadershipInvolvement: '您是否更多地参与领导或决策？',
currentPhoto: '当前照片',
yesEveryMonth: '是的，每月',
yesOccasionally: '是的，偶尔',
noButPlan: '不，但我有计划',
notChanged: '没有变化',
worsened: '恶化了',
fullyIndependent: '完全经济独立',
significantlyContribute: '对家庭有显著贡献',
occasionallyContribute: '偶尔对家庭有贡献',
muchBetter: '好多了',
better: '更好',
same: '差不多',
worse: '更差',
muchWorse: '差多了',
veryGreatExtent: '非常大程度',
greatExtent: '很大程度',
moderateExtent: '中等程度',
smallExtent: '小程度',
notAtAll: '完全没有',
veryConfident: '非常自信',
confident: '自信',
moderatelyConfident: '适度自信',
slightlyConfident: '略微自信',
notConfident: '完全不自信',
transformational: '变革性的',
significantPositive: '显著的积极影响',
moderatePositive: '中等积极影响',
slightPositive: '轻微积极影响',
noImpact: '没有明显影响',
significantly: '是的，显著',
toSomeExtent: '是的，在某种程度上',
noChange: '没有变化',
lessInvolved: '比以前参与少',
    // Trainee Registration Translations - CHINESE
traineeRegister: '注册为学员',
traineeRegistration: '学员注册',
basicInformation: '基本信息',
employmentStatus: '就业状况',
jobSecured: '如何获得工作',
jobRelevance: '工作相关性',
jobChallenges: '求职挑战',
entrepreneurship: '创业情况',
supportNeeded: '所需支持',
confidenceImpact: '信心与影响',
financialSituation: '财务状况',
communityImpact: '社区影响',
registrationComplete: '注册完成！',
thankYouRegistration: '感谢您完成注册。',
registrationSuccess: '您的信息已成功保存。',
registrationSuccessSub: '您现在可以访问平台的所有功能。',
previous: '上一步',
next: '下一步',
submit: '完成注册',
submitting: '提交中...',
fullName: '全名',
age: '年龄',
cohort: '班级',
placementLocation: '安置地点',
competenceSkills: '能力技能',
profilePhoto: '个人照片',
employmentSector: '就业领域',
companyName: '公司名称',
workingPosition: '工作职位',
workingLocation: '工作地点',
modeOfEmployment: '就业方式',
yearsOfExperience: '工作经验年数',
monthlyIncome: '大约月收入',
contractStartDate: '合同开始日期',
contractEndDate: '合同结束日期',
selectCohort: '选择班级',
selectDepartment: '选择部门',
selectStatus: '选择状态',
selectSector: '选择领域',
selectMode: '选择方式',
selectIncome: '选择范围',
selectRelevance: '选择相关性',
selectConfidence: '选择信心水平',
selfEmployed: '自雇',
unemployed: '失业',
employedByCompany: '公司雇员',
workForOthers: '为他人工作',
continuingTraining: '继续培训',
publicSector: '公共部门',
privateSector: '私营部门',
ngo: '非政府组织',
other: '其他',
permanent: '永久职位',
internship: '实习',
partTime: '兼职合同',
volunteer: '志愿者',
directlyRelated: '直接相关',
somewhatRelated: '有些相关',
notRelated: '不相关',
veryGreatExtent: '非常大程度',
greatExtent: '很大程度',
moderateExtent: '中等程度',
smallExtent: '小程度',
notAtAll: '完全没有',
fullyIndependent: '我现在完全经济独立',
significantlyContribute: '我对家庭收入有显著贡献',
occasionallyContribute: '我偶尔为家庭收入做贡献',
notChanged: '我的财务状况没有改变',
worsened: '我的财务状况恶化了',
muchBetter: '好多了',
better: '更好',
same: '差不多',
worse: '更差',
muchWorse: '差多了',
yesEveryMonth: '是的，每月',
yesOccasionally: '是的，偶尔',
noButPlan: '不，但我有计划',
no: '不',
veryConfident: '非常自信',
confident: '自信',
moderatelyConfident: '适度自信',
slightlyConfident: '略微自信',
notConfident: '完全不自信',
transformational: '变革性的',
significantPositive: '显著的积极影响',
moderatePositive: '中等积极影响',
slightPositive: '轻微积极影响',
noImpact: '没有明显影响',
significantly: '是的，显著',
toSomeExtent: '是的，在某种程度上',
noChange: '没有变化',
lessInvolved: '比以前参与少',
confirmToggleStatus: '切换状态',
confirmToggleTraineeStatus: '您确定要切换此学员的活动状态吗？非活跃学员将不会显示在主页上。',
traineeActivated: '学员已成功激活',
traineeDeactivated: '学员已成功停用',
failedToggleTraineeStatus: '切换学员状态失败',
traineeInactive: '学员处于非活跃状态',
    homepageManagement: '主页管理',
heroSlides: '英雄幻灯片',
addHeroSlide: '添加英雄幻灯片',
editHeroSlide: '编辑英雄幻灯片',
noHeroSlides: '没有英雄幻灯片',
addHeroSlidesDesc: '添加要在主页英雄部分显示的幻灯片',
stats: '统计数据',
noStats: '没有统计数据',
addStatsDesc: '添加要在主页上显示的统计数据',
addStat: '添加统计',
editStat: '编辑统计',
statAdded: '统计添加成功',
statUpdated: '统计更新成功',
statDeleted: '统计删除成功',
confirmDeleteStat: '您确定要删除此统计吗？',
confirmDeleteStatTitle: '删除统计',
heroSlideAdded: '英雄幻灯片添加成功',
heroSlideUpdated: '英雄幻灯片更新成功',
heroSlideDeleted: '英雄幻灯片删除成功',
heroSlideStatusToggled: '英雄幻灯片状态已更新',
failedAddHeroSlide: '添加英雄幻灯片失败',
failedUpdateHeroSlide: '更新英雄幻灯片失败',
failedDeleteHeroSlide: '删除英雄幻灯片失败',
failedToggleHeroSlideStatus: '更新英雄幻灯片状态失败',
confirmDeleteHeroSlideTitle: '删除英雄幻灯片',
confirmDeleteHeroSlide: '您确定要删除此英雄幻灯片吗？',
failedLoadHeroSlides: '加载英雄幻灯片失败',
failedLoadStats: '加载统计数据失败',
failedAddStat: '添加统计失败',
failedUpdateStat: '更新统计失败',
failedDeleteStat: '删除统计失败',

activityImages: '活动图片',
activityImagesManagement: '活动图片管理',
addActivityImage: '添加活动图片',
editActivityImage: '编辑活动图片',
activityImageAdded: '活动图片添加成功',
activityImageUpdated: '活动图片更新成功',
activityImageDeleted: '活动图片删除成功',
activityImageStatusToggled: '活动图片状态已更新',
confirmDeleteActivityImage: '您确定要删除此活动图片吗？',
searchActivityImages: '搜索活动图片...',
bulkUpload: '批量上传',
bulkUploadImages: '批量上传图片',
bulkUploadComplete: '批量上传完成成功',
failedBulkUpload: '批量上传失败',
selectImagesToUpload: '请选择要上传的图片',
selectedFiles: '选中的文件',
uploadAll: '全部上传',
uploading: '上传中...',
imageRequired: '图片文件是必需的',
failedAddActivityImage: '添加活动图片失败',
failedUpdateActivityImage: '更新活动图片失败',
failedDeleteImage: '删除图片失败',
imageDeleted: '图片删除成功',
imageRestored: '图片恢复成功',
failedRestoreImage: '恢复图片失败',
imageStatusToggled: '图片状态已更新',
failedToggleImageStatus: '更新图片状态失败',
failedLoadActivityImages: '加载活动图片失败',
exportActivityImages: '导出活动图片',
activityImagesExported: '活动图片导出成功',
failedExportActivityImages: '导出活动图片失败',
womenInAction: '女性在行动',
totalImages: '总图片数',
activeImages: '活跃图片',
departmentsWithImages: '有图片的部门',
lastUpload: '上次上传',
never: '从未',
noActivityImages: '未找到活动图片',
addActivityImagesDesc: '添加要在主页“女性在行动”部分显示的图片',
    whyChooseUs: "为什么选择我们",
    deleteWhyChooseUs: "您确定要删除此项目吗？",
    deleteWhyChooseUsTitle: "删除项目",
    deleteVideo: "您确定要删除此视频吗？",
    deleteVideoTitle: "删除视频",
    added: "项目添加成功",
    updated: "项目更新成功",
    deleted: "项目删除成功",
    statusToggled: "状态更新成功",
    failedAdd: "添加项目失败",
    failedUpdate: "更新项目失败",
    failedDelete: "删除项目失败",
    failedToggle: "更新状态失败",
    videoSections: "视频部分",
    addVideo: "添加视频",
    editVideo: "编辑视频",
    noVideos: "没有视频部分",
    addVideos: "添加要在主页上显示的视频",
    videoUrl: "视频链接",
    thumbnail: "缩略图",
    setAsActive: "设置为活动视频",
    onlyOneActive: "一次只能有一个视频处于活动状态",
    currentThumbnail: "当前缩略图",
    watchVideo: "观看视频",
    playVideo: "播放视频",
    active: "活动中",
    inactive: "非活动",
    untitled: "无标题",
    youtubeEmbedUrl: "使用YouTube嵌入链接（例如：https://www.youtube.com/embed/视频ID）",
    enterVideoTitle: "输入视频标题",
    enterVideoDescription: "输入视频描述",
    setActive: "设置为活动",
    whyChooseUsItems: "为什么选择我们项目",
    addItem: "添加项目",
    editItem: "编辑项目",
    noWhyChooseUsItems: "没有为什么选择我们项目",
    addWhyChooseUsItems: "添加要在主页上显示的项目",
    icon: "图标",
    title: "标题",
    description: "描述",
    sortOrder: "排序顺序",
    status: "状态",
    actions: "操作",
    iconPreview: "图标预览",
    enterTitle: "输入标题",
    enterDescription: "输入描述",
    currentPassword: '当前密码',
enterCurrentPassword: '请输入当前密码',
passwordsDoNotMatch: '密码不匹配',
passwordTooShort: '密码至少需要6个字符',
passwordChanged: '密码修改成功！',
failedChangePassword: '密码修改失败',
changing: '修改中...',
changePassword: '修改密码',
    // Contract Management Translations
contracts: '我的合同',
activeContracts: '有效合同',
contractHistory: '合同历史',
completedContracts: '已完成',
expiringSoon: '即将到期',
noActiveContracts: '没有有效合同',
noActiveContractsDesc: '您目前没有任何有效合同。',
noContractHistory: '没有合同历史',
noContractHistoryDesc: '您没有任何已完成或终止的合同。',
contractDetails: '合同详情',
contractId: '合同ID',
period: '期限',
startDate: '开始日期',
endDate: '结束日期',
daysRemaining: '剩余天数',
status: '状态',
terminationReason: '终止原因',
renew: '续签',
renewNow: '立即续签',
terminate: '终止',
viewDetails: '查看详情',
renewContract: '续签合同',
terminateContract: '终止合同',
renewContractInfo: '当前合同到期日期：',
selectContractPeriod: '选择合同期限',
customMonths: '自定义月数...',
months: '个月',
sendEmailNotification: '发送邮件确认',
renewContractNote: '续签合同将创建新的合同期限。当前合同将被标记为已续签。',
renewing: '续签中...',
terminating: '终止中...',
warning: '警告',
terminateContractWarning: '此操作无法撤消。',
selectReason: '选择原因',
workCompleted: '工作完成',
performance: '表现问题',
budgetConstraints: '预算限制',
restructuring: '公司重组',
mutualAgreement: '双方协议',
other: '其他',
customReason: '自定义原因',
enterTerminationReason: '输入终止原因',
effectiveDate: '生效日期',
effectiveDateNote: '留空表示立即终止',
sendTerminationEmail: '发送终止确认邮件',
womanInformation: '女性信息',
name: '姓名',
age: '年龄',
department: '部门',
skills: '技能',
experience: '经验',
years: '年',
phone: '电话',
email: '邮箱',
contractInformation: '合同信息',
terminationDetails: '终止详情',
terminatedOn: '终止日期',
renewalInformation: '续签信息',
renewedFrom: '续签自',
renewedTo: '续签至',
notes: '备注',
close: '关闭',
expired: '已过期',
active: '有效',
searchContracts: '搜索合同...',
refresh: '刷新',
viewAll: '查看全部',
exportList: '导出列表',
exportSuccessful: '导出成功',
exportFailed: '导出失败，请重试。',
exportingContracts: '正在导出合同...',
    exportOptions: '导出选项',
exportAsCSV: '导出为CSV',
exportAsExcel: '导出为Excel',
exportAsPDF: '导出为PDF',
exportSuccessful: '导出成功',
exportFailed: '导出失败，请重试。',
exportingContracts: '正在导出合同...',
    contractExpiration: '合同到期',
showContractsExpiringIn: '显示在以下时间内到期的合同',
days: '天',
refresh: '刷新',
manageAllContracts: '管理所有合同',
activeContracts: '有效合同',
expiringThisMonth: '本月到期',
renewedThisMonth: '本月续签',
expiringNextMonth: '下月到期',
noExpiringContracts: '没有即将到期的合同',
noContractsExpiringSoon: '在所选时间段内没有即将到期的合同。',
contractsExpiringInNext: '个合同将在',
woman: '女性',
department: '部门',
contractPeriod: '合同期限',
startDate: '开始日期',
endDate: '结束日期',
daysRemaining: '剩余天数',
employer: '雇主',
contact: '联系方式',
actions: '操作',
noPhone: '无电话',
general: '通用',
months: '个月',
sendEmail: '发送电子邮件',
call: '打电话',
viewDetails: '查看详情',
sendReminder: '发送提醒',
extendContract: '延长合同',
exportExpiringContracts: '导出列表',

// Additional export-related translations
exportContracts: '导出合同',
exportAsCSV: '导出为CSV',
exportAsExcel: '导出为Excel',
exportAsPDF: '导出为PDF',
exportingContracts: '正在导出合同...',
exportSuccessful: '导出成功',
exportFailed: '导出失败，请重试。',
downloadExportedFile: '下载导出的文件',
selectExportFormat: '选择导出格式',
includeInactiveContracts: '包括无效合同',
exportAllContracts: '导出所有合同',
exportFilteredContracts: '导出筛选后的合同',
contractExportTitle: '合同导出',
generatingExport: '正在生成导出文件...',
contractList: '合同列表',
totalContracts: '合同总数',
exportDate: '导出日期',
exportedBy: '导出人',
contractDetails: '合同详情',
womanName: '女性姓名',
employerName: '雇主姓名',
employerEmail: '雇主邮箱',
employerPhone: '雇主电话',
contractStart: '合同开始',
contractEnd: '合同结束',
contractMonths: '合同月数',
status: '状态',
active: '有效',
expired: '已过期',
expiringSoon: '即将到期',
critical: '紧急',
warning: '警告',
good: '良好',
exportSummary: '导出摘要',
rowsExported: '行已导出',
exportTime: '导出时间',
contractStats: '合同统计',
fetchingContracts: '正在获取合同...',
noContractsFound: '未找到合同',
viewContract: '查看合同',
contractId: '合同ID',
contractStatus: '合同状态',
renewContract: '续签合同',
contractRenewed: '合同续签成功',
renewalDate: '续签日期',
previousContract: '上一个合同',
nextContract: '下一个合同',
contractHistory: '合同历史',
renewalHistory: '续签历史',
confirmRenewContract: '确定要续签此合同吗？',
enterRenewalMonths: '输入续签月数',
renewalPeriod: '续签期限',
newEndDate: '新的结束日期',
contractNotes: '合同备注',
addContractNote: '添加备注',
viewAllContracts: '查看所有合同',
filterContracts: '筛选合同',
searchContracts: '搜索合同...',
clearFilters: '清除筛选',
applyFilters: '应用筛选',
     // Partners Management - Chinese
     partners: '合作伙伴与赞助商',
     partnersManagement: '合作伙伴管理',
     addPartner: '添加合作伙伴',
     editPartner: '编辑合作伙伴',
     partnerName: '合作伙伴名称',
     partnerType: '合作伙伴类型',
     partnerLogo: '合作伙伴标志',
     websiteUrl: '网站地址',
     sortOrder: '排序顺序',
     enterPartnerName: '输入合作伙伴/组织名称',
     selectType: '选择合作伙伴类型',
     enterPartnerDescription: '输入合作伙伴描述',
     currentLogo: '当前标志',
     updatePartner: '更新合作伙伴',
     failedAddPartner: '添加合作伙伴失败',
     failedUpdatePartner: '更新合作伙伴失败',
     failedDeletePartner: '删除合作伙伴失败',
     failedLoadPartners: '加载合作伙伴失败',
     failedTogglePartnerStatus: '切换合作伙伴状态失败',
     partnerAdded: '合作伙伴添加成功',
     partnerUpdated: '合作伙伴更新成功',
     partnerDeleted: '合作伙伴删除成功',
     partnerStatusToggled: '合作伙伴状态更新成功',
     confirmDeletePartnerTitle: '删除合作伙伴',
     confirmDeletePartner: '确定要删除此合作伙伴吗？此操作无法撤销。',
     searchPartners: '搜索合作伙伴...',
     allTypes: '所有类型',
     noPartnersFound: '未找到合作伙伴',
     noPartnersMatchCriteria: '没有符合条件的合作伙伴',
     showingPartners: '显示 {showing} 个合作伙伴，共 {total} 个',
     deactivate: '停用',
     activate: '激活',
     visit: '访问',
     noDescription: '无描述',
     partnerDescriptionDefault: '合作组织',
     visitWebsite: '访问网站',
     government: '政府',
     internationalNGO: '国际非政府组织',
     localNGO: '本地非政府组织',
     corporate: '企业',
     private: '私营',
     educational: '教育机构',
     other: '其他',
     partnersCount: '合作伙伴数量',
     activePartners: '活跃合作伙伴',
     inactivePartners: '非活跃合作伙伴',
     partnerStats: '合作伙伴统计',
     exportPartners: '导出合作伙伴',
     importPartners: '导入合作伙伴',
     partnerDetails: '合作伙伴详情',
     establishedDate: '成立日期',
     lastUpdated: '最后更新',
    amountNote:'每位女性固定费用 10,000 卢旺达法郎，无论合同期限长短',
    enterEmailAddress: '请输入您的电子邮件地址',
    resetEmailSent: '密码重置电子邮件已发送。请检查您的收件箱。',
    resetRequestFailed: '处理重置请求失败。请重试。',
    forgotPasswordDescription: '输入您的电子邮件以重置密码',
    backToLogin: '返回登录',
    sendResetLink: '发送重置链接',
    sending: '正在发送...',
    resetInstructions: '您将收到一封包含密码重置链接的电子邮件。该链接将在1小时后过期。',
    
    // Chinese (中文)
    contractPeriod: '合同期限',
    selectContractPeriod: '选择合同期限',
    requiredSkills: '所需技能',
    selectRelevantSkills: '选择此职位所需的相关技能',
    noSkillsForDepartment: '该部门没有可用技能',
    expiringContracts: '即将到期的合同',
    showContractsExpiringIn: '显示在以下时间内到期的合同:',
    noExpiringContracts: '没有即将到期的合同',
    noContractsExpiringSoon: '没有即将到期的合同',
    daysRemaining: '剩余天数',
    daysLeft: '剩余天数',
    sendReminder: '发送提醒',
    renewContract: '续签合同',
    contractRenewed: '合同续签成功',
    months: '个月',
    
    csvTemplateInstructions: 'CSV应包含列：姓名、年龄、部门、技能、工作经验年数、教育水平、电话、电子邮件、位置、简介、技能名称',
    importInstructions: '下载模板以确保格式正确',
    downloadTemplate: '下载模板',
    importing: '导入中...',
    import: '导入',
    importProfiles: '导入个人资料',
    cannotAssignDifferentDept: '无法分配来自不同部门的女性',
    validationFailed: '验证失败',
    viewCertificate: '查看证书',
    certified: '已认证',
    certificatePending: '证书待处理',
    requestThisWoman: '请求此女性',
    currentlyEmployed: '目前受雇',
    
    '3 months': '3个月',
    '6 months': '6个月',
    '1 year': '1年',
    '2 years': '2年',
    '3 years': '3年',
    
    beginner: '初级',
    intermediate: '中级',
    advanced: '高级',
    expert: '专家级',
    
    sendCustomEmail: '发送自定义电子邮件',
    emailRecipients: '电子邮件收件人',
    enterEmailRecipients: '输入电子邮件地址（用逗号分隔）',
    commaSeparatedEmails: '输入多个用逗号分隔的电子邮件地址',
    customEmailDescription: '发送电子邮件到任何电子邮件地址（不限于系统用户）',
    allFieldsRequired: '所有字段均为必填项',
    invalidEmails: '无效的电子邮件地址',
    emailSentSuccessfully: '成功发送电子邮件给  位收件人',
    failedToSendEmail: '发送电子邮件失败',
    customEmail: '自定义电子邮件',
    attachments: '附件',
    maxFileSize: '最大文件大小',
    uploadCSVFile: '上传CSV文件',
    importWomenProfiles: '导入女性个人资料',
    // Privacy Policy
  privacyPolicy: '隐私政策',
  lastUpdated: '最后更新',
  privacyIntroTitle: '介绍',
  privacyIntroText: 'Urugo妇女机会中心重视您的隐私。本隐私政策解释了我们如何收集、使用和保护您的个人信息。',
  informationWeCollect: '我们收集的信息',
  personalInformation: '个人信息',
  infoNameEmail: '姓名和电子邮件地址',
  infoPhoneAddress: '电话号码和实际地址',
  infoPaymentDetails: '捐款支付信息',
  infoEmploymentHistory: '工作历史和技能信息',
  usageData: '使用数据',
  dataIPAddress: 'IP地址和浏览器类型',
  dataBrowserType: '设备信息',
  dataPagesVisited: '访问的页面和时间花费',
  dataTimeSpent: '引荐网站信息',
  howWeUseInformation: '我们如何使用您的信息',
  useProvideServices: '提供和维护我们的服务',
  useProcessDonations: '处理捐款和支付',
  useMatchEmployees: '为妇女匹配就业机会',
  useCommunication: '与您沟通',
  useImproveServices: '改进我们的服务和网站',
  useLegalCompliance: '遵守法律义务',
  informationSharing: '信息共享',
  sharingIntro: '我们不出售您的个人信息。我们仅在以下情况下共享信息：',
  withEmployers: '与雇主',
  sharingEmployers: '仅在您同意进行工作匹配时',
  withServiceProviders: '与服务提供商',
  sharingProviders: '协助我们运营的受信任合作伙伴',
  legalRequirements: '法律要求',
  sharingLegal: '当法律或法律程序要求时',
  withConsent: '经您同意',
  sharingConsent: '当您明确给予我们许可时',
  dataSecurity: '数据安全',
  securityMeasures: '我们实施适当的安全措施来保护您的信息。',
  securityEncryption: '数据传输的SSL加密',
  securityAccessControl: '访问控制和身份验证',
  securityRegularAudits: '定期安全审计',
  securityTraining: '员工隐私培训',
  yourRights: '您的权利',
  rightAccess: '访问个人数据的权利',
  rightCorrection: '纠正不准确数据的权利',
  rightDeletion: '删除数据的权利',
  rightObject: '反对处理的权利',
  rightDataPortability: '数据可携权',
  rightWithdrawConsent: '撤回同意的权利',
  cookies: 'Cookie',
  cookiesDescription: '我们使用cookie来改善您在网站上的体验。',
  essentialCookies: '基本Cookie',
  essentialCookiesDesc: '网站基本功能所需',
  analyticsCookies: '分析Cookie',
  analyticsCookiesDesc: '帮助我们了解访问者如何使用我们的网站',
  preferenceCookies: '偏好Cookie',
  preferenceCookiesDesc: '记住您的设置和偏好',
  childrenPrivacy: '儿童隐私',
  childrenPrivacyText: '我们的服务不针对18岁以下的儿童。',
  changesToPolicy: '本隐私政策的变更',
  policyChangesText: '我们可能会定期更新隐私政策。',
  contactUsPrivacy: '联系我们',
  contactPrivacyText: '如果您对本隐私政策有任何疑问，请联系我们：',
  
  // Terms of Service
  termsOfService: '服务条款',
  termsAgreement: '同意条款',
  termsAgreementText: '访问和使用我们的平台，即表示您同意这些服务条款。',
  definitions: '定义',
  platform: '平台',
  platformDefinition: 'Urugo WOC网站和服务',
  services: '服务',
  servicesDefinition: '就业匹配、培训和捐款服务',
  user: '用户',
  userDefinition: '访问或使用平台的任何人',
  employer: '雇主',
  employerDefinition: '寻求雇用的个人或公司',
  employee: '雇员',
  employeeDefinition: '寻求就业机会的妇女',
  donor: '捐赠者',
  donorDefinition: '进行捐赠的个人或组织',
  accountRegistration: '账户注册',
  accountRegistrationText: '要使用某些功能，您必须注册账户。',
  accountAgeRequirement: '您必须年满18岁',
  accountAccurateInfo: '提供准确完整的信息',
  accountSecurity: '维护账户安全',
  accountTransfer: '不要将账户转让给他人',
  servicesDescription: '服务描述',
  employmentServices: '就业服务',
  employmentMatch: '将有资质的妇女与雇主匹配',
  employmentVerification: '技能和资格验证',
  employmentTraining: '培训和技能发展',
  employmentSupport: '持续的就业支持',
  donationServices: '捐款服务',
  donationProcessing: '处理货币捐款',
  donationTracking: '跟踪捐款影响',
  donationReporting: '定期影响报告',
  donationTransparency: '透明的资金分配',
  userObligations: '用户义务',
  generalUserObligations: '一般用户义务',
  obeyLaws: '遵守所有适用的法律法规',
  respectOthers: '尊重其他用户及其隐私',
  noFraud: '不从事欺诈活动',
  accurateInfo: '提供准确信息',
  noHarassment: '不骚扰或歧视',
  employerObligations: '雇主义务',
  fairTreatment: '提供公平的就业条件',
  timelyPayment: '按时支付',
  safeEnvironment: '提供安全的工作环境',
  complianceLaws: '遵守就业法律',
  employeeObligations: '雇员义务',
  professionalConduct: '保持专业行为',
  honestSkills: '诚实地展示技能和可用性',
  commitment: '履行就业承诺',
  respectEmployer: '尊重雇主财产和规则',
  paymentsFees: '付款和费用',
  serviceFees: '某些服务可能会收取服务费',
  donationFees: '捐款处理费',
  paymentMethods: '接受的支付方式',
  refundPolicy: '捐款退款政策',
  taxResponsibility: '税务责任',
  intellectualProperty: '知识产权',
  ipOwnership: '我们拥有平台的所有知识产权。',
  ipLicense: '我们授予您使用平台的有限许可。',
  userContentLicense: '您授予我们使用您内容进行平台运营的许可。',
  limitationLiability: '责任限制',
  liabilityDisclaimer: '我们"按原样"提供服务，不作任何保证。',
  liabilityLimit: '我们的责任限制',
  liabilityForceMajeure: '不可抗力事件',
  termination: '终止',
  terminationClause: '我们可以终止或暂停您对账户的访问。',
  terminationBreach: '违反这些条款',
  terminationInactivity: '长时间不活动',
  terminationRequest: '应您的要求',
  terminationPlatform: '平台维护或安全',
  disputeResolution: '争议解决',
  governingLaw: '管辖法律',
  disputeProcess: '争议解决流程',
  mediationClause: '诉讼前的调解',
  changesToTerms: '条款变更',
  termsChangesText: '我们可以随时修改这些条款。',
  contactUsTerms: '联系我们',
  contactTermsText: '如有关于这些条款的问题，请联系我们：',
  
  // Sitemap
  sitemap: '网站地图',
  sitemapDescription: 'Urugo WOC上所有可用页面和服务的完整概述',
  mainPages: '主要页面',
  accountPages: '账户页面',
  policyPages: '政策页面',
  servicePages: '服务页面',
  departmentPages: '部门页面',
  trainingServices: '培训服务',
  donationServices: '捐款服务',
  supportServices: '支持服务',
  contactInformation: '联系信息',
  quickActions: '快速操作',
  donateNow: '立即捐款',
  registerNow: '立即注册',
  totalPages: '总页数',
  websiteVersion: '网站版本',
  viewPrivacy: '查看隐私政策',
  viewTerms: '查看服务条款',
  viewSitemap: '查看网站地图',
  backToHome: '返回首页',

    // Modal Alert translations
  alertSuccess: '成功',
  alertError: '错误',
  alertWarning: '警告',
  alertInfo: '信息',
  okButton: '确定',
  confirmButton: '确认',
  cancelButton: '取消',
  tryAgainButton: '再试一次',
  close: '关闭',
  
  // Request Modal translations
  step1Title: '告诉我们关于您',
  step1Description: '在我们多元化的社区中寻找培训过的女性',
  step2Title: '创建您的账户',
  step2Description: '加入我们的社区，雇佣熟练的女性',
  loginTitle: '登录您的账户',
  loginDescription: '已经有账户了？登录继续',
  step3Title: '请求培训过的女性',
  step3Description: '填写以下表格，从我们中心请求熟练的女性',
  successTitle: '请求提交成功！',
  successMessage: '您的请求已收到。我们将尽快与您联系。',
  
  // Account types
  individual: '个人',
  individualDesc: '我为自己雇佣',
  company: '公司',
  companyDesc: '我为我的公司雇佣',
  
  // Form labels
  companyNameLabel: '公司名称',
  companyNamePlaceholder: '输入公司名称',
  fullNameLabel: '全名',
  fullNamePlaceholder: '输入您的全名',
  usernameLabel: '用户名',
  usernamePlaceholder: '选择一个用户名',
  workEmailLabel: '工作邮箱',
  workEmailPlaceholder: '输入您的工作邮箱',
  phoneLabel: '电话号码',
  phonePlaceholder: '输入您的电话号码',
  emailLabel: '邮箱地址',
  emailPlaceholder: '输入您的邮箱',
  passwordLabel: '密码',
  passwordPlaceholder: '输入您的密码',
  createPasswordPlaceholder: '创建密码',
  confirmPasswordLabel: '确认密码',
  confirmPasswordPlaceholder: '确认您的密码',
  passwordMinLength: '至少10个字符',
  agreeToTerms: '我同意服务条款和隐私政策',
  
  // Request form
  selectDepartment: '选择部门',
  chooseDepartment: '选择一个部门',
  employeesNeeded: '员工数量',
  costPerEmployee: '每月每位员工10000卢旺达法郎',
  workType: '工作类型',
  fullTime: '全职',
  partTime: '兼职',
  contract: '合同',
  seasonal: '季节性',
  duration: '时长（天）',
  days: '天',
  totalAmount: '总金额',
  woman: '女性',
  'employee(s)': '员工',
  personalInformation: '个人信息',
  yourFullName: '您的全名',
  email: '邮箱',
  phoneNumber: '电话号码',
  
  // Specifications
  womanSpecifications: '女性规格（可选）',
  specificationsDescription: '为您想要雇佣的女性提供额外要求',
  ageRange: '首选年龄范围',
  experienceLevel: '经验水平',
  skillLevel: '所需技能水平',
  educationLevel: '教育水平',
  languageRequirements: '语言要求',
  specialSkills: '所需特殊技能',
  otherSpecifications: '其他规格',
  noPreference: '无偏好',
  years: '年',
  beginner: '初学者',
  intermediate: '中级',
  advanced: '高级',
  expert: '专家',
  basic: '基本技能',
  kinyarwanda: '基尼亚卢旺达语',
  french: '法语',
  kinyarwandaEnglish: '基尼亚卢旺达语和英语',
  anyLanguage: '任何语言',
  primary: '小学教育',
  secondary: '中学教育',
  vocational: '职业培训',
  university: '大学学位',
  specialSkillsPlaceholder: '例如：计算机技能、领导能力等',
  separateWithCommas: '用逗号分隔',
  otherSpecificationsPlaceholder: '任何其他具体要求或偏好...',
  
  // Payment
  paymentInformation: '支付信息',
  mobileMoney: '移动支付',
  bankAccount: '银行账户',
  paymentNote: '提交请求后请完成支付。支付验证后您的请求将被处理。',
  
  // Buttons and actions
  continue: '继续',
  back: '返回',
  backToRegister: '返回注册',
  join: '加入',
  loggingIn: '登录中...',
  creatingAccount: '创建账户中...',
  submitting: '提交中...',
  submitRequest: '提交请求',
  alreadyHaveAccount: '已经有账户',
    // New keys for request specifications
requestManagementWithSpecs: '请求管理（含规格说明）',
specifications: '规格说明',
noSpecifications: '无规格说明',
viewSpecifications: '查看规格说明',
hasSpecifications: '有规格说明',
withSpecifications: '有规格说明',
noSpecificationsProvided: '此请求未提供额外的规格说明。',
requestDetails: '请求详情',
employerInformation: '雇主信息',
statusInformation: '状态信息',
employeesNeeded: '所需员工',
workType: '工作类型',
duration: '持续时间',
amount: '金额',
paymentVerified: '付款已核实',
assignedWomen: '已分配妇女',
availableWomen: '可用妇女',
created: '创建时间',
ageRange: '年龄范围',
experienceLevel: '经验水平',
skillLevel: '技能水平',
educationLevel: '教育水平',
languageRequirements: '语言要求',
specialSkills: '特殊技能',
otherSpecifications: '其他规格说明',
approveRequest: '批准请求',
rejectRequest: '拒绝请求',
assignWomen: '分配妇女',
close: '关闭',

// Certificate related
uploadCertificate: '上传证书',
certificateNumber: '证书编号',
certificateType: '证书类型',
selectCertificateType: '选择证书类型',
vocationalCertificate: '职业证书',
skillCertificate: '技能证书',
trainingCertificate: '培训证书',
professionalCertificate: '专业证书',
otherCertificate: '其他证书',
issuingOrganization: '颁发机构',
issueDate: '颁发日期',
expiryDate: '到期日期',
certificateFile: '证书文件',
maxFileSize: '最大文件大小',
currentCertificate: '当前证书',
viewCurrentCertificate: '查看当前证书',
updateCertificate: '更新证书',
certificateVerified: '已验证证书',
certificateUnverified: '未验证证书',
noCertificate: '无证书',
viewCertificate: '查看证书',
markAsUnverified: '标记为未验证',
verifyCertificate: '验证证书',
deleteCertificate: '删除证书',
confirmDeleteCertificateTitle: '删除证书',
confirmDeleteCertificate: '您确定要删除此证书吗？此操作无法撤销。',
confirmVerifyCertificateTitle: '验证证书',
confirmVerifyCertificate: '您确定要验证此证书吗？',
confirmUnverifyCertificateTitle: '取消验证证书',
confirmUnverifyCertificate: '您确定要将此证书标记为未验证吗？',
certificateUploaded: '证书上传成功',
certificateDeleted: '证书删除成功',
certificateVerifiedSuccess: '证书验证成功',
certificateUnverifiedSuccess: '证书标记为未验证成功',
failedUploadCertificate: '证书上传失败',
failedDeleteCertificate: '证书删除失败',
failedVerifyCertificate: '证书验证失败',
failedUnverifyCertificate: '证书取消验证失败',

// Women management
selectAllAvailable: '选择所有可用妇女',
womanNotAvailable: '妇女不可用于分配',
selectForAssignment: '选择分配',
womenSelectedForAssignment: '已选择分配的妇女',
selected: '已选择',
assignSelectedWomen: '分配已选择的妇女',

// Request status
completed: '已完成',
cancelled: '已取消',
    emailSettings: '电子邮件设置',
emailBroadcast: '邮件广播',
emailBroadcastDescription: '向系统所有用户发送公告和更新',
sendEmailBroadcast: '发送邮件广播',
sendTestEmail: '发送测试邮件',
broadcastAllUsersWarning: '此邮件将发送给系统中的所有用户。',
broadcastEmployersWarning: '此邮件仅发送给雇主。',
broadcastAdminsWarning: '此邮件仅发送给管理员。',
broadcastManagersWarning: '此邮件仅发送给经理。',
currentPassword: '当前密码',
newPassword: '新密码',
confirmPassword: '确认密码',
enterCurrentPassword: '输入当前密码',
enterNewPassword: '输入新密码',
confirmNewPassword: '确认新密码',
changing: '更改中...',
systemSettings: '系统设置',
timezone: '时区',
dateFormat: '日期格式',
itemsPerPage: '每页项目数',
resetToDefaults: '恢复默认设置',
recipients: '收件人',
allUsers: '所有用户',
employersOnly: '仅雇主',
adminsOnly: '仅管理员',
managersOnly: '仅经理',
testEmailAddress: '测试邮件地址',
enterTestEmail: '输入测试邮件地址',
testEmailDescription: '发送测试邮件以验证格式',
sending: '发送中...',
sendBroadcast: '发送广播',
enterEmailSubject: '输入邮件主题',
enterEmailMessage: '在此输入您的邮件内容...',
    // Donate Modal translations - Chinese
    donateTitle: '支持我们的女性',
    donateDescription: '您的捐赠有助于培训更多女性并创造可持续生计',
    quickSelectAmount: '快速选择金额 (RWF):',
    donationAmountLabel: '捐赠金额 (RWF) *',
    donationAmountPlaceholder: '输入金额',
    donorNameLabel: '您的姓名 *',
    donorNamePlaceholder: '输入您的姓名',
    emailLabel: '电子邮件',
    emailPlaceholder: '输入您的电子邮件',
    phoneLabel: '电话',
    phonePlaceholder: '输入您的电话号码',
    messageLabel: '留言 (可选)',
    messagePlaceholder: '添加鼓励信息...',
    donationInfo1: '💝 100%的捐赠直接用于培训项目',
    donationInfo2: '🌍 您的贡献改变生活和社区',
    donationInfo3: '🌍 移动货币: +250791196394',
    donationInfo4: '🏦 银行名称：基加利银行',
donationInfo5: '👤 账户名称：WFW1 Empowerment Center LLC / Urugo Women\'s Opportunity Center',
donationInfo6: '💰 卢旺达法郎账户：00059-06929965-20',
donationInfo7: '💵 美元账户：00059-06929966-21',
    cancelButton: '取消',
    processingButton: '处理中...',
    makeDonationButton: '进行捐赠',
    successTitle: '感谢您的慷慨捐赠！',
    successMessage: '您的支持改变了女性的生活。',
    errorMessage: '处理捐赠时出错。请重试。',
    // Login Modal translations - Chinese
    close: '关闭',
    loginWelcome: '欢迎回来',
    loginDescription: '登录您的账户以继续',
    emailPlaceholder: '电子邮件地址',
    passwordPlaceholder: '密码',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    signingIn: '正在登录...',
    signIn: '登录',
    noAccount: '没有账户？',
    signUp: '注册',
    loginErrorGeneric: '登录失败。请检查您的凭据。',
        // ===== Passwordless Auth Flow - Chinese =====
    loginEmailOnlyHint: '输入您的电子邮件以继续',
    loginStaffHint: '员工登录 — 请输入您的密码',
    loggingInEmployer: '正在登录...',
    checking: '正在检查...',
    change: '更改',
    invalidEmail: '请输入有效的电子邮件地址',
    noAccountFound: '未找到此电子邮件的账户。请先注册。',
    unknownUserType: '未知用户类型。请联系支持。',
    emailLoginHint: '我们将通过电子邮件查找您的账户。无需密码。',
    loginDescriptionEmailOnly: '输入您的电子邮件以继续 — 无需密码',
    registerDescriptionNoPassword: '只需输入您的详细信息 — 无需密码',
    step2DescriptionNoPassword: '只需输入您的电子邮件 — 无需密码',
    loginSuccessMessage: '您现在已登录！',
    // Register Modal translations - Chinese
    registerCreateAccount: '创建账户',
    registerDescription: '加入Urugo WOC，开始雇用受过培训的女性',
    fullNameLabel: '全名 *',
    fullNamePlaceholder: '输入您的全名',
    usernameLabel: '用户名 *',
    usernamePlaceholder: '选择一个用户名',
    emailLabel: '电子邮件地址 *',
    emailPlaceholder: '输入您的电子邮件',
    phoneLabel: '电话号码',
    phonePlaceholder: '输入您的电话号码',
    passwordLabel: '密码 *',
    passwordPlaceholder: '创建密码',
    confirmPasswordLabel: '确认密码 *',
    confirmPasswordPlaceholder: '确认您的密码',
    passwordStrength: '强度',
    passwordVeryWeak: '非常弱',
    passwordWeak: '弱',
    passwordFair: '中等',
    passwordGood: '好',
    passwordStrong: '强',
    userTypeTitle: '我注册为:',
    userTypeEmployer: '雇主',
    userTypeEmployerDesc: '雇用受过培训的女性',
    creatingAccount: '正在创建账户...',
    createAccount: '创建账户',
    registerErrorGeneric: '注册失败。请重试。',
    registerErrorPasswordMatch: '密码不匹配',
    registerErrorPasswordWeak: '请使用更强的密码',
    alreadyHaveAccount: '已有账户？',
    signIn: '登录',
    // Footer & Chat Bot Translations
  chatWelcome: "您好！欢迎来到乌鲁戈女性机会中心。今天我可以如何帮助您？",
  justNow: "刚刚",
  chatQuestionHire: "如何雇用培训过的女性？",
  chatQuestionDonate: "如何捐款支持女性？",
  chatQuestionTraining: "如何申请培训？",
  chatQuestionContact: "如何联系您？",
  chatKeywordHire: "雇用",
  chatResponseHire: "您可以通过在我们的门户网站上创建雇主帐户来雇用我们培训过的女性。访问'雇用人才'部分以查看可用女性资料并提交您的雇用请求。培训过的女性已准备好就业，涵盖咖啡店运营、家政、缝纫等多个部门。",
  chatKeywordEmployer: "雇主",
  chatResponseEmployer: "作为雇主，您可以在我们的门户网站上注册以访问熟练女性资料。我们提供经过预筛选、培训过的女性，随时可以就业。您可以提交具体要求，我们将为您匹配合适的候选人。",
  chatKeywordRequest: "请求",
  chatResponseRequest: "要请求培训过的女性，请登录您的雇主帐户并填写雇用申请表。指定所需女性人数、所需技能和就业期限。我们的团队将在24小时内与您联系。",
  chatKeywordDonate: "捐赠",
  chatResponseDonate: "感谢您有兴趣捐赠！您可以通过我们的安全门户在线捐赠、通过银行转账或访问我们的中心进行捐赠。您的捐赠有助于培训更多女性并为她们提供就业机会。",
  chatKeywordSupport: "支持",
  chatResponseSupport: "您可以通过捐赠、成为企业赞助商、志愿服务或与我们合作来支持我们。请联系我们的发展团队：info@urugowoc.com 获取更多信息。",
  chatKeywordTraining: "培训",
  chatResponseTraining: "我们在7个部门提供职业培训。要申请，请访问我们在卡永扎的中心或通过我们的网站在线申请。培训计划对符合条件的女性免费，并在完成后包括认证。",
  chatKeywordApply: "申请",
  chatResponseApply: "要申请培训，请访问我们的网站并填写申请表。您需要提供个人信息并指明您感兴趣的部门。我们的团队将联系您进行面试。",
  chatKeywordLogin: "登录",
  chatResponseLogin: "要登录，请点击顶部导航栏中的'登录'按钮。雇主、受训者和管理员有单独的登录门户。如果您没有帐户，可以从登录页面注册。",
  chatKeywordRegister: "注册",
  chatResponseRegister: "雇主、寻求培训的女性和志愿者都可以注册。点击登录页面上的'注册'并选择您的用户类型。填写您的详细信息，我们的团队将验证您的帐户。",
  chatKeywordAbout: "关于",
  chatResponseAbout: "乌鲁戈女性机会中心成立于通过职业培训和就业赋权女性。自2013年以来，我们已经培训了600多名女性。请访问我们的'关于我们'页面，了解更多关于我们的使命、愿景和影响的信息。",
  chatKeywordGallery: "画廊",
  chatResponseGallery: "我们的画廊展示了培训中的女性、毕业典礼和成功的就业故事。您可以看到所有7个培训部门的照片，并见证我们中心发生的转变。",
  chatKeywordDepartments: "部门",
  chatResponseDepartments: "我们有7个培训部门：1) 咖啡店运营，2) 家政，3) 接待，4) 缝纫，5) 皮革加工，6) 地毯制作，和7) 牛奶和酸奶生产。每个计划都包括实践培训和认证。",
  chatKeywordContact: "联系",
  chatResponseContact: "您可以通过电子邮件 info@urugowoc.com、致电 +250788350577、访问我们在卡永扎的中心或使用此聊天机器人联系我们。我们的团队在工作日周一至周五上午8点至下午5点提供服务。",
  chatKeywordLocation: "位置",
  chatResponseLocation: "我们位于卢旺达卡永扎。您可以在乌鲁戈女性机会中心，卡永扎区找到我们。请访问我们，查看我们的培训设施并认识我们的团队。",
  chatResponseDefault: "感谢您的问题！如需更具体的信息，请直接通过 info@urugowoc.com 或致电 +250788350577 联系我们。",
  chatTitle: "乌鲁戈 WOC 助手",
  close: "关闭",
  chatQuickQuestions: "快速问题",
  chatPlaceholder: "在此输入您的消息...",
  send: "发送",
  chatToggleTooltip: "与我们聊天",
  whatsappDefaultMessage: "您好乌鲁戈 WOC，我有一个关于雇用培训过的女性/捐赠/培训的问题...",
  whatsappTooltip: "在 WhatsApp 上与我们聊天",
  footerTitle: "WfWI/Urugo WOC",
  footerDescription: "自2013年以来，通过技能培训和就业机会赋权女性。通过创造可持续的生计来转变社区。",
  facebook: "脸书",
  twitter: "推特",
  instagram: "Instagram",
  youtube: "YouTube",
  whatsapp: "WhatsApp",
  quickLinks: "快速链接",
  home: "首页",
  about: "关于我们",
  departments: "部门",
  women: "我们的女性",
  gallery: "画廊",
  donate: "捐赠",
  hire: "雇用",
  login: "登录",
  contactInfo: "联系信息",
  location: "卡永扎，卢旺达",
  phoneNumber: "+250 788350577",
  email: "info@urugowoc.com",
  hireWomen: "雇用培训过的女性",
  donateNow: "立即捐赠",
  loginRegister: "登录/注册",
  ourDepartments: "我们的部门",
  coffeeShopOperation: "咖啡店运营",
  housekeepingOperation: "家政服务",
  receptionOperation: "接待服务",
  sewingOperation: "缝纫服务",
  leatherOperation: "皮革加工",
  carpetOperation: "地毯制作",
  milkYogurtProduction: "牛奶和酸奶生产",
  copyright: "乌鲁戈女性机会中心。保留所有权利。",
  privacyPolicy: "隐私政策",
  termsOfService: "服务条款",
  sitemap: "网站地图",
    // Manager Dashboard Translations
    dashboard: "仪表板",
    requests: "请求",
    women: "女性",
    users: "用户",
    donations: "捐款",
    gallery: "画廊",
    about: "关于",
    reports: "报告",
    settings: "设置",
    manager: "经理",
    totalUsers: "总用户",
    totalRequests: "总请求",
    totalRevenue: "总收入",
    activeWomen: "活跃女性",
    recentActivity: "最近活动",
    totalWomen: "总女性",
    employerCount: "雇主",
    newThisMonth: "本月新增",
    activeToday: "今日活跃",
    pendingRequests: "待处理请求",
    approvedRequests: "已批准请求",
    rejectedRequests: "已拒绝请求",
    loadingDashboard: "正在加载仪表板...",
    failedLoadDashboard: "加载仪表板数据失败",
    justNow: "刚刚",
    notificationPendingRequests: "您有  个待处理请求",
    newUsersThisWeek: "本周新用户",
    newDonations: "新捐款",
    failedLoadEmployerDetails: "加载雇主详情失败",
    selectWomenToAssign: "请先选择要分配的女性",
    selectRequestEmployer: "请选择请求/雇主",
    noWomenSelected: "未选择女性",
    successfullyAssignedWomen: "成功将 名女性分配给 {employer}",
    failedToAssignWomen: "分配女性失败",
    failedLoadWomenProfiles: "加载女性资料失败",
    accessDenied: "访问被拒绝。请重新登录。",
    requestStatusUpdated: "请求状态已更新为 {status}",
    failedUpdateRequest: "更新请求失败",
    userStatusUpdated: "用户 {status} 成功",
    suspended: "已暂停",
    activated: "已激活",
    failedUpdateUser: "更新用户失败",
    confirmDeleteUser: "您确定要删除此用户吗？",
    userDeleted: "用户删除成功",
    failedDeleteUser: "删除用户失败",
    profileAvailabilityUpdated: "资料可用性已更新为 {status}",
    available: "可用",
    hired: "已雇佣",
    failedUpdateProfile: "更新资料失败",
    confirmDeleteProfile: "您确定要删除此资料吗？",
    profileDeleted: "资料删除成功",
    failedDeleteProfile: "删除资料失败",
    profileAdded: "资料添加成功",
    failedAddProfile: "添加资料失败",
    profileUpdated: "资料更新成功",
    exportSuccessful: "导出成功！文件已下载",
    failedExportData: "导出数据失败",
    searchRequests: "搜索请求...",
    clearFilters: "清除筛选",
    filterBy: "筛选依据",
    allStatus: "所有状态",
    pending: "待处理",
    approved: "已批准",
    rejected: "已拒绝",
    cancelled: "已取消",
    to: "至",
    exportRequests: "导出请求",
    noRequestsFound: "未找到请求",
    noRequestsMatch: "没有符合您条件的请求",
    noRequestsAvailable: "没有可用的请求",
    showingRequests: "显示  个请求",
    id: "编号",
    date: "日期",
    employer: "雇主",
    department: "部门",
    employees: "员工",
    duration: "持续时间",
    amount: "金额",
    status: "状态",
    actions: "操作",
    days: "天",
    n_a: "不适用",
    viewRequest: "查看请求",
    approveRequest: "批准请求",
    rejectRequest: "拒绝请求",
    womenProfilesManagement: "女性资料管理",
    searchWomen: "搜索女性...",
    assignSelected: "分配选定",
    addNewProfile: "添加新资料",
    allDepartments: "所有部门",
    clearFilters: "清除筛选",
    womenSelectedForAssignment: " 名女性被选定分配",
    selected: "已选定",
    assignSelectedWomen: "分配选定女性",
    noWomenProfilesFound: "未找到女性资料",
    noProfilesMatchCriteria: "没有符合您条件的资料",
    showingProfiles: "显示 {showing} 个，共 {total} 个资料",
    previous: "上一页",
    pageInfo: "第 {page} 页，共 {pages} 页",
    next: "下一页",
    selectAllAvailable: "选择所有可用女性",
    photo: "照片",
    name: "姓名",
    age: "年龄",
    skills: "技能",
    experience: "经验",
    phone: "电话",
    years: "年",
    womanNotAvailable: "此女性不可用",
    selectForAssignment: "选择分配",
    editProfile: "编辑资料",
    markAsHired: "标记为已雇佣",
    markAsAvailable: "标记为可用",
    deleteProfile: "删除资料",
    employedBy: "受雇于",
    requestId: "请求编号",
    assigned: "已分配",
    userManagement: "用户管理",
    searchUsers: "搜索用户...",
    allTypes: "所有类型",
    admin: "管理员",
    manager: "经理",
    employer: "雇主",
    exportUsers: "导出用户",
    noUsersFound: "未找到用户",
    noUsersMatchCriteria: "没有符合您条件的用户",
    noUsersAvailable: "没有可用的用户",
    showingUsers: "显示  个用户",
    user: "用户",
    fullName: "全名",
    email: "电子邮件",
    phone: "电话",
    type: "类型",
    joined: "加入",
    editUser: "编辑用户",
    suspendUser: "暂停用户",
    activateUser: "激活用户",
    deleteUser: "删除用户",
    galleryManagement: "画廊管理",
    searchGallery: "搜索画廊...",
    addImage: "添加图片",
    noGalleryImagesFound: "未找到画廊图片",
    noImagesMatchCriteria: "没有符合您条件的图片",
    showingImages: "显示 {showing} 个，共 {total} 张图片",
    general: "一般",
    edit: "编辑",
    delete: "删除",
    featured: "特色",
    aboutUsManagement: "关于我们管理",
    pageContent: "页面内容",
    coreValues: "核心价值",
    teamMembers: "团队成员",
    aboutPageContent: "关于我们页面内容",
    editContent: "编辑内容",
    defaultAboutTitle: "通过技能培训赋能女性",
    defaultMission: "我们的使命是通过职业培训和可持续的就业机会赋能女性",
    defaultVision: "我们的愿景是一个每个女性都拥有技能和机会实现经济独立的世界",
    defaultHistory: "成立于2013年，乌鲁戈女性机会中心通过技能培训改变了数百名女性的生活",
    noMissionStatement: "尚未添加使命声明",
    noVisionStatement: "尚未添加愿景声明",
    noHistoryContent: "尚未添加历史内容",
    noAboutPageContent: "没有关于我们页面内容",
    clickEditContentToAdd: "点击'编辑内容'添加信息",
    addValue: "添加价值",
    noCoreValues: "没有核心价值",
    addCoreValues: "添加您组织的核心价值",
    addTeamMember: "添加团队成员",
    noTeamMembers: "没有团队成员",
    addTeamMembers: "添加您的团队成员",
    donationManagement: "捐款管理",
    reset: "重置",
    exportDonations: "导出捐款",
    donor: "捐赠者",
    message: "消息",
    viewDetails: "查看详情",
    sendThankYou: "发送感谢",
    noDonationsFound: "未找到捐款",
    reportsAnalytics: "报告与分析",
    generateReports: "生成报告",
    usersReport: "用户报告",
    requestsReport: "请求报告",
    donationsReport: "捐款报告",
    fullDatabaseExport: "完整数据库导出",
    systemStatistics: "系统统计",
    totalUsers: "总用户",
    activeWomen: "活跃女性",
    totalRevenue: "总收入",
    successRate: "成功率",
    requestStatistics: "请求统计",
    generalSettings: "常规设置",
    siteName: "站点名称",
    emailNotifications: "电子邮件通知",
    autoApproveRequests: "自动批准请求",
    saveSettings: "保存设置",
    accountSettings: "账户设置",
    changePassword: "更改密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    confirmNewPassword: "确认新密码",
    saveChanges: "保存更改",
    editGalleryImage: "编辑画廊图片",
    addGalleryImage: "添加画廊图片",
    title: "标题",
    description: "描述",
    department: "部门",
    featuredImage: "特色图片",
    imageFile: "图片文件",
    currentImage: "当前图片",
    current: "当前",
    cancel: "取消",
    updateImage: "更新图片",
    editAboutPageContent: "编辑关于我们页面内容",
    pageTitle: "页面标题",
    enterPageTitle: "输入页面标题",
    missionStatement: "使命声明",
    enterMissionStatement: "输入使命声明",
    visionStatement: "愿景声明",
    enterVisionStatement: "输入愿景声明",
    historyAboutUs: "历史/关于我们",
    enterHistoryContent: "输入历史内容",
    aboutPageSaved: "关于我们页面保存成功",
    failedSaveAboutPage: "保存关于我们页面失败",
    editCoreValue: "编辑核心价值",
    addCoreValue: "添加核心价值",
    coreValueText: "核心价值文本",
    enterCoreValueText: "输入核心价值文本",
    sortOrder: "排序顺序",
    updateCoreValue: "更新核心价值",
    confirmDeleteCoreValue: "您确定要删除此核心价值吗？",
    coreValueDeleted: "核心价值删除成功",
    failedDeleteCoreValue: "删除核心价值失败",
    coreValueAdded: "核心价值添加成功",
    failedAddCoreValue: "添加核心价值失败",
    coreValueUpdated: "核心价值更新成功",
    failedUpdateCoreValue: "更新核心价值失败",
    editTeamMember: "编辑团队成员",
    addTeamMember: "添加团队成员",
    position: "职位",
    department: "部门",
    bioDescription: "个人简介/描述",
    enterTeamMemberBio: "输入团队成员个人简介",
    profilePhoto: "个人资料照片",
    activeTeamMember: "活跃团队成员",
    currentPhoto: "当前照片",
    updateTeamMember: "更新团队成员",
    confirmDeleteTeamMember: "您确定要删除此团队成员吗？",
    teamMemberDeleted: "团队成员删除成功",
    failedDeleteTeamMember: "删除团队成员失败",
    teamMemberAdded: "团队成员添加成功",
    failedAddTeamMember: "添加团队成员失败",
    teamMemberUpdated: "团队成员更新成功",
    failedUpdateTeamMember: "更新团队成员失败",
    addNewProfile: "添加新资料",
    name: "姓名",
    age: "年龄",
    selectDepartment: "选择部门",
    experienceYears: "经验（年）",
    commaSeparatedSkills: "逗号分隔的技能",
    location: "位置",
    educationLevel: "教育水平",
    selectEducation: "选择教育水平",
    primary: "小学",
    secondary: "中学",
    vocational: "职业",
    university: "大学",
    other: "其他",
    profilePhoto: "个人资料照片",
    addProfile: "添加资料",
    editProfile: "编辑资料",
    saveChanges: "保存更改",
    refresh: "刷新",
    logout: "退出登录",
    toggleMenu: "切换菜单",
    urugoWOC: "乌鲁戈 WOC",
    notifications: "通知",
    noNotifications: "没有通知",
    home: "首页",
    requests: "请求",
    women: "女性",
    users: "用户",
    donations: "捐款",
    gallery: "画廊",
    about: "关于",
    reports: "报告",
    settings: "设置",
    export: "导出",
    csvFormat: "CSV 格式",
    manageWomen: "管理女性",
    profiles: "资料",
    manageUsers: "管理用户",
    quickActions: "快速操作",
    reviewRequests: "审查请求",
    exportAllData: "导出所有数据",
    exportAll: "全部导出",
    clearAll: "全部清除",
    allCaughtUp: "全部已更新！",
    noNewNotifications: "没有新通知",
    departments: "部门",
    employers: "雇主",
    activeToday: "今日活跃",
    thisMonth: "本月",
    currentlyActive: "当前活跃",
    average: "平均",
    womenTrained: "培训过的女性",
    selectAllAvailable: "选择所有可用女性",
    selectForAssignment: "选择分配",
    inactive: "不活跃",
    active: "活跃",
    enterImageDescription: "输入图片描述",
    enterCoreValueText: "输入核心价值文本",
    enterTeamMemberBio: "输入团队成员个人简介",
    bio: "个人简介",
    confirmDeleteImage: "您确定要删除此图片吗？",
    imageDeleted: "图片删除成功",
    failedDeleteImage: "删除图片失败",
    galleryImageAdded: "画廊图片添加成功",
    failedAddGalleryImage: "添加画廊图片失败",
    galleryImageUpdated: "画廊图片更新成功",
    failedUpdateGalleryImage: "更新画廊图片失败",
    selectDepartment: "选择部门",
    successRate: "成功率",
    activeWomen: "活跃女性",
    
    // Existing translations from other sections...
    employerDashboard: "雇主仪表板",
    myRequests: "我的请求",
    hiredWomen: "雇佣的女性",
    payments: "付款",
    newRequest: "新请求",
    markAsPaid: "标记为已支付",
    exportData: "导出数据",
    makePayment: "进行支付",
    downloadReceipt: "下载收据",
    totalSpent: "总支出",
    totalHired: "总雇佣",
    approvalRate: "批准率",
    avgEmployees: "平均员工",
    avgDuration: "平均时长",
    pendingPayments: "待处理付款",
    paymentHistory: "付款历史",
    payNow: "立即支付",
    profileSettings: "个人资料设置",
    companyName: "公司名称",
    contactPerson: "联系人",
    requestTrainedWomen: "请求培训过的女性",
    perRequest: "每个请求",
    womenHired: "雇佣的女性",
    avgPerRequest: "平均/请求",
    browseHired: "浏览雇佣",
    viewHiredWomen: "查看雇佣的女性",
    downloadAllRequests: "下载所有请求",
    unknownDepartment: "未知部门",
    unknownDate: "未知日期",
    exportList: "导出列表",
    unknownName: "未知名称",
    yearsExp: "年经验",
    hiredOn: "雇佣于",
    unknown: "未知",
    notSpecified: "未指定",
    noHiredWomen: "无雇佣女性",
    noHiredWomenDesc: "您尚未雇佣任何女性。批准的请求将显示在此处",
    makeRequest: "提出请求",
    managePayments: "管理您的付款和发票",
    totalPendingPayments: "总待处理付款",
    requests: "请求",
    allCompletedPayments: "所有已完成付款",
    viewAllRequests: "查看所有请求",
    request: "请求",
    due: "到期",
    noPendingPayments: "无待处理付款",
    paidOn: "支付于",
    noPaymentHistory: "尚无付款历史",
    loadingDashboard: "正在加载您的仪表板...",
    failedLoadHiredWomen: "加载雇佣女性数据失败",
    notificationPendingRequests: "您有  个待处理请求",
    notificationPendingPayments: "个付款待处理",
    justNow: "刚刚",
    requestSubmittedSuccess: "请求提交成功！",
    failedSubmitRequest: "提交请求失败。请重试",
    requestUpdatedSuccess: "请求更新成功！",
    failedUpdateRequest: "更新请求失败。请重试",
    confirmCancelRequest: "您确定要取消此请求吗？",
    requestCancelledSuccess: "请求取消成功！",
    failedCancelRequest: "取消请求失败。请重试",
    confirmMarkAsPaid: "标记此请求为已支付？",
    requestMarkedAsPaid: "请求已标记为已支付！",
    failedUpdatePayment: "更新付款状态失败。请重试",
    exportSuccessful: "导出成功！文件已下载",
    failedExportRequests: "导出请求失败",
    confirmDeleteRequest: "您确定要删除此请求吗？此操作无法撤消",
    requestDeletedSuccess: "请求删除成功！",
    failedDeleteRequest: "删除请求失败。请重试",
    downloadingReceipt: "正在下载收据...",
    paymentCompleted: "付款完成成功！",
    
    // Gallery Page Translations
    barista: "咖啡师",
    coffee: "咖啡",
    training: "培训",
    womenLearning: "女性学习",
    preparation: "准备",
    machine: "机器",
    customerService: "客户服务",
    serving: "服务",
    customers: "客户",
    withProfessionalism: "专业地",
    grinding: "研磨",
    learning: "学习",
    proper: "适当的",
    techniques: "技术",
    art: "艺术",
    creating: "创造",
    beautiful: "美丽的",
    designs: "设计",
    teamCollaboration: "团队合作",
    working: "工作",
    together: "一起",
    in: "在",
    shop: "商店",
    roomCleaning: "房间清洁",
    professional: "专业的",
    room: "房间",
    cleaning: "清洁",
    linenManagement: "布草管理",
    linen: "布草",
    folding: "折叠",
    and: "和",
    storage: "储存",
    cleaningEquipment: "清洁设备",
    using: "使用",
    modern: "现代的",
    equipment: "设备",
    hotelStandards: "酒店标准",
    maintaining: "维护",
    high: "高的",
    standards: "标准",
    frontDesk: "前台",
    managing: "管理",
    hotel: "酒店",
    front: "前面",
    desk: "桌子",
    operations: "操作",
    guestCheckin: "客人入住",
    guest: "客人",
    checkin: "入住",
    process: "过程",
    phoneEtiquette: "电话礼仪",
    telephone: "电话",
    communication: "沟通",
    skills: "技能",
    computerSkills: "计算机技能",
    software: "软件",
    sewingMachine: "缝纫机",
    industrial: "工业的",
    sewing: "缝纫",
    machines: "机器",
    patternMaking: "图案制作",
    clothing: "服装",
    patterns: "图案",
    fabricCutting: "布料裁剪",
    precision: "精确",
    fabric: "布料",
    cutting: "裁剪",
    qualityControl: "质量控制",
    checking: "检查",
    finished: "完成的",
    garments: "服装",
    leatherCutting: "皮革裁剪",
    leather: "皮革",
    for: "为",
    products: "产品",
    handStitching: "手工缝制",
    traditional: "传统的",
    stitching: "缝制",
    leatherDyeing: "皮革染色",
    coloring: "染色",
    productAssembly: "产品组装",
    assembling: "组装",
    goods: "货物",
    weaving: "编织",
    carpet: "地毯",
    knotting: "打结",
    handknotting: "手工打结",
    designPlanning: "设计规划",
    designs: "设计",
    finishing: "完成",
    final: "最终的",
    touches: "修饰",
    on: "在",
    carpets: "地毯",
    milkProcessing: "牛奶加工",
    milk: "牛奶",
    processing: "加工",
    yogurtMaking: "酸奶制作",
    yogurt: "酸奶",
    fermentation: "发酵",
    qualityTesting: "质量测试",
    testing: "测试",
    dairy: "乳制品",
    packaging: "包装",
    hygienic: "卫生的",
    
    // UI Translations for Gallery
    images: "图片",
    tryAgain: "再试一次",
    noImagesFound: "未找到图片",
    tryDifferentFilter: "尝试选择不同的部门或搜索词",
    tryDifferentSearch: "尝试不同的搜索词",
    noImagesInDepartment: "此部门尚无可用图片",
    galleryImage: "图库图片",
    noDescription: "无描述可用",
    loadMore: "加载更多",
    trainingImages: "培训图片",
    womenEmpowered: "赋权女性",
    learningOpportunities: "学习机会",
    witnessTransformation: "见证女性通过职业培训改变生活的旅程",
    search: "搜索",
    viewAll: "查看全部",
    tailoringFashion: "裁缝与时装",
    organicFarming: "有机农业",
    culinaryArts: "烹饪艺术",
    cosmetology: "美容学",
    literacyProgram: "扫盲计划",
    handicrafts: "手工艺品",
    leatherwork: "皮革制品",
    farming: "农业",
    cooking: "烹饪",
    tailoring: "裁缝",
    housekeeping: "家政服务",
    reception: "接待",
    sewing: "缝纫",
    carpetWeaving: "地毯编织",
    dairyProduction: "乳制品生产",
    
    // About Us Page Translations
    aboutUs: "关于我们",
    empoweringWomenTransformingCommunities: "赋权女性，转变社区，自2013年起",
    ourMission: "我们的使命",
    ourVision: "我们的愿景",
    ourStory: "我们的故事",
    ourCoreValues: "我们的核心价值观",
    ourTrainingDepartments: "我们的培训部门",
    meetOurTeam: "认识我们的团队",
    contactUs: "联系我们",
    connectWithUs: "与我们联系",
    sendUsAMessage: "给我们发送消息",
    wellGetBackToYou: "我们会尽快回复您",
    ourPartnersSponsors: "我们的合作伙伴和赞助商",
    
    // Contact Information Labels
    address: "地址",
    workingHours: "工作时间",
    alternate: "备用",
    fullName: "全名 *",
    emailAddress: "电子邮件地址 *",
    subject: "主题 *",
    sendMessage: "发送消息",
    sending: "正在发送...",
    thankYouMessageSent: "谢谢！您的消息已成功发送。",
    sorryErrorSending: "抱歉，发送消息时出错。请再试一次。",
    
    // Placeholders and Messages
    loadingAboutInfo: "正在加载关于信息...",
    
    // Form Labels
    formNamePlaceholder: "输入您的全名",
    formEmailPlaceholder: "输入您的电子邮件地址",
    formSubjectPlaceholder: "输入主题",
    formMessagePlaceholder: "在此输入您的消息...",
    
    // Social Media Platforms
    facebook: "脸书",
    twitter: "推特",
    instagram: "Instagram",
    linkedin: "领英",
    youtube: "YouTube",
    whatsapp: "WhatsApp",
    
    // Partner Types
    sponsor: "赞助商",
    partner: "合作伙伴",
    donor: "捐赠者",

    // Existing translations
    home: "首页",
    exploreDepartments: "探索部门",
    meetOurWomen: "认识我们的女性",
    hireTrainedWomen: "雇用培训过的女性",
    empoweringWomen: "赋权女性",
    throughSkillsTraining: "通过技能培训",
    buildingSustainable: "建设",
    futures: "可持续的未来",
    transformingCommunities: "转变社区",
    together: "一起",
    employersConnected: "连接的雇主",
    chooseSpecializedPrograms: "从我们  个专为成功设计的专业培训项目中选择",
    requestTrainedWomen: "请求培训过的女性",
    certifiedTraining: "认证培训",
    flexibleHours: "灵活时间",
    ourWomenInAction: "我们的女性在行动",
    witnessTransformation: "见证她们工作中的转变",
    meetTalentedWomen: "认识我们才华横溢的女性",
    skilledProfessionals: "熟练的专业人士准备做出改变",
    availableNow: "现在可用",
    currentlyWorking: "目前工作",
    empowerMoreWomen: "今天赋予更多女性权力",
    supportProvidesHope: "您的支持提供培训、机会和希望。加入我们，创造持久的改变。",
    donateNow: "立即捐款",
    hireTalent: "雇用人才",
    woman: "女性",
    skilledProfessional: "熟练的专业人士",
    womenEmpowermentActivity: "女性赋权活动",
    makeDonation: "捐款支持女性培训",
    
    // Department names and descriptions
    tailoringDesc: "专业缝纫和时装设计培训",
    farmingDesc: "可持续农业实践和技术",
    culinaryDesc: "专业烹饪和食物准备技能",
    cosmetologyDesc: "美容和护肤产品制作",
    literacyDesc: "基础教育和读写技能",
    handicraftsDesc: "传统和现代工艺品制作",
    leatherworkDesc: "制鞋和皮革制品生产",
    
    // Hero slides descriptions
    heroSlide1Desc: "乌鲁戈女性机会中心已经培训了600多名女性掌握各种职业技能，帮助她们建立可持续的生计并改变她们的社区。",
    heroSlide2Desc: "我们的职业培训计划为女性提供适应当今竞争激烈就业市场的可销售技能，确保长期就业和财务独立。",
    heroSlide3Desc: "通过赋予一位女性权力，我们赋予整个社区权力。加入我们，通过教育、支持和机会创造持久的改变。",
    
    // Additional UI elements
    working: "工作中",
    loadingContent: "正在加载精彩内容...",
  },

  portuguese: {
    homepageManagement: 'Gerenciamento da Página Inicial',
heroSlides: 'Slides Hero',
addHeroSlide: 'Adicionar Slide Hero',
editHeroSlide: 'Editar Slide Hero',
noHeroSlides: 'Nenhum slide Hero',
addHeroSlidesDesc: 'Adicione slides para exibir na seção hero da página inicial',
stats: 'Estatísticas',
noStats: 'Nenhuma estatística',
addStatsDesc: 'Adicione estatísticas para exibir na página inicial',
addStat: 'Adicionar Estatística',
editStat: 'Editar Estatística',
statAdded: 'Estatística adicionada com sucesso',
statUpdated: 'Estatística atualizada com sucesso',
statDeleted: 'Estatística excluída com sucesso',
confirmDeleteStat: 'Tem certeza que deseja excluir esta estatística?',
confirmDeleteStatTitle: 'Excluir Estatística',
heroSlideAdded: 'Slide Hero adicionado com sucesso',
heroSlideUpdated: 'Slide Hero atualizado com sucesso',
heroSlideDeleted: 'Slide Hero excluído com sucesso',
heroSlideStatusToggled: 'Status do slide Hero atualizado',
failedAddHeroSlide: 'Falha ao adicionar slide Hero',
failedUpdateHeroSlide: 'Falha ao atualizar slide Hero',
failedDeleteHeroSlide: 'Falha ao excluir slide Hero',
failedToggleHeroSlideStatus: 'Falha ao atualizar status do slide Hero',
confirmDeleteHeroSlideTitle: 'Excluir Slide Hero',
confirmDeleteHeroSlide: 'Tem certeza que deseja excluir este slide Hero?',
failedLoadHeroSlides: 'Falha ao carregar slides Hero',
failedLoadStats: 'Falha ao carregar estatísticas',
failedAddStat: 'Falha ao adicionar estatística',
failedUpdateStat: 'Falha ao atualizar estatística',
failedDeleteStat: 'Falha ao excluir estatística',

activityImages: 'Imagens de Atividade',
activityImagesManagement: 'Gerenciamento de Imagens de Atividade',
addActivityImage: 'Adicionar Imagem de Atividade',
editActivityImage: 'Editar Imagem de Atividade',
activityImageAdded: 'Imagem de atividade adicionada com sucesso',
activityImageUpdated: 'Imagem de atividade atualizada com sucesso',
activityImageDeleted: 'Imagem de atividade excluída com sucesso',
activityImageStatusToggled: 'Status da imagem de atividade atualizado',
confirmDeleteActivityImage: 'Tem certeza que deseja excluir esta imagem de atividade?',
searchActivityImages: 'Pesquisar imagens de atividade...',
bulkUpload: 'Upload em Massa',
bulkUploadImages: 'Fazer Upload de Imagens em Massa',
bulkUploadComplete: 'Upload em massa concluído com sucesso',
failedBulkUpload: 'Falha no upload em massa',
selectImagesToUpload: 'Por favor, selecione imagens para fazer upload',
selectedFiles: 'Arquivos Selecionados',
uploadAll: 'Enviar Todos',
uploading: 'Enviando...',
imageRequired: 'Arquivo de imagem é obrigatório',
failedAddActivityImage: 'Falha ao adicionar imagem de atividade',
failedUpdateActivityImage: 'Falha ao atualizar imagem de atividade',
failedDeleteImage: 'Falha ao excluir imagem',
imageDeleted: 'Imagem excluída com sucesso',
imageRestored: 'Imagem restaurada com sucesso',
failedRestoreImage: 'Falha ao restaurar imagem',
imageStatusToggled: 'Status da imagem atualizado',
failedToggleImageStatus: 'Falha ao atualizar status da imagem',
failedLoadActivityImages: 'Falha ao carregar imagens de atividade',
exportActivityImages: 'Exportar Imagens de Atividade',
activityImagesExported: 'Imagens de atividade exportadas com sucesso',
failedExportActivityImages: 'Falha ao exportar imagens de atividade',
womenInAction: 'Mulheres em Ação',
totalImages: 'Total de Imagens',
activeImages: 'Imagens Ativas',
departmentsWithImages: 'Departamentos com Imagens',
lastUpload: 'Último Upload',
never: 'Nunca',
noActivityImages: 'Nenhuma imagem de atividade encontrada',
addActivityImagesDesc: 'Adicione imagens para exibir na seção Mulheres em Ação na página inicial',
    // Manager Dashboard Translations
    dashboard: "Painel de Controle",
    requests: "Solicitações",
    women: "Mulheres",
    users: "Usuários",
    donations: "Doações",
    gallery: "Galeria",
    about: "Sobre",
    reports: "Relatórios",
    settings: "Configurações",
    manager: "Gerente",
    totalUsers: "Total de Usuários",
    totalRequests: "Total de Solicitações",
    totalRevenue: "Receita Total",
    activeWomen: "Mulheres Ativas",
    recentActivity: "Atividade Recente",
    totalWomen: "Total de Mulheres",
    employerCount: "Empregadores",
    newThisMonth: "Novo este Mês",
    activeToday: "Ativo Hoje",
    pendingRequests: "Solicitações Pendentes",
    approvedRequests: "Solicitações Aprovadas",
    rejectedRequests: "Solicitações Rejeitadas",
    loadingDashboard: "Carregando painel...",
    failedLoadDashboard: "Falha ao carregar dados do painel",
    justNow: "Agora mesmo",
    notificationPendingRequests: "Você tem  solicitação(ões) pendente(s)",
    newUsersThisWeek: "novos usuários esta semana",
    newDonations: "novas doações",
    failedLoadEmployerDetails: "Falha ao carregar detalhes do empregador",
    selectWomenToAssign: "Por favor, selecione mulheres primeiro para designar",
    selectRequestEmployer: "Por favor, selecione uma solicitação/empregador",
    noWomenSelected: "Nenhuma mulher selecionada",
    successfullyAssignedWomen: " mulheres designadas com sucesso para {employer}",
    failedToAssignWomen: "Falha ao designar mulheres",
    failedLoadWomenProfiles: "Falha ao carregar perfis de mulheres",
    accessDenied: "Acesso negado. Por favor, faça login novamente.",
    requestStatusUpdated: "Status da solicitação atualizado para {status}",
    failedUpdateRequest: "Falha ao atualizar solicitação",
    userStatusUpdated: "Usuário {status} com sucesso",
    suspended: "suspenso",
    activated: "ativado",
    failedUpdateUser: "Falha ao atualizar usuário",
    confirmDeleteUser: "Tem certeza que deseja excluir este usuário?",
    userDeleted: "Usuário excluído com sucesso",
    failedDeleteUser: "Falha ao excluir usuário",
    profileAvailabilityUpdated: "Disponibilidade do perfil atualizada para {status}",
    available: "Disponível",
    hired: "Contratada",
    failedUpdateProfile: "Falha ao atualizar perfil",
    confirmDeleteProfile: "Tem certeza que deseja excluir este perfil?",
    profileDeleted: "Perfil excluído com sucesso",
    failedDeleteProfile: "Falha ao excluir perfil",
    profileAdded: "Perfil adicionado com sucesso",
    failedAddProfile: "Falha ao adicionar perfil",
    profileUpdated: "Perfil atualizado com sucesso",
    exportSuccessful: "Exportação bem-sucedida! Arquivo baixado",
    failedExportData: "Falha ao exportar dados",
    searchRequests: "Pesquisar solicitações...",
    clearFilters: "Limpar Filtros",
    filterBy: "Filtrar por",
    allStatus: "Todos os Status",
    pending: "Pendente",
    approved: "Aprovado",
    rejected: "Rejeitado",
    cancelled: "Cancelado",
    to: "para",
    exportRequests: "Exportar Solicitações",
    noRequestsFound: "Nenhuma Solicitação Encontrada",
    noRequestsMatch: "Nenhuma solicitação corresponde aos seus critérios",
    noRequestsAvailable: "Nenhuma solicitação disponível",
    showingRequests: "Mostrando  solicitação(ões)",
    id: "ID",
    date: "Data",
    employer: "Empregador",
    department: "Departamento",
    employees: "Funcionários",
    duration: "Duração",
    amount: "Valor",
    status: "Status",
    actions: "Ações",
    days: "dias",
    n_a: "N/A",
    viewRequest: "Visualizar Solicitação",
    approveRequest: "Aprovar Solicitação",
    rejectRequest: "Rejeitar Solicitação",
    womenProfilesManagement: "Gerenciamento de Perfis de Mulheres",
    searchWomen: "Pesquisar mulheres...",
    assignSelected: "Designar Selecionado",
    addNewProfile: "Adicionar Novo Perfil",
    allDepartments: "Todos os Departamentos",
    clearFilters: "Limpar Filtros",
    womenSelectedForAssignment: " mulheres selecionadas para designação",
    selected: "selecionado(s)",
    assignSelectedWomen: "Designar Mulheres Selecionadas",
    noWomenProfilesFound: "Nenhum Perfil de Mulher Encontrado",
    noProfilesMatchCriteria: "Nenhum perfil corresponde aos seus critérios",
    showingProfiles: "Mostrando {showing} de {total} perfis",
    previous: "Anterior",
    pageInfo: "Página {page} de {pages}",
    next: "Próximo",
    selectAllAvailable: "Selecionar todas as mulheres disponíveis",
    photo: "Foto",
    name: "Nome",
    age: "Idade",
    skills: "Habilidades",
    experience: "Experiência",
    phone: "Telefone",
    years: "anos",
    womanNotAvailable: "Esta mulher não está disponível",
    selectForAssignment: "Selecionar para designação",
    editProfile: "Editar Perfil",
    markAsHired: "Marcar como Contratada",
    markAsAvailable: "Marcar como Disponível",
    deleteProfile: "Excluir Perfil",
    employedBy: "Empregada por",
    requestId: "ID da Solicitação",
    assigned: "Designada",
    userManagement: "Gerenciamento de Usuários",
    searchUsers: "Pesquisar usuários...",
    allTypes: "Todos os Tipos",
    admin: "Administrador",
    manager: "Gerente",
    employer: "Empregador",
    exportUsers: "Exportar Usuários",
    noUsersFound: "Nenhum Usuário Encontrado",
    noUsersMatchCriteria: "Nenhum usuário corresponde aos seus critérios",
    noUsersAvailable: "Nenhum usuário disponível",
    showingUsers: "Mostrando usuário(s)",
    user: "Usuário",
    fullName: "Nome Completo",
    email: "E-mail",
    phone: "Telefone",
    type: "Tipo",
    joined: "Ingressou",
    editUser: "Editar Usuário",
    suspendUser: "Suspender Usuário",
    activateUser: "Ativar Usuário",
    deleteUser: "Excluir Usuário",
    galleryManagement: "Gerenciamento da Galeria",
    searchGallery: "Pesquisar na galeria...",
    addImage: "Adicionar Imagem",
    noGalleryImagesFound: "Nenhuma Imagem da Galeria Encontrada",
    noImagesMatchCriteria: "Nenhuma imagem corresponde aos seus critérios",
    showingImages: "Mostrando {showing} de {total} imagens",
    general: "Geral",
    edit: "Editar",
    delete: "Excluir",
    featured: "Destaque",
    aboutUsManagement: "Gerenciamento Sobre Nós",
    pageContent: "Conteúdo da Página",
    coreValues: "Valores Fundamentais",
    teamMembers: "Membros da Equipe",
    aboutPageContent: "Conteúdo da Página Sobre",
    editContent: "Editar Conteúdo",
    defaultAboutTitle: "Empoderando Mulheres Através do Treinamento de Habilidades",
    defaultMission: "Nossa missão é empoderar mulheres através do treinamento vocacional e oportunidades de emprego sustentáveis",
    defaultVision: "Nossa visão é um mundo onde cada mulher tenha as habilidades e oportunidades para alcançar independência econômica",
    defaultHistory: "Fundado em 2013, o Centro de Oportunidades para Mulheres Urugo transformou a vida de centenas de mulheres através do treinamento de habilidades",
    noMissionStatement: "Nenhuma declaração de missão adicionada",
    noVisionStatement: "Nenhuma declaração de visão adicionada",
    noHistoryContent: "Nenhum conteúdo histórico adicionado",
    noAboutPageContent: "Nenhum conteúdo na página Sobre",
    clickEditContentToAdd: "Clique em 'Editar Conteúdo' para adicionar informações",
    addValue: "Adicionar Valor",
    noCoreValues: "Nenhum Valor Fundamental",
    addCoreValues: "Adicione os valores fundamentais da sua organização",
    addTeamMember: "Adicionar Membro da Equipe",
    noTeamMembers: "Nenhum Membro da Equipe",
    addTeamMembers: "Adicione os membros da sua equipe",
    donationManagement: "Gerenciamento de Doações",
    reset: "Redefinir",
    exportDonations: "Exportar Doações",
    donor: "Doador",
    message: "Mensagem",
    viewDetails: "Ver Detalhes",
    sendThankYou: "Enviar Agradecimento",
    noDonationsFound: "Nenhuma doação encontrada",
    reportsAnalytics: "Relatórios & Análises",
    generateReports: "Gerar Relatórios",
    usersReport: "Relatório de Usuários",
    requestsReport: "Relatório de Solicitações",
    donationsReport: "Relatório de Doações",
    fullDatabaseExport: "Exportação Completa do Banco de Dados",
    systemStatistics: "Estatísticas do Sistema",
    totalUsers: "Total de Usuários",
    activeWomen: "Mulheres Ativas",
    totalRevenue: "Receita Total",
    successRate: "Taxa de Sucesso",
    requestStatistics: "Estatísticas de Solicitações",
    generalSettings: "Configurações Gerais",
    siteName: "Nome do Site",
    emailNotifications: "Notificações por E-mail",
    autoApproveRequests: "Solicitações de Aprovação Automática",
    saveSettings: "Salvar Configurações",
    accountSettings: "Configurações da Conta",
    changePassword: "Alterar Senha",
    newPassword: "Nova Senha",
    confirmPassword: "Confirmar Senha",
    confirmNewPassword: "Confirmar Nova Senha",
    saveChanges: "Salvar Alterações",
    editGalleryImage: "Editar Imagem da Galeria",
    addGalleryImage: "Adicionar Imagem à Galeria",
    title: "Título",
    description: "Descrição",
    department: "Departamento",
    featuredImage: "Imagem em Destaque",
    imageFile: "Arquivo de Imagem",
    currentImage: "Imagem Atual",
    current: "Atual",
    cancel: "Cancelar",
    updateImage: "Atualizar Imagem",
    editAboutPageContent: "Editar Conteúdo da Página Sobre",
    pageTitle: "Título da Página",
    enterPageTitle: "Digite o título da página",
    missionStatement: "Declaração da Missão",
    enterMissionStatement: "Digite a declaração da missão",
    visionStatement: "Declaração da Visão",
    enterVisionStatement: "Digite a declaração da visão",
    historyAboutUs: "História / Sobre Nós",
    enterHistoryContent: "Digite o conteúdo histórico",
    aboutPageSaved: "Página Sobre salva com sucesso",
    failedSaveAboutPage: "Falha ao salvar página Sobre",
    editCoreValue: "Editar Valor Fundamental",
    addCoreValue: "Adicionar Valor Fundamental",
    coreValueText: "Texto do Valor Fundamental",
    enterCoreValueText: "Digite o texto do valor fundamental",
    sortOrder: "Ordem de Classificação",
    updateCoreValue: "Atualizar Valor Fundamental",
    confirmDeleteCoreValue: "Tem certeza que deseja excluir este valor fundamental?",
    coreValueDeleted: "Valor fundamental excluído com sucesso",
    failedDeleteCoreValue: "Falha ao excluir valor fundamental",
    coreValueAdded: "Valor fundamental adicionado com sucesso",
    failedAddCoreValue: "Falha ao adicionar valor fundamental",
    coreValueUpdated: "Valor fundamental atualizado com sucesso",
    failedUpdateCoreValue: "Falha ao atualizar valor fundamental",
    editTeamMember: "Editar Membro da Equipe",
    addTeamMember: "Adicionar Membro da Equipe",
    position: "Posição",
    department: "Departamento",
    bioDescription: "Biografia/Descrição",
    enterTeamMemberBio: "Digite a biografia do membro da equipe",
    profilePhoto: "Foto do Perfil",
    activeTeamMember: "Membro da Equipe Ativo",
    currentPhoto: "Foto Atual",
    updateTeamMember: "Atualizar Membro da Equipe",
    confirmDeleteTeamMember: "Tem certeza que deseja excluir este membro da equipe?",
    teamMemberDeleted: "Membro da equipe excluído com sucesso",
    failedDeleteTeamMember: "Falha ao excluir membro da equipe",
    teamMemberAdded: "Membro da equipe adicionado com sucesso",
    failedAddTeamMember: "Falha ao adicionar membro da equipe",
    teamMemberUpdated: "Membro da equipe atualizado com sucesso",
    failedUpdateTeamMember: "Falha ao atualizar membro da equipe",
    addNewProfile: "Adicionar Novo Perfil",
    name: "Nome",
    age: "Idade",
    selectDepartment: "Selecionar Departamento",
    experienceYears: "Experiência (Anos)",
    commaSeparatedSkills: "Habilidades separadas por vírgula",
    location: "Localização",
    educationLevel: "Nível de Educação",
    selectEducation: "Selecionar Nível de Educação",
    primary: "Primário",
    secondary: "Secundário",
    vocational: "Profissional",
    university: "Universitário",
    other: "Outro",
    profilePhoto: "Foto do Perfil",
    addProfile: "Adicionar Perfil",
    editProfile: "Editar Perfil",
    saveChanges: "Salvar Alterações",
    refresh: "Atualizar",
    logout: "Sair",
    toggleMenu: "Alternar menu",
    urugoWOC: "Urugo WOC",
    notifications: "Notificações",
    noNotifications: "Nenhuma notificação",
    home: "Início",
    requests: "Solicitações",
    women: "Mulheres",
    users: "Usuários",
    donations: "Doações",
    gallery: "Galeria",
    about: "Sobre",
    reports: "Relatórios",
    settings: "Configurações",
    export: "Exportar",
    csvFormat: "Formato CSV",
    manageWomen: "Gerenciar Mulheres",
    profiles: "perfis",
    manageUsers: "Gerenciar Usuários",
    quickActions: "Ações Rápidas",
    reviewRequests: "Revisar Solicitações",
    exportAllData: "Exportar Todos os Dados",
    exportAll: "Exportar Tudo",
    clearAll: "Limpar Tudo",
    allCaughtUp: "Tudo atualizado!",
    noNewNotifications: "Nenhuma nova notificação",
    departments: "Departamentos",
    employers: "Empregadores",
    activeToday: "Ativo Hoje",
    thisMonth: "este mês",
    currentlyActive: "atualmente ativo",
    average: "Média",
    womenTrained: "Mulheres Treinadas",
    selectAllAvailable: "Selecionar todas as mulheres disponíveis",
    selectForAssignment: "Selecionar para designação",
    inactive: "Inativo",
    active: "Ativo",
    enterImageDescription: "Digite a descrição da imagem",
    enterCoreValueText: "Digite o texto do valor fundamental",
    enterTeamMemberBio: "Digite a biografia do membro da equipe",
    bio: "Biografia",
    confirmDeleteImage: "Tem certeza que deseja excluir esta imagem?",
    imageDeleted: "Imagem excluída com sucesso",
    failedDeleteImage: "Falha ao excluir imagem",
    galleryImageAdded: "Imagem da galeria adicionada com sucesso",
    failedAddGalleryImage: "Falha ao adicionar imagem da galeria",
    galleryImageUpdated: "Imagem da galeria atualizada com sucesso",
    failedUpdateGalleryImage: "Falha ao atualizar imagem da galeria",
    selectDepartment: "Selecionar Departamento",
    successRate: "Taxa de Sucesso",
    activeWomen: "Mulheres Ativas",
    
    // Existing translations from other sections...
    employerDashboard: "Painel do Empregador",
    myRequests: "Minhas Solicitações",
    hiredWomen: "Mulheres Contratadas",
    payments: "Pagamentos",
    newRequest: "Nova Solicitação",
    markAsPaid: "Marcar como Pago",
    exportData: "Exportar Dados",
    makePayment: "Fazer Pagamento",
    downloadReceipt: "Baixar Recibo",
    totalSpent: "Total Gasto",
    totalHired: "Total Contratado",
    approvalRate: "Taxa de Aprovação",
    avgEmployees: "Média de Funcionários",
    avgDuration: "Duração Média",
    pendingPayments: "Pagamentos Pendentes",
    paymentHistory: "Histórico de Pagamentos",
    payNow: "Pagar Agora",
    profileSettings: "Configurações do Perfil",
    companyName: "Nome da Empresa",
    contactPerson: "Pessoa de Contato",
    requestTrainedWomen: "Solicitar mulheres treinadas",
    perRequest: "por solicitação",
    womenHired: "mulheres contratadas",
    avgPerRequest: "média/solicitação",
    browseHired: "Navegar Contratados",
    viewHiredWomen: "Ver mulheres contratadas",
    downloadAllRequests: "Baixar todas as solicitações",
    unknownDepartment: "Departamento Desconhecido",
    unknownDate: "Data desconhecida",
    exportList: "Exportar Lista",
    unknownName: "Nome Desconhecido",
    yearsExp: "anos de experiência",
    hiredOn: "Contratada em",
    unknown: "Desconhecido",
    notSpecified: "Não especificado",
    noHiredWomen: "Nenhuma Mulher Contratada",
    noHiredWomenDesc: "Você ainda não contratou nenhuma mulher. Solicitações aprovadas aparecerão aqui",
    makeRequest: "Fazer uma Solicitação",
    managePayments: "Gerenciar seus pagamentos e faturas",
    totalPendingPayments: "Total de Pagamentos Pendentes",
    requests: "solicitação(ões)",
    allCompletedPayments: "Todos os pagamentos concluídos",
    viewAllRequests: "Ver Todas as Solicitações",
    request: "Solicitação",
    due: "Vencimento",
    noPendingPayments: "Nenhum pagamento pendente",
    paidOn: "Pago em",
    noPaymentHistory: "Nenhum histórico de pagamento ainda",
    loadingDashboard: "Carregando seu painel...",
    failedLoadHiredWomen: "Falha ao carregar dados de mulheres contratadas",
    notificationPendingRequests: "Você tem  solicitação(ões) pendente(s)",
    notificationPendingPayments: " pagamento(s) pendente(s)",
    justNow: "Agora mesmo",
    requestSubmittedSuccess: "Solicitação enviada com sucesso!",
    failedSubmitRequest: "Falha ao enviar solicitação. Por favor, tente novamente",
    requestUpdatedSuccess: "Solicitação atualizada com sucesso!",
    failedUpdateRequest: "Falha ao atualizar solicitação. Por favor, tente novamente",
    confirmCancelRequest: "Tem certeza que deseja cancelar esta solicitação?",
    requestCancelledSuccess: "Solicitação cancelada com sucesso!",
    failedCancelRequest: "Falha ao cancelar solicitação. Por favor, tente novamente",
    confirmMarkAsPaid: "Marcar esta solicitação como paga?",
    requestMarkedAsPaid: "Solicitação marcada como paga!",
    failedUpdatePayment: "Falha ao atualizar status do pagamento. Por favor, tente novamente",
    exportSuccessful: "Exportação bem-sucedida! Arquivo baixado",
    failedExportRequests: "Falha ao exportar solicitações",
    confirmDeleteRequest: "Tem certeza que deseja excluir esta solicitação? Esta ação não pode ser desfeita",
    requestDeletedSuccess: "Solicitação excluída com sucesso!",
    failedDeleteRequest: "Falha ao excluir solicitação. Por favor, tente novamente",
    downloadingReceipt: "Baixando recibo...",
    paymentCompleted: "Pagamento concluído com sucesso!",
    
    // Gallery Page Translations
    barista: "Barista",
    coffee: "Café",
    training: "Treinamento",
    womenLearning: "Mulheres aprendendo",
    preparation: "Preparação",
    machine: "máquina",
    customerService: "Atendimento ao Cliente",
    serving: "Servindo",
    customers: "clientes",
    withProfessionalism: "com profissionalismo",
    grinding: "Moagem",
    learning: "Aprendendo",
    proper: "apropriado",
    techniques: "técnicas",
    art: "Arte",
    creating: "Criando",
    beautiful: "belo",
    designs: "designs",
    teamCollaboration: "Colaboração em Equipe",
    working: "Trabalhando",
    together: "juntos",
    in: "em",
    shop: "loja",
    roomCleaning: "Limpeza de Quartos",
    professional: "Profissional",
    room: "quarto",
    cleaning: "limpeza",
    linenManagement: "Gestão de Roupa de Cama",
    linen: "roupa de cama",
    folding: "dobragem",
    and: "e",
    storage: "armazenamento",
    cleaningEquipment: "Equipamento de Limpeza",
    using: "Usando",
    modern: "moderno",
    equipment: "equipamento",
    hotelStandards: "Padrões de Hotel",
    maintaining: "Mantendo",
    high: "alto",
    standards: "padrões",
    frontDesk: "Recepção",
    managing: "Gerenciando",
    hotel: "hotel",
    front: "frente",
    desk: "balcão",
    operations: "operações",
    guestCheckin: "Check-in de Hóspedes",
    guest: "hóspede",
    checkin: "check-in",
    process: "processo",
    phoneEtiquette: "Etiqueta Telefônica",
    telephone: "telefone",
    communication: "comunicação",
    skills: "habilidades",
    computerSkills: "Habilidades de Computador",
    software: "software",
    sewingMachine: "Máquina de Costura",
    industrial: "industrial",
    sewing: "costura",
    machines: "máquinas",
    patternMaking: "Criação de Padrões",
    clothing: "roupas",
    patterns: "padrões",
    fabricCutting: "Corte de Tecido",
    precision: "precisão",
    fabric: "tecido",
    cutting: "corte",
    qualityControl: "Controle de Qualidade",
    checking: "Verificando",
    finished: "finalizado",
    garments: "vestuário",
    leatherCutting: "Corte de Couro",
    leather: "couro",
    for: "para",
    products: "produtos",
    handStitching: "Costura à Mão",
    traditional: "tradicional",
    stitching: "costura",
    leatherDyeing: "Tingimento de Couro",
    coloring: "Coloração",
    productAssembly: "Montagem de Produtos",
    assembling: "Montando",
    goods: "mercadorias",
    weaving: "Tecelagem",
    carpet: "tapete",
    knotting: "Nós",
    handknotting: "Nós à Mão",
    designPlanning: "Planejamento de Design",
    designs: "designs",
    finishing: "Acabamento",
    final: "Final",
    touches: "toques",
    on: "em",
    carpets: "tapetes",
    milkProcessing: "Processamento de Leite",
    milk: "leite",
    processing: "processamento",
    yogurtMaking: "Fabricação de Iogurte",
    yogurt: "iogurte",
    fermentation: "fermentação",
    qualityTesting: "Teste de Qualidade",
    testing: "teste",
    dairy: "laticínios",
    packaging: "Embalagem",
    hygienic: "higiênico",
    
    // UI Translations for Gallery
    images: "Imagens",
    tryAgain: "Tentar Novamente",
    noImagesFound: "Nenhuma imagem encontrada",
    tryDifferentFilter: "Tente selecionar um departamento diferente ou termo de pesquisa",
    tryDifferentSearch: "Tente um termo de pesquisa diferente",
    noImagesInDepartment: "Nenhuma imagem disponível para este departamento ainda",
    galleryImage: "Imagem da Galeria",
    noDescription: "Nenhuma descrição disponível",
    loadMore: "Carregar Mais",
    trainingImages: "Imagens de Treinamento",
    womenEmpowered: "Mulheres Empoderadas",
    learningOpportunities: "Oportunidades de Aprendizado",
    witnessTransformation: "Testemunhe a jornada de mulheres transformando suas vidas através do treinamento profissional",
    search: "Pesquisar",
    viewAll: "Ver Tudo",
    tailoringFashion: "Costura & Moda",
    organicFarming: "Agricultura Orgânica",
    culinaryArts: "Artes Culinárias",
    cosmetology: "Cosmetologia",
    literacyProgram: "Programa de Alfabetização",
    handicrafts: "Artesanato",
    leatherwork: "Trabalho em Couro",
    farming: "Agricultura",
    cooking: "Culinária",
    tailoring: "Costura",
    housekeeping: "Governança",
    reception: "Recepção",
    sewing: "Costura",
    carpetWeaving: "Tecelagem de Tapetes",
    dairyProduction: "Produção de Laticínios",
    
    // About Us Page Translations
    aboutUs: "Sobre Nós",
    empoweringWomenTransformingCommunities: "Empoderando mulheres, transformando comunidades desde 2013",
    ourMission: "Nossa Missão",
    ourVision: "Nossa Visão",
    ourStory: "Nossa História",
    ourCoreValues: "Nossos Valores Fundamentais",
    ourTrainingDepartments: "Nossos Departamentos de Treinamento",
    meetOurTeam: "Conheça Nossa Equipe",
    contactUs: "Contate-Nos",
    connectWithUs: "Conecte-se Conosco",
    sendUsAMessage: "Envie-Nos uma Mensagem",
    wellGetBackToYou: "Entraremos em contato o mais rápido possível",
    ourPartnersSponsors: "Nossos Parceiros & Patrocinadores",
    
    // Contact Information Labels
    address: "Endereço",
    workingHours: "Horário de Funcionamento",
    alternate: "Alternativo",
    fullName: "Nome Completo *",
    emailAddress: "Endereço de E-mail *",
    subject: "Assunto *",
    sendMessage: "Enviar Mensagem",
    sending: "Enviando...",
    thankYouMessageSent: "Obrigado! Sua mensagem foi enviada com sucesso.",
    sorryErrorSending: "Desculpe, ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente.",
    
    // Placeholders and Messages
    loadingAboutInfo: "Carregando informações sobre...",
    
    // Form Labels
    formNamePlaceholder: "Digite seu nome completo",
    formEmailPlaceholder: "Digite seu endereço de e-mail",
    formSubjectPlaceholder: "Digite o assunto",
    formMessagePlaceholder: "Digite sua mensagem aqui...",
    
    // Social Media Platforms
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    whatsapp: "WhatsApp",
    
    // Partner Types
    sponsor: "Patrocinador",
    partner: "Parceiro",
    donor: "Doador",

    // Existing translations
    home: "Início",
    exploreDepartments: "Explorar Departamentos",
    meetOurWomen: "Conhecer Nossas Mulheres",
    hireTrainedWomen: "Contratar Mulheres Treinadas",
    empoweringWomen: "Empoderando Mulheres",
    throughSkillsTraining: "Através de Formação de Habilidades",
    buildingSustainable: "Construindo",
    futures: "Futuros Sustentáveis",
    transformingCommunities: "Transformando Comunidades",
    together: "Juntos",
    employersConnected: "Empregadores Conectados",
    chooseSpecializedPrograms: "Escolha entre nossos  programas de treinamento especializados projetados para o sucesso",
    requestTrainedWomen: "Solicitar Mulheres Treinadas",
    certifiedTraining: "Treinamento Certificado",
    flexibleHours: "Horários Flexíveis",
    ourWomenInAction: "Nossas Mulheres em Ação",
    witnessTransformation: "Testemunhe a transformação através do seu trabalho",
    meetTalentedWomen: "Conheça Nossas Mulheres Talentosas",
    skilledProfessionals: "Profissionais qualificadas prontas para fazer a diferença",
    availableNow: "Disponível Agora",
    currentlyWorking: "Atualmente Trabalhando",
    empowerMoreWomen: "Empodere Mais Mulheres Hoje",
    supportProvidesHope: "Seu apoio fornece treinamento, oportunidades e esperança. Junte-se a nós na criação de mudanças duradouras.",
    donateNow: "Doar Agora",
    hireTalent: "Contratar Talentos",
    woman: "Mulher",
    skilledProfessional: "Profissional qualificada",
    womenEmpowermentActivity: "Atividade de empoderamento das mulheres",
    makeDonation: "Faça uma doação para apoiar o treinamento de mulheres",
    
    // Department names and descriptions
    tailoringDesc: "Treinamento profissional em costura e design de moda",
    farmingDesc: "Práticas e técnicas agrícolas sustentáveis",
    culinaryDesc: "Habilidades profissionais de culinária e preparação de alimentos",
    cosmetologyDesc: "Fabricação de produtos de beleza e cuidados com a pele",
    literacyDesc: "Educação básica e habilidades de leitura e escrita",
    handicraftsDesc: "Fabricação de artesanato tradicional e moderno",
    leatherworkDesc: "Fabricação de calçados e produtos de couro",
    
    // Hero slides descriptions
    heroSlide1Desc: "O Centro de Oportunidades para Mulheres Urugo treinou mais de 600 mulheres em várias habilidades vocacionais, ajudando-as a construir meios de subsistência sustentáveis e transformar suas comunidades.",
    heroSlide2Desc: "Nossos programas de formação profissional equipam as mulheres com habilidades comercializáveis para o competitivo mercado de trabalho de hoje, garantindo emprego de longo prazo e independência financeira.",
    heroSlide3Desc: "Ao capacitar uma mulher, capacitamos uma comunidade inteira. Junte-se a nós na criação de mudanças duradouras através da educação, apoio e oportunidades.",
    
    // Additional UI elements
    working: "Trabalhando",
    loadingContent: "Carregando conteúdo incrível...",
  }
};



  // Translate text using API
  const translateText = async (text) => {
    if (!text || language === 'english') return text;
    
    try {
      const response = await axios.post('https://hsn.urugowoc.org.rw/api/translate', {
        text,
        targetLanguage: language
      });
      return response.data.translated;
    } catch (error) {
      console.error('Translation error:', error);
      return text;
    }
  };

  // Bulk translate
  const translateBulk = async (texts) => {
    if (!texts || texts.length === 0 || language === 'english') return texts;
    
    try {
      const response = await axios.post('https://hsn.urugowoc.org.rw/api/translate/bulk', {
        texts,
        targetLanguage: language
      });
      return response.data.translated;
    } catch (error) {
      console.error('Bulk translation error:', error);
      return texts;
    }
  };

  // Change language
  const changeLanguage = async (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    
    // Reload the page to apply translations to all content
    window.location.reload();
  };

  // Auto-load saved language on component mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }
  }, []);

  // Save language when it changes
  useEffect(() => {
    localStorage.setItem('language', language);
    
    // Update axios default params with new language
    axios.defaults.params = axios.defaults.params || {};
    axios.defaults.params.lang = language;
  }, [language]);

  const value = {
    language,
    setLanguage: changeLanguage,
    translateText,
    translateBulk,
    t: (key) => staticTranslations[language]?.[key] || staticTranslations.english[key] || key,
    isLoading
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

// Custom hook for components
export const useLanguage = () => {
  const { language, setLanguage } = useTranslation();
  return { language, setLanguage };
};

export const useTranslate = () => {
  const { translateText, translateBulk } = useTranslation();
  return { translateText, translateBulk };
};